export const locale = {
  lang: 'en',
  data: {
    TESTLANG: 'en_base',
    LNG_ITEMS: 'Items',
    LNG_ITEM: 'Item',
    LNG_TIENDAS: 'Stores',
    LNG_TIENDA: 'Store',
    LNG_PRICES_DECISIONS_FILTER_CATEGORYS: 'Subcategories',
    GENERAL_INFO: 'Information',
    GENERAL_DOWNLOAD: 'Download',
    GENERIC_SEARCH: 'Search',
    GENERIC_CLEAN: 'Clean search',
    GENERIC_SELECTED_OPTION: 'Selected option',
    GENERIC_PUBLISH_CONTENT: 'Do you want to publish the following {{val}} selected records?',
    GENERIC_CANCEL_CONTENT: 'Do you want to cancel the following {{val}} selected records?',
    GENERIC_DOWNLOAD_CONTENT: 'Do you want to download the following {{val}} selected records?',
    GENERIC_UNPUBLISH: 'Bulk Publishing Errors',
    GENERIC_WITHOUT_PERMISSION: 'No permission to perform this action',
    GENERIC_ACCESS_PERMISSION: 'No permission to access this screen',
    // PLATFORM-SEC03: user without role
    NO_ROLE_TITLE: 'You have no role assigned',
    NO_ROLE_MESSAGE:
      'You have no role assigned in Prisma, so you do not have access to any module yet. Please contact your organization\'s Prisma administrator to get a role assigned.',
    NO_ROLE_YOUR_DATA: 'Your details',
    NO_ROLE_USER: 'User',
    NO_ROLE_NAME: 'Name',
    NO_ROLE_EMAIL: 'Email',
    USER_WITHOUT_ROLE_WARNING_TITLE: 'User without role',
    USER_WITHOUT_ROLE_WARNING_MSG:
      'You are about to save this user without an assigned role. They will not be able to access the tool until one is assigned. Do you want to continue?',
    USER_WITHOUT_ROLE_SELF_ERROR: 'You cannot remove your own role.',
    GENERIC_ACTION_ROW_CONTENT_FAILED: 'The action could not be carried out correctly',
    GENERIC_VIEW_ALL: 'View all',
    GENERIC_CANCEL: 'Cancel',
    GENERIC_ACCEPT: 'Accept',
    GENERIC_APPLY: 'Apply',
    GENERIC_CLOSE: 'Close',
    GENERIC_OK: 'Ok',
    GENERIC_CONTINUE: 'Continue',
    GENERIC_WARNING: 'Warning',
    GENERIC_REPORT: 'Complete Report',
    GENERIC_ADD: 'Add',
    GENERIC_FILTER: 'Filter',
    GENERIC_FULLSCREEN_TTIP: 'Expand',
    GENERIC_EXITFULLSCREEN_TTIP: 'Reduce',
    GENERIC_EXPORT_TTIP: 'Export',
    GENERIC_CLONE: 'Clone',
    GENERIC_EDIT: 'Edit',
    GENERIC_DELETE: 'Delete',
    GENERIC_VIEW: 'View',
    GENERIC_CONFIRM: 'Confirm',
    GENERIC_RESET: 'Reset',
    GENERIC_RESET_ALT: 'Reset',
    GENERIC_VISUALIZE: 'Visualize',
    GENERIC_SAVE: 'Save',
    GENERIC_SAVE_OK: 'Saved successfully.',
    GENERIC_SAVE_AND_GENERATE: 'Save and Generate',
    GENERIC_GENERATE: 'Generate',
    GENERIC_NONE: 'None',
    GENERIC_DOWNLOAD_EXCEL: 'download.xlsx',
    GENERIC_ITEMS_NOT_FOUND: 'No results found',
    GENERIC_ITEMS_NOT_ITEMS: 'There are no more items.',
    GENERIC_NOTICE: 'Notice',
    GENERIC_SOME: '(Some)',
    GENERIC_YES: 'Yes',
    GENERIC_NO: 'No',
    GENERIC_ALL: 'All',
    GENERIC_ALL_PAGE: 'All page',
    GENERIC_DESELECT: 'Deselect',
    GENERIC_ALL_F: 'All',
    GENERIC_DAY1: 'Monday',
    GENERIC_DAY2: 'Tuesday',
    GENERIC_DAY3: 'Wednesday',
    GENERIC_DAY4: 'Thursday',
    GENERIC_DAY5: 'Friday',
    GENERIC_DAY6: 'Saturday',
    GENERIC_DAY7: 'Sunday',
    GENERAL_NAME_DUPLICATE: 'This name already exists',
    GENERIC_DELETE_LOGIC: 'Inactive record',
    GENERIC_DELETE_LOGIC_SINGLE_CONTENT: 'Are you sure you want to deactivate {{val}}? It can only be deleted if it is not in use',
    GENERIC_DELETE_MULTIPLE: 'Deactivate records',
    GENERIC_SUPPORT_CHAT: 'Chat with Technical Support',
    GENERIC_DELETE_LOGIC_MULTIPLE_CONTENT:
      'Are you sure you want to deactivate {{val}} records? They can only be deleted if they are not in use',
    GENERIC_ERRORS: {
      REQUIRED: 'This field is required',
      EMAIL: 'Must be a valid email',
      MIN: 'The value must be greater than {{val}}',
      MAX: 'The value must be less than {{val}}',
      MINLENGTH: 'Minimum {{val}} characters',
      MAXLENGTH: 'Maximum {{val}} characters',
      PATTERN: 'Invalid format',
      MATDATEPICKERMIN: 'The date must be after {{val}}',
      MATDATEPICKERMAX: 'The date must be before {{val}}',
      CODEEXISTS: 'The code already exists',
    },
    LINEAR_SPACE_TYPES: {
      Sales: 'Sales',
    },
    LNG_PRODUCTS_TYPES: {
      Retail: 'Retail',
      Ingredient: 'Ingredient',
      Combo: 'Kit',
      Recipe: 'Recipe',
      Supply: 'Supply',
      Item: 'Retail',
    },
    LNG_STORES_TYPES: {
      Store: 'Store',
      DistributionCenter: 'Distribution Center ',
      StoreAndDistributionCenter: 'Store And Distribution Center',
    },
    LNG_STRATEGIES_VARIABLES: {
      Sales: 'Sales',
      SalesUN: 'Sales Units',
      Deliveries: 'Deliveries',
      DeliveriesUN: 'Units Delivered',
      Margin: 'Margin',
      MarginWithVendors: 'Margin from agreements',
      MarketSales: 'Market Sales',
      MarketUN: 'Market Units',
    },
    LNG_STRATEGIES_EVENTS: {
      First: 'First purchase',
      CreationDate: 'Creation Date',
    },
    STATUS_CONNECTION: {
      NO_CONNECTION: 'No Connection.',
      BAD_CONNECTION: 'Slow Connection.',
      ACCEPT: 'OK',
      MODAL_TITLE: 'Connection Problem',
      MODAL_MESSAGE: 'Unable to connect to the server. Please check your internet connection and try again.',
      MODAL_BUTTON: 'Understood',
    },
    ABM_STATUS: {
      NEW: 'New',
      ENDORSED: 'Endorsed',
      INFORMED: 'Informed',
      DELETED: 'Deleted',
      MODIFIED: 'Modified',
      CURRENT: 'Current',
      CANCELLED: 'Cancelled',
    },
    PUBLISH_STATUS: {
      PROCESSING: 'Publishing',
      PROCESSING_TOOLTIP: 'Refresh search results when notified about the success of the publication',
      ROW_DISABLED_BY_PROCESSING: 'The action cannot be performed because the record is being processed',
      DELETING: 'Deleting',
      DELETING_TOOLTIP: 'Search results will be updated upon notification of successful deletion',
      ABM_WARNING_DELETING: 'Record in process of deletion.',
    },
    LNG_ADMINISTRATION_MASTER_SUPPLIER_searchStores: 'Find Stores',
    LNG_ADMINISTRATION_MASTER_STORES_newStore: 'New Store',
    LNG_ADMINISTRATION_MASTER_STORES_tooltipDeleteStore: 'Delete selected stores',
    LNG_ADMINISTRATION_MASTER_STORES_storeType: 'Store Type',
    LNG_MASTER_STORETYPES_Store: 'Store',
    LNG_MASTER_STORETYPES_DistributionCenter: 'Distribution Center ',
    LNG_MASTER_STORETYPES_StoreAndDistributionCenter: 'Store and Distribution Center',
    LNG_PRICES_SETUP_PRICERULE_storeScope: 'Store Scope',
    LNG_PRICES_SETUP_PRICERULE_step3storeScope: 'Step 3 - Stores Scope',
    'LNG_PRICE-RULES-TYPES_Margin': 'Margin',
    'LNG_PRICE-RULES-TYPES_Competitive': 'Competitive',
    'LNG_PRICE-RULES-TYPES_ParentItem': 'Product Relationships',
    'LNG_PRICE-RULES-TYPES_ParentZone': 'Store Relationships',
    'LNG_PRICE-RULES-TYPES_ParentCategory': 'Category Relationships',
    LNG_SET_EFFECTIVE_DATES: 'Set valid dates',
    LNG_SET_EFFECTIVE_DATE: 'Set valid date',
    LNG_PREVIEW: 'Preview',
    TIME_UNITS_SHORT: {
      seconds: 'Sec.',
      minutes: 'Min.',
      hours: 'Hours',
      days: 'Days',
    },
    GLOBAL: {
      DATES: 'Dates',
      brand: 'Brand',
      brands: 'Brands',
      manufacturer: 'Supplier',
      internalCode: 'Internal Code',
      externalCode: 'External Code',
      Vendor: 'Supplier',
      Imprent: 'Press',
      Region: 'Region',
      Market: 'Market',
      Format: 'Company Operated',
      Country: 'Country',
      State: 'State',
      Department: 'Department',
      NAME: 'Name',
      QUANTITY: 'Quantity',
      City: 'City',
      ZipCode: 'Zip Code',
      Subcategoría: 'Subcategory',
      OperationType: 'Operation Type Competitors',
      UnCheckedSuggestion: 'Unchecked suggestion',
      PriceRaised: 'Increased prices',
      NoSuggestions: 'No suggestions',
      NotCheckedSimulation: 'Unchecked simulation',
      SuggestionAccepted: 'Accepted suggestion',
      ManualPriceEdited: 'Manually edited price',
      SimulationAcepted: 'Accepted simulation',
      Regular: 'Regular',
      Competition: 'Competition',
      Current: 'Current',
      New: 'New',
      Endorsed: 'Endorsed',
      Informed: 'Informed',
      Historic: 'Historic',
      Future: 'Future',
      Checked: 'Checked',
      Unchecked: 'Unchecked',
      PriceZone: 'Price Zone',
      Search: 'Search',
      Type: 'Type',
      WITHOUT_PERMISSIONS: 'Without Permissions',
      PLACEHOLDER_START_DATE: 'Start date',
      PLACEHOLDER_END_DATE: 'End date',
      MAX_DIFF_DATE: 'Date range must not be greater than ',
      SECOND_DATE_LOWER_THAN_FIRST: 'The start date is greater than the end date. ',
      DATE: 'Date',
      PDV: 'Stores',
      WITHOUT_CHANGES: 'Without Changes',
      WITHOUT_INVALID_MAIN_DATA: 'Invalid Main Data',
    },
    TYPE_ACTION: {
      approved: 'Approve',
      informToERP: 'Publish Decisions',
      TOOLTIP: {
        approved: 'Approve Changes',
        informToERP: 'Publish Decisions',
      },
    },
    NOTIFICATIONS: {
      TITLE: 'Notifications',
      NO_NEW_ITEMS: 'There are no new notifications.',
      NO_OLD_ITEMS: 'There are no unread notifications.',
      MARK_AS_READ: 'Mark as read',
      MARK_ALL_AS_READ: 'Mark all as read',
      VIEW_LAST: 'View read notifications',
      CLOSE_LAST: 'Close read notifications',
      NOT_ENABLED: 'Your browser notifications are disabled.',
      ENABLE_NOTIFICATIONS: 'You must enable notifications in your browser. Click for more info.',
      ENABLE_NOTIFICATIONS_TUTORIAL: 'Activation tutorial',
      DOWNLOAD: 'Download File',
      TOGO: 'Go',
    },
    INSIGHTS: {
      TITLE: 'Insights',
      GO_TO_INSIGHTS: 'Go to the Insights screen',
    },
    GLOBAL_CONFIG: {
      TITLE: 'Settings',
      FONT_SIZE: 'Font size',
      SMALL: 'Small',
      NORMAL: 'Normal',
      BIG: 'Big',
      THEME: 'Theme',
      LIGTH: 'Light',
      DARK: 'Dark',
      DATE_FORMAT: 'Date format',
      RESET_WARNING: 'To apply the changes it is necessary to restart the application',
    },
    HELPS: {
      PRICE: {
        SOON: 'Coming Soon',
        FAQS: {
          ROUTE: 'Pricing',
          TITLE: 'FAQs',
          QUESTION1:
            'What if I have a margin rule and a competition rule for the same product and the same point of sale? Which rule will Prisma prioritize?',
          ANSWER1:
            'In Prisma, the most specific rules will always take precedence over the others. That is, if there is a margin rule for the Electrical Appliances subcategory in Buenos Aires, and in turn there is a competition rule for the Electrical Appliances subcategory, for a specific point of sale in the Buenos Aires area, then the competition rule will have priority in that particular point of sale, while the remaining points of sale in Buenos Aires will be governed by the margin rule.',
          ANSWER1_1:
            'If there is a competition rule and a margin rule, they have an equal product and point of sale scope. Then the competition rule will always take precedence. In other words, Prisma will try to comply with the competitive positioning and if this is not possible then suggestions will be generated from the margin rule.',
          QUESTION2: 'How does the zone margin rule work? In what cases will I use it?',
          QUESTION3: 'What is the difference between margin or markup rules? Which one should I use?',
          ANSWER3:
            'The Profit Margin and the Mark Up are two ways of looking at the same situation: how much I want to earn. They are exactly the same. Their difference is in the way they are obtained: the Mark Up is calculated based on cost, while the Profit Margin is calculated on the sale price.',
          ANSWER3_1:
            'For example, a product or service that has a final cost of $ 100.00 and for which you want to earn a Mark Up of 20%, will have a final price of $ 120.00 and a Profit Margin of 16.66%.',
          ANSWER3_2: 'Mark Up = 20 / Cost = 20/100 = 0.2 x 100 = 20%',
          ANSWER3_3: 'Profit Margin = 20 / Price = 20/120 = 0.16 x 100 = 16.16%',
          QUESTION4: 'What kind of cost does Prisma use to calculate the margin?',
          ANSWER4:
            'At Prisma we recommend working with the Replacement Cost, that is, the price that we have to pay to the supplier to replace a merchandise or raw material. This cost may differ from the accounting cost.',
          QUESTION5:
            'If I have the product "Small Coffee", which is the parent of the product "Medium Coffee" in a rule configured so that the child product costs 20% more than the parent product. Can I have another rule, at the same time, where "Small Coffee" is the parent of "Large Coffee" and the child product ("Large Coffee") costs 40% more than the parent ("Small Coffee")?',
          ANSWER5:
            'You can, Prisma allows you to create several product relationship rules where you define the same item as the parent. In this case, you will create a kinship rule where the item Small Coffee is the parent of medium coffee with a difference of 20% and then you will create another relationship rule where the product Small Coffee is the parent of Large Coffee with a difference of 40%.',
          QUESTION6:
            'I created a rule where product "A" is a child of product "B". "A" changes its price each time price "B" changes. I want to create another rule where the product "C" is also the parent of "A"? Then "A" will change price every time the price of "B" or "C" changes.',
          ANSWER6:
            'Product kinship rules cannot share Children. In this way, if you define that a product will be a child, it can only have a single parent.',
          QUESTION7: "I created kinship rules and I don't see the price suggestions, how can I generate them?",
          ANSWER7:
            'The kinship rules do not generate suggestions. The only rules that generate price suggestions are Margin Rules and Competition Rules.',
          QUESTION8: 'I created a competition / margin rule for a product and Prisma does not suggest a price, what should I do?',
          ANSWER8:
            'If prisma did not generate any suggestions, it means that your prices comply with the defined positioning and guidelines. Therefore, you do not need to generate any suggestions.',
          ANSWER8_1:
            'In the case of competition rules, remember that Prisma feeds on the prices of your competitors. You should check that you have updated prices from competitors.',
          QUESTION9: 'When I am creating a competition rule, there are points of sale that are not listed for selection in scope.',
          ANSWER9:
            'If they do not appear listed, it is because you have points of sale that are badly labeled or do not contain the correct attributes, you can check this from the Configuration Menu> Masters> Points of Sale',
          QUESTION10: 'When I am creating a competition rule there are products that are not listed for selection in scope.',
          ANSWER10:
            'If not all the products are listed, you must check that they are well categorized or have the correct attributes, you can check that from the Item Master module.',
          QUESTION11: 'When I am creating a margin rule there are stores that are not listed for selection in scope.',
          ANSWER11:
            'If they do not appear listed, it is because you have points of sale that are badly labeled or do not contain the correct attributes, you can check this from the Configuration Menu> Masters> Points of Sale',
          QUESTION12: 'When I am creating a margin rule there are products that are not listed for selection in scope.',
          ANSWER12:
            'If not all the products are listed, you must check that they are well categorized or have the correct attributes, you can check that from the Item Master module.',
          QUESTION13: 'When I am creating a relationship rule, there are points of sale that are not listed for selection in the scope.',
          ANSWER13:
            'If they do not appear listed, it is because you have points of sale that are badly labeled or do not contain the correct attributes, you can check this from the Configuration Menu> Masters> Points of Sale',
          QUESTION14: 'When I am creating a relationship rule there are products that are not listed for selection in scope.',
          ANSWER14:
            'If not all the products are listed, you must check that they are well categorized or have the correct attributes, you can check that from the Item Master module.',
        },
      },
    },
    GENERIC_COMP: {
      SCOPE: {
        CLIPBOARD_STORE_TITLE: 'Paste points of sale from clipboard',
        CLIPBOARD_PRODUCT_TITLE: 'Paste products from clipboard',
        STRATEGY_ATTR_TITLE: 'Selection by attribute',
        STRATEGY_ATTR_MSG: 'Attributes are selected to define the scope of products',
        STRATEGY_PROD_TITLE: 'Selection by product',
        STRATEGY_PROD_MSG: 'Products must be chosen explicitly one by one',
        STRATEGY_ATTR_TITLE_STORE: 'Selection by attribute',
        STRATEGY_ATTR_MSG_STORE: 'Attributes are selected to define the scope of points of sale',
        STRATEGY_STORE_TITLE_STORE: 'Selection by points of sale',
        STRATEGY_STORE_MSG_STORE: 'The points of sale must be explicitly chosen one by one',
        TAG_SELECTOR: 'Label Selection',
        ADVANCED_TAG_SELECTOR: 'Advanced Label Selection',
        ITEM_LIST_WITH_ACTIONS: {
          TABLE: {
            ADD: 'Add Forecast',
            NAME: 'Name',
            CODE: 'Code',
            FORECAST: 'Forecast',
            MODAL: {
              TITLE: 'Assign Forecast',
              INPUT: 'Forecast',
            },
            DELETE_FORECAST_TITLE: 'Confirm Delete Forecast',
            DELETE_FORECAST_CONTENT: 'Are you sure you want to delete the forecast of {{val}} {{val2}}?',
          },
        },
      },
      LOOKUP: {
        Search: 'Search...',
        clearAll: 'Unselect all',
        clear: 'Deselect the item',
        selectAll: 'Select all',
        selectAllPage: 'Select all elements on the current page',
        selectAllChilds: 'Select all child',
        onlySelected: 'Show only selected',
        allItemsSelected: 'All items are selected',
        noneItemsSelected: 'No selected items',
        selectedItemsLabel: 'Selected items: ({{val}}):',
        Included: 'Included',
        Excluded: 'Excluded',
        includedAll: 'Include all elements',
        excludedAll: 'Exclude all elements',
        includedclearAll: 'Deselect all included elements',
        excludedclearAll: 'Deselect all excluded elements',
        itemsNotFound: 'No results found',
        parent_item_active: 'This product is a child in other rules, it cannot be used as a parent',
        parent_item_message:
          'A parent item cannot be a child in another rule. The products that are children in other rules are shown in grey',
        parent_store_active: 'This point of sale is a child in other rules, it cannot be used as a parent',
        parent_store_message:
          'A parent store cannot be a child in another rule. The points of sale that are children in other rules are shown in gray',
      },
      CAT_SELECT_V2: {
        LEVEL2: 'Business Unit',
        LEVEL3: 'Department',
        LEVEL4: 'Category',
        LEVEL5: 'Subcategory',
      },
      WEEKDAY_COMPONENT_DAYS: {
        '0': 'Su',
        '1': 'Mo',
        '2': 'Tu',
        '3': 'We',
        '4': 'Th',
        '5': 'Fr',
        '6': 'Sa',
      },
      NESTED_TREE_TABLE: {},
      IMPORTERV2: {
        DEFAULT_TITLE: 'General Importer',
        SELECT_TYPE_PLACEHOLDER: 'Select an Importer',
        DEFAULT_DESCRIPTION:
          'On this screen you can import information by uploading a file. Its format can be downloaded by clicking on the template download button. Once the file is uploaded you will receive instructions on how to continue.',
        DOWNLOAD_TEMPLATE: 'Download Template',
        AssortmentMarketData_alternativeDescription:
          'Once the import is complete, you need to assign new market products to a Prism category from the next screen: <br><b>Inventory > Settings > Market Products</b>',
        TITLES: {
          FERRYES_AND_COMISIONS: 'Importer Freight and Commissions',
          COST_AND_TAXES: 'Costs and Taxes',
          VENDOR_COST: 'Costs by Supplier',
          STORE_TAXES: 'Tax Importer for Store',
          NEW_PRICES: 'New Prices Importer',
          COMPETITOR_PRICES: 'Competitor Prices',
          ITEMS: 'Items',
          IMPORT_VENDORS: 'Resolve Vendor conflicts',
          IMPORT_PRICES_TITLE: 'Prices',
          MARKET_INFORMATION: 'Market Information',
          MARGIN_WITH_VENDOR: 'Margin with Vendor',
          STORE_ASSORTMENT: 'Assortment Importer by Store',
          STORE_COSTS: 'Costs per Store',
          STORE_PRICES: 'Prices by Store',
          STORE_PRICE_OUTPUT: 'Publication of prices',
          COMPETITORS: 'Competitors',
          STORE_PRICE_OUTPUT_PREVIEW: 'Publication of prices - Preview',
          CustomItems: 'Regional Products',
          REGULATED_PRICES: 'Regulated Prices',
          VENDOR_COSTS: 'Costs by Vendor',
          CustomItemsDelete: 'Deletion of regional products',
          CustomItemsUpdatePrice: 'Regional product price update',
          CustomItemsUpdateCosts: 'Regional product cost update',
          VendorCosts: 'Vendor Costs',
          DailySales: 'Daily Sales',
          AssortmentMarketData: 'Market Data',
          Categories: 'Categories',
          Margin2: 'Margin by Agreements',
          MonthlyInventory: 'Monthly Inventory',
          StoreAssortment: 'Store Assortment',
          Stores: 'Stores',
          MonthlySales: 'Monthly Sales',
          ItemMatchings: 'Item Equivalents',
          SpacesAvailability: 'Available Spaces',
          None: 'No Selection',
          CategoriesV2: 'Categories V2',
          SalesFuture: 'Projected Sales',
          ItemRanking: 'Ranking of items for Display',
          MaterialTagValue: 'Promotional material by tag',
          ChargeDefinitionValue: 'Possible values ​​for Costs and Taxes',
          PromotionDeleteStore: 'Delete promotional store',
          DeliveryPlaces: 'Delivery Places',
        },
        RESPONSE_OK: 'The import was sent to the process queue, to track it click here:',
        RESPONSE_OK_TITLE: 'Import in progress',
        TYPES: {
          ALL: 'All',
          Items: 'Items',
          RegulatedPrices: 'Regulated Prices',
          PriceRegulated: 'Regulated Prices',
          ActionExceptionalValue: 'Fixed Price Exceptions',
          ActionExceptionalMixedValue: 'Multiple Fixed Price Exceptions',
          StoreCosts: 'Costs per Store',
          StorePrices: 'Prices per Store',
          StorePriceOutput: 'Publication of Prices',
          VendorCostsOutput: 'Vendor Costs Output',
          StoreCostsOutput: 'Store Costs Output',
          CustomItems: 'Regional Products',
          CustomItemsDelete: 'Regional product deletion',
          CustomItemsUpdatePrice: 'Regional product prices',
          CustomItemsUpdateCosts: 'Regional product costs',
          StorePriceOutputPreview: 'Price Publication - Preview',
          ItemCodes: 'Item Codes',
          UnitsOfMeasures: 'Units of Measurement',
          ItemUnitOfMeasures: 'Item Units of Measure',
          Competitors: 'Competitors',
          CompetitorPrices: "Competitors' Prices",
          CompetitorsPrices: 'Competitor Prices',
          SalesTickets: 'Sales Tickets',
          Vendors: 'Vendors',
          VendorItems: 'Vendor Items',
          DeliveryPlaces: 'Delivery Places',
          DailyInventory: 'Daily Inventory',
          DailySales: 'Daily Sales',
          AssortmentOutputPreview: 'Assortment Publication - Preview',
          AssortmentOutput: 'Assortment Publication',
          VendorCosts: 'Vendor Costs',
          VENDOR_COSTS: 'Vendor Costs',
          StoreCostOutput: 'Cost Output',
          AssortmentMarketData: 'Market Data',
          Categories: 'Categories',
          Margin2: 'Margin by Agreements',
          ItemTags: 'Item Tags',
          StoreTags: 'Store Tags',
          MonthlyInventory: 'Monthly Inventory',
          StoreAssortment: 'Store Assortment',
          Stores: 'Stores',
          MonthlySales: 'Monthly Sales',
          None: 'No Selection',
          DailyMissionReport: 'Daily Missions',
          DailyMissionReport_alt: 'DAILY REPORT',
          ItemMatchingReport: 'Item Matching Report',
          StoreCompetitorsReport: 'Stores and Competitors',
          ItemMatchings: 'Item Equivalents',
          SpacesAvailability: 'Available Spaces',
          PlanogramPopMaterialMarketplaces: 'Rented Material',
          MarketItemToRegister: 'Market Products',
          CategoryTree: 'Category Tree',
          PromiotonPeriod: 'Promotional Periods',
          PromiotionPeriod: 'Promotional Periods',
          Promotion: ' Promotions',
          PromotionPeriod: 'Promotional Periods',
          CategoriesV2: 'Categories V2',
          PromotionReport: 'Promotion Report',
          PrintingList: 'Printing List',
          LogisticsList: 'Logistic List',
          TagValues: 'Tag Values',
          BranchesYpfTiendas: 'Planex Branches',
          DeliveryStoresYpfTienda: 'Planex Delivery locations',
          ItemsYpfTiendas: 'Planex Items',
          PlanogramStructure: 'Planogram Structure',
          TakeAPayBPromotion: 'Buy A Pay B Promotion',
          DiscountPromotion: 'Discount Promotion',
          FixedPricePromotion: 'Fixed Price Promotion',
          Planogram: 'Planograms',
          PopMaterial: 'POP Materials',
          PlanogramPopMaterial: 'Planogram materials',
          PlanogramStore: 'Store planograms',
          PromotionReferencePrice: 'Reference Prices',
          PromotionSpace: 'Spaces',
          PromotionMaterial: 'Materials',
          PromotionSpaceStore: 'Store spaces',
          PromotionSpaceMaterial: 'Space materials',
          PromotionMaterialStore: 'Store materials',
          AxionFuelsBuildupReport: 'BuildUp Report',
          DynamicEntities: 'Dynamic Entities',
          MassiveReplacement: 'Massive Replacement',
          PlanogramPreGenerationReport: 'Planogram Pre-Generation Report',
          SpacePlanogramItems: 'Multiple Planogram Report',
          SpacePlanogramItemsFlat: 'Multiple Planogram Report (single sheet)',
          PromotionProductionLists: 'Promotion Production Lists',
          PromotionLog: 'Promotion Log',
          BranchesAndDeliveryYpfTiendas: 'Planex Branches and Delivery',
          ClientsOutputYpfTiendas: 'Planex Clients YPF',
          DeliveryStoresYpfTiendas: 'Planex Delivery YPF',
          ClusterizationImplementationMode: 'Clusterization (Implementation mode)',
          RangeAssortment: 'Range Assortment',
          StoreClusterReassignment: 'Store cluster reassignment',
          Roles: 'Roles',
          Users: 'Users',
          SystemAudit: 'System Audit',
          LoginAudit: 'Login Audit',
          AxionFuelsOthosAck: 'Price Confirmation',
          PricesAck: 'Price Confirmation',
          Status: 'Status',
          Pending: 'Pending',
          Success: 'Success',
          Failed: 'Failed',
          ReportNotGenerated: 'Report Not Generated (no data)',
          PricesOutputYpfTiendas: 'Planex Prices',
          PricesByPriceLevelYpfTiendas: 'Prices by price level',
          VendorItemCostsYpfTiendas: 'Items by vendor and costs',
          ImagesYpfTiendas: 'Planex Images',
          CostTaxAudit: 'Cost and Tax Audit',
          SalesFuture: 'Projected Sales',
          ItemRanking: 'Ranking of items for Display',
          Contact: 'Contact',
          DynamicEntitiesReport: 'Dynamic Entities Report',
          BuildupReport: 'BuildUp Report',
          MaterialTagValue: 'Promotional material by tag',
          ChargeDefinitionValue: 'Possible values ​​for Costs and Taxes',
          PromotionDeleteStore: 'Delete promotional store',
        },
        STATUS: {
          Pending: 'Pending',
          InProgress: 'In progress',
          Succeeded: 'Succeeded',
          SucceededWithWarnings: 'Succeeded With Warnings',
          Failed: 'Failed',
          Cancelled: 'Cancelled',
          NoDataProcessed: 'No data processed',
          PendingReconcile: 'Pending reconciliation',
          Reconciling: 'Reconciling',
          ReconcileSorting: 'Reconciling: sorting file',
          ReconcileMerging: 'Reconciling: comparing with snapshot',
          ReconcileImporting: 'Reconciling: importing to core',
          ReconcileFailed: 'Reconciliation failed',
        },
        STATUS_MSG: {
          information: 'Ok',
          warning: 'Warnings',
          error: 'Error',
        },
        SOURCE: {
          WebApi: 'Web Api',
          Sftp: 'SFTP',
          ExternalPull: 'Datos Externos',
        },
      },
      INTERFACES_LOG: {
        DEFAULT_TITLE: 'Interface Log',
        LIST_COL_TYPE: 'Entity',
        ENTITY: 'Entity',
        LIST_COL_SOURCE: 'Source',
        LIST_COL_ID: 'Id',
        LIST_COL_CREATED: 'Created',
        LIST_COL_STARTED: 'Started',
        LIST_COL_FINISHED: 'Finished',
        LIST_COL_DURATION: 'Duration',
        LIST_COL_STATUS: 'Status',
        LIST_COL_USERNAME: 'User Name',
        LIST_COL_ORIGINAL_FILE_NAME: 'File Name',
        MORE_DETAIL: 'More Details',
        RETRY: 'Try again',
        RETRY_PERMISSION: 'You do not have the necessary permissions to retry the processing of failed interfaces.',
        RETRY_OK: 'The failed interface is running again.',
        LIST_COL_RECORDS: 'Records',
        LIST_COL_BATCHES: 'Batches',
        LIST_COL_BATCHES_PROGRESS: 'Progress',
        LIST_COL_BATCHES_NUM: 'Batch No.',
        LIST_COL_MESSAGES: 'Messages',
        LIST_COL_LINE: 'Line',
        LIST_COL_BATCHES_COMPLETED: 'Batches Completed',
        DATE: 'Fecha',
        IMPORTER: 'Importer',
        EXPORT_MSG: 'Export Messages',
        EXPORT_MSG_SHRT: 'Export',
        SIMPLE_VIEW: 'Simple View',
        ADVANCED_VIEW: 'Advanced View',
        DOWNLOAD_ORIGINAL: 'Download original file',
        DOWNLOAD_ORIGINAL_TITLE: 'Download the file that was originally uploaded',
        DOWNLOAD_FAILED: 'Download unprocessed records',
        DOWNLOAD_FAILED_TITLE: 'Downloads a file with only the unprocessed records, ready to correct and re-upload',
        FILE_EXPIRED: 'File expired',
      },
    },
    PRICE_RULES: {
      COMPETENCE: {
        POSITION_AGAINST: {
          Minimum: 'Minimum',
          Average: 'Average',
          Maximum: 'Maximum',
          Mode: 'Mode',
        },
        POSITION_TREND: {
          HighestMode: 'Most repeated mode',
          MinimumPrice: 'Minimum Price',
          AveragePrice: 'Average Price',
          MaximumPrice: 'Maximum Price',
        },
        RULE_TYPE: {
          Guideline: 'Guideline',
          Margin: 'Margin',
          Competitive: 'Competitive',
          ParentItem: 'Related Products',
          ParentZone: 'Related Stores',
          ParentCategory: 'Related Categories',
          BasePriceList: 'Base Price List',
        },
      },
    },
    NAV: {
      HOME: {
        TITLE: 'Home',
        DASHBOARD: 'Dashboard',
      },
      DASHBOARD: {
        TITLE: 'Dashboard',
      },
      DATA_ENTRY_ADAPTATIONS: {
        TITLE: 'Data Entry',
      },
      PRICES: {
        TITLE: 'Pricing',
        SETUP: {
          TITLE: 'Setup',
          PRICEZONES: 'Price Zones',
          COMPETITORS: 'Competitors',
          PRICESRULES: 'Pricing Rules',
          BRANDS: 'Brands',
          GUIDELINESANDSTRATEGIES: 'Guidelines and Strategies',
          SENSITIVITIES: 'Sensitivities',
          ROUNDING: 'Rounding Rules',
          STRATEGYANDRULES: 'Strategy and Rules',
        },
        DECISIONS: {
          TITLE: 'Decisions',
          DECISIONS: 'Decisions',
          INFORM_ERP: 'Publish Decisions',
          PRICE_ELASTICITY: 'Price elasticity',
          PRICE_DECISIONS: 'Pricing Decisions',
          DECISIONSSUMMARY: 'Decisions Summary',
        },
        REPORTS: {
          TITLE: 'Reports',
          PRICE_CHANGES: 'Price Audit',
          COMPETITIVENESS_INDEX: 'Competitiveness index',
          PRICE_REPORTS: 'Price Reports',
          SUGGESTION_REPORTS: 'Suggestion Reports',
          COST_REPORTS: 'Cost Reports',
          YPF_REPORTS: 'Ypf Reports',
          PRICES_MAP: 'Price Map',
          PRICE_INCONSISTENCY_REPORT: 'Price Inconsistencies',
          DAILY_MARGIN: 'Daily Margin',
          COMPETITOR_PRICES: 'Competitor Prices',
          CONTEXT_REPORT: 'Context Report',
        },
        ADMIN: {
          TITLE: 'Admin',
          TAXES: {
            TITLE: 'Taxes',
            CO2: 'Tax CO2',
            ICL: 'Tax ICL',
            IIBB: 'Tax IIBB',
          },
          IMPORTERS: {
            TITLE: 'Importers',
            IMPORTPARITY: 'Import Parity',
            IMPORTFLETESCOMISIONES: 'Shipping and commissions',
            IMPORTVENDORCOSTS: 'Vendor Costs',
            IMPORTSTORETAXES: 'Store Taxes',
            IMPORTSTORECOSTS: 'Store Costs',
            IMPORTNEWPRICES: 'New Prices',
            REGULATEDPRICES: 'Regulated Prices',
            COMPETITORSPRICES: 'Competitors Prices',
            IMPORTCOSTSANDTAXES: 'Costs and Taxes',
          },
        },
      },
      ADMIN: {
        TITLE: 'Administration',
        MASTER: {
          TITLE: 'Masters',
          STORES: 'Stores',
          STORES_V2: 'Stores',
          SUPPLIER: 'Supplier',
          SUPPLIER_V2: 'Supplier ',
          TAG: 'Tag',
          TAGS: 'Tags',
          CONTACTS: 'Contacts',
          INSIGHTS: 'Insights',
          EQUIPMENTS: 'Type of Equipment',
          DYNAMIC_ENTITIES: 'Dynamic Entities',
          COST_AND_TAXES: 'Costs and Taxes',
          COST_AND_TAXES_TAXES_ONLY: 'Taxes',
          GENERAL_IMPORTER: 'General Importer',
          INTERFACES_LOG: 'Interface Log',
        },
        SECURITY: {
          TITLE: 'Security',
          USERS: 'Users',
          ROLES: 'Roles',
          REPORTS: 'Reports',
        },
      },
      MYSTERYSHOPPER: {
        TITLE: 'Mystery Shopper',
        MISSIONS: {
          TITLE: 'Missions',
        },
        USER_ASSIGNMENT: {
          TITLE: 'Users Assignment',
        },
      },
      ITEMMASTER: {
        TITLE: 'Item Master',
      },
      AICHAT: {
        TITLE: 'AI Chat',
      },
      AIDASHBOARD: {
        TITLE: 'AI Dashboard',
      },
      ASSORTMENT: {
        TITLE: 'Assortment Planning',
        SETUP: {
          TITLE: 'Setup',
          CLUSTERING: 'Clusterization',
          CATEGORY_SETUP: 'Category Setup',
          TREEOFCATEGORYS: 'Category Tree',
          ROLES: 'Roles',
          STRATEGIES: 'Strategies',
          SEGMENTASSIGNMENTS: 'Assign Segments',
          ROLESANDSTRATEGIESASSIGNMENT: 'Category Settings',
          MARKET_INFORMATION: 'Market Information',
          RULES: 'Rules',
        },
        DECISIONS: {
          TITLE: 'Decisions',
          ASSORTMENTASIGNATION: 'Assortment Decisions',
          INFORM_ERP: 'Publish Decisions',
          SHOW_COLUMNS_TITLE: 'Select Columns',
          DINAMIC_COLUMNS_TITLE_ORDER: 'Order',
          DINAMIC_COLUMNS_SUB_TITLE_ORDER: 'Select the order within each column group',
          MAX_COLUMNS_SELECTED: 'Maximum amount of selected columns ({{val}})',
          MAX_COLUMNS_EXCEED: 'Maximum amount exceeded, the first {{val}} results were selected',
          WITHOUT_CLUSTERS_FOR_LEVEL: 'Without clusters assigned for this level of category',
          DINAMIC_COLUMNS_BTN_CANCEL: 'Cancel',
          DINAMIC_COLUMNS_BTN_APPLY: 'Apply',
          DINAMIC_COLUMNS_TITLE: 'Columns',
          DINAMIC_COLUMNS_SUB_TITLE: 'Select the columns you want to view in the table',
          TAGS_IN_USE: 'It is only possible to manage tags that are applied to the items of this cluster',
          DINAMIC_COLUMNS_GROUP: {
            defaultHeader: 'General',
            productHeader: 'Product Data',
            ticketsHeader: 'Tickets',
            performanceHeader: 'Performance',
            stocksHeader: 'Stock',
            exhibitionHeader: 'Display',
            marketHeader: 'Market',
            paretoHeader: 'Pareto',
            clasificationHeader: 'Classification',
            TGENERAL: 'Total General',
            TGENERAL_RECALC: 'Pareto Recalculated',
          },
          DINAMIC_COLUMNS: {
            itemCode: 'Code',
            itemName: 'Product',
            isNew: 'New',
            status: 'Status',
            segmento: 'Segment',
            tag: 'Tag',
            itemBrand: 'Brand',
            vendorName: 'Vendor',
            itemManufacturer: 'Manufacturer',
            pareto: 'Pareto',
            sales: 'Sales $',
            salesShare: 'Sales Share %',
            salesRanking: 'Sales $ Rank',
            soldUnits: 'Sales UN',
            soldUnitsShared: '% Sales UN',
            soldUnitsRanked: 'Sales UN Rank',
            margin: 'Margin $',
            marginPercentage: 'Margin %',
            marginWithVendor: 'Margin With Vendor',
            presence: 'Presence',
            discounts: 'Discounts $',
            price: 'Price',
            tickets: 'Tickets',
            ticketsTotal: 'Tickets Total',
            ticketsShare: 'Tickets %',
            stockCost: 'Stock $',
            stockCostShare: '% Stock $',
            stockCostCurrent: 'Current Stock $',
            stockUnits: 'Stock UN',
            stockUnitsShare: '% Stock UN',
            stockUnitsCurrent: 'Current Stock UN',
            wasteUnits: 'Waste UN',
            availability: 'Availability',
            outOfStock: 'Out Of Stock',
            daysInStock: 'Stock Days',
            daysInStockCurrent: 'Stock Days Current',
            gmroi: 'GMROI',
            planograms: 'Planograms',
            popMaterial: 'POP Material',
            facings: 'Facings',
            linearSpace: 'Linear Space (mt)',
            gmros: 'GMROS',
            marketSales: 'Market Sales',
            marketUnits: 'Market Units',
            marketPrice: 'Market Price',
            marketSalesShare: 'Market Sales Share',
            marketSalesRanking: 'Market Sales Ranking',
            marketUnitsShare: 'Market Units Share',
            marketUnitsRanking: 'Market Units Ranking',
            salesShareGap: 'Sales GAP',
            unitsShareGap: 'Units GAP',
            weightedIndex: 'IP %',
            weightedIndexPareto: 'Pareto',
            IP: 'IP %',
            UN: 'UN',
            suggestionRoleName: 'Suggestion Name',
            suggestionRoleAction: 'Suggestion Description',
          },
        },
        REPORTS: {
          TITLE: 'Reports',
          CLUSTERANALYSIS: 'Cluster Analysis',
          REPORT_DECISIONS: 'Report of Decisions',
        },
        ADMINISTRATION: {
          TITLE: 'Administration',
          IMPORTERS: {
            TITLE: 'Importers',
            MARKET_INFORMATION: 'Market Information',
            MARGIN_WITH_VENDOR: 'Margin with Vendor',
          },
        },
      },
      ASSORTMENTV2: {
        TITLE: 'Assortment Planning v2',
        SETUP: {
          TITLE: 'Setup',
          GUIDELINES: 'Guidelines',
          EDIT_GUIDELINES: 'Edit Guidelines',
          CONFIGURE_GUIDELINES: 'Configure Guidelines',
          DELETE_CONFIRM_TITLE: 'Confirm deletion',
          DELETE_CONFIRM_MESSAGE: 'Do you want to delete the configuration for category "{{val}}"?',
          GENERAL_CONFIG_WARNING_FULL_MESSAGE: 'General Configuration must be configured',
          GENERAL_CONFIG_DIALOG_TITLE: 'General Configuration',
          GENERAL_CONFIG_TAB_MAIN_DATA: 'Main Data',
          GENERAL_CONFIG_TAB_ALERTS_VALIDATIONS: 'Alerts and Validations',
          GENERAL_CONFIG_TAB_MAIN_DATA_PLACEHOLDER: 'Main data content - To be implemented',
          GENERAL_CONFIG_TAB_ALERTS_VALIDATIONS_PLACEHOLDER: 'Alerts and validations content - To be implemented',
          ALERTS_VALIDATIONS: {
            DESCRIPTION: 'Alerts and Validations to ensure that suggestions meet your business conditions.',
          },
          VALIDATION_MODAL: {
            CREATE_TITLE: 'Configure new validation',
            EDIT_TITLE: 'Edit validation',
            STEP1_LABEL: 'Criterion',
            STEP2_LABEL: 'Action',
            RANGE_TITLE: 'Variation range',
            RANGE_SUBTITLE: 'Select Variable, Condition and Numeric value for the selected criterion',
            FIELD_VARIABLE: 'Variable',
            FIELD_CONDITION: 'Condition',
            FIELD_NUMERIC_VALUE: 'Value',
            ACTION_VALIDATE: 'Validate',
            ACTION_VALIDATE_DESCRIPTION: 'Forces validation within the configured range',
            BANNER_IF_IN_SUGGESTION: 'If in the suggestion of',
            LEVEL_ALTA: 'High',
            LEVEL_BAJA: 'Low',
            BANNER_THEN_SYSTEM: 'then the system must',
            BANNER_SUGGESTED_PRICE: 'the suggestion',
            PLACEHOLDER_LEVEL: 'High/Low',
            PLACEHOLDER_VARIABLE: 'Variable',
            PLACEHOLDER_COMPARATOR: 'Comparator',
            PLACEHOLDER_VALUE: 'Value',
            PLACEHOLDER_SYSTEM_ACTION: 'System action',
            VARIABLE_OUTOFSTOCK: '% Stock Out',
            VARIABLE_PRESENCE: '% Presence',
            VARIABLE_COVERAGE: '% Coverage',
            VARIABLE_GMROI: 'GMROI',
            VARIABLE_GMROS: 'GMROS',
            ERROR_MAX_PERCENTAGE: 'The maximum value for percentage variables is 100',
          },
          NEW_PRODUCTS: {
            TITLE: 'NEW PRODUCTS:',
            DESCRIPTION: 'These are products that are less than 30 days old since their registration date',
            INTRO: 'Configure how many days a product is considered new and which event the count starts from.',
            DAYS_LABEL: 'Days',
            DAYS_DESCRIPTION: 'considered new since its',
            DAYS_HINT_TEMPLATE: 'For {{val}} days since its {{val2}}.',
            EVENT_SELECTOR_TITLE: 'Which event should we count from?',
            EVENT_SELECTOR_HELP: 'Choose the reference event that starts the count.',
            SUMMARY_TITLE: 'Summary',
            SUMMARY_TEMPLATE: 'It will be considered new for {{val}} days since its {{val2}}.',
          },
          NEW_PRODUCT_EVENT: {
            FIRST_ITEM_CREATION: 'Registration date',
            FIRST_ITEM_CREATION_DESC: 'A product is considered new from its creation date',
            FIRST_STOCK_RECORD: 'First stock record',
            FIRST_STOCK_RECORD_DESC: 'A product is considered new from its first stock record',
            FIRST_SALES_RECORD: 'First sales record',
            FIRST_SALES_RECORD_DESC: 'A product is considered new from its first sales record',
          },
          TYPOLOGIES: {
            TITLE: 'TYPOLOGIES (Pareto cuts):',
            DESCRIPTION: '',
            PLACEHOLDER: 'Typologies content - To be implemented',
          },
          ANALYSIS_PERIOD: {
            TITLE: 'Analysis Period',
            DESCRIPTION:
              'In this step you can define the period in months that will be taken to perform the analysis. To normalize and be able to compare, you will always see average values expressed in 30 days in reports and Pareto.',
            LATEST_INPUT: 'Last',
            LATEST_MONTHS_INPUT: 'Last months',
            MONTHS: 'Months',
            MONTHS_VALIDATION: 'The number of months cannot be greater than the selected months',
            MONTHS_SELECTOR_TITLE: 'Months to include',
            MONTHS_SELECTOR_HELP: 'Choose which months are included in the average.',
            SELECTED_COUNT: 'Selected: {{val}} of {{val2}}',
            SUMMARY_TITLE: 'Summary',
            SUMMARY_EMPTY: 'Set the period to see the summary.',
            SUMMARY_TEMPLATE: 'The last {{val}} months will be analyzed. Included months: {{val2}}.',
            NO_MONTHS_SELECTED: 'None',
            MONTH_COUNT_SINGULAR: '{{val}} month',
            MONTH_COUNT_PLURAL: '{{val}} months',
            LEGEND:
              'If you exclude a month from the list, it will not be taken into account as part of the average. If the number of selected months is less than the selected period, the average will be calculated with the number of available months.',
            JANUARY: 'JAN',
            FEBRUARY: 'FEB',
            MARCH: 'MAR',
            APRIL: 'APR',
            MAY: 'MAY',
            JUNE: 'JUN',
            JULY: 'JUL',
            AUGUST: 'AUG',
            SEPTEMBER: 'SEP',
            OCTOBER: 'OCT',
            NOVEMBER: 'NOV',
            DECEMBER: 'DEC',
          },
        },
        DECISIONS: {
          TITLE: 'Decisions',
          ASSORTMENT_DECISIONS: 'Assortment summary',
          DECISIONS_SUMMARY: 'Assortment detail',
          SUGGESTIONS_SUMMARY_NAME: 'Suggestions summary',
          PUBLISH_DECISIONS: {},
          SUGGESTIONS_SUMMARY: {
            PAGE_TITLE: 'Assortment suggestions',
            TABS: {
              PENDING: 'PENDING APPROVAL',
              HISTORY: 'HISTORY',
            },
            KPI: {
              PENDING_TOTAL: 'Total pending suggestions',
              NEW_SUGGESTIONS: 'New suggestions',
              NEXT_TO_EXPIRE: 'Next to expire',
              EXPIRES_TODAY: 'Expire today',
              APPROVERS: 'Approvers',
              CATEGORIES_COUNT: 'Number of categories',
              EXPIRED_YESTERDAY: 'Expired yesterday',
              BADGE_ALTAS_BAJAS: 'Adds and removals',
              TODAY: 'today',
              THIS_WEEK: 'this week',
              CATEGORIES: 'Categories',
            },
            EMPTY: {
              PENDING_TITLE: 'There are no suggestions to review',
              HISTORY_TITLE: 'No suggestion has been reviewed',
            },
            HISTORY_TABLE: {
              DECISIONS_COUNT: '{{count}} decisions',
              STORES_COUNT: '{{count}} stores',
              NO_DATA: 'No decisions were found for the applied filters',
              COLUMNS: {
                CATEGORY: 'Category',
                IMPACTED_STORES: 'Impacted stores',
                TYPE: 'Type',
                USER: 'User',
                DATE: 'Date',
                STATUS: 'Status',
              },
              STATUS_FILTER: {
                ALL: 'All statuses',
                APPROVED: 'Approved',
                REJECTED: 'Rejected',
                EXPIRED: 'Expired',
                PUBLISH_REJECTED: 'Mixed by store',
              },
              DATE_FILTER: {
                FROM: 'Date from',
                TO: 'Date to',
              },
              STATUS: {
                APPROVED: 'Approved',
                REJECTED: 'Rejected',
                EXPIRED: 'Expired',
                PUBLISH_REJECTED: 'Mixed by store',
              },
              TYPE: {
                ALTA: 'Add',
                BAJA: 'Removal',
                AMBAS: 'Both',
                ALTA_WITH_ALERT: 'Add with alert',
                BAJA_WITH_ALERT: 'Removal with alert',
                AMBAS_WITH_ALERT: 'Both with alert',
              },
            },
            PENDING_TABLE: {
              SUGGESTIONS_COUNT: '{{count}} suggestions',
              STORES_COUNT: '{{count}} stores',
              EDIT_STORES: 'Edit stores',
              NO_DATA_FOR_SEARCH: 'No suggestions were found for "{{search}}"',
              BULK: {
                SELECTED_LABEL: 'selected stores',
                WARNING_TITLE: 'There are suggestions with alerts',
                WARNING_MESSAGE:
                  'Only item-store links without alerts will be approved. Those with alerts will be grouped into a new suggestion',
                CONFIRM_WITHOUT_ALERTS: 'APPROVE WITHOUT ALERTS',
                REJECT_ALL: 'REJECT ALL',
                APPROVE_ALL: 'APPROVE ALL',
                APPROVE_ALL_NO_ALERT: 'APPROVE ALL WITHOUT ALERT',
              },
              COLUMNS: {
                CATEGORY: 'Category',
                STORES_TO_IMPACT: 'Stores to impact',
                TYPE: 'Type',
                USER: 'User',
                VALIDITY: 'Validity',
                ACTION: 'Action',
              },
              TYPE: {
                ALTA: 'Add',
                BAJA: 'Removal',
                AMBAS: 'Both',
                ALTA_WITH_ALERT: 'Add with alert',
                BAJA_WITH_ALERT: 'Removal with alert',
                AMBAS_WITH_ALERT: 'Both with alert',
              },
              STATUS: {
                APPROVED: 'APPROVED',
                REJECTED: 'REJECTED',
              },
              VALIDITY: {
                MINUTES: '{{val}} min',
                HOURS: '{{val}} hrs',
                DAYS: '{{val}} days',
              },
            },
            STORE_EDITOR_MODAL: {
              TITLE: 'Suggestion details',
              PRODUCT_FALLBACK: 'Product name',
              STORES_TOTAL: '{{count}} Stores',
              STORES_WITHOUT_ALERT: '{{count}} Without Alert',
              STORES_WITH_ALERT: '{{count}} With Alert',
              SEARCH: 'Search...',
              FILTER_ALL: 'All suggestions',
              FILTER_NORMAL: 'Removal',
              FILTER_ALERT: 'Removal with alert',
              FILTER_NORMAL_ADD: 'Add',
              FILTER_ALERT_ADD: 'Add with alert',
              SELECTED_COUNT: '{{selected}} / {{total}} selected',
              COL_STORE_ID: 'Store id',
              COL_STORE_NAME: 'Store name',
              COL_SUGGESTION: 'Suggestion',
              COL_NOTES: 'Notes',
              COL_APPLY: 'Apply',
              COL_STATUS: 'Status',
              SUGGESTION_NORMAL: 'Removal',
              SUGGESTION_ALERT: 'Removal with Alert',
              SUGGESTION_ADD: 'Add',
              SUGGESTION_ADD_ALERT: 'Add with Alert',
              SUGGESTION_BOTH: 'Both',
              SUGGESTION_BOTH_ALERT: 'Both with Alert',
              NOTE_BREAK_PCT: 'Breakage %',
              NOTE_NONE: '-',
              EMPTY_FILTER: 'There are no stores for the entered filter.',
              REJECT: 'REJECT',
              APPROVE: 'APPROVE',
              CLOSE: 'CLOSE',
              VIEW_DETAIL: 'View detail',
              TAB_SUGGESTIONS: 'Suggestions',
              TAB_PROCESS: 'Process',
              COL_STORES_COUNT: 'Stores',
              COL_STEPS: 'Steps',
              EMPTY_PROCESS: 'No steps available',
            },
          },
          PAGE_TITLE: 'Analyze the assortment',
          SUMMARY_PAGE_TITLE: 'Assortment detail',
          FILTERS: {
            TITLE: 'Filters',
            GROUP_DECISIONS: 'Decisions',
            GROUP_SETUP: 'Setup',
            GROUP_PRODUCTS: 'Products',
            DEPARTMENT: 'Department',
            CATEGORY: 'Category',
            SUBCATEGORY: 'Subcategory',
            STATE: 'State',
            ACTION_TYPE: 'Situation',
            RULE_TYPE: 'Rule type',
            ITEM_TYPE: 'Product type',
            SEARCH: 'Search',
            SEARCH_PLACEHOLDER: 'Search...',
          },
        },
      },
      PROMOTIONS: {
        TITLE: 'Promotions',
        CAMPAIGN: {
          TITLE: 'Campaign',
        },
        ACTIONS: {
          TITLE: 'Promotional Actions',
        },
      },
      PROMOTIONSV2: {
        TITLE: 'Promotions',
        CONFIGURATIONS: {
          TITLE: 'Configuration',
          RULES: {
            TITLE: 'Promotion Rules',
          },
          REFERENCE_PRICES: {
            TITLE: 'Reference Prices',
          },
          PROMOTIONAL_PROCESS: {
            TITLE: 'Promotional Processes',
          },
          MESSAGE_STRUCTURES: {
            TITLE: 'Message Structures',
          },
        },
        CAMPAIGN: {
          TITLE: 'Campaign ',
        },
        CALENDAR: {
          TITLE: 'Calendar',
        },
        PERIODS: {
          TITLE: 'Promotional Periods',
        },
        PROMOTIONAL_PERIOD: {
          TITLE: 'Promotional Periods',
        },
        ACTIONS: {
          TITLE: 'Actions',
        },
        PRODUCTIONLIST: {
          TITLE: 'Production List',
        },
        PRODUCTION_REPORTS: {
          TITLE: 'Operational reports',
        },
        PROMOTION_OUTPUT: {
          TITLE: 'Promotion output',
        },
        LOGISTICS_REPORT: {
          TITLE: 'Logistics report',
        },
        AVAILABLE_SPACES: {
          TITLE: 'Promotional material',
        },
        PROMOTION_REPORT: {
          TITLE: 'Promotion Report',
        },
        PROMOTION_PRODUCTION_LISTS: {
          TITLE: 'Promotion production lists',
        },
        MARKETPLACE: {
          TITLE: 'Marketplace',
        },
        REPORTS: {
          TITLE: 'Reports',
        },
      },
      SPACES: {
        REPLACE: {
          TITLE: 'Replacements',
          NEW_BTN: 'Replace',
          LIST_TITLE: 'Last replacements made',
        },
        REPORTS_TITLE: 'Reports',
        DECISIONS_TITLE: 'Decisions',
        ADMIN_TITLE: 'Administration',
        MATERIAL_PROM_TITLE: 'Promotional Material',
        CONFIG_TITLE: 'Configuration',
        INCONSISTENCIES: {
          TITLE: 'Inconsistencies',
        },
        FLOORPLANS: {
          TITLE: 'Layouts',
        },
        SPACES_TEMPLATES: {
          TITLE: 'Templates',
        },
        TITLE: 'Space Planning',
        TITLEV2: 'Space Planning',
        PLANOGRAMS: {
          TITLE: 'Planograms',
        },
        STRUCTURE: {
          TITLE: 'Structures',
        },
        GENERIC_SPACE: {
          TITLE: 'Generic Space',
        },
        SUPER_PLANOS: {
          TITLE: 'Super Planograms',
        },
        POPMATERIAL: {
          TITLE: 'POP Material',
        },
      },
      REPORTS: {
        TITLE: 'Reports',
        LIST: {
          TITLE: 'Reports Hub',
        },
      },
      SUPPLY: {
        TITLE: 'Smart Supply',
        SETUP: {
          TITLE: 'Setup',
          ORDER_SCHEDULE: 'Order Schedule',
          GENERAL: 'General',
          HOLIDAYS: 'Holidays',
          CAPACITIES: 'Capacity',
        },
        DECISIONS: {
          TITLE: 'Decisions',
          ORDER_CONTROL: 'Order Control',
        },
        ADMINISTRATION: {
          TITLE: 'Administration',
          IMPORTERS: 'Importers',
        },
      },
    },
    TEST_COMPONENT: {
      TEST_A: 'Frase de testing A',
      TEST_B: 'Frase de testing B',
      ANIDADA: {
        TEST_C: 'Frase de testing C',
      },
      TEST_D: 'Esta frase tiene {{val}} valor.',
      TEST_E: 'Esta frase tiene {{val}} valores, no {{val2}} ni {{val3}}.',
      TEST_F: 'Esta otra frase tiene {{val}} valor.',
      TEST_G: 'Esta frase tiene {{val}}, {{val2}} o {{val3}} valores.',
      TEST_H: 'Frase con {{val}} anidadoes',
      TEST_HB: 'VALORES MULTIPLES',
      TEST_I: 'Esta frase tiene {{val}} {{val2}}',
      TEST_I_sinfular: 'valor',
      TEST_I_plural: 'valores',
      TEST_J_ENUM: {
        '1': 'Asignado',
        '2': 'No Asignado',
      },
    },
    DATA_ENTRY_ADAPTATIONS: {
      TITLE: 'Data Entry Management',
      NEW_ITEM_BTN: 'New Data Entry',
      TABLE: {
        TYPE: 'Input Type',
        NAME: 'Name',
      },
      EDIT: {
        TRANSFORMATION_TYPES: {
          Constant: 'Constant',
          Negative: 'Negative',
          ToPercentage: 'To Percentage',
          Trim: 'Trim',
          TrimStart: 'Trim Start',
          TrimEnd: 'Trim End',
          ToBoolean: 'To Boolean',
          ConcatHeadersValues: 'Concat Headers Values',
          SubString: 'Sub String',
          PadLeft: 'Pad Left',
          PadRight: 'Pad Right',
        },
        UPLOADED_FILE: 'Uploaded File',
        STANDARD_LOAD: 'Standard Load',
        ONLY_FIRST_FIVE: 'Only the first 5 records are shown',
        CONFIGURE_TRANSFORMATION: 'Configure Transformation',
        SOURCE_COLUMN: 'Source Column',
        TARGET_COLUMN: 'Target Column',
        TRANSFORMATION: 'Transformation',
        ADD_TRANSFORMATION: 'Add Transformation',
        VALUE: 'Value',
        CHARACTER: 'Character',
        TOTAL_WIDTH: 'Total Width',
        PADDING_CHAR: 'Padding Character',
        INDEX: 'Index',
        LENGTH: 'Length',
        VALUE_FOR_TRUE: 'Value for True',
        TYPE_ENTRY: 'Input Type',
        NAME_INPUT: 'Name',
        TAB1: 'General Data',
        NEW_DATA_ENTRY: 'New Data Entry',
        NO_MAPPING_SUGGESTION: 'There is no source column suggestion for the target column',
      },
      COMP: {
        FILE_UPLOAD: {
          TITLE: 'Drag file here or click to select',
          SIZE_ERROR: 'File exceeds maximum allowed size',
          TYPE_ERROR: 'File type not allowed',
          ALL_FILES: 'All files',
          ACCEPTED_TYPES: 'Accepted file types: {{fileTypes}}',
        },
      },
    },
    HOME: {
      ROUTE: 'Home',
      TITLE: 'Welcome',
      PRICING_MODULE: 'Pricing',
      ASSORTMENT_MODULE: 'Assortment Planning',
      SMART_SUPPLY_MODULE: 'Smart Supply',
      PROMOTIONS_MODULE: 'Promotions',
      ITEM_MASTER_MODULE: 'Item Master',
      SPACE_MODULE: 'Space Planning',
      QUICK_ACCESS: 'Quick Access',
      PRICING_MODULE_RULES: 'Pricing - Pricing Rules',
      PRICING_MODULE_DESICIONS: 'Pricing - Pricing Decisions',
      ASSORTMENT_MODULE_ROL: 'Assortment Planning - Roles',
      ASSORTMENT_MODULE_STRATEGIES: 'Assortment Planning - Strategies',
      ASSORTMENT_MODULE_DECISIONS: 'Assortment Planning - Assortment Decisions',
      ITEM_MASTER_MODULE_ABM: 'Item Master - ABM',
      HELPS: 'Help',
      HELP_1: 'How to create a Margin Rule?',
      ARTICLE_BLOG_TITLE: 'Price Perceptions, Consumer Choices and the Compromise Effect',
      ARTICLE_BLOG_TITLE2: 'How to extract the most value from your retail data',
      READ_MORE_BTN: 'Read More',
      PRISMA_PRICES: 'Prisma Prices',
      COMPETITORS_PRICES: 'Competitor Prices',
      ARTICLE2_BLOG_TITLE: '“Canastas de Alimentos” : listas para comprar en un solo click',
      ARTICLE3_BLOG_TITLE: 'Is your pricing strategy not working? These could be the 4 reasons.',
      PRISMA_SPACES: 'Prisma Spaces',
      PRISMA_SPACES_SUB: 'For retailers who want to make their planograms more profitable',
    },
    PR: {
      STP: {
        COMP: {
          LIST: {
            TITLE: 'Competitors',
            DELETE_TTIP: 'Delete selected competitors',
            DELETE: 'Delete',
            FILTER_TTIP: 'Filter',
            VIEW_TTIP: 'View',
            VIEW_TABLE: 'Table only',
            VIEW_MAP: 'Map only',
            VIEW_TABLE_MAP: 'Map and table',
            NAME: 'Name',
            CODE: 'Code',
            BRAND: 'Brand',
            MARKER: 'Marker',
            EDIT_ROW: 'Edit',
            EDIT_ROW_DISABLED_TOOLTIP: 'Edit selected competitors',
            DELETE_ROW: 'Delete',
          },
          ROUTE: 'Prices / Setup',
          TITLE: 'Competitors',
          NEW_COMP_BTN: 'New Competitor',
          IMPORT_BTN: 'Import',
          IMPORT_OP1_314: 'Res. 314 Prices',
          IMPORT_OP2_COMP: 'Competitors Prices',
          FILTER_TTIP: 'Filter',
          FULLSCREEN_TTIP: 'Expand',
          EXITFULLSCREEN_TTIP: 'Reduce',
          VIEW_TTIP: 'View',
          VIEW_TABLE: 'Table only',
          VIEW_MAP: 'Map only',
          VIEW_TABLE_MAP: 'Map and table',
          EXPORT_TTIP: 'Export',
          IMPORT_TTIP: 'Import',
          PRINT_TTIP: 'Print',
          DELETE_TTIP: 'Delete selected competitors',
          DELETE: 'Delete',
          NAME: 'Name',
          CODE: 'Code',
          BRAND: 'Brand',
          MARKER: 'Marker',
          TYPE: 'Mechanic',
          CHANNEL: 'Channel',
          PROVINCE: 'State',
          LOCATION: 'Location',
          PRICEZONE1: 'Price Zone 1',
          PRICEZONE2: 'Price Zone 2',
          PRICEZONE3: 'Price Zone 3',
          NEW: 'New',
          INCOMPLETES: 'Incomplete',
          TITLE_FILTERS: 'Filters',
          MARKER_FILTER: 'Marker',
          OP1_ALL: 'All',
          OP2_MARKER: 'Marker',
          OP3_NO_MARKER: 'No Marker',
          BRAND_FILTER: 'Brand',
          OPERATION_TYPE_FILTER: 'Operation Type',
          PROVINCES_FILTER: 'State',
          LOCATION_FILTER: 'Location',
          CLEAN_FILTER_BTN: 'Clear',
          APPLY_FILTER_BTN: 'Apply',
          ADD_FILTER_BTN: 'Add filter',
          SEARCH_FILTERS: 'Search filters',
          MODAL_314: 'The 314 data was imported correctly',
          TITLE_FORM: 'New Competitor',
          SAVE_BTN: 'Save',
          BASIC_INFORMATION_TAB: 'Main Data',
          CODE_INPUT: 'Internal Code',
          EXTERNALCODE_INPUT: 'External Code',
          VALIDATION_CODE: 'The field must be greater than 0',
          NAME_INPUT: 'Name',
          BRAND_INPUT: 'Brand',
          MARKER_CHECK: 'Marker',
          MARKER_CHECK_TTP: 'Set competitor as Marker',
          ADRESS_INPUT: 'Address',
          MAP_DATA: 'Map Data',
          LATITUDE_INPUT: 'Latitude',
          VALIDATION_LATITUDE1: 'Latitude must be less than or equal to 90',
          VALIDATION_LATITUDE2: 'Latitude must be greater than or equal to -90',
          LONGITUDE_INPUT: 'Longitude',
          VALIDATION_LONGITUDE1: 'Longitude must be less than or equal to 180',
          VALIDATION_LONGITUDE2: 'Longitude must be greater than or equal to -180',
          CLASIFICATION_TAB: 'Classification',
          Nuevo: 'New',
          Incompleto: 'Incomplete',
        },
        SENSITIVITIES: {
          NEW_SENSITIVITIE: 'New sensitivity',
          SENSITIVITIE: 'Sensitivity',
          NAME: 'Name',
          COD: 'Code',
          SURVEYFREQUENCY: 'Survey Frequency',
          EXPIRATIONDAYS: 'Expiration days',
          VALIDITYINDAYS: 'Effective Days',
          VALIDATION_1: 'The field must be greater than 0',
          SAVE_BTN: 'Save',
          BASIC_INFORMATION_TAB: 'Main Data',
          DAYSTORELIEVE: 'Days to relieve',
          _weekday: {
            Monday: 'Monday',
            Tuesday: 'Tuesday',
            Wednesday: 'Wednesday',
            Thursday: 'Thursday',
            Friday: 'Friday',
            Saturday: 'Saturday',
            Sunday: 'Sunday',
          },
          _frecuency: {
            Daily: 'Daily',
            Weekly: 'Weekly',
            Biweekly: 'Biweekly',
            Monthly: 'Monthly',
            Biannual: 'Biannual',
            Annual: 'Annual',
            BiMonthly: 'Bimonthly',
            ThreeMonth: 'Quarterly',
            Never: 'Never',
          },
        },
        ROUND: {
          ROUTE: 'Prices / Setup',
          TITLE: 'Rounding Rules',
          NEW_ROUNDING_BTN: 'New Rounding Rule',
          FULLSCREEN_TTIP: 'Expand',
          EXITFULLSCREEN_TTIP: 'Reduce',
          PRINT_TTIP: 'Print',
          DELETE_TTIP: 'Delete selected rounding',
          DELETE: 'Delete',
          PRICE_TYPE: 'Price Type',
          SINCE: 'Since',
          TO: 'To',
          DIRECTION: 'Direction',
          TO_TOP_OP1: 'Up',
          NEAREST_OP2: 'Nearest',
          DOWN: 'Down',
          ROUNDING_TYPE: 'Rounding Type',
          WITHOUT_TERMINATIONS: 'Without Ending',
          TOLERANCE: 'Tolerance %',
          SKUS: '# Products',
          SKUS_TO_EXCLUDE: '# Products to Exclude',
          USERS: '# Users',
          DEFINE_ROUNDING_STP1: 'Setup Rounding',
          PRODUCT_SCOPE_STP2: 'Products Scope',
          STORE_SCOPE_STP3: 'Stores Scope',
          STP1: 'Step 1 - Setup Rounding',
          TITLE_FORM_NEW: 'New Rounding',
          TITLE_FORM_EDIT: 'Edit Rounding',
          PRICE_TYPE_INPUT: 'Starting Price Type',
          SINCE_INPUT: 'From',
          TO_INPUT: 'To',
          TOLERANCE_INPUT: 'Tolerance %',
          DIRECTION_INPUT: 'Direction',
          ROUNDING_TYPE_INPUT: 'Rounding Type',
          ROUNDING_UNITS_OP1: 'Rounding Units',
          TERMINATIONS_OP2: 'Endings',
          ROUNDING_UNITS_INPUT: 'Rounding Units',
          TERMINATIONS_INPUT: 'Endings',
          NEXT_BTN: 'Next',
          NEW_TERMINATION: 'New Ending',
          TERMINATION_MODAL_INPUT: 'Ending',
          NO_TERMINATION: 'No ending added',
          ADDED_TERMINATION: 'Added ending',
          ADDED_TERMINATIONS: 'Added endings',
          ADD_BTN: 'Add',
          STP2: 'Step 2 - Products Scope',
          ADD_ATTRIBUTE_BTN: '+',
          PREVIUS_BTN: 'Previous',
          STP3: 'Step 3 - Stores Scope',
          SAVE_BTN: 'Save',
          NONE: 'None',
          ALL: 'All',
          EXCLUDED: 'excluded',
          SEARCH: 'Search',
          milesimas: 'Thousandths ',
          centesimas: 'Hundredths ',
          decimas: 'Tenths ',
          unidades: 'Units ',
          decenas: 'Tens ',
          centenas: 'Hundreds ',
          miles: 'Thousands ',
          decenas_de_miles: 'Tens of thousands',
          Nearest: 'To the nearest',
          Down: 'Down',
          Up: 'Up',
        },
        RULES: {
          DELETE_MODAL: {
            TITLE_ONE: 'Do you want to remove {{val}}?',
            CONTENT: 'Suggestions pending approval will be discarded.\\n Suggestions that are manually approved or modified will be kept.',
            TITLE_MULTIPLE: 'Do you want to delete the selected rules ({{val}})?',
          },
          PARENT_STORE_TITLE: '{{val}} Relationships',
          PARENT_ITEM_TITLE: 'Product Relationships',
          PARENT_CATEGORY_TITLE: 'Category Relationships',
          COMPETENCE_TITLE: 'Competitive',
          MARGIN_TITLE: 'Margin',
          SELECT_ALL_SUBCATEGORY: 'Select all Subcategories',
          SELECT_ALL_CATEGORY: 'Select all Categories',
          ROUTE: 'Prices / Setup',
          TITLE: 'Pricing Rules',
          SUGGESTION_BTN: 'Generate Suggestions',
          GENERATE_SUGGESTIONS_TOOLTIP: 'In order to generate suggestions, you must select a category (only one) or items from the list.',
          GENERATE_SUGGESTIONS_TOOLTIP_WITH_CATEGORY_REQUIRED: 'You cannot generate suggestions for more than one category each time',
          GENERATE_SUGGESTIONS_TOOLTIP_WITH_CATEGORY_REQUIRED_MODAL_DESCRIPTION:
            'This can be applied in the advanced filter or from this same window. Once this selection is applied, the list will be filtered with the rules reached and you will be able to use the Generate Suggestion button (green color) to order it.',
          GENERATE_SUGGESTIONS_SELECTION: 'Suggestions will be generated regarding the following selected category: ',
          GENERATE_SUGGESTIONS_MODAL_DESCRIPTION:
            'Choose the category you want to generate suggestions for. If you already applied one in the filter, it comes preselected.',
          GENERATE_SUGGESTIONS_SCOPE_SELECTED: 'Suggestions will be generated for these {{val}} rules, over the chosen category:',
          GENERATE_SUGGESTIONS_SCOPE_SELECTED_ONE: 'Suggestions will be generated for this rule, over the chosen category:',
          GENERATE_SUGGESTIONS_SCOPE_FILTERED:
            'Suggestions will be generated for the {{val}} rules in the filtered list, over the chosen category.',
          GENERATE_SUGGESTIONS_SCOPE_MORE: 'and {{val}} more',
          GENERATE_SUGGESTIONS_SCOPE_FILTERS_IGNORED: 'List filters do not apply when rules are selected.',
          GENERATE_SUGGESTIONS_SCOPE_WARN_ITEM_STORE:
            'Heads up: the Product and Point of Sale filters do not narrow the generation, so it may reach more rules than you see in the list.',
          GENERATE_SUGGESTIONS_SCOPE_NOTICE: 'The list will stay filtered by the selected category.',
          GENERATE_SUGGESTIONS_CONFIRM_BTN: 'Generate',
          SUGGESTION_OP1_MARGIN: 'Margin',
          SUGGESTION_OP2_COMPETITION: 'Competition',
          NEW_RULE_BTN: 'New Rule',
          NEW_RULE_TITLE_MODAL: 'New Rule',
          RULE_TYPE_INPUT: 'Rule Type',
          ADDITIONAL_FILTERS: 'Additional filters',
          LEGEND_COMP: 'Competitive rules are triggered when a change in competitors prices is detected.',
          LEGEND_MARG: 'Margin rules are triggered when a change in supplier or manufacturing costs is detected.',
          LEGEND_P_STORES: 'Parent Rules of {{val}} are triggered every time the price of a {{val2}} parent is changed.',
          STORES_VAL: 'Stores',
          CATEGORY_VAL: 'Category',
          STORE_VAL: 'Store',
          LEGEND_P_ITEMS: 'Product relationships are evaluated each time a price of a parent product is changed.',
          LEGEND_P_CATEGORIES: 'Category relationship rules are evaluated each time a price of a parent category is changed.',
          CANCEL_BTN: 'Cancel',
          CREATE_BTN: 'Create',
          FILTER_TTIP: 'Filter',
          FULLSCREEN_TTIP: 'Expand',
          EXITFULLSCREEN_TTIP: 'Reduce',
          EXPORT_TTIP: 'Export',
          IMPORT_TTIP: 'Import',
          PRINT_TTIP: 'Print',
          DELETE_TTIP: 'Delete selected rules',
          DELETE: 'Delete',
          CLEAN_FILTERS: 'Clear Filters',
          SHOW_RULES: 'Select at least one filter to show the Rules',
          NAME: 'Name',
          TYPE: 'Type',
          STATE: 'State',
          COUNTRY: 'Country',
          ZONE: 'Zone',
          STORES: '# Stores',
          ITEMS: '# Products',
          MARGIN: 'Margin',
          MARGIN_MARKUP: 'Markup {{val}} %',
          MARGIN_AMOUNT: '$ {{val}}',
          MARGIN_KEEP_PERCENTAGE: 'Keeps margin %',
          MARGIN_KEEP_AMOUNT: 'Keeps margin $',
          MARGIN_BY_CATEGORY: 'By category',
          IPC: 'IPC %',
          LAST_MODIFICATION: 'Last modification',
          USER: 'User',
          TYPE_RULES: 'Price rules',
          SUGGESTIONS_GENERATED_SNACKBAR:
            'The process to generate suggestions was initiated. You will receive a notification when this process is completed.',
          INCLUDED_ITEMS: 'Included Products',
          ACCEPT_BTN: 'Accept',
          INCLUDED_STORES: 'Included Stores',
          TITLE_FILTERS: 'Filters',
          CATEGORY_FILTER: 'Category',
          SEARCH_CATEGORIES_FILTER: 'Search Categories',
          SUBCATEGORY_FILTER: 'Subcategories',
          SEARCH_SUBCATEGORIES_FILTER: 'Search Subcategories',
          RULE_TYPE_FILTER: 'Rule Type',
          USER_FILTER: 'User',
          SEARCH_USER_FILTER: 'Search User',
          CLEAN_FILTER_BTN: 'Clear',
          APPLY_FILTER_BTN: 'Apply',
          DEFINE_RULE_STP1: 'Setup Rule',
          PRODUCT_SCOPE_STP2: 'Products Scope',
          STORE_SCOPE_STP3: 'Stores Scope',
          STP3_STORE: 'Step 3 - Products Scope',
          STP2_STORE: 'Step 2 - Stores Scope',
          STP4_COMPETENCE: 'Step 5 - Limits by Competitor (Optional)',
          STP5_COMPETENCE: 'Step 6 - Margin and Variation Limits (Optional)',
          STP5_COMPETENCE_ALT: 'Step 5 - Margin and Variation Limits',
          STP3_MARGIN: 'Step 4 - Limits by Competitor (Optional)',
          STP4_MARGIN: 'Step 5 - Margin Limits (Optional)',
          STP4_MARGIN_ALT: 'Step 3 - Margin Limits (Optional)',
          STORE_SCOPE_STP5: 'Limits by Competitor (Optional)',
          STORE_SCOPE_STP6: 'Margin and Variation Limits (Optional)',
          TITLE_FORM_NEW: 'New Margin or Markup Rule',
          TITLE_FORM_EDIT: 'View Margin or Markup Rule',
          STP1: 'Step 1 - Setup Rule',
          NAME_INPUT: 'Name',
          QUERY: 'Description / Code',
          POSITION_TYPE_INPUT: 'Rule type',
          NO_COMPETITOR_LIMITS: 'No competitor limits',
          INDICATE_MARGIN_INPUT: 'Indicate margin',
          VALIDATION_MARGIN: 'The field must be less than 100',
          NEXT_BTN: 'Next',
          STP2: 'Step 2 - Products Scope',
          ADD_ATTRIBUTE_BTN: '+',
          SEARCH: 'Search',
          SEE_PROD: 'View Products',
          CODE: 'Code',
          BRAND: 'Brand',
          MANUFACTURER: 'Manufacturer',
          PRICE: 'Price $',
          COST: 'Cost $',
          PRICE_CHIP: 'Price: $',
          COST_CHIP: 'Cost: $',
          REFRESH_PRODUCTS: 'Refresh Products',
          REFRESH_STORES: 'Refresh Stores',
          SEE_STORE: 'View Stores',
          SELECT_PROD: 'Selected Products ',
          SELECT_STORE: 'Selected Stores ',
          FILTER_PROD: 'Filtered Products ',
          FILTER_STORE: 'Filtered Stores ',
          PRICE_TABLE: 'Price: $',
          COST_TABLE: 'Cost: $',
          ADD_PROD: 'Add Products to the list',
          CHANGE_FORM: 'Change Filters',
          PREVIUS_BTN: 'Previous',
          STP3: 'Step 3 - Stores Scope',
          SAVE_BTN: 'Save',
          EXIT_BTN: 'Exit',
          SKIP_BTN: 'Skip',
          SKIP_STEP_LINK: 'Skip this step',
          NONE: 'None',
          ALL: 'All',
          EXCLUDED: 'excluded',
          COMPETITORS_SCOPE_STP2: 'Competitors Scope',
          PARENT_CATEGORY_SCOPE_STP1: 'Products Scope',
          PARENT_PRODUCT_SCOPE_STP1: 'Setup Rule',
          PARENT_PRODUCT_SCOPE_STP2: 'Products Scope',
          PARENT_PRODUCT_SCOPE_STP3: 'Stores Scope',
          PARENT_PRODUCT_SCOPE_STP4: 'Item Relationship Rule Configuration',
          PARENT_PRODUCT_SCOPE_STP1_TITLE: 'Step 1 - Setup Rule',
          PARENT_PRODUCT_SCOPE_STP2_TITLE: 'Step 2 - Products Scope',
          PARENT_PRODUCT_SCOPE_STP3_TITLE: 'Step 3 - Stores Scope',
          PARENT_PRODUCT_SCOPE_STP4_TITLE: 'Step 4 - Summary',
          PARENT_STORE_SCOPE_STP1: 'Setup Rule',
          PARENT_STORE_SCOPE_STP2: 'Stores Scope',
          PARENT_STORE_SCOPE_STP3: 'Products Scope',
          PARENT_STORE_SCOPE_STP1_TITLE: 'Step 1 - Setup Rule',
          PARENT_STORE_SCOPE_STP2_TITLE: 'Step 2 - Stores Scope',
          PARENT_STORE_SCOPE_STP3_TITLE: 'Step 3 - Products Scope',
          PARENT_CATEGORY_STP1_TITLE: 'Paso 1 - Item scope',
          PARENT_CATEGORY_STP2_TITLE: 'Paso 2 - Store scope',
          PARENT_CATEGORY_STP3_TITLE: 'Paso 3 - Rule configuration',
          STORE_SCOPE_STP4: 'Stores Scope',
          COMPETITION_TITLE_FORM_NEW: 'New Competition Rule',
          COMPETITION_TITLE_FORM_EDIT: 'View Competition Rule',
          POSITIONING_INPUT: 'Positioning',
          PERCENT_MARGIN_OBJETIVE: '%',
          MIN_MARGIN_ERROR: 'Value must be greater than or equal to {{val}}%',
          MAX_MARGIN_ERROR: 'Value must be less than or equal to {{val}}%',
          ONLY_ALERT: 'Alert Only: Will generate an alert on the price decision screen but will not generate any change suggestion.',
          DO_NOTHING: 'Do nothing',
          IN_CASE: 'In case of not finding prices of Competitors:',
          PRICE_SUGGESTION_STEP5: 'The suggested price must be:',
          SELECTION_COMPETITORS_STEP5: 'Selection of competitors to calculate the limit:',
          RADIO_MIN_STEP5: 'At least one',
          RADIO_MAX_STEP5: 'At most one',
          RADIO_AVG_STEP5: 'Enter the',
          MORE: 'more',
          AND_THE: 'and the',
          COMPETITORS_STEP5: 'which competitors to select',
          COMPETITORS_STEP5_SECONDVALUE_CHEAP: 'cheaper',
          COMPETITORS_STEP5_SECONDVALUE_EXPENSIVE: 'more expensive',
          COMPETITORS_AVG_STEP5: 'with respect to the competitors to select in this step',
          SUGESSTION_LOW_STEP5: 'Suggest below Minimum',
          SUGESSTION_HIGH_STEP5: 'Suggest above Maximum',
          TITLE_COMPETITORS_STEP6:
            'Specific margin and variation guidelines can be defined for this rule. If you want to use the category guidelines, save the changes directly by skipping this step.',
          TITLE_COMPETITORS_STEP6_NOTICE: 'If this limit is configured, the category limits configuration will be overridden.',
          LINEAL_MARGIN_COMPETITORS_STEP6: 'Margin Guidelines',
          MIN_MARGIN_INPUT_STEP6: 'Margin Min %',
          MAX_MARGIN_INPUT_STEP6: 'Margin Max %',
          MIN_MARGIN_INPUT_STEP6_ALT: 'Minimum Margin ',
          MAX_MARGIN_INPUT_STEP6_ALT: 'Maximum Margin ',
          VARIATION_MARGIN_INPUT_STEP6: 'Significant Variation Margin $',
          MIN_SUGGESTION_MARGIN_INPUT_STEP6: 'Suggest below Minimum',
          MAX_SUGGESTION_MARGIN_INPUT_STEP6: 'Suggest above Maximum',
          VARIATION_PRICE_COMPETITORS_STEP6: 'Price Variation',
          MIN_VARIATION_PRICE_INPUT_STEP6: 'Maximum Decrease %',
          MAX_VARIATION_PRICE_INPUT_STEP6: 'Maximum Increase %',
          MIN_VARIATION_PRICE_INPUT_STEP6_ALT: 'Highest Lowest',
          MAX_VARIATION_PRICE_INPUT_STEP6_ALT: 'Maximum Upload',
          MIN_SUGGESTION_VARIATION_PRICE_INPUT_STEP6: 'Suggest below Minimum',
          MAX_SUGGESTION_VARIATION_PRICE_INPUT_STEP6: 'Suggest above the Maximum',
          MARGIN_OBJETIVE: 'Define Target Margin %',
          MARGIN_OBJETIVE_CATEGORY: 'Margin Objective by Subcategories',
          MARGIN_OBJETIVE_CATEGORY_HELP: 'Keep in mind that the Target Margin % must be complete in Guidelines and Strategies.',
          POSITION_AGAINST_INPUT: 'Position Yourself Against',
          POSITION_TREND_INPUT: 'If there is more than one trend to use',
          SURVEY_SOURCES_INPUT: 'Survey sources',
          STP2_COMP: 'Step 2 - Competitor Selection',
          STP2_COMP_BUTTON_TITLE: 'Select how you want to compare against your competitors.',
          MAINMARKET_TITLE: 'Markers',
          MAINMARKET_MSG: 'It will search the price of the Markers of each Point of Sale.',
          USE_TRADE_AREA_TITLE: 'Trade Area',
          USE_TRADE_AREA_MSG: 'It will search the price of the Competitors associated with the Trade Area of ​​each Point of Sale.',
          SELECT_COMPETITORS_TITLE: 'Selection of Competitors',
          SELECT_COMPETITORS_MSG: 'It will search for competitors who meet the criteria to be defined below',
          TRADE_AREA_CHECK: 'Only trade area',
          MARKERS_CHECK: 'Only markers',
          STP3_COMP: 'Step 3 - Products Scope',
          STP4_COMP: 'Step 4 - Stores Scope',
          STORE_PARENT_TITLE_FORM_NEW: 'New Rule Store Relationships',
          STORE_PARENT_TITLE_FORM_EDIT: 'View Rule Store Relationships',
          STORE_PARENT_INPUT: 'Store Relationships',
          STORE_PARENT_TTIP:
            'Only the stores that have not been assigned as related stores in other rules will appear in the list of parent stores.',
          SEARCH_PARENT: 'Search Parent',
          RELATIONSHIP_TYPE_INPUT: 'Child items position',
          RELATIONSHIP_TYPE_INPUT_STORE: 'Child stores position',
          DIFFERENCE_IN_INPUT: 'Condition',
          relationshipType_Price: 'Evaluate price',
          relationshipType_Margin: 'Evaluate margin',
          relationshipType_DeltaPrice: 'Clone parent item values',
          EVALUATE_PARENT_ITEM_PRICE: 'Evaluate parent item price',
          EVALUATE_PARENT_ITEM_MARGIN: 'Evaluate parent item margin',
          EVALUATE_PARENT_STORE_PRICE: 'Evaluate parent store price',
          EVALUATE_PARENT_STORE_MARGIN: 'Evaluate parent store margin',
          DIFFERENCE_IN_OPTION: 'Difference in',
          DIFFERENCE_INPUT: 'Value',
          DIFFERENCE_INPUT_NOT_ZERO:
            'The value must be different from 0 (Zero). If you want to replicate the value from the parent item, you must select “Match parent item margin/price” in the Condition field.',
          DIFFERENCE_INPUT_LENGTH: 'Value is invalid',
          TEXT_P_STORES: 'The {{val}} children will have {{val2}} {{val3}} father',
          CATEGORIES_INPUT: 'Categories*',
          CATEGORIES_INPUT_EXC: 'Categories Excluded*',
          CATEGORIES_TTIP: 'You must select at least one category, to select the subcategories',
          SEARCH_CATEGORIES: 'Search Categories',
          SUBCATEGORIES_INPUT: 'Subcategories*',
          SUBCATEGORIES_INPUT_EXC: 'Subcategories Excluded*',
          SUBCATEGORIES_TTIP: 'You must select at least one subcategory per selected category',
          SEARCH_SUBCATEGORIES: 'Search Subcategories',
          SELECT_ALL: 'Select all',
          VALIDATION_CATEGORY: 'You must select at least one category',
          VALIDATION_SUBCATEGORY: 'You must select at least one option for each selected category',
          GET_OUT_BTN: 'Exit',
          SAME_PRICE: 'the same price that ',
          SAME_MARGIN: 'The same margin as ',
          HIGHER: 'Higher',
          LOWER: 'Lower',
          UNDER: 'under',
          ABOVE: 'above',
          MAYOR: 'Higher',
          MINOR: 'Lower',
          TEXT_P_STORES_TS: 'a Price {{val}} in {{val2}} at the',
          ITEM_PARENT_TITLE_FORM_NEW: 'New Rule Product Relationships',
          ITEM_PARENT_TITLE_FORM_EDIT: 'View Rule Product Relationships',
          PARENT_RULE_GENERATE_SUGGESTION_TITLE: 'Generate Suggestions',
          PARENT_RULE_ONSAVE_GENERATE_SUGGESTION_CONTENT: 'The rule will be executed immediately',
          ITEM_PARENT_INPUT: 'Product Relationships',
          STORE_INPUT: 'Reference store',
          ITEM_PARENT_TTIP:
            ' Only those products that have not been assigned as related products in other rules will appear in the list of parent products.',
          TEXT_P_COMPETENCE: 'Position a {{val}} ',
          TEXT_P_COMPETENCE_TS: '{{val}} {{val2}} the {{val3}} ({{val4}}) of my competitors',
          TEXT_P_COMPETENCE_TRADEAREA: 'within {{val}} of each Store',
          TEXT_P_COMPETENCE_MARKERS: '| markers',
          TEXT_P_COMPETENCE_COMPETITORS_SELECTED: 'selected',
          TEXT_P_COMPETENCE_STP3: 'within {{val}} of each Store',
          TEXT_P_COMPETENCE_STP4: 'for selected items',
          TEXT_P_COMPETENCE_STP4_ALL: 'for all items ',
          TEXT_P_ACTUAL_MARGIN: '{{val}} {{val2}}',
          TEXT_P_MARGIN: 'Position with a {{val}} {{val2}}',
          TEXT_P_MARGIN_TS_1: 'for selected items',
          TEXT_P_MARGIN_TS_2: 'in the required regions ',
          TEXT_P_MARGIN_POSITION: '{{val}} of{{val2}}',
          TEXT_P_MARGIN_POSITION_0: 'Margin',
          TEXT_P_MARGIN_POSITION_1: 'Margin',
          TEXT_P_MARGIN_POSITION_2: 'Keep current margin in %',
          TEXT_P_MARGIN_POSITION_4: 'Keep current margin in $',
          TEXT_P_MARGIN_POSITION_5: 'Target margin by Zone',
          TEXT_P_MARGIN_POSITION_6: 'Markup',
          TEXT_P_MARGIN_POSITION_7: 'Category Margin',
          MARGIN_POSITION_TYPE_0: 'Margin in %',
          MARGIN_POSITION_TYPE_1: 'Margin in $',
          MARGIN_POSITION_TYPE_2: 'Keep current margin in %',
          MARGIN_POSITION_TYPE_4: 'Keep current margin at $',
          MARGIN_POSITION_TYPE_5: 'Target margin per Zone',
          MARGIN_POSITION_TYPE_6: 'Markup in %',
          MARGIN_POSITION_TYPE_7: 'Category Margin',
          LEGEND_RULE_TITLE: 'RULE: ',
          TEXT_P_ITEMS: 'Related Products will have {{val}} {{val2}}',
          TEXT_P_ITEMS_VARIANT: 'Related Products will have the same Delta Price to {{val}}',
          TEXT_P_ITEMS_TS: 'a {{val}} Price by {{val2}} than ',
          TEXT_P_ITEMS_TS_MARGEN: 'a Margin by {{val}} than ',
          TEXT_P_STORE: 'Related Stores will have {{val}} {{val2}}',
          TEXT_P_STORE_VARIANT: 'Related Stores will have the same Delta Price to {{val}}',
          SEARCH_RESULT_CHILD_STORE: '{{val}} Stores will be affected by this rule.',
          TEXT_P_STORE_TS: 'a Price {{val}} in {{val2}} to ',
          TEXT_P_STORE_TS_MARGEN: 'A margin of {{val}} in {{val2}} ',
          MARK_AS_ZONE: 'Mark as Zone',
          MARK_AS_ZONE_TTIP: 'Same price for all areas',
          STRATEGY: 'Choose the selection strategy of the child products',
          STRATEGY_ATTR_TITLE: 'Selection by attribute (Dinamic)',
          STRATEGY_ATTR_MSG:
            'Attributes are selected to define the scope of products, if the scope changes, the impact of this setting is done automatically and does not need to be changed',
          STRATEGY_STORE_ATTR_MSG: 'Attributes are selected to define the scope of stores',
          STRATEGY_PROD_TITLE: 'Selection by product',
          STRATEGY_STORE_TITLE: 'Selection by store',
          STRATEGY_PROD_MSG: 'Products should be selected one by one',
          STRATEGY_STORE_MSG: 'Stores should be selected one by one',
          STP3_PARENT_ITEM: 'Step 3 - Stores Scope',
          GENERIC_MSG_ERRROR_EXECSUGGESTION: 'Suggestions could not be generated.',
          GENERIC_MSG_NOSUGGESTIONS_EXECSUGGESTION: 'There are no new suggestions.',
          NO_DIFF: 'No Difference',
          LEVEL_SELECT: 'Select Category Tree Level',
          RULE_NAME: 'Rule name',
          RULE_CONDITION: 'Condition',
          RULE_CLONE_PARENT_ITEMS: 'The child items will clone any price or margin modification of the parent item.',
          RULE_SAME_PRICE_PARENT_ITEM: 'Child items will maintain the same {{val}} as the parent item.',
          RULE_PRICE_POSITION: 'Child items will position with a {{val}} of {{val2}} relative to the parent item.',
          RULE_PRICE: 'price',
          RULE_MARGIN: 'margin',
          RULE_ITEM_PARENT_SELECTED: 'Parent item selected',
          RULE_ITEM_CHILD_SELECTED: 'Child items selected',
          RULE_PRICE_UPDATE_ON_CHILD:
            'Any price modification on the parent item will be replicated in the child items according to the configuration.',
          RULE_POINT_OF_SALE_SELECTED: 'Selected points of sale',
          RULE_REMEMBER_PARENT_ITEM_INDEPENDENT:
            'Remember that since it is an item relationship rule, the parent item is independent of the point of sale.  ',
          RULE_REMEMBER_CHECK_ASSORTMENT:
            'Remember to check the assortment of the points of sale to ensure that the child items are included.',
          RULE_CLONE_CHILD_ITEMS: 'Child items will clone any price or margin modification from the parent item.',
        },
        BRAND: {
          ROUTE: 'Prices / Setup',
          TITLE: 'Brands',
          NEW_BRAND_BTN: 'New Brand',
          FULLSCREEN_TTIP: 'Expand',
          EXITFULLSCREEN_TTIP: 'Reduce',
          DELETE_TTIP: 'Delete selected brands',
          DELETE: 'Delete',
          NAME: 'Name',
          LOGO: 'Logo',
          COLOR: 'Color',
          TITLE_FORM_NEW: 'New Brand',
          SAVE_BTN: 'Save',
          BASIC_INFORMATION_TAB: 'Main Data',
          NAME_INPUT: 'Name',
          PICK_COLOR: 'Pick a color',
          CLEAN_COLOR_TTIP: 'Clean color',
          IS_ASIGNED: 'This flag is assigned to points of sale or competitors so it can not be eliminated',
          OWN_BRAND: 'Own Brand',
          BRAND_HAS_ASSOCIATED_STORES:
            'The brand has associated points of sale. Migrate the points of sale before deactivating it as an own brand.',
        },
        GUI_AND_STRA: {
          ROUTE: 'Prices / Setup',
          TITLE: 'Guidelines and Strategies',
          BUSINESS_UNIT: 'Business Unit',
          SELECT_BUSINESS_UNIT: 'Select a business unit to see categories',
          GENERAL_CONFIG_BUTTON: 'GENERAL CONFIGURATION',
          GENERAL_CONFIG_EDIT_TOOLTIP: 'Edit General Configuration',
          GENERAL_CONFIG_CREATE_TOOLTIP: 'Create General Configuration - You must configure validation conditions before continuing',
          GENERAL_CONFIG_WARNING_MESSAGE: 'No general configuration',
          GENERAL_CONFIG_WARNING_FULL_MESSAGE:
            'Configure Validation Conditions for price changes, Reference competitor price calculation method, and other parameters',
          ASSORTMENTV2: {
            SETUP: {
              GUIDELINES: 'Guidelines',
              EDIT_GUIDELINES: 'Edit Guidelines',
              CONFIGURE_GUIDELINES: 'Configure Guidelines',
              GENERAL_CONFIG_WARNING_FULL_MESSAGE: 'General Configuration must be configured',
              GENERAL_CONFIG_DIALOG_TITLE: 'General Configuration',
              GENERAL_CONFIG_TAB_MAIN_DATA: 'Main Data',
              GENERAL_CONFIG_TAB_ALERTS_VALIDATIONS: 'Alerts and Validations',
              ALERTS_VALIDATIONS: {
                DESCRIPTION: 'Alerts and Validations to ensure that suggestions meet your business conditions.',
              },
              NEW_PRODUCTS: {
                TITLE: 'NEW PRODUCTS:',
                DESCRIPTION: 'These are products that have less than 30 days since their registration date',
                INTRO: 'Set how many days a product is considered new and from which event the days are counted.',
                DAYS_LABEL: 'Days',
                DAYS_DESCRIPTION: 'considered new since its',
                DAYS_HINT_TEMPLATE: 'For {{val}} days since its {{val2}}.',
                EVENT_SELECTOR_TITLE: 'From which event are the days counted?',
                EVENT_SELECTOR_HELP: 'Choose the reference that starts the count.',
                SUMMARY_TITLE: 'Summary',
                SUMMARY_TEMPLATE: 'It will be considered new for {{val}} days since its {{val2}}.',
              },
              NEW_PRODUCT_EVENT: {
                FIRST_ITEM_CREATION: 'Registration date',
                FIRST_ITEM_CREATION_DESC: 'A product is considered new since its creation date',
                FIRST_STOCK_RECORD: 'First stock record',
                FIRST_STOCK_RECORD_DESC: 'A product is considered new since its first stock record',
                FIRST_SALES_RECORD: 'First sales record',
                FIRST_SALES_RECORD_DESC: 'A product is considered new since its first sales record',
              },
              ANALYSIS_PERIOD: {
                TITLE: 'Analysis Period',
                DESCRIPTION:
                  'In this step you can define the period in months that will be taken to perform the analysis. To normalize and be able to compare, you will always see average values expressed in 30 days in reports and Pareto.',
                LATEST_INPUT: 'Last',
                LATEST_MONTHS_INPUT: 'Last months',
                MONTHS: 'Months',
                MONTHS_VALIDATION: 'The number of months cannot be greater than the selected months',
                MONTHS_SELECTOR_TITLE: 'Months to include',
                MONTHS_SELECTOR_HELP: 'Choose which months are included in the average.',
                SELECTED_COUNT: 'Selected: {{val}} of {{val2}}',
                SUMMARY_TITLE: 'Summary',
                SUMMARY_EMPTY: 'Set the period to see the summary.',
                SUMMARY_TEMPLATE: 'The last {{val}} months will be analyzed. Included months: {{val2}}.',
                NO_MONTHS_SELECTED: 'None',
                MONTH_COUNT_SINGULAR: '{{val}} month',
                MONTH_COUNT_PLURAL: '{{val}} months',
                LEGEND:
                  'If you exclude a month from the list, it will not be taken into account as part of the average. If the number of selected months is less than the selected period, the average will be calculated with the number of available months.',
                JANUARY: 'JAN',
                FEBRUARY: 'FEB',
                MARCH: 'MAR',
                APRIL: 'APR',
                MAY: 'MAY',
                JUNE: 'JUN',
                JULY: 'JUL',
                AUGUST: 'AUG',
                SEPTEMBER: 'SEP',
                OCTOBER: 'OCT',
                NOVEMBER: 'NOV',
                DECEMBER: 'DEC',
              },
              VALIDATION_MODAL: {
                CREATE_TITLE: 'Configure new validation',
                EDIT_TITLE: 'Edit validation',
                STEP1_LABEL: 'Criterion',
                STEP2_LABEL: 'Action',
                RANGE_TITLE: 'Variation range',
                RANGE_SUBTITLE: 'Select Variable, Condition and Numeric value for the selected criterion',
                FIELD_VARIABLE: 'Variable',
                FIELD_CONDITION: 'Condition',
                FIELD_NUMERIC_VALUE: 'Value',
                ACTION_VALIDATE: 'Validate',
                ACTION_VALIDATE_DESCRIPTION: 'Forces validation within the configured range',
                BANNER_IF_IN_SUGGESTION: 'If in the suggestion of',
                LEVEL_ALTA: 'High',
                LEVEL_BAJA: 'Low',
                BANNER_THEN_SYSTEM: 'then the system must',
                BANNER_SUGGESTED_PRICE: 'the suggested price',
                PLACEHOLDER_LEVEL: 'High/Low',
                PLACEHOLDER_VARIABLE: 'Variable',
                PLACEHOLDER_COMPARATOR: 'Comparator',
                PLACEHOLDER_VALUE: 'Value',
                PLACEHOLDER_SYSTEM_ACTION: 'System action',
                VARIABLE_OUTOFSTOCK: '% Out of stock',
                VARIABLE_PRESENCE: '% Presence',
                VARIABLE_COVERAGE: '% Coverage',
                VARIABLE_GMROI: 'GMROI',
                VARIABLE_GMROS: 'GMROS',
                ERROR_MAX_PERCENTAGE: 'Value cannot be greater than 100 for percentage variables',
              },
              ROLE: {
                TITLE: 'Category Role',
                DESCRIPTION: 'Select the role that defines the strategic behavior of this category.',
                SELECT_LABEL: 'Role',
                DESTINATION: 'Destination',
                ROUTINE: 'Routine',
                CONVENIENCE: 'Convenience',
                SEASONAL: 'Seasonal',
              },
              DEPARTMENT_FILTER: 'Department',
              DELETE_TITLE_MODAL: 'Delete',
              DELETE_SUBTITLE_MODAL: 'Are you sure you want to delete?',
            },
            DECISIONS: {
              NO_DEFAULT_CONFIG: 'No default configuration was found, please contact the system administrator.',
              FILTERS: {
                TITLE: 'Filters',
                PRODUCT_HIERARCHY: 'Product hierarchy',
                HIERARCHY_LEVEL_1: 'Business',
                HIERARCHY_LEVEL_2: 'Business Unit',
                HIERARCHY_LEVEL_3: 'Department',
                HIERARCHY_LEVEL_4: 'Category',
                HIERARCHY_LEVEL_5: 'Subcategory',
                DEPARTMENT: 'Department',
                CATEGORY: 'Category',
                SUBCATEGORY: 'Subcategory',
                ITEM_TAGS: 'Item tags',
                STORE_TAGS: 'Store tags',
                DATES: 'Dates',
                DATE_FROM: 'From',
                DATE_TO: 'To',
              },
              STRUCTURE: {
                TITLE: 'Structure',
                ADD_PLACEHOLDER: 'Add...',
                ADD_GROUPER: 'ADD GROUPER',
                NO_RESULTS: 'No results',
                CLEAR_STRUCTURE: 'Clear structure',
                LOAD_VIEW: 'Load view',
                DEFAULT_VIEW: 'Default view',
                SAVE_VIEW: 'SAVE VIEW',
                SAVE_VIEW_DIALOG_TITLE: 'Save view',
                SAVE_VIEW_OVERWRITE: 'Overwrite',
                SAVE_VIEW_CREATE_NEW: 'Create new',
                SAVE_VIEW_NAME_LABEL: 'View name',
                SAVE_VIEW_NAME_PLACEHOLDER: 'Assign a name to this configuration',
                SAVE_VIEW_NAME_REQUIRED: 'Name is required',
                SAVE_VIEW_MAX_CHARS: 'Maximum 60 characters',
                SAVE_VIEW_SAVE_BTN: 'Save',
                SAVE_VIEW_SUMMARY: 'Configuration summary',
                SAVE_VIEW_STRUCTURE: 'Structure',
                SAVE_VIEW_LEVELS: 'levels',
                SAVE_VIEW_SELECTED_VALUES: 'Selected values',
                SAVE_VIEW_VARIABLES: 'variables',
              },
              TABLE: {
                HEADER: 'Header',
                SUGGESTIONS: 'Suggestions / Decisions',
                SUGGESTIONS_ADD: '+',
                SUGGESTIONS_REMOVE: '-',
                VIEW_DETAIL: 'View detail',
                VENTAS_AMOUNT: 'Sales $',
                VENTAS_UNITS: 'Sales Units',
                MARGEN: 'Margin $',
                MARGEN_ACUERDOS: 'Margin w/ agreements',
                DESCUENTOS: 'Discounts $',
                PRECIO: 'Price',
                PRESENCIA: 'Presence',
                TICKETS: 'Tickets',
                TICKETS_TOTAL: 'Tickets Total',
                STOCK_AMOUNT: 'Stock $',
                STOCK_AMOUNT_ACTUAL: 'Stock $ Actual',
                STOCK_UNITS: 'Stock Units',
                STOCK_UNITS_ACTUAL: 'Stock Units Actual',
                MERMA_UNITS: 'Shrinkage Units',
                DISPONIBILIDAD: 'Availability',
                QUIEBRES: 'Stockouts',
                DIAS_STOCK: 'Days of Stock',
                DIAS_STOCK_ACTUAL: 'Days of Stock Actual',
                GMROI: 'GMROI',
                VENTAS_MERCADO: 'Market Sales $',
                VENTAS_UN_MERCADO: 'Market Sales Units',
                PRECIO_MERCADO: 'Market Price',
                VENTAS_MERCADO_RANK: 'Market Sales $ Rank',
                VENTAS_UN_MERCADO_RANK: 'Market Sales Units Rank',
                VENTAS_UN_GAP: 'Sales Units GAP',
                SEARCH: 'Search...',
                FILTERS_TOOLTIP: 'Filters',
                COLUMNS_TOOLTIP: 'Columns',
                FULLSCREEN_TOOLTIP: 'Expand',
              },
              SUMMARY_TABLE: {
                NO_FILTER_ALERT: 'To enable editing, select an option from the Filters menu on the left',
                INCLUDE_NEW_ITEMS: 'Include new items',
                INCLUDE_NEW_ITEMS_LABEL: 'Include ',
                INCLUDE_NEW_ITEMS_BADGE: 'New',
                ITEM_NEW: 'New',
                ITEM_CODE: 'Code',
                CLUSTER: 'Cluster',
                PARETO: 'Pareto',
                SALES_AMOUNT: 'Sales $',
                SALES_UNITS: 'Sales Units',
                MARGIN: 'Margin %',
                SUGGESTIONS: 'Suggestions',
                NO_SUGGESTIONS: 'No suggestions',
                RESULTS: 'results',
                ACTIVE_STORES: 'Active Stores',
                ACTIVE_STORES_TOOLTIP: 'Active stores / Total stores with sales',
                CLUSTERS: 'Clusters:',
                CLUSTERS_LABEL: 'Clusters',
                CLUSTERS_VISIBLE: 'clusters to display',
                CLUSTERS_TOTAL_GENERAL: 'Total General',
                CLUSTERS_ADD_LABEL: 'Add Label',
                CLUSTERS_APPLY: 'Apply',
                CLUSTERS_SEARCH: 'Search...',
                CLUSTERS_NO_TAGS: 'No labels available',
                CLUSTERS_NO_VALUES: 'No results',
                CLUSTERS_SELECT_VALUES: 'Select values',
                CLUSTERS_REMOVE: 'Remove',
                CLUSTERS_VISIBLE_PANEL_TITLE: 'Clusters to display',
                CLUSTERS_MAX_REACHED: 'Limit of 20 clusters reached. Uncheck one to add another.',
                ADD_MULTI_VARIABLE_ANALYSIS: 'Add multivariable analysis',
                EDIT_MULTI_VARIABLE_ANALYSIS: 'Edit multivariable analysis',
                BULK_REJECT_ALL: 'REJECT ALL',
                BULK_PRE_APPROVE_ALL: 'PRE-APPROVE ALL',
                BULK_PRE_APPROVE_ALL_NO_ALERT: 'PRE-APPROVE ALL WITHOUT ALERT',
                ROW_MENU_TOOLTIP: 'Actions',
                ROW_MENU_ACCEPT: 'Pre-approve',
                ROW_MENU_REJECT: 'Reject',
                ROW_MENU_VIEW_DETAIL: 'View detail',
                WEIGHTED_INDEX: 'WI%',
                WEIGHTED_INDEX_SCORE: 'WI score',
                MULTIVARIABLE_TITLE: 'Multivariable analysis',
                MULTIVARIABLE_STEP_1: 'Step 1',
                MULTIVARIABLE_STEP_2: 'Step 2',
                MULTIVARIABLE_STEP_1_DESCRIPTION: 'Select variables for the weighted index calculation.',
                MULTIVARIABLE_STEP_2_DESCRIPTION: 'Select the weight for each variable.',
                MULTIVARIABLE_CLEAR: 'Clear',
                MULTIVARIABLE_NEXT: 'Next',
                MULTIVARIABLE_BACK: 'Back',
                MULTIVARIABLE_APPLY: 'Apply',
                MULTIVARIABLE_WEIGHTED_CALC: 'Weighted Index Calculation',
                MULTIVARIABLE_TOTAL: 'Total',
                MULTIVARIABLE_TOTAL_MUST_BE_100: 'Total must be exactly 100%.',
                MULTIVARIABLE_MIN_TWO_VARS: 'Select at least two variables.',
                MULTIVARIABLE_MAX_FIVE_VARS: 'You can select up to 5 variables. Uncheck one to choose another.',
                MULTIVARIABLE_GROUP_CLASSIFICATION: 'Classification',
                MULTIVARIABLE_GROUP_PERFORMANCE: 'Performance',
                MULTIVARIABLE_GROUP_TICKETS: 'Tickets',
                MULTIVARIABLE_GROUP_STOCK: 'Stock',
                MULTIVARIABLE_GROUP_MARKET: 'Market',
                MULTIVARIABLE_VAR_STOCK_AMOUNT: 'Stock $',
                MULTIVARIABLE_VAR_CURRENT_STOCK_AMOUNT: 'Current Stock $',
                MULTIVARIABLE_VAR_STOCK_UNITS: 'Stock Units',
                MULTIVARIABLE_VAR_CURRENT_STOCK_UNITS: 'Current Stock Units',
                MULTIVARIABLE_VAR_SALES_AMOUNT: 'Sales $',
                MULTIVARIABLE_VAR_SALES_UNITS: 'Sales Units',
                MULTIVARIABLE_VAR_SALES_UNITS_GAP: 'Sales Units GAP',
                MULTIVARIABLE_VAR_MARGIN: 'Margin %',
                MULTIVARIABLE_VAR_MARGIN_WITH_VENDORS: 'Margin with agreements',
                MULTIVARIABLE_VAR_DISCOUNTS: 'Discounts $',
                MULTIVARIABLE_VAR_PRICE: 'Price',
                MULTIVARIABLE_VAR_PRESENCE: 'Presence',
                MULTIVARIABLE_VAR_SUGGESTIONS: 'Suggestions',
                MULTIVARIABLE_VAR_DECISIONS: 'Decisions',
                MULTIVARIABLE_VAR_TICKETS: 'Tickets',
                MULTIVARIABLE_VAR_TICKETS_TOTAL: 'Total Tickets',
                MULTIVARIABLE_VAR_MERMA_UNITS: 'Shrinkage Units',
                MULTIVARIABLE_VAR_AVAILABILITY: 'Availability',
                MULTIVARIABLE_VAR_STOCKOUTS: 'Stockouts',
                MULTIVARIABLE_VAR_DAYS_IN_STOCK: 'Days in Stock',
                MULTIVARIABLE_VAR_CURRENT_DAYS_IN_STOCK: 'Current Days in Stock',
                MULTIVARIABLE_VAR_GMROI: 'GMROI',
                MULTIVARIABLE_VAR_MARKET_SALES: 'Market Sales $',
                MULTIVARIABLE_VAR_MARKET_UNITS: 'Market Sales Units',
                MULTIVARIABLE_VAR_MARKET_PRICE: 'Market Price',
                MULTIVARIABLE_VAR_MARKET_SALES_RANK: 'Market Sales $ Rank',
                MULTIVARIABLE_VAR_MARKET_UNITS_RANK: 'Market Sales Units Rank',
                REFERENCE_CLUSTER: 'Reference cluster',
                SET_AS_REFERENCE: 'Set as reference cluster',
                COLUMNS: 'Columns',
                COLUMN_PICKER_TITLE: 'Column selection and order',
                COLUMN_PICKER_CANCEL: 'CANCEL',
                COLUMN_PICKER_ACCEPT: 'APPLY',
                COLUMN_PICKER_EMPTY: 'Select at least one column.',
                COLUMN_PICKER_ORDER_TITLE: 'Column order',
                COLUMN_PICKER_ORDER_HINT: 'Drag rows to set the order. Only visible columns are listed.',
                METRIC_GROUP_INDICES: 'Indices & ranking',
                METRIC_GROUP_SALES: 'Performance',
                METRIC_GROUP_STORE_OPERATIONS: 'Stock & operations',
                METRIC_GROUP_MARKET: 'Market',
                METRIC_RANK_IN_CLUSTER: 'Rank in cluster',
                METRIC_WEIGHTED_INDEX_SCORE: 'IP %',
                METRIC_ACTIVE_STORE_COUNT: 'Active stores',
                METRIC_STORES_WITH_SALES: 'Stores with sales',
                METRIC_DECISIONS: 'Decisions',
                METRIC_MARGIN: 'Margin $',
                METRIC_MARGIN_WITH_VENDORS: 'Margin with agreements',
                METRIC_DISCOUNTS: 'Discounts $',
                METRIC_PRICE: 'Price',
                METRIC_PRESENCE: 'Presence',
                METRIC_TICKETS: 'Tickets',
                METRIC_TICKETS_TOTAL: 'Total tickets',
                METRIC_STOCK_AMOUNT: 'Stock $',
                METRIC_CURRENT_STOCK_AMOUNT: 'Current stock $',
                METRIC_STOCK_UNITS: 'Stock units',
                METRIC_CURRENT_STOCK_UNITS: 'Current stock units',
                METRIC_MERMA_UNITS: 'Shrinkage units',
                METRIC_AVAILABILITY: 'Availability',
                METRIC_STOCKOUTS: 'Stockouts',
                METRIC_DAYS_IN_STOCK: 'Days in stock',
                METRIC_CURRENT_DAYS_IN_STOCK: 'Current days in stock',
                METRIC_GMROI: 'GMROI',
                METRIC_MARKET_SALES: 'Market sales $',
                METRIC_MARKET_UNITS: 'Market sales units',
                METRIC_MARKET_PRICE: 'Market price',
                METRIC_MARKET_SALES_RANKING: 'Market sales $ rank',
                METRIC_MARKET_UNITS_RANKING: 'Market units rank',
                METRIC_SALES_UNITS_GAP: 'Sales units GAP',
                METRIC_PARKING_CONTRIBUTION: 'Parking ctb.',
                PARKING_LABEL: 'Parking',
              },
              SUGGESTION_STEP: {
                STEP_PREFIX: 'Step {{stepNumber}}: {{stepTitle}}',
                STEP_TITLE_FALLBACK: 'Process',
                STEP_TITLE: {
                  UserGeneration: 'User generation',
                  PrismaGeneration: 'Prisma generation',
                  PrismaPrioritization: 'Prisma prioritization',
                  PrismaBlocking: 'Prisma blocking',
                  PrismaExclusionCheck: 'Exclusion rules check',
                  PrismaValidation: 'Prisma validation',
                  PrismaSuggestion: 'Prisma suggestion',
                },
                MESSAGE: {
                  UserGenerated:
                    'The user generated an {{action}} suggestion based on {{itemTagLabel}} {{conditionOperator}} {{conditionValue}}{{conditionValueSuffix}}',
                  PrismaGeneratedBoth: 'Prisma generated candidates for Add and Remove',
                  PrismaGenerationSkippedSingleDirection: 'Prisma skipped independent generation (type: {{action}})',
                  PrismaPrioritizationSkippedBlocked: 'Skipped — the candidate was already discarded',
                  PrismaPrioritizationCompleted: 'Prisma prioritized the {{action}} suggestion over an existing opposite one',
                  PrismaPrioritizationSkippedNoConflict: 'No opposing suggestion existed for this item-store pair',
                  PrismaExclusionCheckPassed: 'No exclusion rule applies to this pair',
                  PrismaExclusionCheckBlocked: "{{action}} suggestion blocked by assortment exclusion rule '{{ruleName}}'",
                  PrismaValidationSkippedExcluded: 'Skipped — the pair was already excluded',
                  PrismaValidationBlocked:
                    'Blocked by condition {{variable}} {{conditionOperator}} {{threshold}} (current value: {{actualValue}})',
                  PrismaValidationAlert: 'Prisma detected {{alertCount}} alert(s)',
                  PrismaValidationPassed: 'Prisma validated the pair with no issues',
                  PrismaSuggestionSkippedExcluded: 'Not generated — blocked by exclusion rule',
                  PrismaSuggestionSkippedBlocked: 'Not generated — blocked by validation rule',
                  PrismaSuggestionCompleted: 'Prisma generated the final {{action}} suggestion',
                },
                ACTION: {
                  Add: 'add',
                  Remove: 'remove',
                },
                CONDITION_OPERATOR: {
                  GreaterThan: 'greater than',
                  LessThan: 'less than',
                  Equals: 'equal to',
                },
                CONDITION_VALUE_SUFFIX: {
                  Percentage: '%',
                },
              },
            },
          },
          COLUMN_CATEGORY: 'Store / Category / Subcategory',
          COLUMN_CONFIGURATION: 'Configuration',
          COLUMN_PRICE_INDEX: 'Price Index',
          COLUMN_CURRENT_MARGIN: 'Current Margin %',
          COLUMN_TARGET_MARGIN: 'Target Margin %',
          COLUMN_MIN_MARGIN: 'Min Margin %',
          COLUMN_MAX_MARGIN: 'Max Margin %',
          COLUMN_CONFIGURATION_TOOLTIP: 'Indicates whether the category has custom or inherited configuration',
          COLUMN_PRICE_INDEX_TOOLTIP: 'Price index calculated based on configuration',
          COLUMN_CURRENT_MARGIN_TOOLTIP: 'Current category margin. Arrows indicate if it is above or below the target.',
          COLUMN_TARGET_MARGIN_TOOLTIP: 'Target margin configured for the category or inherited from its parent',
          COLUMN_MIN_MARGIN_TOOLTIP: 'Minimum margin allowed according to validation conditions',
          COLUMN_MAX_MARGIN_TOOLTIP: 'Maximum margin allowed according to validation conditions',
          CONFIG_TYPE_INHERITED: 'INHERITED',
          CONFIG_TYPE_CUSTOMIZED: 'CUSTOMIZED',
          WARNING_NO_CONFIGURATION: 'No configuration',
          WARNING_NO_PRICE_REFERENCE: 'No reference price',
          WARNING_NO_TARGET_MARGIN: 'No target margin',
          WARNING_NO_MIN_MARGIN: 'No minimum margin',
          WARNING_NO_MAX_MARGIN: 'No maximum margin',
          ACTION_EDIT_GUIDELINES: 'Edit guidelines',
          ACTION_CONFIGURE_GUIDELINES: 'Configure guidelines',
          MARGIN_ABOVE_TARGET: 'Margin above target',
          MARGIN_BELOW_TARGET: 'Margin below target',
          MARGIN_EQUALS_TARGET: 'Margin meets target',
          EXPORT_TTIP: 'Export',
          FULLSCREEN_TTIP: 'Expand',
          EXITFULLSCREEN_TTIP: 'Reduce',
          IMPORT_TTIP: 'Import',
          PRINT_TTIP: 'Print',
          CATEGORIES: 'Categories',
          RULES: 'Rules',
          RULES_TTIP: 'Number of price rules',
          TARGET_MARGIN: 'Target Margin %',
          TARGET_MARGIN_TTIP: 'Target Margin Percentage',
          MIN_MARGIN: 'Min Mg %',
          MIN_MARGIN_TTIP: 'Minimum Margin Percentage',
          MAX_MARGIN: 'Max Mg %',
          MAX_MARGIN_TTIP: 'Maximum Margin Percentage',
          ALLOW_MIN_VIOLATION: 'Sug. Under Min Mg',
          ALLOW_MIN_VIOLATION_TTIP:
            'If this box is checked, Prisma will suggest below the minimum margin, and will display a warning sign next to the suggestion. Otherwise the suggestion will consider the minimum value entered.\n',
          ALLOW_MAX_VIOLATION: 'Sug. On Max Mg',
          ALLOW_MAX_VIOLATION_TTIP:
            'If this box is checked, Prisma will suggest above the maximum margin, and will display a warning sign next to the suggestion, otherwise the suggestion will take you to the maximum value entered.',
          SIGNIFICANT_VAR_MARGIN: 'Significant Variation Mg $',
          SIGNIFICANT_VAR_MARGIN_TTIP: 'Significant Variation of Margin in $',
          MIN_VARIATION: 'Max Dec. %',
          MIN_VARIATION_TTIP: 'Maximum price decrease allowed per price change',
          MAX_VARIATION: 'Max Inc. %',
          MAX_VARIATION_TTIP: 'Maximum price increase allowed per price change',
          ALLOW_MIN_VARIATION: 'Sug. Above Max Dec.',
          ALLOW_MIN_VARIATION_TTIP:
            'If this box is checked, Prisma will suggest above the maximum decrease, and will display a warning sign next to the suggestion, otherwise the suggestion will take you to the maximum value entered.',
          ALLOW_MAX_VARIATION: 'Sug. Above Max Inc.',
          ALLOW_MAX_VARIATION_TTIP:
            'If this box is checked, Prisma will suggest above the maximum increase, and will display a warning sign next to the suggestion, otherwise the suggestion will take you to the maximum value entered.',
          SIGNIFICANT_VARIATION: 'Significant Variation $',
          SIGNIFICANT_VARIATION_TTIP: 'Significant Variation in $',
          SAVE_BTN: 'Save',
          BASIC_INFORMATION_TAB: 'Main Data',
          MARGIN_GUIDELINES: 'Margin Guidelines',
          TARGET_MARGIN_INPUT: 'Target Margin %',
          MIN_MARGIN_INPUT: 'Margin Min %',
          MAX_MARGIN_INPUT: 'Margin Max %',
          SIGNIFICANT_VAR_MARGIN_INPUT: 'Significant variation of margin $',
          ALLOW_MIN_VIOLATION_CHECK: 'Suggest below minimum',
          ALLOW_MIN_VIOLATION_CHECK_TTIP:
            'If this box is checked, Prisma will suggest below the minimum margin, and will show a warning sign next to the suggestion, otherwise the suggestion will take you to the minimum value entered.',
          ALLOW_MAX_VIOLATION_CHECK: 'Suggest above Maximum',
          ALLOW_MAX_VIOLATION_CHECK_TTIP:
            'If this box is checked, Prisma will suggest above the maximum margin, and will show a warning sign next to the suggestion, otherwise it will take the suggestion to the maximum value',
          VARIATION_PRICE: 'Price Variation',
          MIN_MARGIN_V_INPUT: 'Maximum Decrease %',
          MAX_MARGIN_V_INPUT: 'Maximum Increase %',
          SIGNIFICANT_VAR_MARGIN_V_INPUT: 'Significant Variation of Margin $',
          ALLOW_MIN_VIOLATION_V_CHECK: 'Suggest Below Minimum',
          ALLOW_MIN_VIOLATION_V_CHECK_TTIP:
            ' If this box is checked, Prisma will suggest above the maximum decrease, and will display a warning sign next to the suggestion, otherwise the suggestion will take you to the maximum value entered.',
          ALLOW_MAX_VIOLATION_V_CHECK: 'Suggest above Maximum',
          ALLOW_MAX_VIOLATION_V_CHECK_TTIP:
            ' If this box is checked, Prisma will suggest above the maximum increase, and will display a warning sign next to the suggestion, otherwise the suggestion will take you to the maximum value entered.',
          TITLE_MODAL: 'Impact changes to the next levels of the category tree',
          SUBTITLE_MODAL:
            'Do you want to establish these same guidelines for the following levels of the category tree, up to and including the subcategory level?',
          REFUSE_BTN: 'Cancel',
          ACCEPT_BTN: 'Accept',
          BRAND_LABEL: 'Own brand',
          BRAND_PLACEHOLDER: 'Select a brand',
          GENERAL_CONFIG_TITLE: 'General Guidelines Configuration',
          NO_GENERAL_CONFIG_TITLE: 'General Configuration Required',
          TAB_REFERENCE_PRICE: 'Reference Price',
          TAB_VALIDATION_CONDITIONS: 'Validation Conditions',
          TAB_MAIN_DATA: 'Main Data',
          CATEGORY_CONFIG_TITLE: 'Configure Category',
          TARGET_MARGIN_HINT: 'Specify the target margin percentage for this category',
          ERROR_TAB_INCOMPLETE: 'Complete the required fields in the "{{val}}" tab',
          AUTO_GENERATE_MARGIN_RULE: 'Generate price suggestions',
          AUTO_GENERATE_MARGIN_RULE_TOOLTIP:
            'By enabling this option, a margin rule will be created with the target margin of the category/subcategory.',
          AUTO_GENERATE_ACTIVE_DESC:
            'Upon changes in costs and/or taxes, Prisma will generate suggestions that seek to meet the target margin.',
          TARGET_MARGIN_PLACEHOLDER: 'Specify the target margin percentage',
          TARGET_MARGIN_MIN_ERROR: 'Value must be greater than or equal to {{val}}%',
          TARGET_MARGIN_MAX_ERROR: 'Value must be less than or equal to {{val}}%',
          CROSS_MIN_GREATER_THAN_TARGET: 'Min margin cannot be greater than target margin',
          CROSS_MAX_LESS_THAN_TARGET: 'Max margin cannot be less than target margin',
          CROSS_MIN_GREATER_THAN_MAX: 'Min margin cannot be greater than max margin',
          REFERENCE_PRICE: {
            TAB_TITLE: 'Configure Reference Price for general configuration',
            COMPETITOR_TITLE: 'Competitor',
            COMPETITOR_DESC: 'Select how you want to compare with your competitors',
            COMPETITOR_PRINCIPAL: 'Main Competitor',
            COMPETITOR_PRINCIPAL_DESC: 'Will search for the Main Competitor price of each Point of Sale.',
            COMPETITOR_TRADE_AREA: 'Trade Area',
            COMPETITOR_TRADE_AREA_DESC: 'Will search for the price of Competitors associated with the Trade Area of each Point of Sale.',
            COMPETITOR_SELECTION: 'Competitor Selection',
            COMPETITOR_SELECTION_DESC: 'Will search for competitors that meet the criteria to be defined below.',
            POSITION_TITLE: 'Position',
            POSITION_DESC: 'Select the position in which you want to compare against your competitor',
            POSITION_MIN: 'Minimum',
            POSITION_MIN_DESC: 'The lowest value',
            POSITION_MAX: 'Maximum',
            POSITION_MAX_DESC: 'The highest value',
            POSITION_AVERAGE: 'Average',
            POSITION_AVERAGE_DESC: 'The average of the values',
            POSITION_MODE: 'Mode',
            POSITION_MODE_DESC: 'The most repeated value',
            SOURCE_TITLE: 'Survey Sources',
            SOURCE_DESC: 'Select the source from where the information or data for this configuration is obtained',
            SOURCE_MYSTERY: 'Mystery Shopper App',
            SOURCE_APP: 'Prisma App',
            SOURCE_MANUAL: 'Manual Survey',
            ONLY_RELEVANT_COMPETITORS: 'Select only relevant competitors (Markers)',
            INCLUDE_FILTERS: 'Include',
            EXCLUDE_FILTERS: 'Exclude',
          },
          VALIDATION_CONDITIONS: {
            TITLE: 'Validation Conditions',
            DESCRIPTION: 'Alerts, Limits and Blocks to ensure that suggestions meet your business conditions.',
            AUTO_APPROVE_TITLE: 'Auto approve',
            AUTO_APPROVE_DESC:
              'If enabled, suggestions and price changes will be automatically approved, as long as they meet all validation conditions.',
            ADD_VALIDATION: 'ADD VALIDATION',
            NO_VALIDATIONS: 'No validations configured. Add a new validation to get started.',
            TABLE_PRIORITY: 'Priority',
            TABLE_CRITERION: 'Criterion',
            TABLE_ACTION: 'Action',
            TABLE_DESCRIPTION: 'Description',
            TABLE_MIN: 'Minimum',
            TABLE_MAX: 'Maximum',
            TABLE_ACTIONS: 'Actions',
            ACTION_ALERT: 'Alert',
            ACTION_LIMIT: 'Limit',
            ACTION_BLOCK: 'Block',
            CRITERION_MARGIN_PERCENTAGE: 'Margin %',
            CRITERION_MARGIN_AMOUNT: 'Margin $',
            CRITERION_PRICE_VARIATION_PERCENTAGE: 'Price variation %',
            CRITERION_PRICE_VARIATION_AMOUNT: 'Price variation $',
            CRITERION_COMPETENCE_LIMIT: 'Competition limit',
            CRITERION_MY_PRICE_VS_COMPETITOR_RANGE: 'My current price vs competitor range',
            QUICK_ADD_TITLE: 'Ensure price suggestions meet your business conditions',
            QUICK_ADD_SUBTITLE: 'Add validations to customize price suggestions',
            MODAL_CREATE_TITLE: 'Configure new validation',
            MODAL_EDIT_TITLE: 'Edit validation',
            STEP1_LABEL: 'Criterion and Range',
            STEP2_LABEL: 'System action',
            STEP_COMPETITOR_LABEL: 'Price Type and Competitor',
            STEP_DATA_SOURCES_LABEL: 'Survey and Data',
            CRITERION_TITLE: 'Criterion',
            CRITERION_DESCRIPTION: 'Select a criterion for price validation',
            RANGE_TITLE: 'Variation range',
            RANGE_DESCRIPTION: 'Select minimum and maximum for the selected criterion',
            MINIMUM: 'Minimum',
            MAXIMUM: 'Maximum',
            MIN_PLACEHOLDER: 'Indicate minimum in numbers',
            MAX_PLACEHOLDER: 'Indicate maximum in numbers',
            ACTION_TITLE: 'System action',
            ACTION_DESCRIPTION: 'Select the position in which you want to be against your competitor',
            ACTION_ALERT_DESCRIPTION: 'Allows suggestion outside the range, but notifies',
            ACTION_ALERT_DESCRIPTION_ASSORTMENT: 'Allows generating the suggestion, but emits a warning notification for non-compliance',
            ACTION_LIMIT_DESCRIPTION: 'Forces the suggestion within the range',
            ACTION_LIMIT_DESCRIPTION_ASSORTMENT: 'Blocks the generation of the suggestion if the value is outside the configured range',
            ACTION_BLOCK_DESCRIPTION: 'Blocks any suggestion outside the range',
            BANNER_TITLE: 'If in the suggested price...',
            BLOCK_LIMITS: 'Limits',
            DESC_RANGE_OUTSIDE: 'if outside the range {{min}}-{{max}}{{unit}}',
            DESC_RANGE_LESS: 'if less than {{min}}{{unit}}',
            DESC_RANGE_MORE: 'if greater than {{max}}{{unit}}',
            DESC_COMPETITOR_COMPARISON: ' vs {{competitor}}{{markers}}',
            DESC_MARKERS_RELEVANT: ' (relevant)',
            DESC_PRICE_TYPE: ' - {{priceType}}',
            DESC_DATA_SOURCES: ' ({{sources}})',
            COMPETITOR_TYPE_PRINCIPAL: 'Main Competitor',
            COMPETITOR_TYPE_TRADE_AREA: 'Trade Area',
            COMPETITOR_TYPE_SELECTION: 'Competitor Selection',
            BANNER_LESS_THAN: ' is less than ',
            BANNER_OR: ' or ',
            BANNER_GREATER_THAN: ' greater than ',
            BANNER_RESPECT_TO_RELEVANT: ' with respect to ',
            BANNER_RESPECT_TO: ' with respect to ',
            BANNER_RELEVANT_COMPETITORS_OF: 'the relevant competitors of',
            BANNER_OF_THE: ' of the ',
            BANNER_ACCORDING_TO: ', according to the surveyed data from ',
            BANNER_THROUGH: ' through',
            BANNER_AND: ' and ',
            BANNER_THEN: ', then ',
            BANNER_SUGGESTED_PRICE: ' the suggested price',
            BANNER_PLACEHOLDER_CRITERION: '[Criterion]',
            BANNER_PLACEHOLDER_COMPETITORS: '[Competitors]',
            BANNER_PLACEHOLDER_COMPETITOR_TYPE: '[Competitor type]',
            BANNER_PLACEHOLDER_PRICE_TYPE: '[Price type]',
            BANNER_PLACEHOLDER_SOURCE: '[Survey Source]',
            BANNER_PLACEHOLDER_ACTION: '[System action]',
            BLOCK_LIMITS_ASSORTMENT: 'Validations',
            BLOCK_BLOCKS: 'Blocks',
            BLOCK_ALERTS: 'Alerts',
            EMPTY_BLOCK: 'No validations in this category',
            BUTTON_BACK: 'Back',
            BUTTON_NEXT: 'Next step',
            BUTTON_SAVE: 'Save new validation',
            BUTTON_UPDATE: 'Update validation',
            PRICE_TYPE_TITLE: 'Surveyed price type',
            PRICE_TYPE_DESCRIPTION: 'Select which price type will be taken into account for this validation',
            PRICE_TYPE_REGULAR: 'Regular',
            PRICE_TYPE_PROMOTIONAL: 'Promotional',
            PRICE_TYPE_WHOLESALE: 'Wholesale',
            PRICE_TYPE_OTHER: 'Other',
            DATA_SOURCES_TITLE: 'Survey Sources',
            DATA_SOURCES_DESCRIPTION:
              'Select the source from which the surveyed price information or data is obtained for this configuration',
            DATA_SOURCE_MYSTERY_SHOPPER: 'Mystery Shopper App',
            DATA_SOURCE_PRISMA_APP: 'Prisma App',
            DATA_SOURCE_MANUAL: 'Manual Survey',
            DATA_SOURCE_OTHER: 'Other',
          },
          GENERAL_CONFIG_LOADING_TOOLTIP: 'Loading...',
        },
      },
      REPORTS: {
        ROUTE: 'Prices / Reports',
        SUGGESTIONREPORTS: {
          ROUTE: 'Prices / Reports',
          GENERATE: 'Generate report',
          TITLE: 'Suggestions Report',
          GENERATE_TITLE: 'Generate Suggestions Report',
          INPROCESS: 'Generating report',
          DAY: 'Day',
          INTRODUCTION: 'Generates a report with the details of all the suggestions from the selected day',
        },
        COSTREPORTS: {
          ROUTE: 'Prices / Reports',
          GENERATE: 'Generate report',
          TITLE: 'Cost Report',
          GENERATE_TITLE: 'Generate Cost Report',
          INPROCESS: 'Generating report',
          DAY: 'Day',
          INTRODUCTION:
            'Generates a report detailing all the filtered costs. From here you can select a date range of no more than 30 days to download costs.',
          PATH: 'Prices / Reports',
        },
        YPF: {
          ROUTE: 'Prices / Reports',
          TITLE: 'Reports YPF',
          FULLSCREEN_TTIP: 'Expand',
          EXITFULLSCREEN_TTIP: 'Reduce',
          COMPETITIVE_POSITION: 'Competitive Positioning',
          EXPORT_TTIP: 'Export',
          APP_TTIP: 'Share to the App',
          DASHBOARD_TTIP: 'Go to dashboard',
          COMPETITOR: 'Competitor',
          N2: 'N2',
          N3: 'N3',
          G2: 'G2',
          G3: 'G3',
          CHEAPER: 'Cheaper',
          EQUEAL_PRICE: 'Equal price',
          MORE_EXPENSIVE: 'More Expensive',
          PROVINCE_FILTER: 'Province',
          FILTER: 'Filter',
          LOCATION_FILTER: 'Location',
          BRANDS_FILTER: 'Brands',
          APPLY_BTN: 'APPLY FILTERS',
          COMPETITION_PRICES: 'Competition Prices',
          NS: 'NS',
          INF: 'INF',
          UD: 'UD',
          D500: 'D500',
          INF_D: 'INF D',
          INF_NS: 'INF vs NS',
          INFD_D500: 'INF D vs D500',
          RETAIL_MARGIN: 'Retail Margins',
          PRODUCTS_FILTER: 'Products',
          WARNING_CONTINUE_PLANEX: 'The action to be performed will send information to PLANEXWARE. Do you want to continue?',
        },
        DAILYMARGIN: {
          LIST: {
            TITLE: 'Daily Margins Reports',
            ROUTE: '/ prices / reports / daily-margin',
            DELETE: 'Delete',
            DELETE_TTIP: 'Delete',
            FILTER_TTIP: 'Filter',
            EXPORT: 'Download',
            EXPORT_TTIP: 'Export report on excel format',
            STORECODE: 'Store code',
            STORENAME: 'Store',
            ITEMCODE: 'Product code',
            ITEMNAME: 'Product',
            PRICE: 'Price',
            PRICEWOTAXES: 'Price without taxes',
            COST: 'Cost',
            MARGIN: 'Margin',
            MAXMARGINAMOUNT: 'Maximum margin',
            COMPETITOR: 'Competitor',
            COMPETITORSPRICE: 'Competitor price',
            MARKETAVERAGEPRICE: 'Average Price',
            CURRENTDATE: 'Current date',
            MARGINVSMAXMARGIN: 'Margin vs Maximum Margin',
            COMPETITIVEINDEX: 'Competitiveness',
            MARKETCOMPETITIVEINDEX: 'Market competitiveness',
          },
        },
        PRICE_INCONSISTENCY: {
          ROUTE: 'Prices / Reports',
          TITLE: 'Price Inconsistencies',
          CODE: 'Code',
          NAME: 'Name',
          CURRENT_PRICE: 'Current Price',
          MAXIMUM_PRICE: 'Maximum price',
          STORE: 'Store',
          FILTER_TTIP: 'Filter',
          FULLSCREEN_TTIP: 'Expand',
          EXITFULLSCREEN_TTIP: 'Reduce',
          EXPORT_TTIP: 'Export',
          IMPORT_TTIP: 'Import',
          PRINT_TTIP: 'Print',
          TITLE_FILTERS: 'Filters',
          CATEGORY_FILTER: 'Category',
          SEARCH_CATEGORY_FILTER: 'Search Categories',
          CLEAN_FILTER_BTN: 'Clear',
          APPLY_FILTER_BTN: 'Apply',
        },
        PRICES_MAP: {
          ROUTE: 'Prices / Reports',
          TITLE: 'Prices Map',
          CHOOSE_PRODUCT: 'Choose a product to show the map',
          CHOOSE_PRODUCT_AND_ZONE: 'Choose a product and zone to show the map',
          FILTER_TTIP: 'Filter',
          PRODUCT_FILTER: 'Product',
          MARKER_FILTER: 'Marker',
          OP1_ALL: 'All',
          OP2_MARKER: 'Marker',
          OP3_NO_MARKER: 'No Marker',
          NAME: 'Name',
          CODE: 'Code',
          PRICE: 'Price',
          BRAND: 'Brand',
          MARKER: 'Marker',
          Nuevo: 'New',
          SOURCE: 'Source',
          SOURCE_TTIP: 'Survey source',
          VALIDFROM: 'Survey Date',
          Incompleto: 'Incomplete',
          OWN_BRAND: 'Own Brand',
          CHART_TITLE: 'Historical Prices',
          CHART_TITLE_PRICE: 'Price',
          CHART_TITLE_VENTAS: 'Sales',
          REFERENCE_STORE: 'Reference Store',
        },
        COMPETITOR_PRICES: {
          ROUTE: 'Prices / Reports',
          TITLE: 'Competitor Prices',
          DOWLOAD_REPORT: 'Download Report',
          SINCE_INPUT: 'From',
          TO_INPUT: 'To',
        },
        CONTEXT_REPORT: {
          TITLE: 'Context Report',
          SUBTITLE: 'Competitor Monitoring by Tag',
          LOADING: 'Generating report...',
          HEADER: {
            HIDE_FILTERS: 'Hide Filters',
            SHOW_FILTERS: 'Show Filters',
            EXPORT: 'Export',
            SAVE: 'Save Changes',
            COMING_SOON: 'Coming soon',
            CLEAR_PRICES: 'Clear prices',
            CLEAR_PRICES_TOOLTIP: 'Removes all modified new prices (also from local storage).',
            MODIFIED_LABEL: 'modified',
            MODIFIED_TOOLTIP: 'Rows with a New Price different from current. Persist across reloads (valid for 48 hours).',
            EXPIRATION_NOTE: 'Competitor prices shown are those within the last {{days}} days.',
          },
          FILTERS: {
            MISSION: 'Survey Mission',
            SOURCES: 'Survey Sources',
            COMPETITOR_BRANDS: 'Competitor Brands',
            GROUPING_TAG: 'Grouping Tag',
            METHODOLOGY: 'Comparison Methodology',
            CATEGORIES: 'Categories',
            SUBCATEGORIES: 'Subcategories',
            TOP_N: 'Top N per category',
            TOP_N_AMOUNT: 'By revenue',
            TOP_N_QUANTITY: 'By units sold',
            TOP_N_COUNT: 'Count',
            GENERATE: 'Generate Report',
          },
          METHODOLOGY: {
            MODE_AVG_FALLBACK: 'Mode with Avg fallback',
            MODE: 'Mode',
            AVG: 'Average',
            MIN: 'Minimum',
            MAX: 'Maximum',
          },
          TABLE: {
            BRAND_TOGGLE: 'Visible brands',
            SEARCH_LABEL: 'Search',
            SEARCH_PLACEHOLDER: 'Product or EAN',
            ALL: 'All',
            ONLY_MODIFIED: 'Only modified prices',
            CLEAR_FILTERS: 'Clear filters',
            SHORTCUTS_TOOLTIP:
              'Shortcuts:\n/ — focus search\nCtrl+M — toggle "only modified"\nF2 — jump to first New Price\nTab — navigate New Price inputs',
            OWN_PRICE_TOOLTIP: 'Mode of my stores prices grouped by {{tagName}}.',
            SUGGESTED_PRICE_TOOLTIP: 'Mode of the suggested prices from the pricing engine for this {{tagName}}.',
            GROUP_CONTEXT: 'Context Info',
            GROUP_OWN: 'My Current State',
            GROUP_COMPETITORS: 'Competitor Prices',
            GROUP_STRATEGY: 'Strategy & Simulation',
            GROUP_ACTIONS: 'Actions',
            PRODUCT: 'Product & Info',
            PRODUCT_SHORT: 'Product',
            SALES_VAR: 'Sales & Variation (30d)',
            OWN_DETAIL: 'Current Price & Margin',
            REFERENCE: 'Market Price',
            SUGGESTED: 'Suggested Price',
            NEW_PRICE: 'New Price',
            ACTIONS: 'Actions',
            VAR_SALES: 'Sales var',
            VAR_UNITS: 'Units var',
            LAST_SALE: 'Last sale',
            SALES_AMOUNT: 'Sales $',
            SALES_UNITS: 'Units',
            UNITS: 'Units Var',
            VOLUME: 'Vol',
            PRICE: 'Price',
            MARGIN: 'Margin',
            VAR_VS_REF: 'Var vs Market',
            MODE_FALLBACK: 'Mode unavailable · Avg',
            VARIATION: 'Variation',
            VARIATION_TOOLTIP: 'Percent variation of the New Price relative to the Current Price.\nClick ⓘ to see the calculation.',
            VARIATION_INFO_TOOLTIP: 'Click to see the calculation',
            VARIATION_DIALOG_TITLE: 'Variation',
            VARIATION_DIALOG_FORMULA: 'Variation = (New Price − Current Price) / Current Price × 100',
            VARIATION_DIALOG_VALUES: 'Variation = (${{newPrice}} − ${{currentPrice}}) / ${{currentPrice}} × 100 = {{sign}}{{variation}}%',
            MARGIN_PROJ: 'Margin',
            SALES_PERIOD_BANNER:
              'Sales last 30 days: from {{currentFrom}} to {{currentTo}} · Compared to {{previousFrom}} to {{previousTo}} (Sales from the last 30 days)',
            COMPETITOR_PERIOD_BANNER: 'Competitor data: prices captured in the last {{days}} days.',
            ACCEPT_SUGGESTED: 'Accept Suggested',
            EQUALIZE_REF: 'Match Market',
            EQUALIZE_REF_TOOLTIP: 'Match market price',
            NO_SUGGESTED: 'No suggested price',
            NO_REFERENCE: 'No market price',
            SUGGESTED_EQUALS_CURRENT: 'Suggested equals current price',
            REF_EQUALS_CURRENT: 'Market price equals current price',
            NO_DATA: 'No Data',
            VIEW_EVIDENCE: 'View Evidence',
            MARGIN_TOOLTIP_TITLE: 'Gross Margin',
            MARGIN_TOOLTIP_NO_DATA: 'Gross Margin\nNo cost data to compute the margin.',
            MARGIN_TOOLTIP_SHORT_NETO: 'Gross Margin\nOver net base (excluding VAT and IEPS).\nClick ⓘ to view the formula.',
            MARGIN_TOOLTIP_SHORT_BRUTO: 'Gross Margin\nOver gross price (no VAT/IEPS netting).\nClick ⓘ to view the formula.',
            MARGIN_INFO_TOOLTIP: 'Click to see the calculation',
            MARGIN_DIALOG_FORMULA: 'Formula',
            MARGIN_DIALOG_CALCULATION: 'Calculation',
            MARGIN_DIALOG_STRATEGY: 'Strategy',
            MARKET_PRICE_TOOLTIP:
              'Aggregate computed over the competitor prices included in the report, using the selected methodology ({{methodology}}). It is not a unique market price.',
            APPLIED_RULE_TOOLTIP: 'Applied rule: {{name}}.\nClick to open in a new tab.',
            TAG_HEADER_TOOLTIP:
              'Store grouping selected in the filters.\nEach row consolidates the stores that share the same value of {{tagName}}.\nPrices, costs and taxes are reported as the mode (most frequent value) across those stores.',
            TAG_STORES_LABEL: 'stores',
            TAG_STORES_TOOLTIP: '{{count}} stores in the group.',
            TAG_STORES_WITH_PRICE_TOOLTIP: '{{count}}/{{tagCount}} stores in the group with item price.',
            DECISION_DEEPLINK_TOOLTIP: 'Open Price Decisions for this product in a new tab.',
            PI_TOOLTIP_GOOD: 'Green: your price is lower than or equal to the competitor.',
            PI_TOOLTIP_BAD: 'Red: your price is higher than the competitor.',
            PI_TOOLTIP_NO_DATA: 'Price Index\nNo competitor data to compute the PI.',
            PI_TOOLTIP_SHORT_GOOD:
              'Price Index\nGreen: your price is lower than or equal to the competitor.\nClick ⓘ to view the calculation.',
            PI_TOOLTIP_SHORT_BAD: 'Price Index\nRed: your price is higher than the competitor.\nClick ⓘ to view the calculation.',
            PI_INFO_TOOLTIP: 'Click to see the calculation',
            PI_DIALOG_TITLE: 'Price Index',
            PI_DIALOG_FORMULA: 'PI = Competitor price / Your current price × 100',
            PI_DIALOG_VALUES: 'PI = ${{competitor}} / ${{own}} × 100 = {{pi}}%',
            SUGGESTED_BADGE: 'Suggested',
            EMPTY: 'Select filters and generate the report to see the data.',
            OPEN_PHOTO: 'Click to open the photo in a new tab',
            EXPIRATION_LABEL: 'Surveys from the last {{days}} days',
            EXPIRATION_TOOLTIP: 'Configured validity window for competitor prices.',
          },
          EVIDENCE: {
            TITLE: 'Competitor Evidence',
            SUBTITLE: 'Prisma Audit Control',
            COMPETITOR: 'Competitor',
            STORE: 'Store',
            SOURCE: 'Source',
            PRICE: 'Captured Price',
            OBSERVED_AT: 'Observation Date',
            OBSERVED_BY: 'Observed By',
            OBSERVATIONS: 'Observations',
            VALID_TO: 'Valid Until',
            NO_PHOTO: 'No image available',
            BADGE_PROMO: 'Promo',
            BADGE_REGULAR: 'Regular',
            BADGE_MAIN_COMPETITOR: 'Main',
            BADGE_RELEVANT_COMPETITOR: 'Relevant',
            SUMMARY_SURVEYS: 'captures',
            SUMMARY_PROMOS: 'promos',
            SUMMARY_PRICE_RANGE: 'price range',
            SUMMARY_WINDOW: 'window',
            SUMMARY_BY_SOURCE: 'By source',
            FILTER_HINT: 'click to filter',
            FILTER_SEARCH_PLACEHOLDER: 'Search competitor store…',
            FILTER_ONLY_PROMO: 'Promo only',
            FILTER_BY_SOURCE: 'Filter by source',
            FILTER_CLEAR: 'Clear',
            SORT_LABEL: 'Sort by',
            SORT_DATE_DESC: 'Date — newest first',
            SORT_DATE_ASC: 'Date — oldest first',
            SORT_PRICE_ASC: 'Price — low to high',
            SORT_PRICE_DESC: 'Price — high to low',
            EMPTY_FILTERED: 'No surveys match the filters.',
            EMPTY_TIMELINE: 'No surveys for this item in this brand.',
            ERROR_TITLE: 'Could not load evidence',
            ERROR_LOAD: 'There was an error fetching the surveys. Please try again or contact support.',
          },
          VALIDATION: {},
        },
        PRICES_AUDIT: {
          PRICE_CHANGES: 'Price Auditing',
          PROD_FILTERS: 'Product Filters',
          FUELS: 'Fuels',
          BUSINESS_UNIT: 'Business Unit',
          DEP: 'Department',
          CAT: 'Category',
          SUBCAT: 'Subcategory',
          PROD: 'Product',
          POS_FILTERS: 'POS Filters',
          REGION: 'Region',
          OPERATION_TYPE_FILTER: 'Operation Type',
          STORE_TYPE_INPUT: 'Store',
          DATE_FILTER: 'Date Filters',
          INITIAL_DATE: 'Initial Date',
          END_DATE: 'End date',
          USER: 'User',
          REPORT: 'Generate Report',
          REPORT_UPDATE: 'Update Report',
          CODE: 'Code',
          STORES: 'Stores',
          NAME: 'Name',
          PREVIUS_PRICE_INPUT: '$ Previous price',
          MARGIN_PRICE_INPUT: '% Previous Margin',
          NEW_PRICE_INPUT: '$ New price',
          AUDIT_PRICE_CHANGE: 'Price Change',
          MARGIN_NEW: '% New Margin',
          INFORM: 'informed Date',
          INFORM_BY: 'updated By',
          SUBTITLE: 'Pricing / Reports',
        },
        PRICE_REPORT: {
          TITLE: 'Pricing / Reports',
          WeightedIndex: 'W index',
          SalesUnits: 'Sales U',
          Sales: 'Sales $',
          Margin: 'Margin $',
          PercentageMargin: 'Margin %',
          Gmroi: 'GMROI',
          COMPETITIVENESS_INDEX: 'Competitiveness index',
          PREVIOUS_MONTH_DIF: 'Dif % Vs Previous Month',
          SUGGESTIONS_ACCEPTED: '% Suggestions Accepted',
          MarginDif: 'Margin Dif. vs Previous Month',
          PercentageMarginDif: 'Percentage Point vs Previous month',
          DEC_TYPE: 'Types of Decisions',
          INDEX_COMP: 'Competitiveness Index (IC%)',
          CATEGORY: 'Category',
          CHEAPER: 'Cheaper',
          SAME: 'Same',
          MORE_EXPENSIVE: 'More Expensive',
          PRICES_TYPES: 'Price Types',
          PERIOD: 'Period',
          CATEGORYS: 'Categories',
          EVOL_GRAPH: 'Evolutionary Graph',
          VARIABLE: 'Variable',
          VARIABLES: 'Variables',
          MAP: 'Map',
          PRODUCT_PERFORMANCE: 'Product Performance',
          PRODUCT: 'Product',
          VOLUME: 'Volume',
        },
      },
      DECISIONS: {
        SUMMARY: {
          ROUTE: 'Prices / Decisions',
          TITLE: 'Decisions Summary',
          REVISE_BTN: 'Review all',
          UPDATE_STATISTICS: 'Update Statistics',
          LASTUPDATEDON: 'Last updated on:',
          FILTER_TTIP: 'Filter',
          FULLSCREEN_TTIP: 'Expand',
          EXITFULLSCREEN_TTIP: 'Reduce',
          EXPORT_TTIP: 'Export',
          IMPORT_TTIP: 'Import',
          PRINT_TTIP: 'Print',
          REVIEW_PENDING: '# Pend. Rev.',
          CATEGORY: 'Category',
          REVIEW_PENDING_TTIP: 'Suggestions Pending Review',
          DECISIONS: '# Decis.',
          DECISIONS_TTIP: 'Decisions Made',
          ADVANCED: 'Progress %',
          ADVANCED_TTIP: 'Take into account only suggestions',
          SEND: 'Send',
          SUGGESTED_IMPACT: 'Sug. Imp. $',
          SUGGESTED_IMPACT_TTIP: 'Suggested Impact',
          DECISIONS_IMPACT: 'Decis. Imp. $',
          DECISIONS_IMPACT_TTIP: 'Decisions Impact',
          REVIEW_IMPACT: 'Rev. Impact $',
          REVIEW_IMPACT_TTIP: 'Review Impact',
          PENDING_APPROVAL: '# Pend. Approve.',
          PENDING_APPROVAL_TTIP: 'Number of Decisions Pending for Approval',
          APPROVED: '# Approve.',
          APPROVED_TTIP: 'Approved Decisions',
          TITLE_FILTERS: 'Filters',
          PROVINCES_FILTER: 'State',
          CLEAN_FILTER_BTN: 'Clear',
          APPLY_FILTER_BTN: 'Apply',
          REJECTED_TTIP: 'Rejected',
          REJECTED: 'Rejtd.',
          APPROVE: 'Approve',
          APPROVE_ALL: 'Approve All',
          REVIEW: 'Review',
          CONFIRM_SEND: 'Confirm Send?',
          CONFIRM_SEND_ALL: 'Do you confirm the send all items?',
          CONFIRM_APPROVE: 'Confirm approval?',
          CONFIRM_APPROVE_ALL: 'Confirm approval of all items?',
          CONFIRM_REVIEW: 'Confirm the review of all items?',
        },
        ERP: {
          ROUTE: 'Prices / Decisions',
          TITLE: 'Publish Decisions',
          DOWLOAD_BTN: 'Download Info',
          PREVIEW_BTN: 'Preview',
          INFORM_BTN: 'Publish',
          LAST_PRICES: 'Latest Prices Published',
          GENERATION_DATE: 'Generation date',
          GENERATION_TIME: 'Generation Time',
          USER: 'User',
          FILE: 'File',
          FULLSCREEN_TTIP: 'Expand',
          EXITFULLSCREEN_TTIP: 'Reduce',
          PREVIEW_PROCCESING: 'Processing has started. You will receive a notification when it is finished.',
          PREVIEW_WITHOUT_PROCCESING: 'There is no new data to process.',
        },
        PRICE_DECISIONS: {
          NO_GROUPID: 'Choose a category to display the list',
          APPLY_FILTERS: 'Applicable filters',
          STRATEGY_DIALOG: {
            UNIT: 'Unit',
            Price: '$',
            Margin: '%',
            UsdxM3: 'USD * M3',
            MIN_MARGIN_ERROR: 'Value must be greater than or equal to {{val}}%',
          },
          FULLSCREEN_TTIP: 'Expand',
          EXITFULLSCREEN_TTIP: 'Reduce',
          SUGGESTED_IMPACT_TITLE: 'Suggested Impact $',
          CHANGES_TITLE: '# Changes',
          VS_SUGGESTED_IMPACT_TITLE: 'Vs Suggested Impact $',
          CHANGES_PRICE_TITLE: 'Price Change %',
          NEW_IMPACT_TITLE: 'New Impact $',
          SUGGESTIONS_ACCEPTED_DESCRIPTION: 'Suggestions Accepted',
          WEIGHTED_SALE_DESCRIPTION: 'Weighted by sale',
          PERCENT_CHANGE: 'Changes %',
          FILTER_CHIP: 'Filter price by',
          CODE_ITEM: 'Item code',
          CODE_STORE: 'Store code',
          PARENT_RULE: 'Parent rule',
          FILTER_CHIP_PARENT: 'Filter prices by parent rule',
          FILTER_CHIP_PARENT_ITEM: 'Parent Item:',
          FILTER_CHIP_PARENT_STORE: 'Parent Store:',
          TABLE_TITLE: 'Suggestion Analysis',
          INIT_PRICE_IMPORT_TITLE: 'Initialized price per import',
          OBSERVATIONS: 'Observations',
          REASON: 'Reason',
          STEP_BY_STEP: 'Step by step',
          SEE_MORE_TABLE: 'See More...',
          PRICE_TABLE: 'Price',
          MARGIN_TABLE: 'Margin',
          CI_TABLE: 'Costs more Taxes',
          ORIGINAL_TABLE: 'Original $',
          ACTUAL_TABLE: 'Current $',
          SUGGESTED_TABLE: 'Suggested $',
          DECISION_TABLE: 'Decision $',
          ROUTE: 'Prices / Decisions',
          TITLE: 'Pricing Decisions',
          FILTER_TTIP: 'Filter',
          EXPORT_TTIP: 'Export',
          IMPORT_TTIP: 'Import',
          PRINT_TTIP: 'Print',
          KEEP_PRICES: 'Ignore Suggestions',
          KEEP_PRICES_TTIP: 'Ignore selected suggestions',
          ACCEPT_SUGGESTIONS: 'Accept Suggestions',
          ACCEPT_SUGGESTIONS_TTIP: 'Accept selected suggestions',
          ENDORSE: 'Approve Changes',
          ENDORSE_TTIP: 'Approve selected changes',
          REJECT_ENDORSE: 'Reject Changes',
          REJECT_ENDORSE_TTIP: 'Reject selected changes',
          REVERT_PRICE: 'Reverse Prices',
          REVERT_PRICE_TTIP: 'Reverse selected prices',
          MARK_REVIEWED: 'Mark as Reviewed',
          MARK_REVIEWED_TTIP: 'Mark selected decisions as reviewed',
          EDIT_PRICES: 'Modify Prices',
          EDIT_PRICES_TTIP: 'Modify prices manually',
          EFFECTIVE_DATE: 'Valid Dates',
          EFFECTIVE_DATE_TTIP: 'Set Valid Dates for selected products',
          CLEAN_FILTERS: 'Clear Filters',
          PRODUCT: 'Product',
          PRICE_TYPE: 'Price Type',
          CURRENT_PRICE_TTIP: 'Current Price',
          VALID_PRICE_TTIP: 'Valid Price',
          NOT_VALID_PRICE_TTIP: 'Invalid Price',
          SUGGESTION_PRICE_TTIP: 'Suggested Price $',
          CHECK_TTIP: 'Reviewed',
          PRICE: 'Current Price $',
          COMPETITION_PRICE: 'Competitor Price $',
          SUGGESTION: 'Suggested Price $',
          DECISIONS: 'Decision $',
          IMPACT: 'Impact $',
          NEWVALIDATEDATE: 'Validate Date',
          ACCEPT_SUGGESTION: 'Accept suggestion',
          KEEP_PRICE: 'Keep the current price',
          EDIT_MANUALLY: 'Change manually',
          TEXT_SNACKBAR: '{{val}} records were modified',
          TEXT_SNACKBAR_MAX_BULK_LIMIT: 'It is not possible to perform bulk actions for more than {{val}} items.',
          EFFECTIVE_DATE_MODAL: 'Valid date',
          EFFECTIVE_DATE_INPUT: 'Valid date',
          TO_DATE_INPUT: 'Valid date To',
          CANCEL_BTN: 'Cancel',
          ACCEPT_BTN: 'Accept',
          TEXT_SNACKBAR2: '{{val}} records were modified',
          TITLE_FILTERS: 'Filters',
          PROVINCE_FILTERS: 'Province',
          CITY_FILTERS: 'City',
          PRICE_ZONE1_FILTERS: 'Price Zone 1',
          PRICE_ZONE2_FILTERS: 'Price Zone 2',
          PRICE_ZONE3_FILTERS: 'Price Zone 3',
          CLEAN_FILTER_BTN: 'Clear',
          APPLY_FILTER_BTN: 'Apply',
          EDIT_PRICE_MODAL: 'Modify prices',
          STRATEGY_INPUT: 'Strategy',
          ROUNDING_CHECK: 'Use rounding rules',
          VALUE_INPUT: 'Value',
          TAB1: 'Decision',
          TAB2: 'Competitors',
          TAB3: 'Costs and Margins',
          TAB4: 'Audit',
          TAB5: 'Related Stores',
          TAB6: 'Recipe',
          TAB7: 'Products in Kit',
          TAB8: 'Kit',
          TAB_ZONES: 'Related Stores',
          TAB_ZONES_TITLE: 'Related Stores',
          CODE_INPUT: 'Code',
          UM_BASE_INPUT: 'Base UM',
          BRAND_INPUT: 'Brand',
          NAME_INPUT: 'Name',
          WITHOUT_SUGGESTION: 'Without Suggestion',
          REVIEW_RULE_BTN: 'Review Rule',
          DISABLED_BY_CHILD: 'No actions can be taken. This product depends on the decisions made in the parent of the parent rule',
          SAME_PRICE_WARNING: 'The selected item already has the price: $',
          SUGGESTION_ACCEPTED_BTN: 'Suggestion Accepted',
          SUGGESTION_ACCEPTED_OP1: 'Keep the Current Price',
          SUGGESTION_ACCEPTED_OP2: 'Change manually',
          SUGGESTION_WITHOUT_REVIEW: 'Suggestion without review',
          SUGGESTION_ACCEPTED: 'Suggestion Accepted',
          SUGGESTION_IGNORED: 'Suggestion Ignored',
          SUGGESTION_ACCEPT: 'Accept Suggestion',
          SUGGESTION_IGNORE: 'Ignore Suggestion',
          SUGGESTION_REVIEWED: 'Reviewed',
          SUGGESTION_ENDOECE: 'Approve Changes',
          SUGGESTION_ENDOECE_REJECTED: 'Reject Changes',
          SUGGESTION_REJECTED: 'Changes rejected',
          SUGGESTION_ALREADY_ENDOECE: 'Approved',
          SUGGESTION_CHANGE_MANUALY: 'Change manually',
          SUGGESTION_CHANGED_MANUALY: 'Changed manually',
          SUGGESTION_MARK_AS_REVIEW: 'Mark as Review',
          REVERT_NEW_PRICE: 'Revert Price',
          NO_DECISIONS_BTN: 'No decisions',
          NO_DECISIONS_OP1: 'Confirm the current price',
          NO_DECISIONS_OP2: 'Change manually',
          EDIT_MANUALLY_BTN: 'Manually Edited',
          EDIT_MANUALLY_OP1: 'Change manually',
          EDIT_MANUALLY_OP2: 'Keep Current Price',
          ORIGINAL_PRICE_INPUT: 'Original price',
          PREVIUS_PRICE_INPUT: 'Previous price',
          COST_INPUT: 'Cost',
          MARGIN_INPUT: 'Margin $',
          PERCENTAGE_MARGIN_INPUT: 'Margin %',
          LEGEND_COMP_MAP: 'Filter the map and the KPIs using prices in the store trade area or using the prices of the competitive rule',
          COMPETITOR_INPUT: 'Competitor',
          SOURCE_INPUT: 'Source',
          MARKERS_CHECK: 'Markers Only',
          MARKERS_TTIP: 'Relevant Competitors Only',
          BRAND: 'Brand',
          CODE_NAME: 'Cod | Name',
          TYPE: 'Type',
          SURVEY_DATE: 'Date',
          SURVEY: 'Source',
          COMPETENCE_TAB_KPIS_TITLE_1: 'Current Comp. Price',
          COMPETENCE_TAB_KPIS_TITLE_2: 'Current CI %',
          COMPETENCE_TAB_KPIS_TITLE_3: 'Suggested CI %',
          COMPETENCE_TAB_KPIS_TITLE_4: 'Suggested Price',
          COMPETENCE_TAB_KPIS_DESC_3: 'Vs. Current CI',
          COMPETENCE_TAB_KPIS_DESC_4: 'Vs. Current Price',
          COMPETENCE_KPIS_TITLE_TRADE: 'Trade Area',
          COMPETENCE_KPIS_TITLE_COMPETITOR: 'Main Competitors',
          COMPETENCE_KPIS_TITLE_RULE: 'Rule',
          TITLE_MAP_SECTION: 'Competition Map',
          TITLE_TABLE: 'Trade Area',
          TITLE_KPIS: 'Competition Analysis',
          NEW: 'Status',
          NEW_CHIP: 'NEW',
          INVALID_CHIP: 'Invalid',
          OLD_CHIP: 'Old',
          SUGGESTION_COLUMN: 'Suggested',
          MARK: 'Marker',
          OWNER: 'Main Competitor',
          PVC: 'PVP',
          MARGIN: 'Margin',
          MARGIN_USD: 'Margin USDxM3',
          PERCENTAGE_MARGIN: 'Margin %',
          COST_TAXES: 'Costs and Taxes',
          CURRENT: 'Current',
          PREVIUS: 'Previous',
          VAR: 'Variation %',
          LAST_VAR: 'Last Var.',
          EVENT: 'Event',
          DATE: 'Date',
          PREVIUS_PRICE: 'Previous price $',
          DECISIONS_PRICE: 'Price decision $',
          COST: 'Cost',
          USER: 'User',
          CHILDREN_STORE: 'Related Store',
          CODE: 'Code',
          RECIPE: 'Recipe',
          NAME: 'Name',
          CURRENT_PRICE: 'Current $',
          SUGGESTION_RECIPE: 'Suggestion $',
          DECISION: 'Decision $',
          SEE_RECIPE_BTN: 'View Recipes',
          INGREDIENTS: 'Ingredients',
          ORIGIN_COST: 'Original Cost $',
          QUANTITY: 'Quantity',
          CURRENT_COST: 'Current Cost $',
          COMBO_PRODUCT: 'Product in kit',
          COMBOS: 'Kits',
          PARTICIPATION: 'Share %',
          SEE_COMBO_BTN: 'View Kit',
          PARTICIPATION_TTIP: 'Sales share within this kit.',
          LEGEND_COMBO: 'The following Kits may be directly or indirectly affected by the price decision made.',
          COMBO: 'Kit',
          SUGGESTION_COMBO: 'Suggestion $',
          COMBOS_COMPONENTS: 'Kit Components',
          BLOCK: 'Group',
          TOOLTIP_PARENT: 'Parent Product',
          TOOLTIP_PARENT_OPEN: 'open related products',
          TOOLTIP_PARENT_OPENED: 'close related products',
          TOOLTIP_CHILD: 'Related Product',
          TOOLTIP_PRICE_VARIATION: 'The child products will have the same Price Variation as the parent product',
          TOOLTIP_SUPERIOR_PRICE: 'The Child Products will have a Higher Price in {{val}} than the parent product',
          TOOLTIP_INFERIOR_PRICE: 'The Child Products will have a Lower Price in {{val}} than the parent product',
          TOOLTIP_SAME_PRICE: 'Child Products will have the same Price as the parent product',
          TOOLTIP_SUPERIOR_MARGIN: 'Child Products will have a Higher Margin in {{val}} than the parent product',
          TOOLTIP_INFERIOR_MARGIN: 'Child Products will have a Lower Margin in {{val}} than the parent product',
          TOOLTIP_SAME_MARGIN: 'Child Products will have the same Margin as the parent product',
          TOOLTIP_COMBO: 'Kit',
          TOOLTIP_RECIPE: 'Recipe',
          TOOLTIP_STORE: 'Store relationship',
          TOOLTIP_COMBO_ITEM: 'Kit Component',
          TOOLTIP_MAX_PRICE: 'The price is above the regulated price',
          TOOLTIP_IS_PARENT: 'Parent item in kinship rule. The variation of its price affects its child items.',
          RULE_TYPE_TITLE: 'Rule Type',
          COMBO_ANALYST: 'Analyst',
          COMBO_DECISIONTYPE: 'Decision Type',
          COMBO_APPROVER: 'Approver',
          COMBO_RULETYPE: 'Rule Type',
          AUDIT_PRICE_CHANGE: 'Price Change',
          SHOW_KPIS: 'Show KPIs',
          HIDE_KPIS: 'Hide KPIs',
          RULE_TYPE: {
            Guideline: 'Guideline',
            Margin: 'Margin',
            Competitive: 'Competitive',
            ParentItem: 'Related Products',
            ParentZone: 'Related Stores',
            ParentCategory: 'Related Categories',
            BasePriceList: 'Base Price List',
          },
          ADVANCED_FILTER: {
            NONE: 'All',
            SEE_CHILDS_MSG:
              'By enabling this option you will be able to search and view the products that are children of other products with respect to the price management performed in the price rules of stores and products',
            SEE_CHILDS: 'See Child Products',
            SEE_FIXED_PRICES_MSG:
              "By enabling this option you will be able to search and see only the items with fixed prices. You can't make decisions over suggestions on them.",
            SEE_FIXED_PRICES: 'See Fixed Prices',
            TITLE_FILTERS: 'Filters',
            STATE_FILTERS: 'Status',
            ACTION_TYPE_FILTERS: 'Situation',
            PRICE_TYPE_FILTERS: 'Price Type',
            TYPE_FILTERS: 'Type',
            CATEGORY_INPUT: 'Category',
            SEARCH_CATEGORY: 'Search Categories...',
            SUBCATEGORIES_INPUT: 'Subcategories',
            SEARCH_SUBCATEGORIES: 'Search Subcategories',
            TitleStoreTags: 'Store Filters',
            TitleItemTags: 'Product Filters',
            UnCheckedSuggestion: 'Unchecked Suggestion',
            PriceRaised: 'Price Raised',
            NoSuggestions: 'Without Suggestions',
            NotCheckedSimulation: 'Not Reviewed Suggestions',
            SuggestionAccepted: 'Accepted Suggestions',
            ChangeRuleParent: 'Change Rule Parent',
            PricePublished: 'Price Published',
            BlockedSuggestion: 'Blocked Suggestion',
            NewSuggestion: 'New Suggestion',
            SuggestionExpired: 'Suggestion Expired',
            KeepPrice: 'Keep Current Price',
            MarkAsReviewed: 'Mark As Reviewed',
            MarkAsReviewedIgnoringSuggestions: 'Mark as Reviewed Ignoring Suggestions',
            SetEffectiveDate: 'Set Effective Date',
            ChangePrice: 'Changed Price',
            RevertNewPrice: 'Reverted Price',
            RejectEndorse: 'Rejected Changes',
            Endorse: 'Approved',
            ManualPriceEdited: 'Manually Changed Prices',
            SimulationAcepted: 'Accepted Simulation',
            AboutToExpire: 'About to Expire',
            OldPrices: 'Old Prices',
            Regular: 'Regular',
            Competition: 'Competition',
            Current: 'Current',
            Todos: 'All',
            Checked: 'Checked',
            Unchecked: 'Unchecked',
            ApprovalPending: 'Approval Pending',
            'ApprovalPending-Aproval': 'Approval Pending',
            Rejected: 'Rejected',
            Approved: 'Approved',
            Error: 'Suggestion calculation failed',
            SuggestionIgnored: 'Suggestions Ignored',
            PriceDrop: 'Price Drop',
            SharpPriceDrop: 'Sharp Price Drop',
            SharpPriceRaised: 'Sharp Price Raised',
            DepressedMargins: 'Depressed Margins',
            HighMargins: 'High Margins',
            Margin: 'Margin Rule',
            Competitive: 'Competitive Rule',
            AUDIT_PRICE_CHANGE: 'Price Change',
          },
          TAB: {
            STEP_TEXT_REGULATEDPRICE_GUIDELINES_APPLIED_FORCED:
              'The price of {{val}} was changed to {{val3}} because the limits of Regulated Maximum Prices were applied.',
            STEP_TEXT_REGULATEDPRICE_GUIDELINES_NOTAPPLIED_FORCED:
              'The price of {{val}} is within the limits of regulated maximum prices {{val3}}.',
            STEP_TEXT_REGULATEDPRICE_GUIDELINES_NOTAPPLIED_HIGHER_NOTFORCED:
              'The price of {{val}} exceeds the limits of Regulated Maximum Prices {{val3}}, but no corrections were made.',
            STEP_TEXT_REGULATEDPRICE_GUIDELINES_NOTAPPLIED_MINOR_NOTFORCED:
              'The price of {{val}} is within the limits of Regulated Maximum Prices {{val3}}, and no corrections were made.',
            STEP_LINK_COMPETITIVE_RULE: 'Competitive Rule ',
            STEP_TEXT_COMPETENCE_RULE_below: 'below average ',
            STEP_TEXT_COMPETENCE_RULE_above: 'above average ',
            STEP_TEXT_COMPETENCE_RULE_equal: 'equal to average ',
            STEP_TEXT_COMPETENCE_RULE_PRE: 'A',
            STEP_TEXT_COMPETENCE_RULE_POST: 'to set the price a {{val2}}{{val}} {{val4}}, remaining at {{val3}}',
            STEP_TEXT_COMPETENCE_RULE: 'A {{val}} was applied: "{{val2}}" and generated a suggested price of {{val3}}',
            STEP_TEXT_MARGIN_RULE: 'A {{val}} was applied: "{{val2}}" and generated a suggested price of {{val3}}',
            STEP_TEXT_COMPETENCE_RULE_NOTAPPLIED: 'No price rule applied',
            STEP_TEXT_MARGIN_RULE_NOTAPPLIED: 'No price rule applied',
            STEP_TEXT_MARGIN_SUGGESTION_TRIGGER:
              'PRISMA detected that your current price of {{val}} does not comply with the target margin of {{val2}}',
            STEP_TEXT_COMPETITIVE_SUGGESTION_TRIGGER:
              'PRISMA detected that your current price of {{val}} does not comply with your competitive positioning defined in rule {{val2}} considering market reference price of {{val3}}',
            STEP_TEXT_SUGGESTION_ERROR:
              'PRISMA could not calculate the suggested price for this item and store (suggested price {{val}}), please check its costs and taxes or contact support',
            STEP_TEXT_COMPETITIVE_SUGGESTION_TRIGGER_SHORT:
              'PRISMA detected that your current price of {{val}} does not comply with your competitive positioning.',
            STEP_TEXT_RELATED_PRODUCTS_RULE_SHORT: 'A Rule Parent Item was applied: "{{val}}" and generated a price of {{val2}}',
            STEP_TEXT_RELATED_STORES_RULE_SHORT: 'A Rule Parent Store was applied: "{{val}}" and generated a price of {{val2}}',
            STEP_TEXT_COMPETENCE_LIMITS_APPLIED:
              'The suggestion of {{val}} was changed to {{val2}} because the competence limits were applied',
            STEP_TEXT_COMPETENCE_LIMITS_NOTAPPLIED: 'Competence Limits where verified. No corrections were made.',
            STEP_TEXT_COMPETENCE_RULE_MARGIN_FALLBACK:
              'Prisma could not find market reference price. Suggestion was created using rule margin fallback. {{val}}',
            STEP_TEXT_COMPETENCE_CATEGORY_MARGIN_FALLBACK:
              'Prisma could not find market reference price. Suggestion was created using category margin fallback. {{val}}',
            STEP_TEXT_VARIATION_GUIDELINES_APPLIED:
              'The suggestion of {{val}} (variation: {{val2}}) has been changed to {{val3}} since the {{val5}} supported for this category is {{val4}}.',
            STEP_TEXT_VARIATION_GUIDELINES_NOTAPPLIED: 'The price variation guidelines were checked. No corrections were made.',
            STEP_TEXT_MARGIN_GUIDELINES_APPLIED:
              'The suggestion of {{val}} (margin: {{val2}}) was changed to {{val4}} as {{val3}} was the {{val5}} margin for the category.',
            STEP_TEXT_VARIATION_GUIDELINES_APPLIED_RULE:
              'The suggestion of {{val}} (variation: {{val2}}) has been changed to {{val3}} since the {{val5}} supported for this rule is {{val4}}.',
            STEP_TEXT_MARGIN_GUIDELINES_APPLIED_RULE:
              'The suggestion of {{val}} (margin: {{val2}}) was changed to {{val4}} because {{val3}} is the margin {{val5}} of the rule.',
            STEP_TEXT_MARGIN_GUIDELINES_NOTAPPLIED: 'Margin guidelines were verified. No corrections were made.',
            STEP_TEXT_ROUNDING_APPLIED: 'The suggestion was rounded to {{val}}',
            STEP_TEXT_ROUNDING_NOTAPPLIED: 'No rounding was applied',
            STEP_TEXT_SUMMARY_ACCEPTED: 'You have made a decision, and accepted the suggestion of {{val}}',
            STEP_TEXT_SUMMARY_CHANGED: 'You have made a decision, and you changed the price to {{val}}',
            STEP_TEXT_SUMMARY_IGNORED: 'You have made a decision, and ignore the price {{val}}',
            STEP_TEXT_SUMMARY_WITHOUT_SUGGESTION: 'You have made a decision, and you changed the price from {{val}} to {{val2}}',
            STEP_LINK_APPLIED_RULE: 'view rule...',
            STEP_LINK_COMPETITIVE_SUGGESTION_TRIGGER: 'view data...',
            STEP_LINK_VARIATION_GUIDELINES_APPLIED: 'view guidelines...',
            STEP_LINK_MARGIN_GUIDELINES_APPLIED: 'view guidelines...',
            STEP_LINK_VARIATION_GUIDELINES_APPLIED_RULE: 'Review Rule...',
            STEP_LINK_MARGIN_GUIDELINES_APPLIED_RULE: 'Review Rule...',
            STEP_LINK_ROUNDING_APPLIED: 'view rule...',
            STEP_LINK_REGULATEDPRICE_GUIDELINES_APPLIED: 'view configuration',
            STEP_LINK_REGULATEDPRICE_GUIDELINES_NOTAPPLIED: 'view configuration',
            STEP_LINK_RELATED_PRODUCTS_RULE: 'view parent rule...',
            STEP_LINK_RELATED_STORES_RULE: 'view parent rule...',
            STEP_COMPETENCE_RULE: 'Competitive rule',
            STEP_MARGIN_RULE: 'Margin rule',
            SUGGESTION_TITLE: 'Price Decision',
            NOT_STEPS: 'No Steps found',
            AUX_MAX_MARGIN: 'maximum',
            AUX_MIN_MARGIN: 'minimum',
            AUX_MAX_VARIATION: 'max raise',
            AUX_MIN_VARIATION: 'low minimum',
            STEP_TEXT_REGULATEDPRICE_GUIDELINES_APPLIED:
              'The price of {{val}} was changed to {{val3}} because the Maximum Regulated Price limits were applied.',
            STEP_TEXT_REGULATEDPRICE_GUIDELINES_NOTAPPLIED:
              'The price of {{val}} exceeds the limits of Maximum Regulated Prices {{val3}} but no corrections were made.',
            STEP_TEXT_APPLY_PRODUCTS_RULE:
              'This item was identified as a parent in certain item parent rules. In correlation with this item, the following rules were applied and generated a decision on the child items: {{val}}',
            STEP_TEXT_APPLY_STORES_RULE:
              'This store was identified as a parent in certain store parent rules. In correlation with this item, the following rules were applied and generated a decision on the child stores: {{val}}',
          },
          TAB_ZONES_COL_ZONE: 'Rule (Stores Relationships)',
          TAB_ZONES_COL_RULE: 'Rule',
          TAB_ZONES_COL_ACTUAL: 'Current',
          TAB_ZONES_COL_SUGGEST: 'Suggest',
          TAB_ZONES_COL_DIFF: 'diff %',
          TAB_ZONES_COL_DECISION: 'Decision',
          TAB_ZONES_COL_IMPACT: 'Impact',
          WARNING_CHILD_WHITH_WARNING: 'Related prices with warnings',
          WARNINGS_PRICES_LIST: {
            TEST: 'warning test / value: {{val}}, type: {{val2}}',
            MIN_MARGIN: 'Margin {{val}} is below the minimum margin of {{val2}}.',
            MAX_MARGIN: 'Margin {{val} is above the maximum margin of {{val2}}.',
            EQUAL_MARGIN: 'The margin of {{val}} is equal to the maximum margin of {{val2}}',
            VAR_BAJA: 'The price decreased by {{val}}. he maximum decrease is {{val2}} according to the guidelines.',
            VAR_SUBA: 'The price increased by{{val}}. he maximum increase is {{val2}} according to the guidelines.',
            SUGGESTION_ERROR: 'Invalid suggested price.',
          },
          STRATEGY_OP3: 'Carry a fixed price',
          STRATEGY_OP2: 'Lead to a target margin',
          STRATEGY_OP1: 'Apply price variation',
          SUGGESTED_IMPACT_TTIP: 'Does not include child products',
          NEW_IMPACT_TTIP: 'Includes children products',
          DATETIME: 'Datetime',
          OLD_PRICE: 'Old Price',
          NEW_PRICE: 'New Price',
          USERNAME: 'User',
          COMBO_SITUATION: 'Situation',
        },
        ANALYSIS: {
          TITLE: 'Analysis',
          COLUMNS: {
            GROUP: 'Group',
            CHANGE_PERCENT: 'Change %',
            IMPACT: 'Impact $',
            MARGIN: 'Margin %',
          },
          ACTIONS: {},
          FILTERS: {
            STATUS_LABEL: 'Status',
            STATUS: {
              ALL: 'All',
              NEW: 'New',
              REVIEWED: 'Reviewed',
            },
            ALERTS_LABEL: 'Alerts',
            ALERTS: {
              ALL: 'All',
              NO_ALERTS: 'No alerts',
              WITH_ALERTS: 'With alerts',
            },
          },
        },
      },
      TAXES: {
        IIBB: {
          ROUTE: 'Prices / Administration / Taxes',
          TITLE: 'Gross Income',
          JURISDICTION: 'Jurisdiction',
          PERCENTAGE_RATE: 'Percentage rate',
          SAVE_BTN: 'Save',
          PERCENTAGE_RATE_INPUT: 'Percentage rate',
          VALIDATION_1: 'The field cannot be greater than 100',
          VALIDATION_2: 'The field must be greater than 0',
          VALIDATION_3: 'The field is mandatory',
        },
        CO2: {
          ROUTE: 'Prices / Administration / Taxes',
          TITLE: 'CO2 taxes',
          YES: 'Yes',
          NOT: 'Not',
          EXCEMPT_ZONE: 'Exempt Zone',
          NS: 'NS',
          IN: 'IN',
          UD: 'UD',
          D500: 'D500',
          EURO: 'EURO',
          SAVE_BTN: 'Save',
          NS_INPUT: 'NS',
          VALIDATION1: 'The field must not exceed 100',
          VALIDATION2: 'The field must be greater than 0',
          IN_INPUT: 'IN',
          UD_INPUT: 'UD',
          D500_INPUT: 'D500',
          EURO_INPUT: 'EURO',
          TITLE_FORM: 'CO2 Taxes - Exempt {{val}} area',
        },
        ICL: {
          ROUTE: 'Prices / Administration / Taxes',
          TITLE: 'ICL taxes',
          YES: 'Yes',
          NOT: 'Not',
          EXCEMPT_ZONE: 'Exempt Zone',
          NS: 'NS',
          IN: 'IN',
          UD: 'UD',
          D500: 'D500',
          EURO: 'EURO',
          SAVE_BTN: 'Save',
          NS_INPUT: 'NS',
          VALIDATION1: 'The field must not exceed 100',
          VALIDATION2: 'The field must be greater than 0',
          IN_INPUT: 'IN',
          UD_INPUT: 'UD',
          D500_INPUT: 'D500',
          EURO_INPUT: 'EURO',
          TITLE_FORM: 'ICL Tax - Zone {{val}} exempt',
        },
      },
      IMPORTERS: {
        PARITY: {
          ROUTE: 'Pricing / Administration / Importers',
          TITLE: 'Import Parity',
          IP_BTN: 'Upload Daily IP',
          DAY: 'Day',
          TRANSFER_PRICING: 'Transfer pricing',
          IMPORT_TTIP: 'Import data',
          IP_DAILY: 'Daily IP weight',
          IP_NS: 'IP NS',
          IP_IN: 'IP IN',
          IP_GO2: 'IP GO2',
          IP_GO3: 'IP GO3',
          TC: 'TC',
          TERMINAL: 'Terminal',
          DESCRIPTION: 'Description',
          NS: 'NS',
          IN: 'IN',
          GO2: 'GO2',
          GO3: 'GO3',
          TITLE_FORM: 'Import Parity - Coefficients',
          SAVE_BTN: 'Save',
          DATE_COEFFICIENTS_INPUT: 'Change date of IP coefficients',
          VALIDATION1: 'The field must be greater than 0',
          TC_INPUT: 'TC',
          NS_INPUT: 'NS',
          IN_INPUT: 'IN',
          GO2_INPUT: 'GO grado 2',
          GO3_INPUT: 'GO grado 3',
        },
        FERRYES_AND_COMISIONS: {
          TITLE: 'Freight and commissions',
        },
        COST_AND_TAXES: {
          TITLE: 'Costs and taxes',
        },
        VENDOR_COST: {
          TITLE: 'Cost importer by supplier',
        },
        STORE_TAXES: {
          TITLE: 'Tax importer by store',
        },
        NEW_PRICES: {
          TITLE: 'New Prices',
        },
        COMPETITOR_PRICES: {
          TITLE: 'Competitors prices',
        },
      },
    },
    ASSORT: {
      STP: {
        CLUSTERING: {
          ROUTE: 'Assortment / Setup',
          TITLE: 'Clusterization',
          SUBTITLE:
            'Clustering allows to strategically classify points of sale according to a set of variables. It can be a single cluster for all categories or multiple classifications depending on the category. In this way, business decision-making is streamlined and product offerings are standardized. From this screen you can create and modify clusterizations.',
          NEW_CLUSTERIZATION_BTN: 'New Clustering',
          FULLSCREEN_TTIP: 'Expand',
          EXITFULLSCREEN_TTIP: 'Reduce',
          EXPORT_TTIP: 'Export',
          IMPORT_TTIP: 'Import',
          PRINT_TTIP: 'Print',
          DELETE_TTIP: 'Delete selected clusters',
          DELETE: 'Delete',
          NAME: 'Name',
          OBSERVATION: 'Observation',
          EDIT_TITLE_FORM: 'Edit Clustering',
          NEW_TITLE_FORM: 'New Clustering',
          SAVE_BTN: 'Save',
          BASIC_INFORMATION_TAB: 'Main Data',
          NAME_INPUT: 'Name',
          OBSERVATION_INPUT: 'Observation',
          CLUSTER_NAME_TTIP: 'Click here to view stores and associated clusters',
        },
        CLUSTER_ASSIGN: {
          REDO_CHANGE_CLUSTERS: 'Return changes of selected clusters',
          REDO_CHANGE_CLUSTERS_DESC: 'Do you want to filter by the selected cluster? this will erase unsaved changes',
          ROUTE: 'Clustering / Cluster Assignment',
          SUBTITLE:
            'On this screen you can create and assign a cluster to each point of sale. Or work the points of sale as free agents without assigning a cluster. In this case, it works independently as a cluster with a single point of sale.',
          SAVE_BTN: 'Save',
          FILTER_TTIP: 'Filter',
          FULLSCREEN_TTIP: 'Expand',
          EXITFULLSCREEN_TTIP: 'Reduce',
          EXPORT_TTIP: 'Export',
          IMPORT_TTIP: 'Import',
          PRINT_TTIP: 'Print',
          STORES: 'Stores',
          CODE: 'Code',
          TYPE: 'Type',
          PROVINCE: 'Province',
          STATE: 'State',
          CLUSTER: 'Cluster',
          NEW_CLUSTER: 'New Cluster',
          NO_CLUSTER_ASSIGNED: 'No Assigned Cluster',
          NEW_CLUSTER_BTN: 'NEW CLUSTER',
          NEW_CLUSTER_TITLE: 'New Cluster',
          NEW_CLUSTER_SUBTITLE:
            'The cluster is a group of points of sale, with specific characteristics or similar purchasing behavior, to which a role and a strategy are assigned together with the category. In turn, it simplifies assortment allocation and management.',
          NAME_INPUT: 'Name',
          OBSERVATION_INPUT: 'Observation',
          CANCEL_BTN: 'Cancel',
          ADD_BTN: 'Add',
          TITLE_FILTERS: 'Filters',
          STATE_FILTERS: 'State',
          TYPE_FILTERS: 'Type',
          SEARCH_TYPE: 'Search Type...',
          PROVINCE_FILTERS: 'Province',
          CLUSTER_FILTERS: 'Cluster',
          SEARCH_CLUSTER: 'Search Cluster...',
          CLEAN_BTN: 'Clear',
          APPLY_BTN: 'Apply',
          Todos: 'All',
          Checked: 'Active',
          Unchecked: 'Inactive',
          FREE_AGENTS: 'Free Agents',
        },
        CATEGORY_SETUP: {
          ROUTE: 'Assortment / Configuration',
          TITLE: 'Category Setup',
          SUBTITLE:
            'On this screen you can assign a clustering and the main segmentation of products for each category level, previously defined in the category tree; In turn, you can assign a role and a differentiated strategy for each cluster, and see the information regarding the distribution and assignment of the segments.',
          LIST: {
            CATEGORIES: 'Categories',
            CLUSTERIZATION: 'Clustering',
            ROL: 'Role',
            STRATEGY: 'Strategy',
            SEGMENTATION: 'Segmentation',
            SEGMENT_QUANTITY: '# Segments',
            SEGMENT_QUANTITY_TTIP: 'Segments Quantity',
            CLASSIFIELDS: 'Classified %',
            CLASSIFIELDS_TTIP: 'Percentage of products within the category classified with a segment.',
            SWITCH_ACTIVE: 'Show Categories without Assignment',
            SWITCH_INACTIVE: 'Show Categories with Assignment',
            CLUSTERIZATION_OR_SEGMENT_DISABLE: 'Category not editable because it has associated items.',
            FILTER_TTIP: 'Filter',
            NOTFOUNDCATEGORYTREE:
              'No Categories without Assignment were found with these selected filters, request assistance from support to enable them',
            WITHOUTCLUSTERIZATION: 'Without Clustering',
            WITHOUTSEGMENT: 'Without Segments',
            WITHOUTSTRATEGY: 'Without Strategies',
            WITHOUTROL: 'Without Clusters',
            WITHOUTCLUSTER: 'Without Clusters',
          },
        },
        ROLES_STRATEGIES_ASSIGN: {
          SUBTITLE:
            'On this screen you can assign a cluster for each category level, previously defined in the category tree. In turn, for each cluster or point of sale of the selected cluster, you can assign a role and a differentiated strategy.',
          EXPORT_TTIP: 'Export',
          FULLSCREEN_TTIP: 'Expand',
          EXITFULLSCREEN_TTIP: 'Reduce',
          IMPORT_TTIP: 'Import',
          PRINT_TTIP: 'Print',
          CATEGORIES: 'Categories',
          CLUSTERING: 'Clustering',
          ROL: 'Role',
          STRATEGY: 'Strategy',
          UNALLOCATED_TTIP: 'Not assigned',
          SEARCH_CLUSTER: 'Search Cluster...',
          SEARCH_ROL: 'Search Rol...',
          WITHOUT_CLUSTERS: 'Function enabled if clusters are assigned',
          SEARCH_STRATEGY: 'Search Strategy...',
          CHANGE_CLUSTERING_TITLE: 'Are you sure about changing this clustering?',
          CHANGE_CLUSTERING_SUBTITLE: 'This will clear the roles and strategies assigned to all the clusters in this category.',
          CANCEL_BTN: 'Cancel',
          CHANGE_BTN: 'Change',
          ACCEPT_BTN: 'Accept',
          CHANGE_RS_TITLE: 'Modify Role / Strategy',
          CHANGE_RS_SUBTITLE: 'Do you want to assign: {{val}} to all the clusters in this category?',
          ROUTE: 'Assortment / Configuration',
          TITLE: 'Category Setup',
        },
        ROLES: {
          ROUTE: 'Assortment / Setup',
          TITLE: 'Roles',
          SUBTITLE: 'On this screen you can create and modify the different roles that will be assigned to the categories.',
          NEW_ROLE_BTN: 'New Role',
          FULLSCREEN_TTIP: 'Expand',
          EXITFULLSCREEN_TTIP: 'Reduce',
          EXPORT_TTIP: 'Export',
          IMPORT_TTIP: 'Import',
          PRINT_TTIP: 'Print',
          DELETE_TTIP: 'Delete selected roles',
          DELETE: 'Delete',
          NAME: 'Name',
          OBSERVATION: 'Observation',
          DELISTING_RULE: 'Rule Deactivate',
          LISTING_RULE: 'Rule Activate',
          OTHERS_RULES: 'Othes Rules',
          FRECUENCY: 'Frequency',
          DEFINE_ROL_STP1: 'Setup Role',
          DELISTING_RULES_STEP2: 'Deactivate Rules',
          LISTING_RULES_STEP3: 'Activate Rules',
          OTHERS_RULES_STEP4: 'Additional Rules',
          FRECUENCY_STEP5: 'Analysis Frequency',
          TITLE_FORM_NEW: 'New Role',
          TITLE2_FORM_NEW: 'New Role /',
          STP1: 'Step 1 - Setup Role',
          LEGEND_ROL:
            'The Category Role sets the criteria to activate or deactivate a product for a given cluster. The role and the strategy define the criteria and metrics to be evaluated to generate suggestions.',
          NAME_INPUT: 'Name',
          OBSERVATION_INPUT: 'Observation',
          NEXT_BTN: 'Next',
          STP2: 'Step 2 - Deactivate Rules',
          LEGEND_DELISTING_RULE: 'In this step you can define the criteria to deactivate products.',
          RULE_DELISTING_RULE: 'Suggest deactivate products whose ',
          RULE_LISTING_RULE: 'Suggest activate products whose ',
          RULE_DELISTING_RULE_ALT: 'Suggest deactivating products ',
          RULE_LISTING_RULE_ALT: 'Suggest activating products ',
          RULE_HIGH_AI: 'Suggest activate with AI',
          MINIMUM_AVAILABILITY: 'Minimum availability of ',
          PRESENCE_IN_STORES: 'Minimum store presence of ',
          SUPPLIERS_W_SKU: 'Suppliers with a minimum share of products of ',
          NEW_DATES: 'When new data is entered',
          OPPORTUNITIES_IA: 'When AI finds opportunities',
          AND: 'AND',
          THE: 'the',
          THEFREQ: 'the',
          AUXS: {
            _variableSource: {
              _DEMOMercado: 'Market',
              ParetoCluster: 'Cluster Pareto',
              ParetoGeneral: 'Total Pareto',
              ParetoMarket: 'Market Pareto',
              TotalMarket: 'Total Market',
              ParetoReference: 'Pareto Reference',
            },
            _variableSource_phrase: {
              ParetoCluster: 'of the Cluster Pareto',
              ParetoGeneral: 'of the Total Pareto',
              ParetoMarket: 'of the Market Pareto',
              TotalMarket: 'of the Total Market',
              ParetoReference: 'of the Reference Pareto',
            },
            _variable: {
              WeightedIndex: 'W index',
              SalesUnits: 'Sales U',
              Sales: 'Sales $',
              Margin: 'Margin $',
              MarginWithVendor: 'Margin per agreement',
              PercentageMargin: 'Margin %',
              Gmroi: 'GMROI',
              Presence: 'Presence',
              MarketSales: 'Market $',
              MarketUnits: 'Market Un.',
            },
            _variable_phrase: {
              WeightedIndex: 'of Sales in Weighted Index',
              SalesUnits: 'Sales in units',
              Sales: 'Sales in $',
              Margin: 'Margin in $',
              MarginWithVendor: 'Margin per agreement',
              PercentageMargin: 'Margin in %',
              Gmroi: 'of GMROI',
              Presence: 'of Presence',
              MarketSales: 'Market Sales in $',
              MarketUnits: 'Market Sales in Un.',
            },
            _method: {
              AbsoluteValue: 'Absolute value',
              TotalShare: 'Share %',
              CumulativeShare: 'Accumulated Share %',
            },
            _methodTop: {
              AbsoluteValue: 'Absolute value',
              TotalShare: 'Share %',
              CumulativeShare: 'Accumulated Share %',
            },
            _method_phrase: {
              AbsoluteValue: 'Absolute value',
              TotalShare: 'Share %',
              CumulativeShare: 'Accumulated Share %',
            },
            _condition: {
              GreaterThan: 'is greater',
              LowerThan: 'is less',
              Equals: 'is the same',
            },
            _condition_phrase: {
              GreaterThan: 'be greater than',
              LowerThan: 'be less than',
              Equals: 'be equal to',
            },
            _condition_banner: {
              GreaterThan: 'is greater than',
              LowerThan: 'is less than',
              Equals: 'is equal to',
            },
            _conditionTopBottom: {
              LowerThan: 'Top',
              GreaterThan: 'Bottom',
            },
            _conditionTopBottom_phrase: {
              LowerThan: 'is less than or equal to',
              GreaterThan: 'is greater than or equal to',
            },
            _combinationMethod: {
              And: 'and',
              Or: 'or',
            },
            _combinationMethod_phrase: {
              And: 'and the',
              Or: 'or the',
            },
            _weekday: {
              Monday: 'Monday',
              Tuesday: 'Tuesday',
              Wednesday: 'Wednesday',
              Thursday: 'Thursday',
              Friday: 'Friday',
              Saturday: 'Saturday',
              Sunday: 'Sunday',
            },
            _frecuency: {
              Biweekly: 'Fortnightly',
              Monthly: 'Monthly',
              BiMonthly: 'Bimonthly',
              ThreeMonth: 'Quarterly',
              FourMonth: 'Every 4 months',
              SixMonth: 'Biannual',
              Annually: 'Annual',
            },
            _frecuency_phrase: {
              Biweekly: 'Fortnightly',
              Monthly: 'Monthly',
              BiMonthly: 'Bimonthly',
              ThreeMonth: 'Quarterly',
              FourMonth: 'Every 4 months',
              SixMonth: 'Biannual',
              Annually: 'Annual',
            },
          },
          COMBINATION: 'RULE',
          DELETE_COMBINATION_TTIP: 'Delete Rule',
          CANCEL_BTN: 'Cancel',
          CONFIRM_BTN: 'Confirm deletion',
          VARIABLE_SOURCE_INPUT: 'Source',
          VARIABLE_INPUT: 'Metric',
          METHOD_INPUT: 'Method',
          CONDITION_INPUT: 'Condition',
          VALUE_INPUT: 'Value',
          LOGIC_INPUT: 'Logic',
          REFERENCE_CLUSTER: 'Reference Cluster',
          ADD_COMBINATION_BTN: 'Add Rule',
          PREVIUS_BTN: 'Previous',
          STP3: 'Step 3 - Activate Rules',
          LEGEND_LISTING_RULE: 'In this step you can define the criteria to activate new products.',
          STP4: 'Step 4 - Other Rules',
          LEGEND_OTHERS_RULES: 'In this step you can setup other rules and constraints that you want to add to this role.',
          CHECK_AVAILABILITY: 'Check availability before deactivate',
          CHECK_AVAILABILITY_TEXT:
            'Suggests to deactivate a product only if the availability is equal or higher to the value specified here. You have to have stock data.',
          MINIMUM_AVAILABILITY_INPUT: 'Min. Availability',
          MINIMUM_AVAILABILITY_TTIP: 'Minimum Availability',
          CHECK_PRESENCE: 'Check presence before deactivate',
          CHECK_PRESENCE_TEXT:
            'Suggests deactivate only when a product has had sales at a minimum of {{val}}% of the stores in the cluster and within the selected period of analysis.',
          MINIMUM_PRESENCE_INPUT: 'Minimum Pres.',
          MINIMUM_PRESENCE_TTIP: 'Minimum Presence',
          CHECK_SUPPLIER: 'Check suppliers with few products',
          CHECK_SUPPLIER_TEXT:
            'If this option is activated, Prisma will suggest the deactivate of all products belonging to suppliers with a sales share lower than specified here, thus optimizing your supply chain.',
          MINIMUM_PART_INPUT: 'Minimum Share',
          MINIMUM_PART_TTIP: 'Minimum Share',
          SUGGEST_HIGH: 'Suggest activate with artificial intelligence',
          SUGGEST_HIGH_TEXT:
            'Prisma artificial intelligence will suggest activate products depending on their attributes and performance in the {{val}} / cluster.',
          COMING_SOON: 'Coming soon',
          STP5: 'Step 5 - Frequency of Analysis',
          LEGEND_CATEGORY_ANALYSIS:
            'In this step you will define how often you will execute a range review analysis for the categories with this role.',
          FRECUENCY_INPUT: 'Frequency',
          WEEKDAY_INPUT: 'Weekday',
          GENERATE_SUGGESTIONS_IA: 'Generate activate suggestions when AI finds opportunities',
          GENERATE_SUGGESTIONS_IA_TEXT: 'Suggestions to activate new products will be generated using Prisma AI proprietary algorithms.',
          GENERATE_SUGGESTIONS: 'Generate activate suggestions every time new market information is available',
          GENERATE_SUGGESTIONS_TEXT: 'Generate activate suggestions for new product releases based on available market information.',
          SAVE_BTN: 'Save',
          NEW_COMBINATION: 'New Rule',
          ADD_BTN: 'Add',
          REPEATED_VARIABLE_AND_SOURCE: 'Variable and Source cannot be duplicated for more than one rule.',
          SUGGESTION_ROLE_NAME: 'Role Suggestion',
          SUGGESTION_ROLE_DESCRIPTION: 'Suggestion Description',
        },
        STRATEGIES: {
          DELETE_TITLE: 'Delete Strategy',
          DELETE_TITLE_MULTIPLE: 'Delete Strategies',
          DELETE_CONTENT: '{{val}} strategy will be deleted.',
          DELETE_CONTENT_MULTIPLE: '{{val}} strategy records will be deleted.',
          ROUTE: 'Assortment / Setup',
          TITLE: 'Strategies',
          SUBTITLE: 'On this screen you can create and modify the different strategies that will be assigned to the categories.',
          NEW_STRATEGY_BTN: 'New Strategy',
          FILTER_TTIP: 'Filter',
          FULLSCREEN_TTIP: 'Expand',
          EXITFULLSCREEN_TTIP: 'Reduce',
          EXPORT_TTIP: 'Export',
          IMPORT_TTIP: 'Import',
          PRINT_TTIP: 'Print',
          DELETE_TTIP: 'Delete selected strategies',
          DELETE: 'Delete',
          STRATEGY: 'Strategy',
          OBSERVATION: 'Observation',
          VARIABLE: 'Metric',
          NEWS: 'New',
          TYPOLOGIES: 'Classification',
          PERIOD: 'Period',
          DEFINE_STRATEGY_STP1: 'Setup Strategy',
          VARIABLES_SELECTION_STP2: 'Metric Selection',
          OTHER_CONFIGURATIONS_STP3: 'Other Settings',
          ANALYSIS_PERIOD_STP4: 'Analysis period',
          TITLE_FORM_NEW: 'New Strategy',
          TITLE_FORM_EDIT: 'Edit Strategy',
          STP1: 'Step 1 - Setup Strategy',
          LEGEND_STRATEGY: 'The strategy will help you define the metric by which the Pareto analysis will be performed.',
          NAME_INPUT: 'Name',
          OBSERVATION_INPUT: 'Observation',
          NEXT_BTN: 'Next',
          STP2: 'Step 2 - Selection of Metrics',
          LEGEND_SELECTION_VARIABLES: 'In this step you can define the criteria to assortment is going to be analyzed and optimized.',
          VARIABLE_INPUT: 'Metric',
          COMBINATION_PERCENTAGE_INPUT: 'combination',
          VALIADATION: 'The value entered must be greater than 0 or equal to 100%',
          DELETE_VARIABLE_TTIP: 'Delete',
          VALIADATION2: 'The sum of all metrics must be 100%',
          ADD_COMBINATION_BTN: 'Add Combination',
          PREVIUS_BTN: 'Previous',
          STP3: 'Step 3 - Other Settings',
          LEGEND_OTHER_CONFIGURATIONS: 'In this step you can enter additional settings that will improve the accuracy of the analysis.',
          OTHER_CONFIGURATIONS_TEXT: 'A product is considered new by',
          DAYS_INPUT: 'Days',
          DAY_INPUT: 'Day',
          SINCE_TEXT: 'considered new from its',
          SINCE: 'from',
          EVENT_INPUT: 'Event',
          TYPOLOGIES_TEXT: 'CLASSIFICATION (Pareto sections):',
          DEFINE_PARETO_TEXT: ' Define the Pareto sections ranges to classify products automatically based on the selected metric.',
          HIGH_ROTATION: 'FAST-MOVING',
          HIGH_ROTATION_TEXT: ': Products that their accumulated index (Pareto) goes from 0 to',
          VALIDATION_HIGH_ROTATION: 'Must be less than 100% and less than Slow-Moving products',
          LOW_ROTATION: 'SLOW-MOVING',
          LOW_ROTATION_TEXT: ': Products that their accumulated index (Pareto) goes from {{val}}% to',
          VALIDATION_LOW_ROTATION: 'Must be less than 100% and greater than High Rotation',
          LONG_TAIL: 'LONG TAIL',
          LONG_TAIL_TEXT:
            ': Products that their accumulated index (Pareto) goes from {{val}}% to 100%. They are the last {{val2}}% of the Pareto.',
          WITHOUT_ROTATION: 'NON-MOVING',
          WITHOUT_ROTATION_TEXT: ': Products with no sales during the selected period of analysis.',
          NEWS1: 'NEW ITEMS',
          NEWS_TEXT: 'Products that have less than {{val}} days since their {{val2}}',
          STP4: 'Step 4 - Analysis Period',
          DEFINE_PERIOD_TEXT:
            'In this step you can define the period in months that it will take to perform the analysis. To normalize and be able to compare you will always see average values ​​expressed at 30 days in reports and pareto.',
          LATEST_INPUT: 'Latest',
          MONTHS: 'Months',
          JANUARY: 'JAN',
          FEBRUARY: 'FEB',
          MARCH: 'MAR',
          APRIL: 'APRL',
          MAY: 'MAY',
          JUNE: 'JUN',
          JULY: 'JUL',
          AUGUST: 'AUG',
          SEPTEMBER: 'SEP',
          OCTOBER: 'OCT',
          NOVEMBER: 'NOV',
          DECEMBER: 'DEC',
          LEGEND_MOTHS:
            'If you exclude a month from the list, it will not be considered as part of the average. If the number of selected months is less than the selected period, the average will be calculated using the number of months available.',
          SAVE_BTN: 'Save',
          FROM_DATE_OF: 'days from',
          LAST_MONTH_: 'Last Month',
          LASTS_: 'Last',
          MONTHS_: 'Months',
          EXCEPT_FOR: 'Except for',
          MONTHS_VALIDATION: 'Analysis months cannot be greater than the enabled months',
        },
        RULES: {
          ROUTE: 'Assortment / Setup',
          TITLE: 'Assignment and Exclusion Rules',
          SUBTITLE: 'On this screen you can create and modify the different configuration rules.',
          DOWNLOAD_CATALOG: 'DOWNLOAD CATALOG',
          DOWNLOAD_CATALOG_ERROR: 'Error downloading catalog. Please try again.',
          DOWNLOAD_UNASSIGNED: 'DOWNLOAD UNASSIGNED',
          DOWNLOAD_UNASSIGNED_TOOLTIP: 'Select a category to download',
          DOWNLOAD_UNASSIGNED_ERROR: 'Error downloading unassigned. Please try again.',
          VIEW_RULES: 'VIEW RULES',
          SELECT_CATEGORY_TITLE: 'Select <the Category> you want to work with',
          SELECT_CATEGORY_DESCRIPTION: 'Once selected, you can group stores and assign the category assortment',
          SELECTED_CATEGORY: 'Selected category',
          STORES_TAB: 'STORES OF THE SELECTED CATEGORY',
          PRODUCTS_TAB: 'PRODUCTS OF THE SELECTED CATEGORY',
          SELECT_CATEGORY_MESSAGE: 'Please select a category to view stores',
          SEARCH_STORES: 'Search stores by name or code',
          STORES_WITHOUT_ASSORTMENT: 'There is at least one store(s) without assigned assortment',
          VIEW: 'VIEW',
          BACK: 'BACK',
          STORE_COLUMN: 'Store',
          TAGS_COLUMN: 'Tags',
          CATEGORIES_COLUMN: 'Assigned Categories',
          NO_ASSORTMENT: 'No assortment',
          NO_STORES_FOUND: 'No stores found with the applied filters.',
          SEARCH_PRODUCTS: 'Search products',
          PRODUCTS_WITHOUT_ASSORTMENT: 'There is at least one product not assigned to any store',
          PRODUCT_COLUMN: 'Product',
          STORES_COLUMN: 'Stores',
          IN_ALL_STORES: 'In all stores',
          IN_STORES: 'In {{val}} Stores',
          IN_ZERO_STORES: 'In 0 stores',
          NO_PRODUCTS_FOUND: 'No products found',
          NO_PRODUCTS_IN_CATEGORY: 'There are no products in this category',
          NO_ASSIGNMENT_MESSAGE: 'You have not yet assigned this assortment to any store',
          CREATE_FIRST_RULE: 'Create the first assignment rule for the category',
          DOWNLOAD_ITEMS_STORES_WITHOUT_ASSIGNMENT: 'DOWNLOAD ITEMS/STORES WITHOUT ASSIGNMENT',
          CREATE_RULE: 'CREATE RULE',
          SEARCH_RULES: 'Search rules',
          RULE_TYPE_FILTER_LABEL: 'Rule type',
          RULE_TYPE_FILTER_ALL: 'All',
          RULE_TYPE_FILTER_INCLUSION: 'Inclusion',
          RULE_TYPE_FILTER_EXCLUSION: 'Exclusion',
          KPI_INCLUSION_ONLY_WARNING: 'The KPIs shown always reflect inclusion rules, not exclusion rules.',
          DELETE_MODAL: {
            TITLE_ONE: 'Do you want to delete the rule {{val}}?',
            CONTENT: 'This action cannot be undone. The rule will be permanently deleted.',
          },
          CREATE_RULE_MODAL: {
            TITLE: 'Configure new rule',
            STEP1_LABEL: 'Segment your Stores',
            STEP2_LABEL: 'Segment your assortment',
            STEP3_LABEL: 'Name the rule',
            STEP1_TITLE: 'Segment your stores',
            STEP2_TITLE: 'Segment your assortment',
            STEP3_TITLE: 'Name the rule',
            BUTTON_NEXT: 'NEXT STEP',
            STEP3_HEADING: 'Assign a name to this rule',
            STEP3_NAME_PLACEHOLDER: 'Assign a name to this rule',
            REQUIRED_FIELD: 'Required field',
            SUMMARY_TITLE: 'Rule summary',
            SUMMARY_STORES_TITLE: 'In the following ({{val}}) stores:',
            SUMMARY_ITEMS_TITLE: 'Assign the following ({{val}}) items:',
            SUMMARY_EXCLUDING: 'Excluding',
            SUMMARY_STORES_INCLUDED: 'Included stores ({{val}})',
            SUMMARY_PRODUCTS_INCLUDED: 'Included products ({{val}})',
            SUMMARY_NO_STORES: 'There are no stores to display.',
            SUMMARY_NO_ITEMS: 'There are no products to display.',
          },
          KPI_STORES_TITLE: 'Total Stores vs Assigned Stores',
          KPI_STORES_SUBTITLE: 'Assigned stores are those that have assigned assortment',
          KPI_STORES_TOTAL: 'Total Stores',
          KPI_STORES_ASSIGNED: 'Assigned Stores',
          KPI_STORES_UNASSIGNED: 'Unassigned Stores',
          KPI_ITEMS_TITLE: 'Total Items vs Assigned Items',
          KPI_ITEMS_SUBTITLE: 'Lorem ipsum dolor',
          KPI_ITEMS_TOTAL: 'Total assortment items',
          KPI_ITEMS_ASSIGNED: 'Total assigned items',
          KPI_ITEMS_UNASSIGNED: 'Total unassigned items',
          KPI_PROGRESS: 'Progress',
          TABLE_RULE_NAME: 'Rule Name',
          TABLE_STORE_SEGMENTS: 'Store Segments',
          TABLE_STORE_COUNT: 'Store Count',
          TABLE_ITEM_SEGMENTS: 'Item Segments',
          TABLE_ITEM_COUNT: 'Item Count',
          TABLE_EXCLUDES: 'Excludes',
          NO_RULES_MESSAGE: 'No rules available',
        },
        SEG_ASSIGNMENT: {
          ROUTE: 'Assortment / Setup',
          TITLE: 'Assign Segments',
          SUBTITLE:
            'On this screen you can assign for each category level, previously defined in the category tree, the main product segmentation that will be used to carry out the analysis and assortment optimization.',
          EXPORT_TTIP: 'Export',
          FULLSCREEN_TTIP: 'Expand',
          EXITFULLSCREEN_TTIP: 'Reduce',
          IMPORT_TTIP: 'Import',
          PRINT_TTIP: 'Print',
          CATEGORY: 'Category',
          SEGMENTATION: 'Segmentation',
          NOT_ASSIGNED_TTIP: 'Not allocated',
          SEARCH_SEGMENTATION: 'Search Segmentation...',
          SEGMENT_QUANTITY: '# Segm. Quantity',
          SEGMENT_QUANTITY_TTIP: 'Segment Quantity',
          CLASSIFIELDS: 'Classified %',
          CLASSIFIELDS_TTIP: 'Percentage of products within the category classified with a segment.',
        },
        CATEGORIES: {
          ROUTE: 'Assortment / Setup',
          TITLE: 'Category Tree',
          SUBTITLE: 'Here you can visualize the hierarchy of categories loaded in Prisma.',
          SAVE_BTN: 'Save',
          PRINT_TTIP: 'Print',
          FULLSCREEN_TTIP: 'Expand',
          EXITFULLSCREEN_TTIP: 'Reduce',
          SECTOR: 'Sector',
          CATEGORY: 'Category',
          SUBCATEGORY: 'Subcategory',
          ELEMENTS: 'Elements',
          SELECTED_CATEGORIES_TTIP: 'Selected Categories: ',
          MODAL_TTILE: 'Do you wish to save changes?',
          MODAL_SUBTTILE: 'When saving the previous changes will be stepped on',
          CLOSE_BTN: 'Close',
          UNDO_BTN: 'Undo changes',
          ACCEPT_BTN: 'Accept',
        },
        HELP: {
          VARIABLE_SOURCE_INPUT:
            'Indicates if the suggestion is going to be generated based on the pareto of the cluster being analyzed, the pareto of all the clusters or with market information.',
          VARIABLE_INPUT: 'Indicate with which variable the pareto is to be constructed to evaluate the rule.',
          CONDITION_INPUT: 'Indicates the numerical condition to generate the rule. It can be greater, lesser or equal.',
          METHOD_INPUT:
            'It allows defining what type of cut is going to be used for the rule. It can be an absolute value, a percentage of participation or a cumulative percentage of participation.',
          VALUE_INPUT: 'Numeric value required to complete the rule condition.',
          FRECUENCY_INPUT: 'Indicates the repetition of the category analysis over time.',
          WEEKDAY_INPUT: 'Days of the week in which the category analysis should be carried out.',
          VARIABLE_S_INPUT: 'Indicates with which variable the assortment is to be analyzed.',
          COMBINATION_PERCENTAGE_INPUT:
            'Indicates the percentage of the variable that will be taken into account for the analysis. If it is a single variable, the value must be 100%. If there are more analysis variables, the sum of the analysis percentages of the same should be 100%.',
        },
        MARKET_INFO: {
          TITLE: 'Market Items',
          CATEGORY_ASSIGN: 'Assign Category',
          CATEGORY_ASSIGN_TOOLTIP: 'Assign Category',
          CATEGORY_ASSIGN_DISABLED_TOOLTIP: "You don't have permissions",
          CATEGORY_ASSIGN_MSG: 'Please select a Category to assign to the chosen Items.',
          marketItemName: 'Name',
          marketItemCode: 'Barcode',
          marketCategory: 'Market Category',
          prismaCategory: 'Category',
          marketItemBrand: 'Brand',
          marketItemManufacturer: 'Manufacturer',
          matching: 'Matching',
          CREATION_DATE: 'Creation Date',
          ITEMS_NOT_MATCH: 'See Items without matching',
          MARKET_CATEGORIES: 'Market Categories',
          MARKET_CATEGORY: 'Market Category',
          PRODUCT: 'Item',
          PRODUCTS: 'Items',
          itemMarketDataType: {
            ownItems: 'Own Items',
            marketItems: 'Market Items',
            all: 'Everyone',
          },
        },
      },
      DECISIONS: {
        ASSORT_ASSIGNATION: {
          ROUTE: 'Assortment / Decisions',
          TITLE: 'Assortment Decisions',
          SUBTITLE:
            'On this screen you can see how the assortment mix by category is made up in each cluster. In turn, we had a summary of overvoltages and impacts of the same. Using the switches, you can activate or deactivate categories in each cluster and within each category, segments, or assortment mix.',
          SELECT_CATEGORY: 'Select the category you want to work with.',
          LAST_SALE: 'Last month of sales:',
          NO_DATA: 'No data',
          LAST_STOCK: 'Last month of stock:',
          LAST_MARGIN2: 'Last month of Margin by Agreements:',
          LAST_MARKET_INFO: 'Last month of Market Information:',
          SHOW_CLUSTER_ASSORTMENT: 'Choose a Category to show the assortment of each cluster',
          FILTER_TTIP: 'Filter',
          FULLSCREEN_TTIP: 'Expand',
          EXITFULLSCREEN_TTIP: 'Reduce',
          PRINT_TTIP: 'Print',
          CLUSTER: 'Cluster',
          CATEGORY: 'Category',
          SEGMENT: 'Segment',
          NO_SEGMENT: 'You must have a segment to be able to activate it',
          IE: 'EI %',
          LISTINGS: '# Active',
          SKUS: '# Products',
          TOTAL: '# Total',
          INACTIVE: '# To Deactivate',
          ACTIVE: '# To Activate',
          IMPACT: 'Impact $',
          VIEW_PARETOC_TTIP: 'Click here to view pareto of "category" in "cluster"',
          VIEW_PARETOT_TTIP: 'Click here to view pareto of "category" total company',
          IMPACT_TTIP: 'Impact on $ Sales if suggestions are activate or deactivate',
          DELIST_TTIP: 'Number of Suggestions to Deactivate',
          LIST_TTIP: 'Number of Suggestions to Activate',
          TOTAL_TTIP: 'Total products within the segment',
          LISTINGS_TTIP: 'Total active products in the cluster',
          PERCENTAGE_TTIP: 'Percentage of products active',
          ERROR: 'Allocation failed',
          CORRECT: 'Allocation saved successfully',
          ACCEPT_BTN: 'Accept',
          ENABLE_ASSIGNMENT_TITLE: 'Confirm activate these products in this cluster?',
          DISABLE_ASSIGNMENT_TITLE: 'Confirm deactivate these products in this cluster?',
          ACTION_ASSIGNMENT_SUBTITLE: 'This action will modify the assortment of all the products within the Cluster.',
          CANCEL_BTN: 'Cancel',
          EDIT_BTN: 'Modify',
          CHECK: 'Do not ask again.',
          TITLE_FILTERS: 'Filters',
          CATEGORY_FILTERS: 'Category',
          CATEGORY_FILTERS_TTIP: 'You must select at least one category to be able to filter by cluster',
          SEARCH_CATEGORY: 'Search Categories...',
          COUNT_FILTRED: 'Filtered count',
          TOTAL_COUNT: 'Total count',
          CLUSTER_FILTERS: 'Cluster',
          WITHOUT_NEWS: 'Without new products',
          TOTALITEMS: 'Total Products',
          TOTALSALES: 'Total sales',
          MSG_WITHOUT_NEWS:
            'The products that are not in a new state will be displayed, maintaining the position they occupy in the pareto',
          WITHOUT_INACTIVES: 'Without inactive products',
          MSG_WITHOUT_INACTIVES: 'Inactive products for selected clusters will not be displayed',
          RECALC_PARETO: 'Recalculate pareto',
          SHOW_ONLY_SUGGESTIONS: 'Show Only Suggestions',
          MSG_RECALC_PARETO: 'The pareto will be updated based on the filtered products',
          ANALYST_FILTERS: 'Analyst',
          APPROVER_FILTERS: 'Approver',
          CLEAN_FILTER_BTN: 'Clear',
          APPLY_FILTER_BTN: 'Apply',
          UNASSIGNEDSEGMENTS: 'Show Unassigned Segments',
          UNASSIGNEDCLUSTERS: 'Show Unassigned Clusters',
          EXPORT_TTIP: 'Export',
        },
        ASSORT_ASSIGNATION_ITEM: {
          OBSERVATION: 'Observations',
          ACTIVE_IN: 'Active in',
          ITEM_TAGS: 'Product Filters',
          STORE_TAGS: 'Filters for Stores',
          BEHAVIOR_FOR_CATEGORY: 'This item can only be operated from the general cluster pareto.',
          SUGGESTION_MODAL_MSG:
            'The request to generate suggestions for this cluster will be taken, you will be notified once the process is complete, it may take a few minutes',
          NOT_ASSORTMENT_BASED: 'This Item is not assortment based. You must modify it from item master first.',
          BLOCKED_FOR_SALES: 'This item is blocked for sale. You must modify it from item master first.',
          BLOCKED_FOR_MARKET: 'This item is blocked. Market Product, it should be managed from the suggestions by cluster.',
          ROUTE: 'Assortment Allocation /',
          FILTER_TTIP: 'Filter',
          FULLSCREEN_TTIP: 'Expand',
          ORDER_TTIP: 'Order',
          EXITFULLSCREEN_TTIP: 'Reduce',
          PRINT_TTIP: 'Print',
          ACTIVATE: 'Activate',
          ACTIVATE_TTIP: 'Activate the selected products',
          INACTIVATE: 'Deactivate',
          INACTIVATE_TTIP: 'Deactivate the selected products',
          PRODUCT: 'Product',
          BRAND: 'Brand',
          STATE: 'State',
          ACTIVE: 'Active',
          INACTIVE: 'Inactive',
          INACTIVE_MARKET_PROD: 'Market Product, suggestions for action should be generated',
          SEGMENT: 'Segment',
          CIA: '# UN Comp.',
          MARKET: '# UN Mark.',
          PRICE: 'Price $',
          MARGIN: 'Margin %',
          CORRECT: 'Allocation saved successfully',
          REPORT_OK: 'Generating Exceptional Inventory Report. You will be notified when the item report is ready.',
          ACCEPT_BTN: 'Accept',
          TITLE_FILTERS: 'Filters',
          STATE_FILTERS: 'State',
          ALL_OP1: 'All',
          ACTIVE_OP2: 'Active',
          INACTIVE_OP3: 'Inactive',
          CLEAN_FILTER_BTN: 'Clear',
          APPLY_FILTER_BTN: 'Apply',
          LISTING: 'Activate',
          DELISTING: 'Deactivate',
          ACCEPT_SUGGESTION: 'Accept Suggestion',
          REJECT_SUGGESTION: 'Reject Suggestion',
          ACCEPT_SUGGESTIONS: 'Accept Suggestions',
          REJECT_SUGGESTIONS: 'Ignore Suggestions',
          REVERT_SUGGESTION: 'Revert Changes',
          REVERT_SUGGESTION_TO_INACTIVE: 'Revert Changes (Inactivate)',
          REVERT_SUGGESTION_TO_ACTIVE: 'Revert Changes (Activate)',
          COLUMN_DISPLAY_TTIP: 'Column Display',
          REPORTS: 'Reports',
          SUGGESTION: 'Generate Suggestion',
          PRODUCTS: 'Products',
          SALES: 'Sales',
          IMPACT: 'Sales Impact',
          DAYS: 'Days',
          COST: 'Cost $',
          ORDERS: '# Orders',
          DAYS_STOCK: 'Days of Stock',
          IN_STOCK: 'In-Stock',
          CLUSTER_SUGGESTION_ADD_TTIP: 'Inactive / It is suggested to add this product in this cluster based on the generated rule.',
          CLUSTER_SUGGESTION_REMOVE_TTIP: 'Active / It is suggested to remove this product in this cluster based on the generated rule.',
          REFERENCE_MISSING_TTIP: 'This product could not be evaluated: it has no data in the rule Reference Cluster.',
          CLUSTER_SUGGESTION_ADD_DEMO_TTIP: 'Suggest activating products with sales share within the top 80% of the market',
          CLUSTER_SUGGESTION_REMOVE_DEMO_TTIP: 'Suggest deactivating products at bottom 5% of sales and availability above 80%',
          ACTIVE_NEW: 'To Activate',
          INACTIVE_NEW: 'To deactivate',
          ASSORTMENT_FOR_CATEGORY__BY_CLUSTER: 'Handle by Cluster',
          ASSORTMENT_FOR_CATEGORY__BY_CATEGORY: 'Handle by General Total',
          LISTING_ALL_CLUSTERS: 'Activate in all Clusters',
          DELISTING_ALL_CLUSTERS: 'Deactivate in all Clusters',
          STATUS_PDV: 'Only Assortment of Stores',
          STATUS_COMBO: 'Part of Recipe or Combo',
          CHANGE_GENERAL_CONFIRM_DIALOG_TITLE: 'Assortment Assignment Confirmation',
          CHANGE_GENERAL_CONFIRM_DIALOG_BODY: 'Do you want to handle this Item in a General Total?',
          CHANGE_GENERAL_CONFIRM_DIALOG_BODY_ALT:
            'Assortment assignment will be changed to "General". The individual assignments of each cluster will be lost.',
          WHITH_FILTERS: 'With Filters',
          WHITH_NO_FILTERS: 'Without Filters',
          setOrderBydefault: 'Sort by Pareto',
          setOrderBysalesShare: 'Sort by Sales Share',
          setOrderBysalesShareGap: 'Sort by Share GAP',
          EXIST_EXCEPTION_STORE_ASSORTMENT_TOOLTIP:
            'There are Exceptional Stock Settings for this item. Click here to download the report.',
          STORE_CLUSTER_COUNT_TOOLTIP_ACTIVE: 'The product is Active for sale in {{val}} out of {{val2}} POS.',
          STORE_CLUSTER_COUNT_TOOLTIP_INACTIVE: 'The product is Inactive for sale in {{val}} out of {{val2}} POS.',
        },
        ASSORT_CLUSTER_REPORTS: {
          GENERAL_REPORT: 'General Report',
          REPORT_DECISIONS: 'Decision Support Reports',
          CLUSTER_REPORT: 'Report by Cluster',
          PREFIX_REPORT: 'Report by',
        },
        ERP: {
          ROUTE: 'Assortment / Decisions',
          TITLE: 'Publish Decisions',
          DOWLOAD_BTN: 'Download Info',
          PREVIEW_BTN: 'Preview',
          INFORM_BTN: 'Publish',
          LAST_PRICES: 'Latest Prices Published',
          GENERATION_DATE: 'Generation date',
          GENERATION_TIME: 'Generation Time',
          USER: 'User',
          FILE: 'File',
          FULLSCREEN_TTIP: 'Expand',
          EXITFULLSCREEN_TTIP: 'Reduce',
          PREVIEW_PROCCESING: 'Processing has started. You will receive a notification when it is finished.',
          PREVIEW_WITHOUT_PROCCESING: 'There is no new data to process.',
          REPORT_ASSORTMENT_DECISIONS: 'Assortment Decisions',
          REPORT_MARKET_ITEM: 'Market Items',
        },
      },
      REPORTS: {
        TITLE_DECISIONS: 'Decision Reports',
        CLUSTER_ANALYSIS: {
          ROUTE: 'Assortment / Reports',
          TITLE: 'Cluster Analysis',
          SUBTITLE:
            'Prisma uses artificial intelligence algorithms to detect consumer purchasing patterns and thus validate the clustering carried out. On this screen, you can analyze the consistency of previously defined clustering and change a point of sale of a cluster if necessary. By accepting a change suggestion, Prisma will automatically produce the assortment reassignment and the report that must be published or points of sale for the change to be correctly implemented.',
          DISPERSION_TITLE: 'Scattering of {{val}} by Cluster',
          EXPORT_TTIP: 'Export',
          APP_TTIP: 'Share to the App',
          DASHBOARD_TTIP: 'Go to dashboard',
          NUMBER_OF_STORES: 'Number of Stores',
          PREVIOUS_MONTH_DIF: 'Dif % Vs Previous Month',
          CLUSTER_QUANTITY: 'Cluster Quantity',
          PREVIEW_PROCCESING: 'Processing has started. You will receive a notification when it is finished.',
          PREVIEW_WITHOUT_PROCCESING: 'There is no new data to process.',
        },
      },
      ADMIN: {
        IMPORTERS: {
          MARKET_INFO: {
            TITLE: 'Market Information',
          },
        },
      },
      ABM_MODAL: {
        ROLE_SELECTION: 'Role Selection',
        NEW_ROL_NAME: 'Role Data',
        RULES_TO_DELIST: 'Rules to Deactivate',
        RULES_TO_LIST: 'Rules to Activate',
        MARKET_LIST: 'Market Registration',
        VIEW: 'View',
        RULES_SELECT_LEGEND1:
          'The request to generate the suggestions for this category will be taken, you will be notified once the process is complete, it may take a few minutes.',
        RULES_SELECT_LEGEND2:
          'The role is assigned to the category and combined with the strategy define the criteria and variables that will be evaluated in the suggestions.',
        RULES_SELECT_LEGEND3: ' Suggestions will only be generated for visible clusters.',
        ASSIGN_ROLE: 'Assign Role',
        ROLES_TYPES_TITLES: {
          NORMAL: 'Default role of the category:',
          OTHER: 'Assign Previously Created Role',
          NEW: 'Create and assign a new Role',
          TEST: 'Assign Test Rules',
          MARKET: 'Registration of Market products',
        },
        ROLES_TYPES_DESCRIPTION: {
          NORMAL:
            'Suggestions for registration and cancellation will be generated according to the Role already selected for this category.',
          OTHER:
            'The registration and cancellation suggestions will be generated according to the selection of a previously registered Role.',
          NEW: 'Allows you to Create and Assign a new role for this category.',
          TEST: ' Up and Down rules will be assigned and generated according to the predefined settings in a personalized way for this category.',
          MARKET: 'Allows you to create products that you do not have in ItemMaster',
        },
        GENERATE_SUGGESTIONS_OK: 'Suggestion assigned successfully',
      },
    },
    IMV2: {
      LIST: {
        TITLE: 'Item Master',
        NEW_ITEM: 'New Item',
        ROUTE: 'item-master / list',
        DELETE: 'Delete',
        DELETE_TTIP: 'Deactivate the registry',
        UNDELETE: 'Activate',
        UNDELETE_TTIP: 'Activate the registry',
        DELETE_ROWS: 'Inactive records',
        DELETE_ROW_CONTENT: 'Are you sure you want to inactive {{val}}? it can be inactivated if is not in use',
        DELETE_ROWS_CONTENT: 'Are you sure you want to inactive {{val}} products? they can only be inactivated if they are not in use',
        UNDELETE_ROW: 'Activate Record',
        UNDELETE_ROWS: 'Activate Records',
        UNDELETE_ROW_CONTENT: 'Are you sure you want to activate {{val}}? it will be activated with the state new',
        UNDELETE_ROWS_CONTENT: 'Are you sure you want to activate {{val}} products? they will be activated with the state new',
        ACTION_ROW_CONTENT_SUCCESS: 'Action completed successfully',
        ENTITIES: {
          REPORT: 'Full report here',
          APPLY: 'Due to being in use in the following entities:',
          ITEM_NOT_FOUND: 'Item/s not found',
          USEDINCOMBOS: 'Combos: {{val}}',
          USEDINMISSIONS: 'Missions: {{val}}',
          USEDINPARENTRULES: 'Pricing rules: {{val}}',
          USEDINPLANOGRAMS: 'Planograms: {{val}}',
          USEDINPROMOTIONS: 'Promotions: {{val}}',
          USEDINRECIPES: 'Recipes: {{val}}',
          IMPEDIMENT: {
            USEDINPARENTRULES: 'Parent product cannot be empty. Delete rule and create a new one with another parent product if required.',
            USEDINMISSIONS: 'Gift product cannot be left empty. Assign another gift product first.',
            USEDINPLANOGRAMS: 'A product present in a planogram cannot be deleted. Remove from planogram first.',
            USEDINRECIPES: 'You cannot delete a product that is part of a recipe. Remove from recipe first.',
            USEDINCOMBOS: 'The last product of a block cannot be removed. Add another product to the block or remove the block.',
          },
        },
        ACTION_FAIL: {
          DESCRIPTION_ERROR: 'The problem was caused by ',
          TYPE: 'Type: {{val}}',
          KEYWORD: 'Keyword: {{val}}',
          VALUES: 'Values: {{val}}',
          WARNING: 'Alert',
          ERROR: 'Error',
          ENTITYNOTFOUND: 'Entity not found',
        },
        FILTER_TTIP: 'Filter',
        FULLSCREEN_TTIP: 'Maximize',
        EXPORT_TTIP: 'Export',
        REPORT_REQUIRES_FILTER: 'Apply at least one filter to generate the report',
        NAME: 'Name',
        CODE: 'Code',
        INTERNAL_CODE: 'Internal Code',
        CODE_EXIST: 'The code {{val}} already exist',
        TYPE: 'Type',
        CATEGORY: 'Category',
        SUBCATEGORY: 'Subcategory',
        BRAND: 'Brand',
        EDIT_ROW: 'Edit record',
        VIEW_ROW: 'View record',
        EDIT_ROW_DISABLED_TOOLTIP: 'Cannot edit a record in publishing process',
        COPY_ROW: 'Copy record',
        DISABLED_CLONE_TOOLTIP: 'Only records in published state can be cloned',
        DISABLED_CLONE_TOOLTIP_OR_NEW: 'Only published or new records can be cloned.',
        DELETE_ROW: 'Inactive record',
        TYPE_FILTERS: 'Types of items',
        SEE_DELETED_FILTERS: 'View Inactivated',
        SEE_ITEMS_CREATED_WHIT_MARKET_RULE: 'See Items created based on Market Information',
        SEE_WITHOUT_EXHIBITION: 'See items without exhibition unit',
        SHORT_NAME: 'Short Description',
        STATUS: 'Status',
        STATUS_NEW: 'New',
        STATUS_MODIFIED: 'Modified',
        STATUS_CURRENT: 'Posted',
        EAN: 'Internal Code',
        ITEM_CREATION_ON: 'Item Creation Date',
        DEPARTMENT: 'Department',
        CREATOR: 'Created by',
        ITEM_MODIFY_ON: 'Item Modification Date',
        ASSORTMENTBEHAVIORS: 'Assortment',
        STORES_FILTER: 'Stores',
        CLONE_ITEM_TITLE: 'Clone Item',
        CLONE_ITEM_CONTENT:
          'Define name and internal code to the new item. All existing points will be cloned by {{val}} ({{val2}}), having the possibility of editing.',
        ITEM_TAGS: 'Product Filters',
        ITEM_FILTER: 'Item',
        ACTION_ROW_CONTENT_FAILED: 'The action cannot be carried out correctly',
      },
      EDIT: {
        AUTOSAVE: {
          SYNCING: 'Autosaving…',
          SAVED: 'Autosaved',
          ERROR: 'Could not autosave',
        },
        ITEM: {
          SAVE: 'Save',
          PUBLISH: 'Publish',
          WARNING_SAVE: 'Current changes are required to be saved.',
          WARNING_PUBLISH: 'You need to republish for the saved changes to take effect.',
          NOVALID_PUBLISH_ADVICE: 'The following tab is not valid:',
          BASIC_INFORMATION_TAB: 'Main data',
          CLASSIFICATION_TAB: 'Classification',
          UNITS_OF_MEASURE_TAB: 'Units of measure',
          ASSORTMENT_TAB: 'Assortment Planning',
          WARNING_SEGMENT: 'It is necessary to complete the Segment field on Assortment tab, to be able to publish changes.',
          VENDORS_TAB: 'Suppliers, Cost. & Tax.',
          PRICES_TAB: 'Prices',
          INGREDIENTS_TAB: 'Ingredients',
          COMPONENTS_TAB: 'Kit Components',
          CODES_TAB: 'Codes',
          CODES_MATCHING: 'Matchings',
          VARIANTS_TAB: 'Variants',
          DELIVERY_TAB: 'Sales channels',
          LOADING: 'Loading...',
          NEW_ITEM_BTN: 'New Item',
          PUBLISH_CONFIRM:
            'The publication process includes the creation of the Assortment, Prices, Costs and other records related to the Product.<br><br><b>Are you sure you want to Publish?</b>',
          PUBLISH_CONFIRM_TITLE: 'Publication Confirmation',
          PUBLISHING_WARNING: 'Item in process of publication, try again in a few minutes.',
          PUBLISH_LONG_TIME:
            'The publication of this Product may take a few minutes, when it ends you will be notified with a notification.',
          PUBLISH_InvalidCombo: 'The combo is invalid, check the flap corresponding to the product.',
          PUBLISH_InvalidRecipe: 'The recipe is invalid, check the label corresponding to the product',
          PUBLISH_Vendors: 'There is an error in the associated suppliers, check the tab corresponding to suppliers.',
          REPORT: 'Report',
          REPORT_WARNING: 'Publish is required to download the report.',
        },
        MAIN_DATA: {
          NAME: 'Name',
          SHORT_NAME: 'Short Description',
          TICKET_DESCRIPTION: 'Ticket Description',
          NOMBRE_ARTICULO_TAG_FIELD: 'Item Name',
          NAME_AUTO_HINT: 'Generated automatically from classification tags.',
          COMPOSE_TAGS_MISSING:
            'Some of the tags required for the automatic name were not found: {{val}}. Please contact the support team.',
          TICKET_DESCRIPTION_HINT: 'Name truncated to the ticket print length limit.',
          CREATION_DATE: 'Item Creation Date',
          INTERNAL_CODE: 'Internal Code',
          CODE_AUTO_HINT: 'It will be created automatically when you save.',
          VALIDATION_CODE2: 'The {{val}} code already exists.',
          BAR_CODE: 'Bar Code',
          REGIONAL_ITEM: 'Regional Item',
          REGIONAL_ITEM_CHANGE: 'Change to Standard Item',
          REGIONAL_ITEM_DISABLED: 'You do not have permissions to switch to Standard Product',
          REGIONAL_ITEM_MODAL_TITLE: 'Change Regional Item Status',
          REGIONAL_ITEM_MODAL_CONTENT:
            'Are you sure you want to modify the item to stop being a Regional item type? This operation is irreversible. Only by means of interfaces can items of the Regional type be created and other types of items cannot be modified to this state.',
          DISPLAY_NAME: 'Totem Display Name',
          DISPLAY_NAME_TIP:
            'Name the final customer sees on self-service totems when customizing the product. Optional: if empty, the item name is used.',
          KDS_PREP_MINUTES: 'Prep time minutes (KDS)',
          KDS_PREP_SECONDS: 'Prep time seconds (KDS)',
          KDS_PREP_TIME_TIP:
            'Preparation time shown on the KDS (kitchen display). Optional: if both are empty nothing is sent; if only one is set, the other counts as 0.',
        },
        UNITS_OF_MEASURE: {
          NAME: 'Name',
          DUP_CODE_AND_CONVERSION: 'There cannot be 2 units of measure with an exact name and conversion factor.',
          ONLY_SINGLE_SELLING_UNIT_UOM: 'No can be two units of sale measurement.',
          UNIT_NAME: 'Unit Name',
          CONVERSION: 'Conversion factor',
          UNIT_BASE: 'Base Unit',
          SALES_UNITS: 'Sales unit',
          SOME_SELLING_UNIT: 'There must be at least one sales unit.',
          INITIAL_PRICE: 'Initial price',
          INITIAL_PRICE_TIP: 'This price will be applied to all the stores where the product is active',
          FRONT_PHOTO: 'Front item image',
          SIDE_PHOTO: 'Item image from side',
          PHOTO_ABOVE: 'Item image above',
          EXHIBITION_UNITS: 'Exhibition Unit',
          CAN_EXHIBIT_ON_HOOK_MODULE: 'Can be displayed on hook module?',
          FACINGS_LIMIT: 'Frentes Limit',
          MIN_FACES: 'Minimum Faces',
          MAX_FACES: 'Maximum Faces',
          MAG_HEIGHT_WITH_MAG: 'Height (cm.)',
          MAG_WIDTH_WITH_MAG: 'Width (cm.)',
          MAG_DEPTH_WITH_MAG: 'Depth (cm.)',
          EXHIBITION_DIMENSIONS_REQUIRED: 'Enter height, width and depth greater than 0 to save with exhibition enabled.',
          MAX_COMPRESSION_PERCENT: 'Max compression %',
          MAX_COMPRESSION_PERCENT_HINT: 'Optional. Value between 0 and 100. Empty = non-compressible product.',
          MAX_COMPRESSION_PERCENT_ERROR: 'Percentage must be greater than 0 and less than 100.',
          STACKABLE_SWITCH: 'Stackable',
          OVERTHROW_SWITCH: 'Overthrowing',
          ROTATE_SWITCH: 'Rotating',
          MAX_STACKS: 'Maximum stacks',
          NEW_UNIT_BTN: 'New Unit',
          REGULATED_PRICE_MAX: 'Maximum Price',
          REGULATED_COST_MAX: 'Maximum Cost',
          REGULATED_PRICE_TIP: 'Define the maximum value for the price',
          REGULATED_COST_TIP: 'Define the maximum value for the cost',
          FORCE_REGULATED_PRICE_MAX: 'Force Maximum Price',
          FORCE_REGULATED_COST_MAX: 'Force Maximum Cost',
          REGULATED_PRICE_MARGIN: 'Margin',
          REGULATED_PRICE_MARGIN_TIP: 'Define the margin for the price',
          EXHIBITION_UNIT: 'Exhibition Unit',
          FRONT_LOAD: 'Front Units',
          DEPTH_LOAD: 'Depth Units',
          HEIGHT_LOAD: 'Height stacking',
          HEIGHT_LOAD_TIP: 'Number of vertical SRP levels. When empty, it is treated as 1.',
          HEIGHT_LOAD_ERROR: 'Height stacking must be an integer greater than or equal to 1.',
          SRP: 'SRP',
          SHELF_READY_PACKAGE: 'Shelf Ready Package',
          EXHIBITION_TYPE: 'Exhibition Type',
          INDIVIDUAL: 'Same as sales unit',
          SRP_REPLACE_BASE_UNIT_WARNING: 'By adding this exhibition unit, it will replace the individual unit in planogram generation',
          TOOLTIP_SINGLE_SELLING_UNIT_UOM: 'Selling unit limit is 1 only.',
          DELETION_BLOCKERS: {
            TITLE: 'Unit of measure {{val}} cannot be deleted:',
            NotFound: 'The unit of measure was not found',
            AlreadyDeleted: 'It was already deleted',
            IsBase: 'It is the base unit',
            IsSellingUnit: 'It is the selling unit',
            UsedByVendors: 'It is a vendor order unit',
            UsedByVendorCosts: 'It has vendor costs',
            UsedByItemCodes: 'It has item codes',
            UsedByRecipes: 'It is used in a recipe',
            UsedByCombos: 'It is used in a combo',
            UsedByStorePrices: 'It has active prices (republish the item before deleting it)',
          },
        },
        RECIPE: {
          COMPONENT: 'Component',
          TYPE: 'Type',
          NO_UOM: 'Item without Unit of measure',
          UOM: 'Unit of measure',
          QUANTITY: 'Quantity',
          WASTE_INPUT: 'Waste %',
          COST: 'Cost',
          TAX: 'Tax',
          TOTAL_COST: 'Approximate Total Cost:',
          ADD_COMPONENT: 'Add Component',
          OPTIONAL: 'Customizable',
          OPTIONAL_TIP: 'The final customer can remove this component from the product at the point of sale.',
        },
        COMBO: {
          NAME: 'Name',
          QUANTITY: 'Quantity',
          NO_UOM: 'Item without Unit of measure',
          UOM: 'Unit of measure',
          MAX_COST_TIP: 'The component with the highest cost is taken into account',
          TOTAL_COST: 'Approximate Total Cost:',
          ADD_BLOCK: 'Add Group',
          ADD_COMPONENT: 'Add Component',
          COST: 'Cost',
          TAX: 'Tax',
        },
        CODES: {
          HELP_BOX: 'In this section you can add additional barcodes or other external codes.',
          CODE_TYPE: 'Code type',
          CODE: 'Code',
          VALIDATION_CODE2: 'The {{val}} code already exists.',
          VALIDATION_CODE_DUPLICATE: 'There are duplicate codes',
          INVALID_CODE: 'Invalid code format.',
          UNITS_OF_MEASURE_BUY: 'Unit of Measure',
          ADD_CODE: 'Add Code',
          NEW_CODE: 'New Code',
          PRIMARY_CODE_DELETE_WARNING: 'It is not possible to delete a Primary Code.',
        },
        VARIANTS: {
          ADD_VARIANT: 'Add Variant',
          PRINCIPAL_LABEL: 'Principal Product:',
          DESCRIPTION:
            'In this section you can configure the principal product of this item when it belongs to an exhibition variant group.',
          ALREADY_PRINCIPAL:
            'This item is already the principal product of other variants. It cannot be assigned as a variant of another product.',
        },
        MATCHINGS: {
          ADD_MATCHING: 'Add matching',
          ITEM_CODE_TYPE: 'Item code type',
          ITEM_CODE: 'Item code',
          ITEM_NAME: 'Item name',
          DUPLICATED_FLAGS: 'Duplicated Flags',
          DUPLICATED_FLAG_AND_CODE: 'Duplicate Item Code-Flag Combination',
          INVALID_CODE: 'Invalid code',
          NAME_REQUIRED: 'Name required',
          FLAG_REQUIRED: 'Flag required',
          MATCHING_OF: 'Matching of',
          CONVERTION_RATE: 'Convertion rate',
          CONVERTION_RATE_REQUIRED: 'Convertion rate required',
          CONVERSION_FACTOR_CALCULATOR: 'Conversion Factor Calculator',
          FORMULA: 'Formula',
          QUANTITY: 'Quantity',
          VOLUME_YOUR: 'Own product volume',
          VOLUME_COMPETITOR: 'Equivalent product volume',
          YOUR_PRODUCT: 'Own product',
          COMPETITOR_PRODUCT: 'Equivalent product',
          VOLUME: 'Volume / Weight / Length',
          TOTAL: 'Total',
          CALCULATED_FACTOR: 'Calculated factor',
          CLEAR: 'Clear',
          UNIT_WARNING: 'Both products must use the same unit of measure for the calculation to be correct.',
        },
        ASSORTMENT: {
          NOT_PARAMETERIZED: 'To enable this button, the parameterization of the category in Assortment must be completed.',
          NOT_ACCESS_PERMISSION: "Don't have permissions to complete this section",
          NOTIFY_USER: 'NOTIFY USER',
          NOTIFIED_USER: 'Notified user',
          IMPORT_FILE_NAME_LINK: 'determinar-PDV.xlsx',
          IMPORT_FILE_NAME_BTN: 'load assortment exception',
          IMPORT_ASSORTMENT_STORE_CONTEXT:
            'Can import exceptions of assortment by the importer button or see the assortment state for this item',
          BTN1_TITLE: 'Based on assortment',
          BTN1_MSG:
            'It takes into account the main segmentation defined for the category, being able to make exceptions through an importer.',
          BTN2_TITLE: 'Active in all Sales Points',
          BTN2_MSG: 'The product will be active at all points of sale.',
          BTN3_TITLE: 'Only if it is part of Recipe or Combo',
          BTN3_MSG: 'The product can participate in a recipe or a combo.',
          BTN4_TITLE: 'Only Assortment of Sales Points',
          BTN4_MSG: 'The product will be active in certain Points of Sale',
          BTN3_TOOLTIP_COMBO: 'Combos cannot be part of recipes or combos',
          NO_PERMISSION_TOOLTIP: 'You do not have permission to edit assortment behavior',
          NO_IMPORT_PERMISSION_TOOLTIP: 'You do not have permission to import assortment exceptions',
          LOCKED_BY_DELIVERY_PLACES: 'Defined by Delivery Places configuration',
          BTN3_TITLE_RECIPE: 'Only if part of a Combo',
          BTN3_MSG_RECIPE: 'The product can participate in a combo.',
          BTN1_TOOLTIP_RECIPE: 'Recipes cannot use the Based on Assortment option when the module is licensed',
          ASSORTMENT_SEGMENT_SETUP_TITLE: 'Define segment',
          ASSORTMENT_SEGMENT_SETUP_CONTENT_1: 'Define segment for category {{val}}.',
          ASSORTMENT_SEGMENT_SETUP_CONTENT_2: 'This change will impact the segment assignment screen in the Assortments module.',
          SEGMENT: 'Segment',
          DEFINE: 'Define',
          CANCEL: 'Cancel',
          IMPORT_TITLE: 'Import Points of Sale',
          ASSORTMENTBEHAVIORS_BASEDONASSORTMENT: 'Based on assortment',
          ASSORTMENTBEHAVIORS_ACTIVEINALLSTORES: 'Active at all points of sale',
          ASSORTMENTBEHAVIORS_ONLYIFPARTOFRECIPEORCOMBO: 'Only if it is part of Recipe or Combo',
          ASSORTMENTBEHAVIORS_ONLYSTOREASSORTMENT: 'Only assortment of Stores',
          INIT_ASSORMENT: 'Assortment configuration',
          CHOOSE_OPT_ASSORMENT: 'Choose assortment behavior',
          BLOCKED_FOR_PURCHASE: 'Buy block',
          BLOCKED_FOR_SALES: 'Block sale',
          CLONE_EXCEPTION_STORE_ASSORTMENT: 'Clone Assortment Exceptions',
          CLONE_EXCEPTION_STORE_ASSORTMENT_MSG:
            'Enabling this option will clone stock exceptions from this record. There must be at least one assortment exception that is not blocked for sale',
          DOWLOAD_EXCEL: 'Download excel',
          VIEW_ASSORTMENT_STATUS: 'Assortment Report',
          VIEW_ASSORTMENT_STATUS_ACTUAL: 'Assortment Report Actual',
          REQUIRE_SAVE_ASSORTMENT_STATUS: 'Requires saving changes made',
          REQUIRE_SAVE_ASSORTMENT_STATUS_MSG:
            'Changes were detected that affect the status of the Assortment, to be able to access you must save the changes made',
          IMPORT_ITEMS: 'Assortment by Point of Sale',
          IMPORT_EXCEL_ITEMS_FIXED_PRICE: 'Import Fixed Prices',
          IMPORT_EXCEL_ITEMS_DISCOUNT: 'Import Discounts',
          IMPORT_EXCEL_ITEMS: 'Import exceptions',
          DELETE_EXCEL_ITEMS: 'Delete Exceptions',
          DELETE_EXCEL_ITEMS_MESSAGE: 'All loaded exceptions will be deleted.',
          IMPORT_EXCEL_ITEMS_WARNING:
            'In order to import assortment exceptions and check the status of the same, it is necessary to have at least the main data saved. ',
          CATEGORY_CONFIG_WARNING:
            'To use assortment-based behavior, it is required that this items category have Segmentation and Clustering assigned.',
          CONFIG_CATEGORY: 'Assign Segmentation and Clustering to Category',
          CONFIG_TAG: 'Assign tag values',
          CONFIG_TAG_CONTENT: 'The segment that belongs to the selected category has no values',
          DEFINE_SEGMENT: 'DEFINE SEGMENT',
          CATEGORY_WARNING:
            'Category {{val}} does not have a defined main segmentation, choose an option to move forward with assortment initialization.',
          CATEGORY_SELECT_WARNING: 'You need to select a category for this product in order to proceed with assortment initialization.',
          NAME: 'Name',
          CODE: 'Code',
          ACTIVE: 'Active',
          BLOCQUED_SELL: 'Blocked for sale',
          BLOCQUED_BUY: 'Blocked for purchase',
          OBSERVATIONS: 'Observations',
        },
        PRICES: {
          SUGGESTED_PRICE_INPUT: 'National fixed price',
          DINAMIC_PRICE_INPUT: 'Discount on components %',
          PRICE_TYPE_INPUT: 'Price Type',
          DISCOUNT_INPUT: 'Discount',
          BTN3_TITLE: 'Based on the price of its components',
          BTN3_MSG: 'Every time you change the price of a component, the kit price can change.',
          PERMANENT_PRICE_INPUT: 'Fixed price',
          BTN1_TITLE: 'National Price',
          BTN1_MSG: 'It takes into account the initial unique price defined for each of the sales measurement units',
          BTN2_TITLE: 'Clone Price',
          BTN2_MSG: 'Clone the price of an existing product',
          INIT_PRICE: 'Initialization of Prices',
          CHOOSE_INIT_PRICE: 'Choose a price initialization option',
          REVIEW_CHANGES: 'To consult price changes go to ',
          PRICE_DECISIONS: 'Pricing Decisions',
          NO_PRICE_TIP:
            'In case of not finding a price at any point of sale for the cloned product, the initial price of the sales unit of measure will be used.',
          INITIAL_PRICE: 'Initial Price',
          SELL_UOM: 'Sales unit of measure',
          IVA: 'VAT',
          VIEW_ASOCIATED_RULES: 'VIEW ASSOCIATED RULES',
          CONFIRM_CLONE_VALIDATION_MSG:
            'The product from which you want to clone prices does not have the same units of measure. It is recommended to choose a product with the same sales units of measure.',
          CONFIRM_CLONE_VALIDATION_TITLE: 'Confirm selection',
          CONFIRM_CLONE_VALIDATION_OK: 'Continue with current selection',
          CONFIRM_CLONE_VALIDATION_CANCEL: 'Choose new product',
          VIEW_ASOCIATED_RULES_TITLE: 'No associated rules',
          VIEW_ASOCIATED_RULES_TITLE_MGS: 'Cannot query an item that was not published',
        },
        VENDORS: {
          TITLE: 'Suppliers, Costs & Taxes',
          SUBTITLE:
            'Define a supplier/s for this product. If you choose with a segmentation, all the points of sale must have an assigned value and in this way they can charge specific costs and taxes for each value of the segment.',
          VENDOR: 'Vendor',
          PRIMARY_VENDOR_WARNING: 'At least one Primary Vendor must exist.',
          MISSING_DELIVERY_PLACES_INLINE: 'No Delivery Places',
          MISSING_DELIVERY_PLACES_TOOLTIP:
            'This vendor has no Delivery Places configured. Set up at least one entry before publishing the item.',
          PRIMARY_VENDOR_WARNING_ONLY_ONE: 'There cannot be more than one Primary Provider.',
          PRIMARY_VENDOR_WARNING_UOM: 'The same Supplier cannot exist with the same unit of measure.',
          PRIMARY_VENDOR_WARNING_DUP: 'It is not possible to register a provider more than once.',
          REGIONAL_PRODUCT_WITH_ONE_VENDOR: 'You cannot have more than one supplier',
          PRIMARY_VENDOR_DELETE_WARNING: 'It is not possible to delete a Primary Provider.',
          CONFIRM_DELETE_TITLE: 'Delete Vendor',
          CHECKING_DELETE_IMPACT: 'Checking associated delivery places…',
          CONFIRM_DELETE_WITH_DELIVERY_PLACES: 'Deleting vendor {{val}} will remove {{val2}} associated delivery places. Confirm?',
          INTERNAL_CODE: 'Internal Supplier Code',
          SEGMENT: 'Segment',
          SEGMENTATION: 'Segmentation',
          UOM_BUY: 'Unit of measure',
          MIN_ORDER: 'Minimum Order',
          MAX_ORDER: 'Maximum Order',
          NEW_VENDOR: 'Associate Vendor',
          UNIQUE_COST: 'Unique cost',
          UNIQUE_COST_NATIONAL: 'National cost',
          SEGMENT_COSTS: 'Segment Costs',
          PRIMARY_VENDOR: 'Primary vendor',
          SECONDARYY_VENDOR: 'Secondary vendor',
          INDICATE_TEXT: 'indicate the cost and tax values corresponding to:',
          VENDOR_ITEM_NUMBER_EXISTS: 'The internal supplier code already exists (Product code: {{val}})',
          TAX_PERCENT_OUT_OF_RANGE: 'The value must be between 0 and 100.',
          UNIT_COST_LABEL: 'Unit cost',
        },
      },
    },
    ITEM_MASTER: {
      TITLE: 'Items',
      DELIVERY_PLACES: {
        NO_MATCHES: 'No results match your search.',
        NO_ROWS: 'No data to display.',
        DISCARD_TITLE: 'Discard changes',
        DISCARD_MESSAGE: 'You have {{count}} unsaved change(s). Closing this dialog will discard them. Close anyway?',
        SAVE_OK_WITH_WARNINGS: 'Changes were saved, but {{count}} row(s) have warnings. Review the ones marked in red.',
        SAVE_IMPACT_TITLE_CREATE: 'Confirm delivery places setup',
        SAVE_IMPACT_MESSAGE_CREATE:
          "You're setting up delivery places for this vendor. Once saved, the product will start arriving at the stores you selected. Confirm?",
        SAVE_IMPACT_TITLE_MODIFY: 'Confirm delivery places changes',
        SAVE_IMPACT_MESSAGE_MODIFY:
          "You're changing this vendor's delivery places: some stores will stop receiving the product through this vendor, and others will start. Confirm?",
        CHIP_MANAGE: 'Manage',
        TAB_LABEL: 'Delivery places',
        NO_PERMISSION_TOOLTIP: 'You do not have permission to configure Delivery Places. Contact your administrator.',
        SAVE_VENDOR_FIRST: 'Save the vendor before setting delivery places',
        VENDOR_LABEL: 'Vendor',
        PILLS_LABEL: 'Delivery modes',
        PILL_DIRECTA: 'Direct',
        PILL_CEDIS: 'CEDIS',
        COL_REGIONS: 'Regions',
        COL_ZONAS: 'Zones',
        COL_TIENDAS: 'Stores',
        COL_CEDIS: 'CEDIS',
        SEARCH_REGION: 'Search region...',
        SEARCH_ZONA: 'Search zone...',
        SEARCH_TIENDA: 'Search store...',
        SEARCH_CEDIS: 'Search CEDIS...',
        TIENDAS_LABEL: 'stores',
        SELECT_ALL_TOOLTIP: 'Select / deselect all',
        COVERAGE_TITLE: 'Configure CEDIS coverage',
        COVERAGE_HINT_APPLY_THEN_SAVE: 'Changes apply locally. Press "Save" in the main popup to persist.',
        COVERAGE_EMPTY: 'No stores match the search.',
        COVERAGE_CONFIGURE_TOOLTIP: 'Configure stores included in the CEDIS coverage',
        COVERAGE_APPLIED_REMEMBER_SAVE: 'Coverage applied. Press "Save" to confirm the changes.',
        APPLY_BTN: 'Apply',
        SAVE_BTN: 'Save',
        CANCEL_BTN: 'Cancel',
        SAVING_BTN: 'Saving...',
        SAVE_OK: 'Delivery Places saved',
        SAVE_ERROR: 'Error saving. Please retry.',
        NO_CHANGES: 'No changes to save',
        LOAD_ERROR: 'Could not load data',
        COHERENCE_ERROR:
          'Coherence conflict in {{count}} row(s). Review rows highlighted in red: Delivery Type must match other vendors for the same store.',
        NO_VENDOR: 'Select a vendor to start.',
        NO_PILLS_ACTIVE: 'Enable at least one delivery mode (DIRECT or CEDIS).',
      },
      NEW_ITEM_BTN: 'New Item',
      DUPLICATED_ITEM: 'Duplicated Item',
      FILTER_TTIP: 'Filter',
      FULLSCREEN_TTIP: 'Expand',
      EXITFULLSCREEN_TTIP: 'Reduce',
      EXPORT_TTIP: 'Export',
      IMPORT_TTIP: 'Import',
      PRINT_TTIP: 'Print',
      DELETE_TTIP: 'Delete selected items',
      DELETE: 'Delete',
      RECOVER: 'Recover',
      RECOVER_TTIP: 'Recover selected items',
      NAME: 'Name',
      CODE: 'Code',
      TYPE: 'Type',
      CATEGORY: 'Category',
      SUBCATEGORY: 'Subcategory',
      BRAND: 'Brand',
      CREATION_DATE: 'Creation Date',
      RECOVER_ITEMS_TITLE: 'Do you want to recover the selected items?',
      RECOVER_ITEMS_SUBTITLE: 'These items will disappear from the list of deleted items.',
      CANCEL_BTN: 'Cancel',
      CONFIRM_BTN: 'Confirm',
      NEW_ITEM_MODAL: 'New Item',
      ITEM_TYPE_INPUT: 'Item Type',
      LEGEND_RETAIL:
        'Retail items are regular items that can be sold in any sales channel without undergoing transformations or combinations with other items.',
      LEGEND_INGREDIENT: 'These items cannot be sold individually, but are part of a recipe.',
      LEGEND_RECIPES: 'It is a item that is made up of one or more ingredients.',
      LEGEND_SUPPLY: 'These items cannot be sold individually, but are part of a recipe.',
      CREATE_BTN: 'Create',
      TITLE_FILTERS: 'Filters',
      SEE_DELETED_FILTERS: 'View Deleted',
      TYPE_FILTERS: 'Type',
      CLEAN_FILTER_BTN: 'Clear',
      APPLY_FILTER_BTN: 'Apply',
      DEFINE_ITEM_STP1: 'Setup Item',
      CLASSIFICATION_STP2: 'Classification',
      LOGISTICS_DATA_STP3: 'Logistics Info',
      INTEGRATION_STP3: 'Integration',
      PURCHASE_DATA_STP4: 'Supply Info',
      SALES_DATA_STP5: 'Sales Info',
      EDIT_TITLE_FORM: 'Edit',
      NEW_TITLE_FORM: 'New',
      INGREDIENT_TITLE: 'Ingredient',
      SUPPLY_TITLE: 'Supply',
      RETAIL_TITLE: 'Retail',
      RECIPE_TITLE: 'item - Recipe',
      COMBO_TITLE: 'item - Kit',
      ITEM: 'Item',
      STP1: 'Step 1 - Setup Item',
      INTERNAL_CODE_INPUT: 'Internal code',
      ERROR: 'incorrect',
      EAN_INPUT: 'Barcode',
      TYPE_INPUT: 'Type',
      NAME_INPUT: 'Name',
      SHORT_DESCRIPTION_INPUT: 'Short description',
      SHORT_DESCRIPTION_VALIDATION: 'Characters entered:',
      CREATION_DATE_INPUT: 'Creation date',
      NEXT_BTN: 'Next',
      STP2: 'Step 2 - Item Classification',
      CATEGORY_INPUT: 'Category',
      SEARCH_CATEGORY: 'Search Category ...',
      SUBCATEGORY_INPUT: 'Subcategory',
      SEARCH_SUBCATEGORY: 'Search Subcategory ...',
      BRAND_INPUT: 'Brand',
      SEARCH_BRAND: 'Search Brand...',
      ADD_BRAND_BTN: 'Add Brand',
      PREVIUS_BTN: 'Previous',
      STP3: 'Step 3 - Logistics Info',
      UNIT_NAME: 'Unit Name',
      UNIT_NAME_INPUT: 'Unit Name',
      DELETE_UM: 'Delete Unit of Measure',
      CODE_INPUT: 'Code',
      REQUIRED: 'Required field',
      CODE_VALIDATION: 'Code must be unique',
      UNIT_REPEATED: 'Unit repeated',
      CODE_REPEATED: 'Code repeated',
      CREATE_UNIT: 'Create new Unit',
      CONVERSION_FACTOR_INPUT: 'Conversion factor',
      UNIT_BASE_CHECK: 'It is Base Unit',
      NEW_UNIT_BTN: 'New Unit',
      UNIT_ALREADY_EXIST: 'Unit already exist',
      STP4: 'Step 4 - Purchase Info',
      STP5: 'Step 5 - Purchase Info',
      PURCHASE_UNIT_INPUT: 'Purchase Unit',
      QUANTITY_UMB_INPUT: 'Quantity x BUoM',
      SUPPLIER_INPUT: 'Suppliers',
      SEARCH_SUPPLIER: 'Search Suppliers...',
      COST_INPUT: 'Cost',
      PURCHASE_IVA_INPUT: 'Purchase Tax',
      SALE_IVA_INPUT: 'Sales Tax',
      SAVE_BTN: 'Save',
      STP_4_2: 'Step 4 - Integration',
      UNITS_OF_MEASURE_INPUT: 'Unit of measurement',
      WASTE_INPUT: 'Waste %',
      STP5_R: 'Step 5 - Sales Info',
      SALES_UNITS: 'SALES UNIT',
      SALES_UNITS_DELETE_TTIP: 'Delete Sales Unit',
      SALES_UNITS_INPUT: 'Sales unit',
      SALES_UNITS_VALIDATION: 'Unit already selected',
      HIGH_INPUT: 'High',
      WIDTH_INPUT: 'Width',
      DEPTH_INPUT: 'Depth',
      MAX_STACKABLE: 'maximum number of Stacks',
      OVERTHROW_SWITCH: 'Overthrowing',
      ROTATE_SWITCH: 'Rotating',
      ROTATEY_SWITCH: 'Rotating in Y',
      EXHIBITION_UNITS_INPUT: 'Exhibition Unit',
      STACKABLE_SWITCH: 'Stackable',
      FRONT_PHOTO: 'Upload front item image',
      SIDE_PHOTO: 'Upload item image from side',
      PHOTO_ABOVE: 'Upload item image above',
      COMPOSITION_STP3: 'Ingredients',
      STP3_RECIPES: 'Step 3 - Recipe Ingredients',
      INGREDIENT: 'Ingredient',
      ITEM_TITLE: 'Item',
      INGREDIENT_DELETED_TTIP: 'Delete the {{val}}° ingredient',
      ITEM_DELETED_TTIP: 'Delete the {{val}}° item',
      INGREDIENT_INPUT: 'Ingredient',
      ITEM_INPUT: 'Item',
      SEARCH_INGREDIENT: 'Search Ingredients ...',
      QUANTITY_INPUT: 'Quantity',
      NEW_INGREDIENT_BTN: 'New Ingredient',
      DEFINE_COMBO_STP1: 'Setup Kit',
      COMBO_ARMING_STP3: 'Kit Item Groups',
      PRICE_STP4: 'Price',
      STP1_COMBO: 'Step 1 - Setup Kit',
      STP3_COMBO: 'Step 3 - Kit Item Groups',
      BLOCK_NAME_INPUT: 'Group Name',
      BLOCK_DELETED_TTIP: 'Delete Group',
      ITEMS_INPUT: 'Items',
      SEARCH_ITEMS: 'Search Items ...',
      ADD_BLOCK_BTN: 'Add Group',
      STP4_COMBO: 'Step 4 - Definition of price type',
      PRICE_TYPE_INPUT: 'Price Type',
      DISCOUNT_INPUT: 'Discount',
      FIXED_PRICE_MESSAGE: 'The fixed price nationwide will set the same price for all stores and channels',
      DISCOUNT_MESSAGE:
        'It takes into account the price of the cheapest component of each group and only the items that are active in the assortment of each store.',
      SUGGESTED_PRICE_INPUT: 'National fixed price',
      PERMANENT_PRICE_INPUT: 'Fixed price',
      EXCLUDED_RULES_CHECK: 'This kit will be excluded from the margin and competitive rules',
      EXCLUDED_RULES_CHECK_ALT: 'This combo will be included in the margin and competition rules',
      DINAMIC_PRICE_INPUT: 'Discount on components %',
      PRICE_STRATEGY: 'How are you going to price this kit?',
      INIT_PRICE: 'How are you going to set the initial price of this kit?',
      INIT_PRICE_EDIT: 'Do you want to change the current price?',
      PRICE_STRATEGY_COMPONENT_TITLE: 'Based on the price of its components',
      PRICE_STRATEGY_COMPONENT_MSG: 'Every time you change the price of a component, the kit price can change.',
      PRICE_STRATEGY_RULE_TITLE: 'Based on competitive or relationship rules',
      PRICE_STRATEGY_RULE_MSG:
        "When a competitor's price changes or when the price of a related item changes, Prisma will suggest a price change.",
      SUGGESTED_PRICE_TEXT:
        ': Minimum price of products in all blocks - Same price at all points of sale, starting or not from the suggested one.',
      DINAMIC_PRICE_TEXT:
        ': Current price of each point of sale (according to their products) + discount. It will not be affected by the kinship rules.',
      DINAMIC_PRICE_TTIP: 'Dynamic Price: Current price of each store (according to its items) + discount',
      NEW_UNIT: 'New Unit',
      NAME_INNPUT: 'Name',
      ADD_BTN: 'Add',
      NEW_INGREDIENT: 'New Ingredient',
      FREE_STORES: 'Stores without cost or price',
      FREE_STORES_SUBTITLE: 'Costs and prices were generated for all stores',
      ACCEPT_BTN: 'Accept',
      ERROR1: 'No cost or price was generated for these stores, because some of the kits items do not have a price.',
      ERROR2: 'No cost or price was generated for these stores, because some of the ingredients do not have a cost.',
      NEW_BRAND: 'New Brand',
      NEW_SUPPLIER: 'New Supplier',
      INFO_PERMISSION: 'The current user have only permission to edit attributes, any other change will not be allowed.',
      Retail: 'Retail',
      Ingrediente: 'Ingredient',
      Receta: 'Recipe',
      Combo: 'Kit',
      Supply: 'Supply',
      Insumo: 'Supply',
    },
    SUPPLY: {
      SETUP: {
        ORDER_SCHEDULE: {
          TITLE: 'Order Schedule',
          ROUTE: 'Supply / Setup',
          DEFINITION: 'Supplier / Center Definition',
          SCOPE_PDV: 'Scope of Store',
          FREQUENCY: 'Frequency',
          NEW_ORDER_BTN: 'NEW SCHEDULE',
          STORES_FILTER: 'Stores',
          SUPPLY_FILTER: 'Supply',
          TYPE_ALL: 'All',
          TYPE_SUPPLIER: 'Supplier',
          TYPE_DISTRIBUTION_CENTER: 'Distribution Center',
          TITLE_SCHEDULE_TO_LEAD: 'Schedule to load',
          TITLE_FRECUENCY: 'Frequency',
          TITLE_INCLUDES: 'Includes',
          TITLE_LEAD_TIME: 'Lead Time (days)',
          TITLE_OVERLAPP: 'Overlapping Schedules',
          TTIP_OVERLAPP: 'View overlapping schedules',
          BTN_OVERLAPP_MODAL_CLOSE: 'Close',
          PH_CATEGORYS: 'Categories',
          PH_CATEGORYS_EXC: 'Categories Excluded',
          FORM: {
            EDIT: 'Edit Schedule',
            NEW: 'New Schedule',
            STEP: 'Step',
            NEXT_BTN: 'Next',
            PREVIUS_BTN: 'Previous',
            SAVE_BTN: 'Save',
            SCOPE_PDV: {
              CODE_SEARCH: 'Search by code',
              TITLE: 'Advanced Selection',
              DESC: 'Apply filters to your search in order to reach the desired result. This option will deselect by filters.',
              CLIPBOARD_TITLE: 'Paste stores from clipboard',
            },
            FRECUENCY: {
              HOLIDAY_RECEPTION: 'In case the day of "Order reception" / "Merchandise delivery" is a holiday / non-working day',
              NEXT_BUSINESS_DAY: 'The order is received next business day',
              NEXT_DAY_STIPULATED: 'The order is received next day stipulated in Agenda.',
            },
          },
          TYPEOFDELIVER: {
            DELIVERY: 'Product delivery',
            RECEIPT: 'Receipt of orders',
          },
          FREQUENCYTIME: {
            DAILY: 'Daily',
            WEEKLY: 'Weekly',
            MONTHLY: 'Monthly',
          },
          HOLIDAYSHANDLING: {
            WEEKLY_DAYS_NO_HOLIDAYS: 'Only days of the week except holidays',
            ALL_DAYS_NO_HOLIDAYS_NO_SUNDAYS: 'Every day except holidays and Sunday',
            ALL_DAYS_NO_HOLIDAYS: 'Every day except holidays',
            ALL_DAYS: 'Every day',
          },
        },
        ORDER_SCHEDULE_LIST: {
          TYPE_FILTER: 'Types',
          STORES_FILTER: 'Stores',
          NAME: 'Suppliers / DC',
          NAME_TTIP: 'Supplier or Distribution Center',
          CATEGORY: 'Categories',
          STORES: 'Stores',
          STORES_TTIP: 'Stores',
          FREQUENCY: 'Frequency',
          MONDAY_CHAR: 'M',
          TUESDAY_CHAR: 'T',
          WEDNESDAY_CHAR: 'W',
          THURSDAY_CHAR: 'T',
          FRIDAY_CHAR: 'F',
          SATURDAY_CHAR: 'S',
          SUNDAY_CHAR: 'S',
        },
      },
      DECISIONS: {
        ORDER_CONTROL: {
          TITLE: 'Order Control',
          ROUTE: 'Smart Supply / Decisions',
          INFORM_BTN: 'Inform',
          NEW_ORDER_BTN: 'New Order',
          FILTER_TTIP: 'Filter',
          FULLSCREEN_TTIP: 'Expand',
          EXPORT_TTIP: 'Export',
          STATUS_FILTER: 'Status',
          TYPE_FILTER: 'Movement type',
          TYPE_ALL: 'All',
          TYPE_AUTOMATIC: 'Automatic',
          TYPE_MANUAL: 'Manual',
          ORIGIN_FILTER: 'Origin',
          DESTINATION_FILTER: 'Destination',
          CREATION_DATE_FILTER: 'Order Date',
          PLANNING_DATE_FILTER: 'Target Delivery Date',
          DELIVERY_DATE_FILTER: 'Delivery date',
          NRO: 'N.',
          TYPE: 'Type',
          TYPE_TOOLTIP: 'Movement type',
          ORIGIN: 'Origin',
          DESTINATION: 'Destination',
          CREATION_DATE: 'Order Date',
          CREATION_DATE_TTIP: 'Order Date',
          PLANNING_DATE: 'Target Del. Date',
          PLANNING_DATE_TTIP: 'Target Delivery Date',
          DELIVERY_DATE: 'Delivery date',
          DELIVERY_DATE_TTIP: 'Delivery date',
          STATUS: 'Status',
          VALUE: '$ Cost',
          DECISIONS: 'Decisions',
          SAVE_BTN: 'Save',
          HEADER: 'Headboard',
          PRINT_TTIP: 'Print',
          ADD_TTIP: 'Add Products to Order',
          COPY_TTIP: 'Add products from a list copied to your clipboard',
          CODE: 'Code',
          DESCRIPTION: 'Description',
          CATEGORY: 'Category',
          BRAND: 'Brand',
          APPROVE: 'Approve',
          REJECT: 'Reject',
          INFORM: 'Report',
          TYPE_INPUT: 'Movement type',
          CODE_INPUT: 'Code',
          ORIGIN_INPUT: 'Origin',
          DESTINATION_INPUT: 'Destination',
          STATE_INPUT: 'Status',
          PRIORITY_INPUT: 'Priority',
          OBSERVATION_INPUT: 'Observation',
          CREATION_DATE_INPUT: 'Order Date',
          PLANNING_DATE_INPUT: 'Target Delivery Date',
          DELIVERY_DATE_INPUT: 'Delivery Date',
          CANCEL_BTN: 'Cancel',
          ORDER_VALUE: 'Order Cost:',
          ADD_BTN: 'Add',
          ADD_PROD_TITLE_MODAL: 'Add products to order',
          PRODUCT_INPUT: 'Product',
          UDM_INPUT: 'Units of Measure',
          QUANTITY_INPUT: 'Quantity',
          DELETE: 'Delete',
          DELETE_TTIP: 'Remove product from order',
          SUGGESTED: '# Suggested',
          SUGGESTED_TTIP: 'Suggested Amount',
          TO_ASK: '# To ask',
          TO_ASK_TTIP: 'Quantity to order',
          TO_ASK_TTIP_ANEXO: '(Pallets)',
          UDM: 'UOM',
          EAN: 'EAN: {{val}}',
          SUPPLIER: 'Supplier: {{val}}',
          STEP_BY_STEP: 'Step to Step',
          UNITS_INPUT: 'Units',
          NAME: 'Name',
          FORECASTED_SALE: 'Forecasted sale',
          CURRENT_STOCK: 'Current stock in Super San Martin',
          CURRENT_STOCK2: 'Current stock in Distribution Center Campana',
          TRANSIT_STOCK: 'Stock in transit to Super San Martin',
          MINIMUM_STOCK: 'Minimum Stock',
          MAXIMUM_STOCK: 'Maximum Stock',
          AVAILABITY_DAYS_NOW: 'Availability Days Now',
          AVAILABITY_DAYS_AFTER: 'Availability Days After',
          NEED: 'Need',
          SUBCATEGORY: 'Subcategory',
          EDIT_TTIP: 'Edit product quantity to order',
          INVENTORY: 'Inventory',
        },
      },
    },
    ADMIN: {
      MASTER: {
        STORES: {
          LIST: {
            TYPE_FILTERS: 'Type',
            STATUS: 'Status',
            STORE_TAGS: 'Point of Sale Tags',
            NAME: 'Name',
            CODE: 'Code',
            BRAND: 'Flag',
            STATE: 'Status',
            TYPE: 'Type',
            AVAIBLE: 'Enabled',
            ROUTE: 'Administration / Teachers',
            TITLE: 'Points of Sale',
            NEW_STORE_BTN: 'New Point of Sale',
            FILTER_TTIP: 'Filter',
            FULLSCREEN_TTIP: 'Expand',
            EXITFULLSCREEN_TTIP: 'Reduce',
            VIEW_TTIP: 'View',
            VIEW_TABLE: 'Only Table',
            VIEW_MAP: 'Map only',
            VIEW_TABLE_MAP: 'Map and table',
            EDIT_ROW: 'Edit',
            COPY_ROW: 'Clone',
            DELETE_ROW: 'Delete',
            INACTIVE: 'Inactive',
            ACTIVE: 'Active',
            CLONE_STORE_TITLE: 'Clone Point of Sale',
            CLONE_ITEM_CONTENT: 'A new point of sale will be created from the data of the selected row',
            CANCEL_BTN: 'Cancel',
            CREATE_BTN: 'Create',
          },
          SAVE_TOOLTIP: {
            ASSORTMENT_INVALID: 'You must assign all clusters a cluster in order to save.',
          },
          PRICES: {
            BTN2_TITLE: 'Clone prices of a store',
            BTN2_MSG: 'Choose a reference point of sale, from where all the prices will be copied.',
          },
          STORES_FILTER: 'Store',
          ROUTE: 'Administration / Master',
          TITLE: 'Stores',
          NEW_STORE_BTN: 'New Store',
          FILTER_TTIP: 'Filters',
          FULLSCREEN_TTIP: 'Expand',
          EXITFULLSCREEN_TTIP: 'Reduce',
          VIEW_TTIP: 'View',
          VIEW_TABLE: 'Table Only',
          VIEW_MAP: 'Map Only',
          VIEW_TABLE_MAP: 'Map and table',
          EXPORT_TTIP: 'Export',
          IMPORT_TTIP: 'Import',
          PRINT_TTIP: 'Print',
          DELETE_TTIP: 'Delete selected stores',
          DELETE: 'Delete',
          NAME: 'Name',
          CODE: 'Code',
          BRAND: 'Brand',
          TYPE: 'Type',
          STORE: 'Store',
          STORES_V2: 'Store',
          STATE: 'State',
          INACTIVE: 'Inactive',
          ACTIVE: 'Active',
          TITLE_FILTERS: 'Filters',
          STATE_FILTER: 'State',
          TYPE_FILTER: 'Type',
          CLEAN_FILTER_BTN: 'Clear',
          APPLY_FILTER_BTN: 'Apply',
          TITLE_FORM: 'New Store',
          SAVE_BTN: 'Save',
          BASIC_INFORMATION_TAB: 'Main Data',
          LATITUDE_INPUT: 'Latitude',
          VALIDATION_LATITUDE1: 'Latitude must be less than or equal to 90',
          VALIDATION_LATITUDE2: 'Latitude must be greater than or equal to -90',
          LONGITUDE_INPUT: 'Longitude',
          VALIDATION_LONGITUDE1: 'Length must be less than or equal to 180',
          VALIDATION_LONGITUDE2: 'Length must be greater than or equal to -180',
          CODE_INPUT: 'Code',
          EXTERNALCODE_INPUT: 'External Code',
          VALIDATION_CODE: 'The field must be greater than 0',
          VALIDATION_CODE2: 'The {{val}} code already exists.',
          NAME_INPUT: 'Name',
          BRAND_INPUT: 'Brand',
          EMAIL_INPUT: 'Email',
          PHONE_INPUT: 'Telephone',
          OPENING_DATE_INPUT: 'Opening date',
          ADRESS_INPUT: 'Address',
          ACTIVE_CHECK: 'Active',
          ACTIVE_TTIP: 'Mark as Activate the {{val}}',
          EXCEMPT_CHECK: 'Exempt',
          EXCEMPT_TTIP: 'Mark as exempt',
          CLASSIFICATION_TAB: 'Classification',
          WITHOUT_SELECTION: 'Without Selection ...',
          ADD_ATRIBUTE_BTN: 'Add Attributes',
          QUERY_FILTER: 'Name',
          FEATURES_TAB: 'Features',
          STORE_TYPE_INPUT: 'Store Type',
          TERMINAL_INPUT: 'Distribution Center',
          NO_DISTRIBUTION_CENTERS_HINT: 'No distribution centers available',
          TRADE_AREA_TAB: 'Trade Area',
          LEGEND_FILTERS: 'Filter competitors by setting the Trade Area',
          TRADE_AREA_TITLE: 'Trade Area distance from competitors: ',
          SELECTED_COMPETITORS: 'Selected Competitors',
          NO_SELECTED_COMPETITORS: 'No competitors selected.',
          NO_SELECTED_COMPETITORS_TTIP: 'Refresh listing',
          DELETE_BTN: 'Remove',
          DELETE_COMPETITOR_TTIP: 'Delete Competitor',
          CODE_NAME: 'Cod | Name',
          MARKER: 'Marker',
          PROVINCE: 'Province',
          LOCATION: 'Location',
          ADD_COMPETITORS_BTN: 'Add competitors',
          EMPTY_STATE: 'No competitors found with the selected search criteria.',
          ADD_BTN: 'Add',
          ADD_COMPETITOR_TTIP: 'Add competitor',
          CHANGE_TRADE_AREA_TITLE_MODAL: 'Modify Trade Area to: {{val}} Km.',
          CHANGE_TRADE_AREA_SUBTITLE_MODAL: 'The selected competitors will be lost and will be modified with those of the new Trade Area.',
          EDIT_BTN: 'Modify',
          SEARCH: 'Search ',
          SET_PRINCIPAL_COMPETITOR_TTIP: 'Mark as main competitor for this Store',
          SET_PRINCIPAL_COMPETITOR__REMOVE_TTIP: 'Remove as main competitor for this Store',
          ASSORTMENT_TAB: 'Assortment',
          ASSORTMENT_TAB_ENABLED: 'Tab enabled only in state modified',
          ASSORTMENT_TAB_NO_EDIT_TOOLTIP: 'this information can be completed when modify the store previous to publish',
          ASSORTMENT_TITLE: 'Assortment Initialization',
          ASSORTMENT_SUBTITLE: 'Select the cluster to which the new store will belong in each of the Clusterizations defined in Prisma.',
          CLUSTERING: 'Clustering',
          CLUSTER: 'Cluster',
          CLUSTER_ASSIGNMENT: 'Cluster Assignment',
          CLONE_TTIP: 'Clone an existing Store.',
          CLONE_MODAL_TITLE: 'Clone Assortment',
          CLONE_MODAL_SUBTITLE: 'The clusters will be cloned for each clustering according to the selected store.',
          STORES: 'Store',
          CANCEL_BTN: 'Cancel',
          CLONE_BTN: 'Clone',
          PRICING_TAB: 'Pricing',
          PRICING_TITLE: 'Pricing Initialization',
          PRICING_SUBTITLE: 'Choose a price initialization option',
          BTN1_TITLE: 'Complete prices in Excel',
          BTN1_MSG: 'The price column should be completed for the entire active assortment.',
          BTN2_TITLE: 'Clone prices of a store',
          BTN2_MSG: 'Choose a reference point of sale, from where all the prices will be copied.',
          BTN3_TITLE: 'Relationship Rules',
          BTN3_MSG: 'Relationship rules will be taken into account for price autocompletion.',
          DOWLOAD_EXCEL: 'Download Excel',
          IMPORT_EXCEL_BTN: 'Import prices from excel',
          CLONE_PRICE_MODAL_TITLE: 'Clone Prices',
          CLONE_PRICE_MODAL_SUBTITLE: 'Prices will be cloned according to the selected store.',
          EXCEL1: 'Complete-Prices.xlsx',
          EXCEL2: 'Clone-Prices.xlsx',
          EXCEL3: 'Parent-Rule.xlsx',
          IMPORT_PRICES_TITLE: 'Import Prices',
          VENDORS: 'Suppliers',
          TABS: {
            VENDORS: {
              TITLE: 'Provider initialization',
              INTRO: 'Assign which suppliers supplies each product to the point of sale.',
              DISABLED_VENDORS_INPUT: 'Providers already initialized',
              BTN_IMPORT_SWITCH: 'Solve Conflicts',
              COMP: {
                TITLE: 'Advanced Selection',
                INTRO: 'Select the suppliers that will supply the point of sale.',
              },
            },
          },
          CHANGE_TRADE_AREA_TITLE_MODAL_ALT: 'Modify Localization',
          CHANGE_TRADE_AREA_SUBTITLE_MODAL_ALT:
            'The selected competitors will be lost and will be modified with those of the new Trade Area.',
          STORE_V2: 'Store',
        },
        STORESV2: {
          LIST: {
            TYPE_FILTERS: 'Type',
            STATUS: 'Status',
            STORE_TAGS: 'Point of Sale Tags',
            NAME: 'Name',
            CODE: 'Code',
            BRAND: 'Flag',
            STATE: 'Status',
            TYPE: 'Type',
            AVAIBLE: 'Enabled',
            ROUTE: 'Administration / Teachers',
            TITLE: 'Points of Sale',
            NEW_STORE_BTN: 'New Point of Sale',
            FILTER_TTIP: 'Filter',
            FULLSCREEN_TTIP: 'Expand',
            EXITFULLSCREEN_TTIP: 'Reduce',
            VIEW_TTIP: 'View',
            VIEW_TABLE: 'Only Table',
            VIEW_MAP: 'Map only',
            VIEW_TABLE_MAP: 'Map and table',
            EDIT_ROW: 'Edit',
            EDIT_ROW_DISABLED_TOOLTIP: 'Cannot edit a record in publishing process',
            COPY_ROW: 'Clone',
            DISABLED_CLONE_TOOLTIP: 'Only records in published state can be cloned',
            DISABLED_DELETE_EQUIPMENT: 'There is equipment assigned, remove or relocate all equipment to delete the store',
            DELETE_ROW: 'Inactive',
            UNDELETE_ROW: 'Active',
            INACTIVE: 'Inactive',
            ACTIVE: 'Active',
            CLONE_STORE_TITLE: 'Clone Point of Sale',
            CLONE_ITEM_CONTENT: 'A new point of sale will be created from the data of the selected row',
            CANCEL_BTN: 'Cancel',
            CREATE_BTN: 'Create',
            SEE_DELETED_FILTERS: 'View Deleted',
            PUBLISH_TTIP: 'Publish selected points of sale',
            PUBLISH_ROW_CONTENT: 'Do you want to publish the point of sale {{val}}?',
            PUBLISH_ROWS_CONTENT: 'Do you want to publish {{val}} selected points of sale?',
            PUBLISH_SUCCESS: 'The points of sale are being published. You will receive a notification when the process is complete.',
          },
          SAVE_TOOLTIP: {
            ASSORTMENT_INVALID: 'You must assign all clusters a cluster in order to save.',
          },
          CLONE_DELIVERY_PLACES: {
            TITLE: 'Clone Delivery Places from…',
            HINT: 'Copy Delivery Places from another published store or CEDIS. Overwrites any existing mappings on the destination.',
            REQUIRES_CEDIS: 'Assign a Distribution Center first in the Data tab.',
            SOURCE_NOT_ELIGIBLE: 'The selected source is no longer eligible (CEDIS or status changed).',
            STORE_MISSING_FOR_PUBLISH: 'The store has no Delivery Places configured. Configure them before publishing.',
            NO_SOURCES: 'No published stores available to clone from with this CEDIS assigned.',
          },
          PRICES: {
            BTN2_TITLE: 'Clone prices of a store',
            BTN2_MSG: 'Choose a reference point of sale, from where all the prices will be copied.',
            REVIEW_CHANGES: 'To consult price changes go to ',
            PRICE_DECISIONS: 'Pricing Decisions',
            VIEW_ASOCIATED_RULES: 'VIEW ASSOCIATED RULES',
            MAIN_SAVE_WARNING: 'In order to use this section, it is necessary at least have the mainstairs data saved',
          },
          EQUIPMENT: {
            ownerShip: 'Owner',
            acquisitionDate: 'Acquisition Date',
            acquisitionValue: 'Acquisition Value',
            adquisitionDate: 'Acquisition Date',
            adquisitionValue: 'Acquisition Value',
            usefulLife: 'Useful life (years)',
            EQUIPMENT_TYPE: 'Type of equipment',
            ADD_EQUIPMENT: 'Add Equipment',
            REMAINING_LIVE: 'Remaining life',
            NAME: 'Name',
            ASSIGMENT_DATE: 'Assignment Date',
            EDIT_EQUIPMENT: 'Edit Equipment',
            ADD_EQUIPMENT_TITLE: 'Add Equipment',
            AWARD_DATE: 'Award Date',
            DELETE_TITLE: 'Deactivate Equipment',
            DELETE_CONTENT: 'This action cannot be reversed. Do you wish to continue?',
            NAME_ALREADY_EXIST: 'The name is already in use',
            DISABLE_REUBICATION: 'The assignment must be saved to be relocated',
            REUBICATION_CONFIRM: 'Are you sure you want to relocate this equipment to the {{val}} point of sale?',
            REUBICATION: 'Relocate to another point of sale',
            OWNER_OPTION: {
              Owner: 'Own',
              Third: 'Third',
            },
            RELOCATION_CONFIRM: 'Are you sure you want to relocate this equipment {{val}} to the store?',
            RELOCATION: 'Relocate to another point of sale',
            ASSIGNMENT_DATE: 'Assignment Date',
          },
          COMPETITORS_SCOPE: 'Scope of competitors',
          COMPETITORS_SCOPE_SUBTITLE: 'Select the scope of competitors for this store',
          SELECTED_COMPETITOR_TTIP: 'Competitor selected',
          COMPETITOR_SELECTED: 'Selected competitors',
          COMPETITOR_SELECTED_COUNT: 'Number of Competitors selected',
          COMPETITOR_SELECTED_TITLE: 'Select Competitors',
          COMPETITOR_SELECTED_CONTENT: 'Search and add competitors by trade Area and tags',
          VIEW_ASOCIATED_RULES_TITLE: 'No associated rules',
          VIEW_ASOCIATED_RULES_TITLE_MGS: 'Cannot query a store that was not published',
          INFO_ASSORTMENT_STATUS:
            'The status of assortment displayed represents the status once it is published, in the same way all the data affected by this change will take effect when being in that state.',
          IMPORT_ITEMS: 'Assortment by Item',
          CODE_EXIST: 'Code {{val}} already exist',
          ITEMS_ALLOWED: '# Items allowed',
          TIP_ITEMS_ALLOWED: 'Maximum number of own products that this store can create.',
          NOT_ACCESS_PERMISSION: "Don't have permissions to complete this section",
          NOTIFY_USER: 'NOTIFY USER',
          NOTIFIED_USER: 'Notified user',
          IMPORT_FILE_NAME_LINK: 'determinar-PDV.xlsx',
          IMPORT_FILE_NAME_LINK_ITEMS: 'determinar-surtido.xlsx',
          IMPORT_FILE_NAME_BTN: 'load assortment exception',
          IMPORT_ASSORTMENT_STORE_CONTEXT:
            'Can import exceptions of assortment by the importer button or see the assortment state for this store',
          STORES_FILTER: 'Store',
          ROUTE: 'Administration / Master',
          TITLE: 'Stores',
          NEW_STORE_BTN: 'New Store',
          FILTER_TTIP: 'Filters',
          FULLSCREEN_TTIP: 'Expand',
          EXITFULLSCREEN_TTIP: 'Reduce',
          VIEW_TTIP: 'View',
          VIEW_TABLE: 'Table Only',
          VIEW_MAP: 'Map Only',
          VIEW_TABLE_MAP: 'Map and table',
          EXPORT_TTIP: 'Export',
          IMPORT_TTIP: 'Import',
          PRINT_TTIP: 'Print',
          DELETE_TTIP: 'Delete selected stores',
          DELETE: 'Delete',
          NAME: 'Name',
          CODE: 'Code',
          BRAND: 'Brand',
          TYPE: 'Type',
          STORE: 'Store',
          STORES_V2: 'Store',
          STATE: 'State',
          INACTIVE: 'Inactive',
          ACTIVE: 'Active',
          TITLE_FILTERS: 'Filters',
          STATE_FILTER: 'State',
          TYPE_FILTER: 'Type',
          CLEAN_FILTER_BTN: 'Clear',
          APPLY_FILTER_BTN: 'Apply',
          TITLE_FORM: 'New Store',
          SAVE_BTN: 'Save',
          BASIC_INFORMATION_TAB: 'Main Data',
          LATITUDE_INPUT: 'Latitude',
          VALIDATION_LATITUDE1: 'Latitude must be less than or equal to 90',
          VALIDATION_LATITUDE2: 'Latitude must be greater than or equal to -90',
          LONGITUDE_INPUT: 'Longitude',
          VALIDATION_LONGITUDE1: 'Length must be less than or equal to 180',
          VALIDATION_LONGITUDE2: 'Length must be greater than or equal to -180',
          CODE_INPUT: 'Code',
          EXTERNALCODE_INPUT: 'External Code',
          VALIDATION_CODE: 'The field must be greater than 0',
          VALIDATION_CODE2: 'The {{val}} code already exists.',
          NAME_INPUT: 'Name',
          BRAND_INPUT: 'Brand',
          EMAIL_INPUT: 'Email',
          PHONE_INPUT: 'Telephone',
          OPENING_DATE_INPUT: 'Opening date',
          ADRESS_INPUT: 'Address',
          ACTIVE_CHECK: 'Active',
          ACTIVE_TTIP: 'Mark as Activate the {{val}}',
          EXCEMPT_CHECK: 'Exempt',
          EXCEMPT_TTIP: 'Mark as exempt',
          CLASSIFICATION_TAB: 'Classification',
          WITHOUT_SELECTION: 'Without Selection ...',
          ADD_ATRIBUTE_BTN: 'Add Attributes',
          FEATURES_TAB: 'Features',
          STORE_TYPE_INPUT: 'Store Type',
          TERMINAL_INPUT: 'Distribution Center',
          TRADE_AREA_ALL_DISTANCE: 'All competitors will be searched regardless of their distance',
          GEOLOCATION_STORE: 'Coordinates of store for Trade Area',
          TRADE_AREA_TAB: 'Trade Area',
          LEGEND_FILTERS: 'Filter competitors by setting the Trade Area',
          TRADE_AREA_TITLE: 'Trade Area distance from competitors: ',
          SELECTED_COMPETITORS: 'Selected Competitors',
          NO_SELECTED_COMPETITORS: 'No competitors selected.',
          NO_SELECTED_COMPETITORS_TTIP: 'Refresh listing',
          DELETE_BTN: 'Remove',
          DELETE_COMPETITOR_TTIP: 'Delete Competitor',
          CODE_NAME: 'Cod | Name',
          MARKER: 'Marker',
          PROVINCE: 'Province',
          LOCATION: 'Location',
          ADD_COMPETITORS_BTN: 'Add competitors',
          EMPTY_STATE: 'No competitors found with the selected search criteria.',
          ADD_BTN: 'Add',
          ADD_COMPETITOR_TTIP: 'Add competitor',
          CHANGE_TRADE_AREA_TITLE_MODAL: 'Modify Trade Area to: {{val}} Km.',
          CHANGE_TRADE_AREA_TITLE_MODAL_ALT: 'Modify Location',
          CHANGE_TRADE_AREA_SUBTITLE_MODAL: 'The selected competitors will be lost and will be modified with those of the new Trade Area.',
          CHANGE_TRADE_AREA_SUBTITLE_MODAL_ALT:
            'The selected competitors will be lost and will be modified with those of the new Trade Area.',
          EDIT_BTN: 'Modify',
          SEARCH: 'Search ',
          SET_PRINCIPAL_COMPETITOR_TTIP: 'Mark as main competitor for this Store',
          SET_PRINCIPAL_COMPETITOR__REMOVE_TTIP: 'Remove as main competitor for this Store',
          ASSORTMENT_TAB: 'Assortment',
          ASSORTMENT_TAB_ENABLED: 'Tab enabled only in state modified',
          ASSORTMENT_TAB_NO_EDIT_TOOLTIP: 'this information can be completed when modify the store previous to publish',
          ASSORTMENT_TITLE: 'Assortment Initialization',
          ASSORTMENT_SUBTITLE: 'Select the cluster to which the new store will belong in each of the Clusterizations defined in Prisma.',
          CLUSTERING: 'Clustering',
          CLUSTER: 'Cluster',
          CLUSTER_ASSIGNMENT: 'Cluster Assignment',
          CLONE_TTIP: 'Clone an existing Store.',
          CLONE_MODAL_TITLE: 'Clone Assortment',
          CLONE_MODAL_SUBTITLE: 'The clusters will be cloned for each clustering according to the selected store.',
          STORES: 'Store',
          CANCEL_BTN: 'Cancel',
          CLONE_BTN: 'Clone',
          PRICING_TAB: 'Pricing',
          PRICING_TITLE: 'Pricing Initialization',
          PRICING_SUBTITLE: 'Choose a price initialization option',
          BTN1_TITLE: 'Complete prices in Excel',
          BTN1_MSG: 'The price column should be completed for the entire active assortment.',
          BTN2_TITLE: 'Clone prices of a store',
          BTN2_MSG: 'Choose a reference point of sale, from where all the prices will be copied.',
          BTN3_TITLE: 'Relationship Rules',
          BTN3_MSG: 'Relationship rules will be taken into account for price autocompletion.',
          DOWLOAD_EXCEL: 'Download Excel',
          VIEW_ASSORTMENT_STATUS: 'Assortment Report',
          VIEW_ASSORTMENT_STATUS_ACTUAL: 'Assortment Report Actual',
          REQUIRE_SAVE_ASSORTMENT_STATUS: 'Requires saving changes made',
          REQUIRE_SAVE_ASSORTMENT_STATUS_MSG:
            'Changes were detected that affect the status of the Assortment, to be able to access you must save the changes made',
          IMPORT_EXCEL_BTN: 'Import prices from excel',
          CLONE_PRICE_MODAL_TITLE: 'Clone Prices',
          CLONE_PRICE_MODAL_SUBTITLE: 'Prices will be cloned according to the selected store.',
          EXCEL1: 'Complete-Prices.xlsx',
          EXCEL2: 'Clone-Prices.xlsx',
          EXCEL3: 'Parent-Rule.xlsx',
          IMPORT_PRICES_TITLE: 'Import Prices',
          VENDORS: 'Suppliers',
          IMPORT_EXCEL_ITEMS: 'IMPORT POS FROM EXCEL',
          IMPORT_EXCEL_ITEMS_EXCEPT: 'IMPORT ASSORTMENT FROM EXCEL',
          NO_IMPORT_PERMISSION_TOOLTIP: 'You do not have permissions to import assortment from Excel',
          IMPORT_TITLE_ITEMS: 'Importa assortment',
          MAIN_SAVE_WARNING: 'In order to use this section, it is necessary at least have the mainstairs data saved',
          IMPORT_PDV_OK: 'IMPORTED STORES',
          NOVALID_PUBLISH_ADVICE: 'The following tab is not valid:',
          TABS: {
            VENDORS: {
              TITLE: 'Provider initialization',
              INTRO: 'Assign which suppliers supplies each product to the point of sale.',
              DISABLED_VENDORS_INPUT: 'Providers already initialized',
              BTN_IMPORT_SWITCH: 'Solve Conflicts',
              COMP: {
                TITLE: 'Advanced Selection',
                INTRO: 'Select the suppliers that will supply the point of sale.',
              },
            },
          },
          ITEM: {
            SAVE: 'Save',
            PUBLISH: 'Publish',
            REPORT: 'Report',
            REPORT_TOOLTIP: 'A report will be generated that can be downloaded through notifications.',
            REPORT_WARNING: 'Publish is required to download the report.',
            WARNING_SAVE: 'Current changes are required to be saved.',
            WARNING_PUBLISH: 'You need to republish for the saved changes to take effect.',
            BASIC_INFORMATION_TAB: 'Main data',
            CLASSIFICATION_TAB: 'Classification',
            PRICES_TAB: 'Prices',
            LOADING: 'Loading...',
            NEW_ITEM_BTN: 'New Item',
            TRADE_AREA_TAB: 'Trade Area',
            COMPETITORS_SCOPE: 'Competitors Scope',
            PUBLISH_CONFIRM:
              'The publication process includes the creation of the Assortment, Prices, Costs and other records related to the Store.<br><br><b>Are you sure you want to Publish?</b>',
            PUBLISH_CONFIRM_TITLE: 'Publication Confirmation',
            PUBLISHING_WARNING: 'Item in process of publication, try again in a few minutes.',
            PUBLISH_LONG_TIME:
              'The publication of this Item may take a few minutes, when it ends you will be notified with a notification.',
          },
        },
        SUPPLIER: {
          ROUTE: 'Administration / Master',
          TITLE: 'Supplier',
          NEW_SUPPLIER_BTN: 'New Supplier',
          FULLSCREEN_TTIP: 'Expand',
          EXITFULLSCREEN_TTIP: 'Reduce',
          EXPORT_TTIP: 'Export',
          IMPORT_TTIP: 'Import',
          PRINT_TTIP: 'Print',
          DELETE_TTIP: 'Delete selected suppliers',
          DELETE: 'Delete',
          NAME: 'Name',
          CODE: 'Code',
          PHONE: 'Telephone',
          DEFINE_SUPPLIER_STP1: 'Setup Supplier',
          ITEMS_ALLOCATION_STP2: 'Products Supplied',
          EDIT_TITLE_FORM: 'Edit Supplier',
          NEW_TITLE_FORM: 'New Supplier',
          STP1: 'Step 1 - Setup Supplier',
          NAME_INPUT: 'Name',
          CODE_INPUT: 'Code',
          PHONE_INPUT: 'Telephone',
          NEXT_BTN: 'Next',
          STP2: 'Step 2 - Products Supplied',
          ITEM: 'Product',
          MAIN_STORES: '# Main Stores',
          SECONDARY_STORES: '# Secondary Stores',
          DELETE_ITEM_TTIP: 'Delete product',
          ADD_ITEM_BTN: 'Add Product',
          PREVIUS_BTN: 'Previous',
          SAVE_BTN: 'Save',
          DELETE_TITLE_MODAL: 'Delete',
          DELETE_SUBTITLE_MODAL: 'Are you sure you want to delete?',
          DELETE_SUBTITLE2_MODAL: 'You will delete: {{val}}}. Are you sure?',
          DELETE_BTN: 'Delete',
          ALLOCATION_STORES: 'Stores Supplied',
          ITEM_INPUT: 'Product',
          SEARCH_ITEM: 'Search Product...',
          STORES_INPUT: 'Stores',
          ADD_STORES: 'Add more stores',
          SEARCH_STORES: 'Search Stores...',
          ALL_CHECK: 'All',
          SECONDARY_STORES_INPUT: 'Secondary Stores',
          ADD_SECONDARY_STORE: 'Add more secondary Stores',
          SEARCH_SECONDARY_STORE: 'Search secondary Stores ...',
          CANCEL_BTN: 'Cancel',
          ACCEPT_BTN: 'Accept',
        },
        SUPPLIERV2: {
          ROUTE: 'Administration / Master',
          TITLE: 'Supplier',
          NEW_SUPPLIER_BTN: 'New Supplier',
          FULLSCREEN_TTIP: 'Expand',
          EXITFULLSCREEN_TTIP: 'Reduce',
          EXPORT_TTIP: 'Export',
          IMPORT_TTIP: 'Import',
          PRINT_TTIP: 'Print',
          DELETE_TTIP: 'Delete selected suppliers',
          DELETE: 'Delete',
          NAME: 'Name',
          CODE: 'Code',
          PHONE: 'Telephone',
          STATUS: 'Status',
          DEFINE_SUPPLIER_STP1: 'Setup Supplier',
          CLASIFICATION: 'Clasification',
          ITEMS_ALLOCATION_STP2: 'Products Supplied',
          EDIT_TITLE_FORM: 'Edit Supplier',
          NEW_TITLE_FORM: 'New Supplier',
          STP1: 'Step 1 - Setup Supplier',
          NAME_INPUT: 'Name',
          CODE_INPUT: 'Code',
          PHONE_INPUT: 'Telephone',
          NEXT_BTN: 'Next',
          STP2: 'Step 2 - Products Supplied',
          ITEM: 'Product',
          MAIN_STORES: '# Main Stores',
          SECONDARY_STORES: '# Secondary Stores',
          DELETE_ITEM_TTIP: 'Delete product',
          ADD_ITEM_BTN: 'Add Product',
          PREVIUS_BTN: 'Previous',
          SAVE_BTN: 'Save',
          DELETE_TITLE_MODAL: 'Delete',
          DELETE_SUBTITLE_MODAL: 'Are you sure you want to delete?',
          DELETE_SUBTITLE2_MODAL: 'You will delete: {{val}}}. Are you sure?',
          DELETE_BTN: 'Delete',
          ALLOCATION_STORES: 'Stores Supplied',
          ITEM_INPUT: 'Product',
          SEARCH_ITEM: 'Search Product...',
          STORES_INPUT: 'Stores',
          ADD_STORES: 'Add more stores',
          SEARCH_STORES: 'Search Stores...',
          ALL_CHECK: 'All',
          SECONDARY_STORES_INPUT: 'Secondary Stores',
          ADD_SECONDARY_STORE: 'Add more secondary Stores',
          SEARCH_SECONDARY_STORE: 'Search secondary Stores ...',
          CANCEL_BTN: 'Cancel',
          ACCEPT_BTN: 'Accept',
          SEGMENTATION: 'Segmentation',
          INTERNAL_CODE_INPUT: 'Internal Code',
          UNIQUE_CODE_INPUT: 'Unique Code',
          ITEM_FORM: {
            SAVE: 'Save',
            PUBLISH: 'Publish',
            WARNING_SAVE: 'Current changes are required to be saved.',
            WARNING_PUBLISH: 'You need to republish for the saved changes to take effect.',
            LOADING: 'Loading...',
            NEW_ITEM_BTN: 'New Item',
            PUBLISH_CONFIRM:
              'The publication process includes the creation of costs in stores related to the supplier.<br><br><b>Are you sure you want to Publish?</b>',
            PUBLISH_CONFIRM_TITLE: 'Publication Confirmation',
            NO_SEGMENT: 'Unsegmented',
            PUBLISHING_WARNING: 'Item in process of publication, try again in a few minutes.',
            PUBLISH_LONG_TIME:
              'The publication of this Item may take a few minutes, when it ends you will be notified with a notification.',
            TIP_ATTRIBUTES_NO_SELECT: 'Supplier costs will apply to the entire network.',
            TIP_ATTRIBUTES_SELECT: 'Supplier costs apply only to points of sale tagged as:',
            TIP_USESOWNITEMNUMBERS:
              "If Internal Code is required, both the cost update and the supply module orders must be complete with the supplier's internal codes.",
          },
        },
        INSIGHTS: {
          ROUTE: 'Administration / Master',
          TITLE: 'Insights',
          FILTER_TTIP: 'Filter',
          NAME: 'Name',
          DESCRIPTION: 'Description',
          MARGIN: 'Margin $',
          CREATE_DATE: 'Date',
          ACTIONS: 'Actions',
          CONSULT_REPORTS: 'Consult Reports',
          REVIEW_PRICES: 'Review Prices',
          TOGGLE_FILTER: 'Just my Insights',
          ANTIQUITY_FILTER: 'Antiquity',
          INSIGHTS_TYPE_FILTER: 'Insight Type',
          STORES_FILTER: 'Stores',
        },
        CONTACTS: {
          ROUTE: 'Administration / Masters',
          TITLE: 'Contacts',
          TITLE_FULL: 'Contacts',
          NEW: 'New Contact',
          EDIT: 'Edit Contact',
          EMAIL: 'Email',
          PHONE: 'Phone',
          STORE_COUNT: '# Stores',
          CATEGORY_COUNT: '# Categories',
          STORES: 'Stores',
          CATEGORIES: 'Categories (level 3)',
          SAVE: 'Save',
          DELETE: 'Delete',
          DELETE_CONFIRM_TITLE: 'Confirm delete',
          DELETE_CONFIRM_MESSAGE: 'Do you want to soft-delete this contact?',
          DELETE_SUCCESS: 'Contact deleted successfully',
          SAVE_SUCCESS: 'Contact saved successfully',
          VALIDATION_CHANNEL_REQUIRED: 'At least one channel is required: email or phone',
          VALIDATION_EMAIL_INVALID: 'The email entered is not valid',
          SEARCH_PLACEHOLDER: 'Search by email or phone',
          NO_CHANGES_WARNING: 'No changes detected to save',
          ERROR: {
            ContactCategoriesNotLevel3: 'Categories must be level 3',
            ContactNotFound: 'Contact not found',
            ContactChannelRequired: 'At least one channel is required: email or phone',
          },
        },
        EQUIPMENTS: {
          ROUTE: 'Administration / Masters',
          TITLE: 'Equipment',
          TITLE_FULL: 'Equipment Types',
          FILTER_TTIP: 'Filter',
          NAME: 'Name',
          DESCRIPTION: 'Description',
          EDIT: 'Edit Equipment Type',
          NEW: 'New Equipment Type',
          DELETE: 'Delete Equipment Type',
          DELETE_WARN: 'This type of equipment is assigned, it is not possible to delete it',
          ITEMS: 'Items',
          ATTR: 'attributes',
          ATTR_ALT: 'Attributes',
          REQUIRED: 'required',
          SAVE: 'Save',
          PUBLISH: 'Publish',
          WARNING_SAVE: 'Saving current changes is required.',
          WARNING_PUBLISH: 'Republishing is required for saved changes to take effect.',
          LOADING: 'Loading...',
          ADD_ATTR: 'Add Attribute',
          EDIT_ATTR: 'Edit Attribute',
          TYPE_ATTR: 'Attribute Type',
          NEW_ITEM: 'New Equipment Type',
          VALUE_LIST: 'List of Values:',
          ADD_VALUE: 'Add Value',
          VALUE: 'Value',
          VALIDATION_NAME_DUPLICATE: 'This name already exists',
          VALIDATION_ATTR_DUPLICATE: 'There are duplicate attributes',
          ASSIGNED: 'Assigned',
          ATTR_REQUIRED: 'Required attribute',
          ATTR_UNIQUE: 'Unique attribute',
          UNIQUE: 'Unique',
          GENERAL: 'Main Data',
          ASSIGN_REQUIRED_DISCLAIMER:
            'This type of equipment already has equipment assigned to stores, this change will not be reactive for equipment that has already been assigned.',
          REPORT: 'Download Report',
          TYPES: {
            NUMBER: 'Number',
            STRING: 'Text',
            BOOLEAN: 'Boolean',
            LIST: 'List of values',
            PRICE: 'Price',
            DATETIME: 'Date',
          },
        },
        DYNAMIC_ENTITIES: {
          ROUTE: 'Administration / Masters',
          TITLE: 'Equipment',
          TITLE_FULL: 'Dynamic Entities',
          FILTER_TTIP: 'Filter',
          NAME: 'Name',
          INSTANCES: 'Instances',
          DESCRIPTION: 'Description',
          EDIT: 'Edit Entity Type',
          NEW: 'New Entity Type',
          DELETE: 'Delete Entity Type',
          DELETE_INSTANCE: 'Delete instance',
          DELETE_WARN: 'This entity type is assigned and cannot be deleted',
          DELETE_INSTANCE_WARN: 'This instance is assigned and cannot be deleted',
          ITEMS: 'Items',
          ATTR: 'attributes',
          ATTR_ALT: 'Attributes',
          REQUIRED: 'required',
          SAVE: 'Save',
          PUBLISH: 'Publish',
          WARNING_SAVE: 'You need to save the current changes.',
          WARNING_PUBLISH: 'You need to republish for the saved changes to take effect.',
          LOADING: 'Loading...',
          ADD_ATTR: 'Add Attribute',
          EDIT_ATTR: 'Edit Attribute',
          TYPE_ATTR: 'Attribute Type',
          NEW_ITEM: 'New Entity Type',
          VALUE_LIST: 'Value List:',
          ADD_VALUE: 'Add Value',
          VALUE: 'Value',
          VALIDATION_NAME_DUPLICATE: 'This name already exists',
          VALIDATION_ATTR_DUPLICATE: 'There are duplicate attributes',
          VALIDATION_ATTR_CHANGE_NOT_ALLOWED:
            'It is not possible to change the attribute validation condition because there are inconsistencies in the loaded instances.',
          ASSIGNED: 'Assigned',
          ATTR_REQUIRED: 'Required attribute',
          ATTR_UNIQUE: 'Unique attribute',
          UNIQUE: 'unique',
          ATTR_OPTIONAL: 'Optional',
          ATTR_OPTIONAL_DESC: 'Field can be empty',
          ATTR_REQUIRED_DESC: 'Field must be filled',
          ATTR_REQUIRED_UNIQUE: 'Required and unique',
          ATTR_REQUIRED_UNIQUE_DESC: 'Cannot be repeated or empty',
          ATTR_TYPE_SELECTION: 'Attribute type',
          GENERAL: 'General',
          ASSIGN_REQUIRED_DISCLAIMER:
            'This entity type already has equipment assigned to stores; this change will not be retroactive for equipment that has already been assigned.',
          REPORT: 'Download Report',
          TYPES: {
            NUMBER: 'Number',
            STRING: 'Text',
            BOOLEAN: 'Boolean',
            LIST: 'Value List',
            PRICE: 'Price',
            DATETIME: 'Date',
          },
          NAME_ALREADY_EXISTS: 'The name already exists',
          UNIQUE_ATTRIBUTE_EXISTS: 'The value "{{value}}" already exists for the field "{{field}}"',
          SET_NAME_AS_UNIQUE_TITLE: 'Set Name as Unique',
          SET_NAME_AS_UNIQUE_BODY: 'Do you want to mark the Name field as unique? This will prevent duplicate values.',
          UNSET_NAME_AS_UNIQUE_TITLE: 'Remove Uniqueness from Name',
          UNSET_NAME_AS_UNIQUE_BODY: 'Do you want to remove the unique constraint from the Name field? This will allow duplicate values.',
          CODE_ALREADY_EXISTS: 'The code already exists',
          ADD_ENTITY_TITLE: 'New Entity',
          ADD_INSTANCE_TITLE: 'New Instance',
          EDIT_ENTITY: 'Edit Entity',
          CODE: 'Code',
          TAGNAME: 'Tag Name',
          ADD_INSTANCE: 'Add Instance',
          EDIT_INSTANCE: 'Edit Instance',
          CANCEL_BTN: 'Cancel',
          RELATION_WITH_ITEMS: 'Relationship with Items',
          RELATION_WITH_STORES: 'Relationship with Stores',
          RELATION: 'Relationship',
          DELETE_TITLE: 'Delete Entity',
          DELETE_CONTENT: 'This action cannot be undone. Do you want to continue?',
          STORES: 'Stores',
          MASSIVE_IMPORT: 'Bulk Import',
          NEW_DYNAMIC_ENTITY: 'New dynamic entity, instances cannot be displayed.',
          IMPORT_SUCCESS: 'Successful Importation',
          RELATIONSHIP_TYPE: 'Relationship Type',
          ITEM_RELATIONSHIP: 'Relationship with Items',
          STORE_RELATIONSHIP: 'Relationship with Points of Sale',
          VENDOR_RELATIONSHIP: 'Relationship with Suppliers',
          NO_RELATIONSHIP: 'No Relationship',
          ITEM: 'Items',
          STORE: 'Points of Sale',
          VENDOR: 'Suppliers',
        },
        COST_AND_TAXES: {
          TITLE: 'Costs and Taxes',
          TITLE_TAXES_ONLY: 'Taxes',
          NEW: 'Create cost or tax',
          NEW_TAXES_ONLY: 'Create tax',
          TABLE: {
            NAME: 'Name',
            VALUE: 'Value',
            CODE: 'Code',
            TYPE: 'Type',
            FROM: 'From',
            STORE_QUANTITY: '# of Stores',
            ITEM_QUANTITY: '# of Items',
            VALIDATION: 'Validation',
            STATUS: 'Status',
            APPLICATION: 'Application',
            VALIDITY: 'Validity',
            TYPE_CURRENT: 'Current',
            TYPE_FUTURE: 'Future',
            TYPE_NA: 'N/A',
            TYPE_NEW: 'New',
            VALIDATION_NOT_REVIEWED: 'Not reviewed',
            VALIDATION_APPROVED: 'Approved',
            VALIDATION_REJECTED: 'Rejected',
            ADD_FUTURE_VALUE: 'Add Future Value',
            EDIT_SEE_DETAIL: 'Edit / See Details',
            CHANGE_VALIDATION_STATUS: 'Change status',
            VIEW_HISTORY_CHANGES: 'View History Changes',
          },
          ADD_NEW_FUTURE_VALUE: 'Add new future value',
          TYPE: 'Type',
          COST_TYPE: 'Cost Type',
          TAX_TYPE: 'Tax Type',
          TAX_SUBTYPE_TAX_RATE_DISPLAY: 'VAT',
          APPLICATION_STATUS: 'Application Status',
          VALIDATION_STATUS: 'Validation Status',
          COST: 'Cost',
          TAX: 'Tax',
          COSTS: 'Costs',
          TAXES: 'Taxes',
          ALL: 'All',
          FORM: {
            NEW: 'New',
            MAIN_DATA: 'Main Data',
            STORE_SCOPE: 'Store Scope',
            ITEM_SCOPE: 'Item Scope',
            HISTORY: 'History',
            NAME: 'Name',
            CODE: 'Code',
            VALUE: 'Value',
            VALUE_TYPE: 'Value type',
            ADD_FUTURE_VALUE: 'Add Future Value',
            CODE_EXISTS: 'The code already exists',
          },
          APPLIED_FROM: 'Applied From',
          NEW_VALUE: 'New Value',
          APPLY_FROM: 'Apply From',
          NEW_VALUE_REQUIRED: 'The new value is required',
          NEW_VALUE_MIN: 'The new value must be greater than 0',
          APPLY_FROM_REQUIRED: 'The apply from date is required',
          VALUE_CREATED_SUCCESS: 'The new value has been created successfully',
          VALUE_APPROVED_SUCCESS: 'The new value has been approved successfully',
          VALUE_REJECTED_SUCCESS: 'The new value has been rejected successfully',
          NOT_REVIEWED_PENDING: 'Not reviewed pending',
          APPROVE: 'Approve',
          REJECT: 'Reject',
          CHANGES_HISTORY: 'Changes History',
          USER: 'User',
          NO_DATA_HISTORY: 'No history data available',
          VALUE_REJECT_SUCCESS: 'The new value has been rejected successfully',
        },
        TAGS: {
          ACCEPT: 'Accept',
          NAME_ALREADY_EXIST: 'The name already is in use',
          TYPES: {
            Item: 'Item',
            Store: 'Store',
            Competitor: 'Competitor',
            Brands: 'Brands',
            Vendor: 'Vendor',
          },
          DATA_TYPES: {
            Text: 'Text',
            Number: 'Number',
            Boolean: 'Boolean',
            DynamicEntity: 'Dynamic entity',
            FreeNumber: 'Free number',
          },
          ENTITIES: {
            COMPETITORS: 'Competitors: {{val}}',
            ITEMS: 'Products: {{val}}',
            ROUNDINGRULES: 'Rounding rules: {{val}}',
            COMPETITIVELIMITRULES: 'Competitors limit: {{val}}',
            PRICINGRULESITEMS: 'Product relationship rules: {{val}}',
            PRICINGRULESSTORES: 'Relationship rules for points of sale: {{val}}',
            STORES: 'Points of sale: {{val}}',
            VENDORS: 'Suppliers: {{val}}',
            VENDORCOSTS: 'Costs: {{val}}',
            ASSORTMENTASSIGNMENTS: 'Assortment allocation: {{val}}',
            ASSORTMENTITEMEXCEPTIONS: 'Assortment exception by products: {{val}}',
            ASSORTMENTSTOREEXCEPTIONS: 'Assortment exception by points of sale: {{val}}',
            ASSORTMENTCATEGORIES: 'Assortment categories: {{val}}',
          },
          DEFAULTVALUE: 'Start with this default value',
          ISDEFAULTVALUE: 'Is Default value',
          TAG_IN_USE: 'Failed to delete tag is in use',
          ENTITIES_IN_USE: 'You must reassign the following number of records for each entity using the tag to delete',
          CANCEL_BTN: 'Cancel',
          NEW_TAG_VALUE_ADD_BTN: 'Create new tag value',
          FREE_NUMBER_VALUES_INFO:
            'This tag is a Free number tag. Its values are not managed from this screen: they are entered in Item Master and created automatically when saving the product.',
          ALLOW_DIRECT_VALUE_LOAD: 'Direct value entry',
          ALLOW_DIRECT_VALUE_LOAD_POPOVER_TOOLTIP:
            'Allows creating new values from the Classification tab (Item Master, Stores or Vendor) without going to the tags master.',
          ADD_TAG_VALUE_INLINE: '+ Add value',
          ADD_TAG_VALUE_INLINE_TITLE: 'Add tag value',
          ADD_TAG_VALUE_INLINE_VALUE_LABEL: 'Value',
          ADD_TAG_VALUE_INLINE_CONFIRM: 'Add',
          ADD_TAG_VALUE_INLINE_SUCCESS: 'Value added',
          ADD_TAG_VALUE_INLINE_DEDUPE: 'That value already existed; the existing one was selected.',
          ADD_TAG_VALUE_INLINE_ERROR: 'Could not add the value. Please try again.',
          ROUTE: 'Administration / Master',
          ISDELETED: 'Eliminated',
          ISDELETED_POPOVER_TOOLTIP: 'When enabling only deleted labels will be shown',
          USEFORREPORTS: 'Used for reports',
          USEFORREPORT: 'Used for reports',
          USEFORREPORTS_POPOVER_TOOLTIP: 'When enabling, only the labels assigned for reports will be shown',
          YES: 'Yes',
          NO: 'No',
          REQUIRED_CHECKBOX_POPOVER_TOOLTIP:
            'Makes the loading of this field mandatory for all "products". It allows assigning a default value if this option is active.',
          REQUIRED_FOR_COMPETITOR_POPOVER_TOOLTIP:
            'Makes the loading of this field mandatory for all "competitors". It allows assigning a default value if this option is active.',
          REQUIRED_FOR_STORE_POPOVER_TOOLTIP:
            'Makes the loading of this field mandatory for all "points of sale". It allows assigning a default value if this option is active.',
          TERMINATION_SLIDE_POPOVER_TOOLTIP:
            'You can add a default termination to the tag values. Ex: for Net Content, "cc" or "cm3". Tag: 250 cc',
          DEPENDENCIES_POPOVER_TOOLTIP:
            'Use it in case this tag depends on another. Parent / child relationship. Ex: "City" depends on "State"',
          SELECT_PARENT_TAG_POPOVER_TOOLTIP:
            'In case of changing for another parent label the values of this label will be eliminated. In case of deallocation, the values of this label will lose relation to parent values',
          SELECT_PARENT_TAG_WARNING:
            'Make sure to select the correct parent tag before loading the parent values, if changed you will lose the previously added values',
          TITLE: 'Tags',
          CANCEL: 'Cancel',
          OK: 'Ok',
          NEW_STORE_BTN: 'New Tag',
          DELETE: 'Delete',
          DELETE_TTIP: 'Delete selected Tags',
          FILTER_TTIP: 'Filters',
          EXPORT_TTIP: 'Export',
          IMPORT_TTIP: 'Import',
          PRINT_TTIP: 'Print',
          NAME: 'Name',
          TYPE: 'Type',
          FIELD_TYPE: 'Field Type',
          REQUIRED: 'Required',
          QUANTITY_TAGS: '# Tags',
          QUANTITY_TAGS_TTIP: 'Number of Tags that belong to a group',
          DEFINE_TAG_STP1: 'Define Tags',
          ADMIN_TAG_STP2: 'Manage Tags',
          EDIT_TAG: 'Edit Tags',
          DELETE_ROW: 'Delete Tag',
          NEW_TAG: 'New Tags',
          STP1: 'Define Tags',
          NAME_INPUT: 'Name',
          TYPE_INPUT: 'Tags Type',
          DATATYPE_INPUT: 'Datatype',
          REQUIRED_CHECKBOX: 'Required for all products',
          REQUIRED_FOR_COMPETITOR: 'Required for all competitors',
          REQUIRED_FOR_STORE: 'Required for all own brands Points of Sale',
          ADDITIONAL_SLIDE: 'Additional features',
          COLOR_SLIDE: 'Color',
          ICON_SLIDE: 'Icon and Image',
          REQUIRED_SLIDE: 'Requires Special Permit',
          TERMINATION_SLIDE: 'Termination',
          TERMINATION_INPUT: 'Enter Termination',
          DEPENDENCIES: 'Dependencies',
          DEPENDENCIES_INPUT: 'Select Parent Tag',
          REQUIRED_WARNING_OFF_CONTENT: 'If a value of this tag exists as a default value, it will be disabled',
          REQUIRED_WARNING_OFF_TITLE: 'Do you want this tag to not be required?',
          NEXT_BTN: 'Next',
          STP2: 'Administrate Tag Value',
          NEW_TAG_INPUT: 'Add new tag',
          DEPENCENCY_TAG_INPUT: 'Select Parent Tag Value',
          PARENT: 'Parent',
          TYPE_CENTER: 'Type Center',
          COLOR: 'Color',
          ICON: 'Icon',
          TERMINATION: 'Termination',
          PARENT_VALUE: 'Parent Value',
          ELEMENTS: '# Elements',
          ELEMENTS_TTIP: 'Quantity Elements',
          PREVIOUS_BTN: 'Previous',
          SAVE_BTN: 'Save',
          ADD_BTN: 'Add',
          EDIT_BTN: 'Edit',
          TAG_VALUE_EXIST: 'Tag value already exist',
          DEFAULT_TTP: 'No default value can be assigned if the tag is not marked as mandatory',
          INVALID_TAG_VALUES_FORM: 'All loaded values must contain the required fields',
          OWN_STORES: 'own stores',
          PRODUCTS: 'products',
          COMPETITORS: 'competitors',
          REQUIRED_DEFAULT_TAG: 'You must set a default tag value in order to Save',
          TAG_UPDATE_ALL_PRODUCTS: 'This tag will update all Products. Do you wish to continue?',
          TAG_UPDATE_ALL_OWN_STORES: 'This tag will update all Own Brand Stores. Do you wish to continue?',
          TAG_UPDATE_ALL_COMPETITORS: 'This tag will update all Competitors. Do you wish to continue?',
        },
      },
      SECURITY: {
        REPORTS: {
          TITLE: 'Security Reports',
          USERS: 'Users',
          ROLES: 'Roles',
          LOGIN_AUDIT: 'Login Audit',
          SYSTEM_AUDIT: 'System Audit',
        },
        USERS: {
          LIST: {
            TITLE: 'Users',
            EDIT_ROW: 'Edit',
            USERNAME_INPUT: 'Username',
            EMAIL_INPUT: 'Email',
            ROLE_INPUT: 'Role',
            BLOCK_ROW: 'Block user',
            UNBLOCK_ROW: 'Unblock user',
            BLOCK_TITLE: 'Block user',
            BLOCK_CONFIRM:
              'Blocking {{val}} will prevent them from signing in to Prisma, both through corporate access and with username and password, even if their account is still enabled in your organization directory. Do you want to continue?',
            BLOCK_OK: 'User blocked',
            UNBLOCK_OK: 'User unblocked',
          },
          ITEM: {
            TAB1: 'General Data',
            USERNAME_INPUT: 'Userame',
            FIRSTNAME_INPUT: 'Name',
            LASTNAME_INPUT: 'Last Name',
            EMAIL_INPUT: 'Email',
            PASSWORD_INPUT: 'Password',
            PREV_PASSWORD_INPUT: 'Previous password',
            RESET_PASS: 'Reset Password',
            REPEAT_PASSWORD_INPUT: 'Repeat Password',
            PASSWORD_BTN: 'Hide password',
            ROLES_INPUT: 'Role',
            CATEGORIES: 'Categories',
            STORES: 'Stores',
            EDIT_STORES: 'Edit Stores',
            CATEGORIES_ADVICE: 'If you leave this selection empty, no category restrictions will be applied to the user.',
            STORES_ADVICE: 'If you leave this selection empty, no stores restrictions will be applied to the user.',
          },
          NEW_USER_BTN: 'New User',
        },
        ROLES: {
          LIST: {
            TITLE: 'Roles',
            EDIT_ROW: 'Edit',
            NAME_INPUT: 'Name',
            DELETE_ROW: 'Delete',
          },
          NEW_ROLE_BTN: 'New Role',
          DELETE: {
            TITLE: 'Delete Role',
            MESSAGE: 'Are you sure you want to delete the role {{name}}? This action cannot be undone.',
            SUCCESS_TITLE: 'Role Deleted',
            SUCCESS_MESSAGE: 'The role has been successfully deleted.',
            ERROR_TITLE: 'Cannot delete role',
            ERROR_MESSAGE: 'The role cannot be deleted because it has assigned users: {{users}}',
            GENERAL_ERROR: 'An error occurred while trying to delete the role. Please try again.',
          },
          ITEM: {
            TAB1: 'General Data',
            NAME_INPUT: 'Name',
            NAME_ROLE: 'Name',
            DESCRIPTION_ROLE: 'Description',
            SELECTED: 'Selected',
            SELECTED_PLURAL: 'Selected',
            ROLE: {
              admin_view: 'View Administration menu',
              itemmaster_view: 'View Item Master menu',
              prices_competitors_view: 'View flags and competitors menu',
              prices_costsandtaxes: 'Importer of store costs and supplier costs',
              prices_decisions: 'Change prices, Accept and ignore suggestions. Request approval, and Import new prices',
              prices_endorse: 'Approve prices and reject changes.',
              prices_guidelineStrategy_view: 'View guidelines and strategies menu',
              prices_competitors_delete: 'Delete a competitor',
              prices_roundings_delete: 'Delete a rounding rule',
              prices_rules_delete: 'Delete a rule',
              prices_sensitivities_delete: 'Delete a sensitivity',
              prices_decisions_prices_endorse: 'Accept a suggestion (send to publish)',
              assortment_clustering_save: 'Save a new clustering',
              assortment_clustering_delete: 'Delete a clustering',
              assortment_roles_save: 'Save changes in a role (or create a new one)',
              assortment_roles_delete: 'Delete a role',
              assortment_strategies_save: 'Save changes in a strategy (or create a new one)',
              assortment_strategies_delete: 'Delete a strategy',
              assortment_decisions_save: 'TBD',
              assortment_output: 'TBD',
              spaces_planograms_save: 'Save changes in a planogram (or create a new one)',
              spaces_planograms_upload_audit_photo: 'Upload planogram audit photos',
              spaces_planograms_approve: 'Action on planogram approval flow (TBD)',
              spaces_planograms_request_approval: 'Action on planogram approval flow (TBD)',
              spaces_planograms_inform: 'Action on planogram approval flow (TBD)',
              spaces_planograms_messaging: 'TBD',
              spaces_planograms_pop_material_save: 'Save standard POP material (TBD Promos)',
              spaces_layout_save: 'Save changes in a layout (or create a new one)',
              spaces_layout_delete: 'Delete a layout',
              spaces_layout_messaging: 'Add comments on a layout',
              spaces_templates_save: 'Save a new Planogram Generator configuration',
              spaces_templates_delete: 'Delete a Planogram Generator configuration',
              equipments_save: 'Save changes in equipment (or create a new one)',
              equipments_delete: 'Delete equipment',
              storemaster_save: 'Save changes in a Point of Sale (or create a new one)',
              storemaster_delete: 'Access Tags menu',
              tags_delete: 'Delete a tag',
              vendor_save: 'Save changes in a Vendor (or create a new one)',
              vendor_publish: 'Publish a vendor (TBD)',
              vendor_delete: 'Delete a vendor',
              general_importer_view: 'Access general importer',
              itemmaster_save: 'Save changes in an item (or create a new one)',
              itemmaster_publish: 'Publish an item',
              itemmaster_delete: 'Delete an item',
              update_custom_item_to_standard_item: 'Convert a custom item to a standard item',
              mysteryShopper_missions_save: 'Save changes in a mission (or create a new one)',
              mysteryShopper_missions_delete: 'Delete a mission',
              prices_output: 'Publish price decisions',
              prices_output_readonly: 'View Publish decisions menu and generate preview',
              prices_roundings_view: 'View rounding rules menu',
              prices_rules_view: 'View pricing rules menu',
              prices_sensitivities_view: 'View sensitivities menu',
              prices_view: 'View price decisions menu',
              pricing_manual_suggestions: 'Generate manual price suggestions',
              pricing_survey: 'Import competition prices',
              storemaster_view: 'View Store Points menu',
              tags_view: 'View tags menu',
              prices_competitors_save: 'Create and update flags and competitors',
              prices_guidelineStrategy_save: 'Updates on guidelines and strategies',
              prices_roundings_save: 'Create and update rounding rules',
              prices_rules_save: 'Create and update price rules',
              prices_sensitivities_save: 'Create and update sensitivities',
              tags_save: 'Create and update tags',
              assortment_categoryTree_view: 'View category tree and category configuration menu.',
              categories_tree_view: 'View category tree and category configuration menu.',
              assortment_clustering_view: 'View clustering menu',
              assortment_decisions_view: 'View assortment decisions menu',
              assortment_output_readonly: 'View assortment decision publishing menu and allow preview generation',
              assortment_roles_view: 'View roles menu',
              assortment_strategies_view: 'View Strategies menu',
              assortment_view: 'Enable general assortment menu',
              equipments_view: 'View equipments menu',
              category_tree_button_view: 'View category tree report button',
              mysteryShopper_missions_view: 'View missions menu',
              mysteryShopper_userAssigment_view: 'View user assignment menu',
              mysteryShopper_view: 'Enable general missions menu',
              promotion_action_view: 'View Actions menu',
              promotion_campaign_view: 'View Campaigns menu',
              promotion_view: 'Enable general promotions menu',
              promotion_calendar_view: 'View the calendar menu',
              promotion_configuration_view: 'View the configuration menu',
              promotion_reportes_view: 'View the reports menu',
              promotion_periods_view: 'View the promotional periods menu',
              promotion_audit_report_view: 'View the promotional log report',
              promotion_reportes_production_view: 'View production lists',
              promotion_reportes_logistic_view: 'View logistics lists',
              promotion_reportes_pos_view: 'View POS data',
              promotion_action_save: 'Create and update promotional actions',
              promotion_action_cancel: 'Delete promotional actions',
              promotion_action_publish: 'Publish promotional actions',
              promotion_campaign_save: 'Create and update campaigns',
              promotion_reports_view: 'View promotional reports',
              promotion_can_edit_all_promotional_actions: 'Create or edit promotions for periods that have already started/finished',
              promotion_promotional_process_view: 'View the menu of promotional processes',
              promotion_promotional_process_edit: 'Create and update promotional processes',
              spaces_layout_view: 'View Layout menu',
              spaces_planograms_pop_material_view: 'View Material Pop menu',
              spaces_planograms_view: 'View planograms menu',
              spaces_view: 'Enable general spaces menu',
              vendor_view: 'View vendors menu',
              masters_delivery_places_view: 'View item Delivery Places per vendor',
              masters_delivery_places_save: 'Save and update item Delivery Places per vendor',
              admin_security: 'Permissions in Role and User management',
              spaces_planograms_delete: 'Enables the user to deactivate all created planograms.',
              output_system_audit: 'System audit report',
              output_users: 'Users report',
              output_login_audit: 'Login audit report',
              output_roles: 'Roles report',
              output_promotion_production_lists: 'Production Lists Report',
              output_spaces_availability: 'Available Spaces Report',
              output_promotion_period: 'Promotions Periods Report',
              output_promotion_log: 'Promotions Log Report',
              output_promotion_oxxo: 'POS Report',
              output_promotion_report_oxxo: 'Promotions Report',
              output_dynamic_entities_report: 'Dynamic Entities Report',
              output_context_report: 'Context Report',
              output_item_matching_report: 'Item Matching Report',
              output_prices_by_price_level_ypf_tiendas: 'Prices by Price Level Report',
              output_vendor_item_costs_ypf_tiendas: 'Items by Vendor and Costs Report',
              range_rules_edit: 'Edit range rules',
              range_rules_delete: 'Delete range rules',
              range_rules_pending_coverage_download: 'Download pending coverage for range rules',
              range_assignment_rules_list_view: 'View range assignment rules list',
              range_category_rules_list: 'View range category rules list',
              range_category_setup_save: 'Save range category setup',
              range_category_setup_edit: 'Edit range category setup',
              range_category_setup_delete: 'Delete range category setup',
              dynamic_entities_view: 'View dynamic entities',
              dynamic_entities_save: 'Create and update dynamic entities',
              dynamic_entities_delete: 'Delete dynamic entities',
              workflows_execute_action: 'Execute workflow action',
              workflows_execute_start: 'Start workflow execution',
              range_rules_save: 'Create and update range rules',
              'update-custom-item-to-standard-item': 'Update custom item to standard item',
              itemmaster_assortment_edit: 'Edit item master assortment',
              itemmaster_assortment_import: 'Import item master assortment',
              outputintegration_view: 'View output integrations',
              outputintegration_execute: 'Execute output integrations',
              outputintegration_retry: 'Retry output integrations',
              interfaces_retry_failed_batches: 'Retry failed interface batches',
              storemaster_publish: 'Publish store master',
              prices_decisions_read: 'Read price decisions',
              prices_charge_view: 'View price charges',
              prices_charge_save: 'Create and update price charges',
              prices_charge_delete: 'Delete price charges',
              'prices_decisions,prices_endorse': 'Endorse price decisions',
              mysteryShopper_userAssigment_save: 'Save Mystery Shopper user assignment',
              promotion_can_rebuild_action_scope: 'Rebuild promotional action scope',
              spaces_templates_view: 'View space templates',
              assortment_decisions_endorse: 'Endorse assortment decisions',
              output_prices_output: 'Prices output report',
              output_prices_suggestions: 'Price suggestions report',
              output_promotion_item_tasks: 'Promotional item tasks report',
              output_promotion_item_stores: 'Promotional item stores report',
              output_promotion_report: 'Promotions report',
              output_printing_list: 'Printing list report',
              output_logistics_list: 'Logistics list report',
              output_promotion_biactives: 'Active promotions BI report',
              output_promotion_biplanned: 'Planned promotions BI report',
              output_promotion_overlapping: 'Overlapping promotions report',
              output_space_planogram_items: 'Space planogram items report',
              output_competitors_prices: 'Competitor prices report',
              output_promotion_bi: 'Promotions BI report',
              output_assortment_report: 'Assortment report',
              output_assortment_prisma_output_report: 'Prisma assortment output report',
              output_markdown_activation: 'Markdown activation report',
              output_markdown_items: 'Markdown items report',
              output_admin_items_to_ignore: 'Items to ignore report',
              output_fuels_all_information_report: 'Fuels all information report',
              output_assortment_output: 'Assortment output report',
              output_pos_items_data_with_assortment: 'POS items data with assortment report',
              output_daily_margin_report: 'Daily margin report',
              output_equipment_assigment: 'Equipment assignment report',
              output_daily_mission_report: 'Daily mission report',
              output_list_missions: 'Missions list report',
              output_other_reports: 'Other reports',
              output_items: 'Items report',
              output_stores: 'Stores report',
              range_store_report_view: 'View store report',
              output_market_item_to_register: 'Market items to register report',
              output_promotion: 'Promotion report',
              output_planogram_pre_generation_report: 'Pre-generation planogram report',
              output_planogram_post_generation_report: 'Post-generation planogram report',
              output_massive_replacement: 'Massive replacement report',
              output_prices_costs: 'Price costs report',
              output_contacts: 'Contacts report',
              output_assortment_status_current_report: 'Current assortment status report',
              output_cost_tax_audit: 'Cost and tax audit report',
              output_range_unassigned_report: 'Unassigned ranges report',
              output_range_active_current_assortment_report: 'Active range current assortment report',
              output_vendor_cost_output: 'Vendor costs report',
              output_tag_values: 'Tag values report',
              output_assortment_decisions_report: 'Assortment decisions report',
              output_category_tree: 'Category tree report',
            },
          },
        },
      },
      PROFILE: {
        CHANGE_PASS: 'Change Password',
        PROFILE_TITLE: 'My Profile',
        PERMISSIONS: 'Permissions',
      },
    },
    PROMO: {
      CAMPAIGNS: {
        ROUTE: 'Promotions',
        TITLE: 'Campaigns',
        NEW_CAMPAING_BTN: 'New Campaign',
        NAME: 'Name',
        CODE: 'Code',
        ACTIONS: '# Actions',
        SINCE: 'Starts',
        TO: 'Ends',
        STATE: 'State',
        USER: 'User',
        LAST_MOD: 'Last Modif.',
        FULLSCREEN_TTIP: 'Expand',
        EXITFULLSCREEN_TTIP: 'Reduce',
        EXPORT_TTIP: 'Export',
        IMPORT_TTIP: 'Import',
        PRINT_TTIP: 'Print',
        TITLE_FORM: 'New Campaign',
        SAVE_BTN: 'Save',
        BASIC_INFORMATION_TAB: 'Main Data',
        CODE_INPUT: 'Code',
        NAME_INPUT: 'Name',
        SINCE_INPUT: 'Starts',
        TO_INPUT: 'Ends',
        DESCRIPTION_INPUT: 'Description',
        STATUS_STORES: 'All',
        STATUS_HISTORY: 'Historical',
        STATUS_VIGENT: 'Valid',
        STATUS_FUTURE: 'Future',
        STATUS_NOTVALID: 'Not valid',
        STATUS_EMPTY: 'Not valid',
        INVALID_TO_DATE: 'Must be greater than the Start date and within the campaign date range',
        INVALID_FROM_DATE: 'Must be less than the End date and within the campaign date range',
        INVALID_TO_DATE_CAMPAING: 'Must be greater than the Start date',
        INVALID_FROM_DATE_CAMPAING: 'Must be smaller than the End date',
        NAME_TTIP: 'Click here to see related actions',
        ACTIONS_TTIP: 'Number of Actions',
        LAST_MOD_TTIP: 'Last modification',
      },
      ACTIONS: {
        ROUTE: 'Promotions',
        TITLE: 'Actions',
        FILTER_TTIP: 'Filter',
        FULLSCREEN_TTIP: 'Expand',
        EXITFULLSCREEN_TTIP: 'Reduce',
        NAME: 'Name',
        CODE: 'Code',
        TYPE: 'Type',
        STORES: '# Stores',
        LIFT: 'Lift %',
        BRAND: 'Brand',
        NONE: 'None',
        SINCE: 'Starts',
        TO: 'Ends',
        SUPPLIES_LAST: 'Subject to stock availability',
        USER: 'User',
        LAST_MOD: 'Last Modif.',
        STATE: 'State',
        TYPE_OP1: 'Get A pay B',
        TYPE_OP2: 'Direct Discount',
        TYPE_OP3: 'Amount discount',
        STATUS_STORES: 'All',
        STATUS_HISTORY: 'Historical',
        STATUS_VIGENT: 'Valid',
        STATUS_FUTURE: 'Future',
        STATUS_NOTVALID: 'Not valid',
        STATUS_EMPTY: 'Not valid',
        STATUS_CANCELLED: 'Cancelled',
        INVALID_TO_TIME: 'Must be greater than the Starting Hour',
        INVALID_FROM_TIME: 'Must be less than the Ending Hour',
        INVALID_TO_DATE: 'Must be greater than the Start date and within the campaigns date range',
        INVALID_FROM_DATE: 'Must be less than the End date and within the campaigns date range',
        INVALID_TO_DATE_CAMPAING: 'Must be greater than the Start date',
        INVALID_FROM_DATE_CAMPAING: 'Must be less than the End date',
        DEFINE_ACTION_STP1: 'Setup Action',
        RESTRICTIONS_STP2: 'Restrictions',
        PRODUCTS_SCOPE_STP3: 'Products Scope',
        STORES_SCOPE_STP4: 'Stores Scope',
        OTHERS_TERMS_STP5: 'Other conditions',
        TITLE_FORM_NEW: 'New Action - ',
        TITLE_FORM_EDIT: 'Edit Action - ',
        STP1: 'Step 1 - Setup Action',
        CODE_INPUT: 'Code',
        PROMOTION_CODE_INPUT: 'External Promo Code',
        NAME_INPUT: 'Name',
        TYPE_INPUT: 'Type',
        QUANTITY_BUY_INPUT: 'Quantity to buy',
        QUANTITY_PAY_INPUT: 'Quantity to pay',
        DISCOUNT_RATE_INPUT: 'Discount rate',
        UNIT_DISCOUNT_INPUT: 'Unit discount',
        DISCOUNT_VALUE_INPUT: 'Discount amount',
        QUANTITY_UNITS_INPUT: 'Quantity of Units to take',
        UNIT_DISCOUNT_PER_INPUT: 'Unit discount {{val}}',
        SINCE_INPUT: 'Starts',
        TO_INPUT: 'Ends',
        SUPPLIES_LAST_CHECK: 'While supplies last',
        UNITS_AVAILABLE_INPUT: 'Units available',
        FRECUENCY_INPUT: 'Frequency',
        DAYS_INPUT: 'Days',
        TIME_FROM_INPUT: 'Starting Hour',
        TIME_TO_INPUT: 'Ending Hour',
        TICKET_MESSAGE_INPUT: 'Ticket Message',
        OBSERVATION_INPUT: 'Observation',
        NEXT_BTN: 'Next',
        MONDAY: 'Monday',
        TUESDAY: 'Tuesday',
        WEDNESDAY: 'Wednesday',
        THURSDAY: 'Thursday',
        FRIDAY: 'Friday',
        SATURDAY: 'Saturday',
        SUNDAY: 'Sunday',
        DAILY: 'Daily',
        WEEKLY: 'Weekly',
        BIWEEKLY: 'Biweekly',
        MONTHLY: 'Monthly',
        BIMONTHLY: 'Bimonthly',
        CUARTERLY: 'Quarterly',
        SEARCH_CONDITIONS: 'Search Other Conditions...',
        STP2: 'Step 2 - Restrictions',
        UNIT_RESTRICTION: 'Unit Restriction',
        MINIMUM_AMOUNT_INPUT: 'Minimum amount',
        MAXIMUM_AMOUNT_INPUT: 'Maximum quantity',
        AMOUNT_RESTRICTION: 'Amount Restriction',
        OTHERS_INPUT: 'Other conditions',
        PREVIOUS_BTN: 'Previous',
        EQUAL_BRAND: 'Same brand',
        EQUAL_PRICE: 'Same price',
        EQUAL_CATEGORY: 'Same category',
        EQUAL_DISCOUNT: 'Same discount',
        EQUAL_PRODUCT: 'Same product',
        STP3: 'Step 3 - Products Scope',
        MANUAL_SELECTION_RADIO: 'Manual Selection',
        CATEGORY_INPUT: 'Category',
        SEARCH_CATEGORY: 'Search Category',
        EXCLUDE_CATEGORY_INPUT: 'Category to exclude',
        SEARCH_EXCLUDE_CATEGORY: 'Search Category to exclude',
        SUBCATEGORY_INPUT: 'Subcategory',
        SEARCH_SUBCATEGORY: 'Search Subcategory',
        EXCLUDE_SUBCATEGORY_INPUT: 'Subcategory to exclude',
        SEARCH_EXCLUDE_SUBCATEGORY: 'Search Subcategory to exclude',
        SUPPLIER_INPUT: 'Supplier',
        SEARCH_SUPPLIER: 'Search Supplier',
        EXCLUDE_SUPPLIER_INPUT: 'Supplier to exclude',
        SEARCH_EXCLUDE_SUPPLIER: 'Search Supplier to exclude',
        BRAND_INPUT: 'Brand',
        SEARCH_BRAND: 'Search Brand',
        EXCLUDE_BRAND_INPUT: 'Brand to exclude',
        SEARCH_EXCLUDE_BRAND: 'Search brand to exclude',
        TAGS_INPUT: 'Attributes',
        SEARCH_TAGS: 'Search Attributes',
        EXCLUDE_TAGS_INPUT: 'Attributes to exclude',
        SEARCH_EXCLUDE_TAGS: 'Search Attributes to exclude',
        ITEMS_INPUT: 'Products',
        SEARCH_ITEMS: 'Search Products',
        EXCLUDE_ITEMS_INPUT: 'Products to exclude',
        SEARCH_EXCLUDE_ITEMS: 'Search Products to exclude',
        MANUAL_LOAD_RADIO: 'Manual loading',
        DRAG_FILE: 'Drag and drop the file here, or click to search on your PC',
        STP4: 'Step 4 - Stores Scope',
        CLUSTER_INPUT: 'Cluster',
        SEARCH_CLUSTER: 'Search Cluster...',
        EXCLUDE_CLUSTER_INPUT: 'Cluster to exclude',
        SEARCH_EXCLUDE_CLUSTER: 'Search Cluster to exclude',
        FORMAT_INPUT: 'Format',
        SEARCH_FORMAT: 'Search Clients / Communities ...',
        EXCLUDE_FORMAT_INPUT: 'Format to exclude',
        SEARCH_EXCLUDE_FORMAT: 'Search Format to exclude...',
        STORE_INPUT: 'Store',
        SEARCH_STORE: 'Search Store...',
        EXCLUDE_STORE_INPUT: 'Store to exclude',
        SEARCH_EXCLUDE_STORE: 'Search Store to exclude...',
        STP5: 'Step 5 - Other Conditions',
        CLIENTS_COMMUNITIES: 'Clients / Communities',
        SEARCH_CLIENTS_COMMUNITIES: 'Search Clients / Communities',
        PAYMENT_METHODS: 'Payment methods',
        SEARCH_PAYMENT_METHODS: 'Search Payment Methods ...',
        BANK_PROMOTIONS: 'Bank promotions',
        SEARCH_BANK_PROMOTIONS: 'Search bank promotions...',
        CUMULATIVE: 'Cumulative with other promotions',
        SAVE_BTN: 'Save',
        NEW_ACTION_TITLE: 'New Action',
        LEGEND_OP1:
          'It is the discount where A represents the units to be purchased by the customer and B represents the units to be paid by the customer. Examples: 2x1 (take 2 and paid for 1) or 3x2 (take 3 and paid for 2)',
        LEGEND_OP2:
          'It is the percentage or amount of discount that will be applied to the current price of the product. Examples: "a 15% discount over current price" or "$ 10 discount over current price"',
        LEGEND_OP3:
          'It is the discount percentage that will be applied to the current price of the product when more than one unit is purchased. Example: Buy the second unit with an 80% discount.',
        CANCEL_BTN: 'Cancel',
        CREATE_BTN: 'Create',
        OVERLAP_TITLE: 'There is an overlap',
        OVERLAP_SUBTITLE: 'Products are being promoted in different promotional actions.',
        DATAIL_BTN: 'Show me the overlaps',
        ACCEPT_BTN: 'Accept',
        ROUTE2: 'Promotions / Campaign',
        ROUTE2_PROMOTIONAL_PERIOD: 'Promotions / Promotional Periods',
        NEW_ACTION_BTN: 'New Action',
        ACTIONS_TITLE: 'Actions',
        VIEW_TTIP: 'View',
        VIEW_TABLE: 'Table Only',
        VIEW_CALENDAR: 'Calendar only',
        TITLE_FILTERS: 'Filters',
        STATE_FILTER: 'State',
        STATE_OP1_FILTER: 'Historical',
        STATE_OP2_FILTER: 'Valid',
        STATE_OP3_FILTER: 'Future',
        CAMPAINGS_FILTER: 'Campaigns',
        CLEAN_FILTER_BTN: 'Clear',
        APPLY_FILTER_BTN: 'Apply',
        STORES_TTIP: 'Number of Stores',
        LAST_MOD_TTIP: 'Last modification',
        STP1_SUB: 'In this step you can define the main components of the type of action selected.',
        STP2_SUB: 'In this step you can define the assortment conditions and minimum and maximum restrictions for the action.',
        STP3_SUB: 'In this step you can select the products to be promoted.',
        STP4_SUB: 'In this step you can select the stores that will execute this promotion.',
        STP5_SUB: 'In this step you can establish conditions that will limit the application of this promotional action.',
        STRATEGY: 'Next, choose the selection strategy for the child products.',
        STRATEGY_ATTR_TITLE: 'Selection by attribute (Dinamic)',
        STRATEGY_ATTR_MSG:
          'Attributes are selected to define the scope of products, if the scope changes, the impact of this setting is done automatically and does not need to be changed',
        STRATEGY_STORE_ATTR_MSG: 'Attributes are selected to define the scope of stores',
        STRATEGY_PROD_TITLE: 'Selection by product',
        STRATEGY_STORE_TITLE: 'Selection by store',
        STRATEGY_PROD_MSG: 'Products should be selected one by one',
        STRATEGY_STORE_MSG: 'Stores should be selected one by one',
        GENERIC_MSG_ERRROR_EXECSUGGESTION: 'Suggestions could not be generated.',
        GENERIC_MSG_NOSUGGESTIONS_EXECSUGGESTION: 'There are no new suggestions.',
        GENERIC_ACTUAL_FILE: 'Actual File:',
      },
      HELP: {
        QUANTITY_BUY_INPUT: 'Indicates the units (A) that the client will take. Example: If the action is "3 x 2", you must enter "3".',
        QUANTITY_PAY_INPUT:
          'Indicates the units (B) that the customer will pay. It should always be less than (A). Example: If the action is "3 x 2" here you must enter "2".',
        FRECUENCY_INPUT: 'Indicates the frequency of the action.',
        DAYS_INPUT: 'Days of the week in which the action will be effective.',
        TIME_FROM_INPUT: 'Time range in which the action will be effective.',
        TIME_TO_INPUT: 'Time range in which the action will be effective.',
        TICKET_MESSAGE_INPUT: 'Short description of the action that will be reflected in the invoice or ticket.',
        OBSERVATION_INPUT: 'It allows entering some type of information or detail of the action.',
        UNIT_DISCOUNT_INPUT: 'Indicates the value of the discount to be applied to each unit sold.',
        DISCOUNT_RATE_INPUT: 'Indicates if the discount is going to be in percentage or a fixed amount.',
        SUPPLIES_LAST_CHECK: 'Informative message for legal purposes for the point of sale.',
        UNITS_AVAILABLE_INPUT:
          'Indicates the total company product units available for the action. Informative message for legal purposes for the point of sale.',
        DISCOUNT_VALUE_INPUT: 'Discount value. Example: If the action is "2nd unit at 30% discount", here we must enter the number "30".',
        UNIT_DISCOUNT_PER_INPUT:
          'Discount value for each unit sold. Example: If the action is "2nd unit at 30% discount", here we must enter the number "15" which is the percentage that will apply the discount on each unit sold.',
        QUANTITY_UNITS_INPUT:
          'Indicates the number of units that the customer should buy for the discount to apply. Example: If the action is "2nd unit at 30% discount", here we must enter the number "2".',
        MINIMUM_AMOUNT_INPUT:
          'Indicates the minimum number of units that the customer should buy for the discount to apply. Example: If the action is "15% discount taking 3 units", here we must enter the number "3".',
        MAXIMUM_AMOUNT_INPUT:
          'Indicates the maximum number of units that the customer can buy with the discount. Example: If the action is "15% discount up to 6 units", here we must enter the number "6". If the customer buys seven units, the 7th unit will not have a discount.',
        MINIMUM2_AMOUNT_INPUT:
          'Indicates the minimum monetary value that the customer should spend for the promotion to apply. Example: If the action is "10% discount on purchases over $ 1,000", here we must enter the number "1,000". If that amount is not reached, the discount does not apply.',
        MAXIMUM2_AMOUNT_INPUT:
          'Indicates the maximum monetary value that the customer should spend for the promotion to apply. Example: If the action is "10% discount on purchases up to $ 1,000", here we must enter the number "1,000". If the purchase is $ 1,500, the discount will still be $ 100 = 1000 x 10%.',
      },
    },
    PROMOV2: {
      CONFIGURATIONS: {
        LIST: {
          TITLE: 'Promotion Rules',
          NEW_RULE: 'New rule',
          NAME: 'Name',
          CODE: 'Code',
          RULE_TYPE: 'Rule Type',
        },
        FORM: {
          NEW_ITEM_TITLE: 'New Promotion Rule',
          NAME: 'Name',
          CODE: 'Code',
          RULE_TYPE: 'Rule Type',
          PROMOTIONAL_PROCESS_TYPE: 'Promotional Process Type',
          PROMOTION_TYPE: 'Mechanics',
          PROMOTION_RULE_TYPE: 'Rule Type',
          LIMITS: 'Limits',
          PRICE_RULES_TITLE: 'The price must be:',
          VALUE: 'Value {{val}}',
          RULE_MESSAGES: {
            FIXPRICE_MINIMUM: 'My {{val}} promotional price must be ${{val2}}.',
            FIXPRICE_MAXIMUM: 'My {{val}} promotional price must be ${{val2}}.',
            REGULARPRICE_MINIMUM: 'My {{val}} promotional price must be {{val3}}{{val2}} lower than the regular price.',
            REGULARPRICE_MAXIMUM: 'My {{val}} promotional price must be {{val3}}{{val2}} above the regular price.',
            TRUCKPRICE_MINIMUM: 'My {{val}} promotional price must be {{val3}}{{val2}} less than the truck price.',
            TRUCKPRICE_MAXIMUM: 'My {{val}} promotional price must be {{val3}}{{val2}} over the truck price.',
            SELECT_CONDITION: '(Select a condition for the rule)',
            INSERT_VALUE: '(Insert a value)',
            SELECT_DISCOUNT_TYPE: '(Select the discount type)',
          },
          REFERENCE_PRICE_TYPES: {
            PLACEHOLDER: 'Reference Price Type',
            FIXPRICE: 'Fixed Price',
            REGULARPRICE: 'Regular Price',
            TRUCKPRICE: 'Truck Price',
          },
          RULE_LIMIT_TYPES: {
            PLACEHOLDER: 'Condition',
            MINIMUM: 'Minimum',
            MAXIMUM: 'Maximum',
          },
          PROMOTION_REGULAR_PRICE_CONDITION: {
            CURRENCY: '$',
            PERCENTAGE: '%',
          },
        },
        RULE_TYPES: {
          PRICE: 'Price',
        },
        PROMOTIONAL_PROCESS: {
          TABS: {
            MAINDATA: 'Main data',
            TASKSTAB: 'Tasks',
            TAB_ERROR: 'The tab "{{val}}" contains errors or incomplete fields.',
            TASKSTAB_ERRORS: {
              NO_TASK_WITH_BEFORE_POSITION: 'There must be at least one task with "Before" selected.',
              ACTIONABLE_EDITING_TASK_NOT_BEFORE: 'You cannot edit a task with actionables if you do not have "Before" selected.',
              ACTIONABLES_NOT_ALLOWED_FOR_NON_BEFORE_TASKS: 'You cannot use actionables in tasks that do not have "Before" selected.',
            },
          },
          LIST_TITLE: 'Promotional Processes',
          NAME: 'Name',
          CODE: 'Code',
          MINIMUM_COVERAGE: 'Minimum coverage %',
          TASK_QUANTITY: 'Number of tasks',
          EDIT: 'Edit',
          CANT_EDIT_TOOLTIP: 'The promotional process cannot be edited as it has assigned promotional periods.',
          CANT_DELETE_TOOLTIP: 'The promotional process cannot be deleted as it has assigned promotional periods.',
          NEW: 'New promotional process',
          WITHOUT_PERMISSION: 'The user does not have permission to edit.',
          DELETE_ROW: 'Delete promotional process',
          DELETE_MODAL_TITLE: 'Do you want to delete the promotional process{{val}}?',
          TASKS: {
            NAME: 'Name',
            STARTING_DAY: 'Starting day',
            BEFORE: 'Before',
            AFTER: 'After',
            TASK_OWNER: 'Responsible',
            CONSULTANTS: 'Consultants',
            DURATION_IN_DAYS: 'Duration',
            REQUIRES_COMPLETION: 'Requires completion',
            ACTIONABLE: 'Actionable',
            NO_ACTIONABLES: 'No actionables available',
            NEW: 'Add task',
            DELETE_MODAL_TITLE: 'Do you want to delete task {{val}}?',
            CLOSE_ALL: 'Close All',
            EXPAND_ALL: 'Expand All',
            ORDER: 'Order',
            ORDER_TOOLTIP: 'Sort tasks by start date',
            ACTIONABLES: {
              GeneratePOSAndPeriodReport: 'Automatic output sending',
              GeneratePromotionReport: 'Automatic promotion report sending',
              GeneratePrintingAndLogisticsReport: 'Automatic production list sending ',
              PublishAllApprovedNewActions: 'Automatic publication',
              EnableActionEditingAndCreation: 'Enable promotional action editing and creation',
            },
          },
          MAIN_DATA_TAB: 'Main data',
          TASKS_TAB: 'Tasks',
        },
        MESSAGE_STRUCTURES: {
          TABS: {
            MAINDATA: 'Main Data',
            MESSAGESTRUCTURE: 'Message Structure',
            TAB_ERROR: 'The tab "{{val}}" contains errors or incomplete fields.',
          },
          MESSAGE_STRUCTURE_WARNING:
            'A default message structure already exists. If you want to edit it, the current data will be overwritten.',
          MESSAGE_STRUCTURE_WARNING_TITLE: 'Default Message Structure',
          LIST: {
            NAME: 'Name',
            CODE: 'Code',
            PROMOTION_PROCESS: 'Promotional Process',
            PROMOTION_TYPE: 'Mechanics',
            COMMUNICATION_TYPE: 'Communication Type',
            DEFAULT_STRUCTURE: 'Default Structure',
            NEW_STRUCTURE: 'New Structure',
            DELETE_STRUCTURE: 'Delete Structure',
            VIEW_ONLY_INACTIVES: 'View only inactives',
            DELETE_STRUCTURE_MESSAGE: 'Are you sure you want to delete the message structure{{val}}?',
            DELETE_STRUCTURE_IN_USE: 'The message structure is in use and cannot be deleted.',
            DELETE_DEFAULT_STRUCTURE: 'A default structure cannot be deleted',
            DELETE_DEFAULT_STRUCTURE_MESSAGE: 'The default structure cannot be deleted.',
            NO_MESSAGE_STRUCTURES: 'No message structure is available.',
            CLONE_MESSAGE_STRUCTURE: 'Clone Promotional Structure',
            CLONE_MESSAGE_STRUCTURE_REFERENCE: 'Are you about to clone the message structure {{val}}?',
          },
          FORM: {
            NEW_STRUCTURE_TITLE: 'New message structure',
            NAME_INPUT: 'Name',
            CODE_INPUT: 'Code',
            COMMUNICATION_TYPE_INPUT: 'Communication type',
            NO_MECHANIC_TITLE: 'Select a mechanic',
            NO_MECHANIC_MESSAGE:
              'To view and configure the available chips, you must first select a promotional mechanic in the "Main Data" tab.',
            DEFAULT_MESSAGE_STRUCTURE_INPUT: 'Default message structure',
            MESSAGE_STRUCTURE_TAB: 'Message structure',
            MESSAGE_STRUCTURE_TAB_ERROR: 'The "{{val}}" tab contains errors or incomplete fields.',
            EXAMPLE: 'Example',
            DEFAULT_MESSAGE_STRUCTURE_INPUT_DISABLED: 'A promotional process and a mechanic must be selected to choose a default structure',
            CHIP_MENU_TYPES: {
              InitialSupportText: 'Initial Support Text',
              FinalSupportText: 'Final Support Text',
              Quantity: 'Quantity',
              Items: 'Products',
              Connectors: 'Connections',
              Price: 'Precio',
              FreeText: 'Free text',
              VariableText: 'Text variable',
              SupportText: 'To select this text',
              Tags: 'Tags',
              Extra: 'Extra',
            },
            CHIP_PLACEHOLDER: {
              ITEMS: 'Select products',
              TAGS: 'Select the value',
            },
          },
          ADD_CHIP_MODAL: {
            ADD_CHIP_TITLE: 'Add Chip to {{val}}',
            ADD_CHIP: 'Add Chip',
            CHIP_TEXT_INPUT: 'Chip Text',
            CHIP_TEXT_LABEL: 'Enter chip text',
            CHIP_TEXT_REQUIRED: 'Chip text is required',
          },
          CHIP_MENU_TYPES: {
            InitialSupportText: 'Initial support text',
            FinalSupportText: 'Final support text',
            Quantity: 'Quantity',
            Items: 'Items',
            Connectors: 'Connectors',
            Price: 'Price',
            FreeText: 'Free text',
            VariableText: 'Variable text',
            SupportText: 'Selectable support text',
            Tags: 'Tags',
          },
        },
      },
      CAMPAIGNS_LIST: {
        ROUTE: 'Promotions',
        TITLE: 'Campaigns',
        TITLE_PROMOTIONAL_PERIOD: 'Promotional Period',
        NEW_CAMPAING_BTN: 'New Campaign',
        NEW_PROMOTIONAL_PERIOD: 'New Promotional Period',
        NAME: 'Name',
        CODE: 'Code',
        ACTIONS: '# Actions',
        FROM: 'From',
        TO: 'Until',
        STATE: 'Status',
        USER: 'User',
        ACTIONSCOUNT: '# Actions',
        LAST_MOD: 'Last Modified',
        FULLSCREEN_TTIP: 'Expand',
        EXITFULLSCREEN_TTIP: 'Reduce',
        EXPORT_TTIP: 'Export',
        IMPORT_TTIP: 'Import',
        PRINT_TTIP: 'Print',
        TITLE_FORM: 'New Campaign',
        SAVE_BTN: 'Save',
        BASIC_INFORMATION_TAB: 'Main Data',
        CODE_INPUT: 'Code',
        NAME_INPUT: 'Name',
        FROM_TTIP: 'Date from',
        TO_TTIP: 'Date to',
        DESCRIPTION_INPUT: 'Description',
        STATUS_STORES: 'All',
        STATUS_HISTORY: 'Historical',
        STATUS_VIGENT: 'Current',
        STATUS_FUTURE: 'Future',
        STATUS_NOTVALID: 'Invalid',
        STATUS_EMPTY: 'Invalid',
        INVALID_TO_DATE: 'Must be greater than the From date and be in the date range of the campaign',
        INVALID_FROM_DATE: 'Must be less than the Until date and be in the date range of the campaign',
        INVALID_TO_DATE_PROMOTIONAL_PERIOD: 'Must be greater than the From date and be in the promotional period date range',
        INVALID_FROM_DATE_PROMOTIONAL_PERIOD: 'Must be less than the To date and be in the promotional period date range',
        INVALID_TO_DATE_CAMPAING: 'Must be greater than From date',
        INVALID_FROM_DATE_CAMPAING: 'Must be less than Until date',
        NAME_TTIP: 'Click here to see associated actions',
        ACTIONS_TTIP: 'Number of Actions',
        LAST_MOD_TTIP: 'Last Modified',
        SEE_ACTIONS: 'Actions',
      },
      CAMPAIGNS_EDIT: {
        SAVE_BTN: 'Save',
        BASIC_INFORMATION_TAB: 'Main Data',
        CODE_INPUT: 'Code',
        NAME_INPUT: 'Name',
        FROM: 'From',
        INVALID_TO_DATE_CAMPAING: 'Must be greater than From date',
        INVALID_FROM_DATE_CAMPAING: 'Must be less than Until date',
        TO: 'Until',
        DESCRIPTION_INPUT: 'Description',
        TITLE_FORM: 'New Campaign',
        TITLE_FORM_PROMOTIONAL_PERIOD: 'New Promotional Period',
      },
      ACTIONS_LIST: {
        EXPORT_TTIP: 'export',
        FILTER_TTIP: 'filter',
        DELETE_TTIP: 'delete',
        DELETE: 'delete',
        TITLE: 'List of actions',
        NEW_ACTION: 'new action',
        EDIT_ROW_DISABLED_TOOLTIP: 'Cannot edit a record in publishing process',
        EDIT_ROW: 'Edit',
        DELETE_ROW: 'Delete',
        REVALIDATE_ROW: 'Revalidate',
        REVALIDATING_TOOLTIP: 'Revalidate',
        SEE_DELETED_FILTERS: 'View deleted',
        SEE_CANCELLED_FILTERS: 'View Only Canceled',
        SEE_SUGGESTED_FILTERS: 'View Suggestions Only',
        SEE_WITHOUT_POP_MATERIAL: 'View Without Promotion Materials',
        SEE_SUGGESTED_FILTERS_TOOLTIP: 'Suggested Action',
        ACTION_STATUS: 'Action Status:',
        STATUS_VAL: 'Status and Validation',
        STATUS: 'Status',
        ACTION_STATUS_VALIDATION: 'Validation Status:',
        TYPE_FILTERS: 'Filter by type',
        CREATION_ON: 'Creation date',
        STORES_FILTER: 'Points of Sale',
        ITEM_TAGS: 'Filters for Products',
        STORE_TAGS: 'Point of Sale Tags',
        ITEM_TYPE_INPUT: 'Type of Action',
        ITEM_TYPE_INPUT_OXXO: 'Promotional process',
        ITEM_TYPE_MEC_INPUT: 'Mechanics',
        NEW_ITEM_MODAL: 'New Action',
        CLONE_ROW: 'Clone record',
        CANCEL_ROW: 'Cancel registration',
        CREATE_BTN: 'Create',
        COPY_ROW: 'Copy record',
        DISABLED_CLONE_TOOLTIP: 'Only records in published state can be cloned',
        REPORT_TOOLTIP: 'Download Report',
        REPORT_TOOLTIP_MORE_INFO:
          "This report generates records based on the promotion's configuration.\nTo generate the records, the following fields must be filled: period, spaces, store and product coverage, and discount and approved coverage configuration.",
        ACTIONS: {
          ROUTE: 'Promotions',
          TITLE: 'Actions',
          FILTER_TTIP: 'Filter',
          FULLSCREEN_TTIP: 'Expand',
          EXITFULLSCREEN_TTIP: 'Reduce',
          NAME: 'Name',
          CODE: 'Code',
          TYPE: 'Type',
          LIFT: 'Lift%',
          BRAND: 'Brand',
          NONE: 'None',
          TO: 'Until',
          SUPPLIES_LAST: 'Until stocks last',
          USER: 'User',
          LAST_MOD: 'Last Modified',
          STATE: 'Status',
          PROMOTIONAL_SPACES: 'Promotional spaces',
          PROMOTIONAL_MATERIAL: 'Promotional Material',
          EDIT_PROMOTIONAL_SPACES: 'Edit Promotional Material',
          EDIT_VALIDATIONS: 'Edit business validations',
          LIST_PROMOTIONAL_SPACES: 'Selected Promotional Spaces:',
          VALIDATION_STATE: 'Validation Status',
          VALIDATION_TYPES: 'Validation Types',
          VALIDATION_TYPE_VALUES: {
            COVERAGE: 'Coverage',
            MAX_SLOTS: 'Max Slots',
            FIX_AND_REGULAR_PRICE: 'Fixed and Regular Price',
            STORES_AND_PROMOTIONAL_SPACE: 'Stores and Promotional Space',
            REFERENCE_PRICE: 'Reference Price',
            FIX_PRICE_EXCEPTIONS: 'Fixed Price Exceptions',
            PROMOTIONAL_MESSAGE: 'Promotional Message',
            GIFT_PRICE: 'Regular Gift Price vs Extra Value',
          },
          VALID_TO_PUBLISH: 'Already to publish',
          TYPE_OP1: 'Take A pays B',
          TYPE_OP2: 'Direct Discount',
          TYPE_OP3: 'Quantity Discount',
          METHODTYPE: 'Method type',
          DISCOUNTTYPE: 'Discount type',
          STOREQUANTITY: '# Points of sale',
          ESTIMATEDSALE: 'Estimated sale',
          FREQUENCYTYPE: 'Frequency type',
          FROM: 'From',
          FROM_TTIP: 'Date from',
          TO_TTIP: 'Date to',
          PROMOTINOAL_PERIOD: 'Promotional Period',
          PROMOTIONAL_LOG: 'Promotions Log',
          PROMOTIONAL_PERIOD_CODE: 'Promotional Period Code',
          EXTERNAL_CODE: 'External Code',
          ONLY_ACTIVE_PERIODS: 'Only active periods',
          NO_ACTIVE_PERIODS: 'There are no active periods.',
          NO_ACTIVE_PERIODS_IN_SELECTION: 'There are currently no active promotional periods for the selected year and process.',
          NO_ACTIVE_PERIODS_IN_SELECTION_MORE_INFO:
            'If you need to make changes, we recommend:<br><ul> <li> Check the Calendar and verify the task dates that include the option "Enable upload and editing of promotional actions" </li> <br> <li> Contact an <b>admin user</b> or the <b>responsible role</b> to adjust the dates if applicable.</li> </ul>',
          NAVIGATE_TO_CALENDAR: 'Go to Calendar',
          CANT_EDIT_VALIDATIONS:
            'Validations can only be modified when the period is active. <br><br> If you need to make changes, we recommend contacting an <b>admin user</b> or the <b>responsible role</b> to request an exception if applicable.',
          VALIDATION_TYPES_VALUES: {
            COVERAGE: 'Coverage',
            MAX_SLOTS: 'Max Slots',
            FIX_AND_REGULAR_PRICE: 'Fixed and Regular Price',
            STORES_AND_PROMOTIONAL_SPACE: 'Stores and Promotional Space',
            REFERENCE_PRICE: 'Reference Price',
            FIX_PRICE_EXCEPTIONS: 'Fix Price Exceptions',
            PROMOTIONAL_MESSAGE: 'Promotional Message',
            GIFT_PRICE: 'Regular Gift Product Price vs Extra Value',
          },
          FREECUENCYTYPE: 'Frequency type',
        },
        TYPE: {
          DISCOUNT: 'Discount',
          BUYAPAYB: 'Take A pays B',
          BUYAGETDISCOUNTINXUNIT: 'Get discount per unit',
          SURCHARGE: 'Surcharge',
          FIXPRICE: 'Fixed Price',
          GIFT: 'Gift',
          WHOLESALER: 'Wholesaler',
          IMAGECOMMUNICATION: 'Image Communication',
        },
        TYPE_DEC: {
          DISCOUNT:
            'Allows you to define a monetary value or percentage that will be applied reducing the final price that the customer will pay.',
          BUYAPAYB: 'Discount where A is the number of units to be purchased by the customer and B is the units to be paid.',
          BUYAGETDISCOUNTINXUNIT: 'A discount is applied to a number of units within a minimum quantity to buy of the same product.',
          SURCHARGE:
            'Allows you to define a monetary value or percentage that will be applied increasing the final price that the client will pay.',
          FIXPRICE: 'Establish the price to pay carrying a number of units.',
          GIFT: 'Allows you to define a gift product when buying other products, a minimum purchase and/or setting the price of the gift product.',
          WHOLESALER: 'Wholesaler',
          IMAGECOMMUNICATION: 'Highlight new products or the regular price that is so attractive',
        },
        METHODTYPE: {
          ACTIVATEONLYDURINGPROMOTION: 'Active only during promotion',
          ACTIVATEINDEFINITELY: 'Active indefinitely',
          DONOTACTIVATE: 'Do not activate products',
        },
        DISCOUNTTYPE: {
          ABSOLUTEVALUE: '$',
          PERCENTAGE: '%',
        },
        FREQUENCYTYPE: {
          EVERYDAY: 'Every day',
          CERTAINDAYSOFTHEWEEK: 'Certain days of the week',
          CERTAINDAYSOFTHEMONTH: 'Certain days of the month',
        },
        CLONE: {
          MODAL_CONTENT:
            'Define name and internal code for the new promotion. All existing points will be cloned from {{val}} ({{val2}}), having the possibility of editing.',
          CREATE_BTN: 'Clone',
          CANCEL: 'Cancel',
        },
        CANCEL: {
          MODAL_CONTENT:
            'The promotion will be canceled {{val}} ({{val2}}) all its content will be disabled for modifications and the promotion will not be valid',
          CANCEL_REASON: 'Cancellation reason',
          CANCEL_OBSERVATION: 'Observation',
          CREATE_BTN: 'OK',
          CANCEL: 'Close',
        },
      },
      ACTIONS_TYPES: {
        Discount: 'Direct Discount',
        BuyAPayB: 'Buy A pays B',
        BuyAGetDiscountInXUnit: 'Get discount per unit',
        Surcharge: 'Surcharge',
        FixPrice: 'Fixed Price',
        Gift: 'Gift',
        Wholesaler: 'Wholesaler',
        ImageCommunication: 'Image Communication',
        ImageComunication: 'Image Communication',
      },
      ACTIONS_EDIT: {
        TEST: 'TEST',
        SAVE: 'Save',
        PUBLISH: 'Publish',
        CANCEL_ACTION: 'Cancel',
        OK: 'Ok',
        WARNING_DOWNLOAD: 'Only one promotional period selected in the filters is required.',
        WARNING_SAVE: 'Requires saving current changes.',
        WARNING_PUBLISH: 'You need to republish for saved changes to take effect.',
        NOVALID_PUBLISH_ADVICE: 'The following tab is not valid:',
        PROMOTION_EDIT_DISABLED: 'The promotional action can only be modified when the period is active.',
        BASIC_INFORMATION_TAB: 'Main Data',
        ACTIVATION_TAB: 'Activation',
        LOADING: 'Loading ...',
        SCOPE_OF_ITEMS: 'Scope of Products',
        PAYMENTMETHODS: 'Payment Methods',
        CUSTOMFIELDS: 'Additional Information',
        SCOPE_OF_STORES: 'Scope of Points of Sale',
        GIFT_ITEM: 'Gifts Product',
        GIFT_ITEM_TAB: 'Scope of Gifts Products',
        NEW_ITEM_BTN: 'New Promotional Action',
        PUBLISH_CONFIRM:
          'The publication process includes the creation of the Assortment, Prices, Costs and other records related to this action. <br> <br> <b> Are you sure you want to Publish? </b>',
        PUBLISH_CONFIRM_TITLE: 'Publication Confirmation',
        PUBLISHING_WARNING: 'Item in process of publishing, please try again in a few minutes.',
        PUBLISH_LONG_TIME:
          'The publication of this Product may take a few minutes, when it is finished you will be notified with a notification.',
        INVALID_TO_TIME: 'Must be greater than Time From',
        INVALID_FROM_TIME: 'Must be less than Hours Until',
        STRATEGY_ATTR_TITLE: 'Selection by attribute (Dinamic)',
        STRATEGY_ATTR_MSG:
          'Attributes are selected to define the scope of products, if the scope changes, the impact of this setting is done automatically and does not need to be changed',
        STRATEGY_PROD_TITLE: 'Selection by product',
        STRATEGY_PROD_MSG: 'Products must be chosen explicitly one by one',
        STRATEGY_ATTR_TITLE_STORE: 'Selection by attribute (Dinamic)',
        STRATEGY_ATTR_MSG_STORE:
          'Attributes are selected to define the scope of points of sale, if the scope changes, the impact of this setting is done automatically and does not need to be changed',
        STRATEGY_STORE_TITLE_STORE: 'Selection by points of sale',
        STRATEGY_STORE_MSG_STORE: 'The points of sale must be explicitly chosen one by one',
        CLIPBOARD_STORE_TITLE: 'Paste points of sale from clipboard',
        CODE_AND_DESCRIPTION_INPUT: 'Code / Description',
        CLIPBOARD_PRODUCT_TITLE: 'Paste products from clipboard',
        DELETE_TIME_RANGE: 'Borrar Rango Horario',
        ADD_TIME_RANGE: 'Agregar Rango Horario',
        OVERLAP_TIME_RANGE: 'Overlapping Time Range',
        SAVE_LONG_TIME: 'Confirm Save',
        SAVE_OBSERVATION: 'Observations',
        SAVE_LONG_TIME_MSG_A:
          'Saving this promotion may take a few minutes. It will be validated, and you will be notified once it is completed.',
        SAVE_LONG_TIME_MSG_B:
          'Until the validation process is completed, the promotion cannot be modified again.<br><br><b>Are you sure you want to Save?</b>',
        SAVE_LONG_TIME_MSG_C: 'Until the validation process is completed, the promotion cannot be modified again.',
        SAVE_LONG_TIME_MSG_D: 'Are you sure you want to save?',
        SAVE_PVD_MSG:
          'I agree that my promotional action applies to all my <br> products and points of sale. (I am aware that this may result in a longer wait time in the validation process.)',
        SAVE_STORE_SCOPE_PVD_MSG:
          'I agree that my promotional action applies to all my <br> points of sale. (I am aware that this situation may result in a longer wait time in the validation process.)',
        SAVE_ALL_ITEMS_SELECTED_WARNING:
          'The defined product scope corresponds to 100% of the products, please define a specific scope to save.',
        PROCESS_WARNING_TITLE: 'The required action cannot be completed',
        PROCESS_WARNING_MSGLONGTIME: 'The publication and/or saving cannot be completed for the following reasons:',
        PROCESS_WARNING_MSGLONGTIME_EXTEND_1:
          'The promotion is in the Validation Process, so it cannot be saved or published until it is completed.',
        PROCESS_WARNING_MSGLONGTIME_EXTEND_2: 'The promotion is in a Rejected Validation state, so it cannot be published.',
        PROCESS_WARNING_MSGLONGTIME_EXTEND_3: 'The promotion is in a Cancelled Validation state, so it cannot be published.',
        PROCESS_WARNING_MSGLONGTIME_EXTEND_4:
          'The promotion is pending Required Action, so it cannot be published until the action is resolved.',
        COVERAGE_TITLE: 'Coverage',
        MAIN_DATA: {
          NAME: 'Name',
          CODE: 'Code',
          EXTERNAL_CODE: 'External Code',
          MESSAGE: 'Ticket Message',
          REGENERATE: 'Regenerate',
          REGENERATE_TOOLTIP: 'A message is generated with the first {{val}} characters of the promotional action name, excluding prices.',
          INTERNAL_CODE: 'Internal Code',
          VALIDATION_CODE2: 'The code {{val}} already exists.',
          SINCE_INPUT: 'From',
          TO_INPUT: 'Until',
          OBSERVATION: 'Observation',
          TITLE_FRECUENCY: 'Frequency',
          TIME_FROM: 'Time from',
          TIME_TO: 'Schedule Until',
          CAMPAING: 'Campaign',
          PROMOTIONAL_PERIOD: 'Promotional Period',
          SET_PROMOTIONAL_PERIOD:
            'When selecting or modifying the dates of the chosen promotional period, the dates of the chosen promotional period will be loaded.',
          PROMOTIONAL_MATERIAL: 'Promotional Material',
          GIFT_ITEM: 'Gift Product',
          ACCUMULATE_ACTIONS: 'Accumulative with other actions',
          GIFT_ITEM_POPOVER_MSG: 'You can select a single gift product, existing in the Item Master module',
          GIFT_ITEM_NEW: 'New Gift Product',
          GIFT_ITEM_NEW_POPOVER_MSG:
            'If the gift product should not be managed by the Item Master module, the name of the same can be indicated in this field',
          SELECTTIMERANGE: 'Active 24 hours a day',
          SELECTTIMERANGE_TEXT:
            'If this option is active, the promotional action will be in effect 24 hours a day, otherwise it will be necessary to define a daily time range to indicate the period in which the promotional action is active.',
          PLANOGRAMS_WARNING_PRODUCT_SCOPE: 'Select the Product Scope to be able to edit.',
          PLANOGRAMS_WARNING_STORE_SCOPE: 'Select the Store Scope to be able to edit.',
          PLANOGRAMS_WARNING_SAVE: 'Save changes to be able to edit.',
          PLANOGRAMS_WARNING_NO_PLANOGRAMS: 'There are no planograms in the selected store scope.',
          PLANOGRAMS_WARNING_ALL_ITEMS: 'Define a specific product scope to get the available promotional material.',
          PLANOGRAMS_WARNING_MAIN_DATA: 'Complete the mandatory fields to save changes and edit.',
          PLANOGRAMS_WITHOUT_POP_MATERIAL: 'Without promotional material',
          PLANOGRAMS_DELETED: '{{val}} previously selected promotional materials are no longer available.',
          PERIOD_WARNING_INVALID_FROM_TODAY:
            'The promotional period is not currently active. If you need to make changes, we recommend contacting an <b>admin user</b> or the <b>responsible role</b> to request an exception if applicable.',
          PERIOD_WARNING_INVALID_FROM_TASK: 'The first planning task for the selected period should have started on',
          PERIOD_WARNING_INVALID_FROM_TO: 'The start date cannot be later than the end date',
          ESTIMATEDSALE: 'Estimated sale',
          CHANGE_REASON: 'Reason for change',
          TICKET_MESSAGE: {
            MODAL_TITLE: 'Do you want to regenerate the ticket message?',
            PRICE: 'Prices are not allowed in the message.',
            SPECIALCHARACTERS: 'Special characters are not allowed in the message.',
            DOUBLESPACES: 'Double spaces are not allowed in the message.',
            MAXCHARACTER: 'You have reached the maximum number of characters allowed for the message.',
          },
        },
        VALIDATIONS: {
          VALIDATIONS_TITLE: 'Validations',
          ERROR_VALIDATION:
            'An error occurred while running the validation, please try REVALIDATE. If the error persists, please contact the support team',
          COVERAGE_TOOLTIP:
            'To improve this validation, we suggest adjusting the scope of stores or products, checking coverage through labels beforehand, and analyzing the current coverage status by different sets of points of sale.',
          MAX_SLOTS_TOOLTIP:
            'To improve this validation, we suggest adjusting the scope of stores or modifying the promotional materials used.',
          FIX_AND_REGULAR_PRICE_TOOLTIP:
            'To improve the results of this validation, we suggest adjusting the promotional price from the activation tab.',
          STORE_AND_PROMOTIONAL_SPACE:
            'To improve this validation, we suggest adjusting the scope of stores or modifying the promotional materials used.',
          FIX_PRICE_EXCEPTIONS: 'To improve this validation, we suggest adjusting the price exceptions in the exceptions importer.',
          REFERENCE_PRICE: 'To improve this validation, we suggest adjusting the promotional price from the activation tab.',
          ACTION_BUTTON_DISABLED_TOOLTIP: 'Changes are only allowed when the promotional action is published.',
          PROMOTIONAL_MESSAGE_TOOLTIP:
            'To improve this validation, we suggest adjusting the promotional message from the product scope tab.',
          TAB_TITLE: 'Business Validations',
          TAB_DESCRIPTION:
            'Business validations are used to ensure that the promotional action meets the necessary criteria for execution. In the event that a validation encounters errors, it can be approved or rejected when publishing or preemptively modifying the involved data to obtain new results. Through reports, we can obtain detailed information about the failures, and if all the necessary data is not available to perform the validation, it will be reported as incomplete. It is necessary to have all validations approved and validated to obtain productive reports.',
          storesAndPromotionalSpace: {
            VALIDATION_NAME: 'Store Scope vs Promotional Material',
            VALIDATION_DESCRIPTION:
              'Validates if any store configured for this promotion does not have the selected promotional materials.',
            VALIDATION_ERROR:
              '{{val}} stores configured for this promotion were found not to have some of the selected promotional materials.',
            VALIDATION_SUCCESS: 'All selected promotional materials are available in the promotion stores.',
            VALIDATION_INCOMPLETE:
              'The impact on stores cannot be determined because promotional materials or store scope for this promotion were not selected.',
          },
          MaxSlots: {
            VALIDATION_NAME: 'Maximum Number of Promotions per Promotional Material',
            VALIDATION_DESCRIPTION:
              'Validates if the maximum number of promotions supported in any of the selected promotional materials has been exceeded.',
            VALIDATION_ERROR: 'This promotion exceeds the maximum capacity supported by {{val}} space-stores.',
            VALIDATION_SUCCESS: 'The promotion was successfully assigned to the selected promotional materials.',
            VALIDATION_INCOMPLETE: 'The maximum number of promotions was not calculated because promotional materials were not selected.',
          },
          FixAndRegularPrice: {
            VALIDATION_NAME: 'Promotional Price vs Regular Price',
            VALIDATION_DESCRIPTION:
              'Validates that the fixed promotional price is lower than the regular price in that store, ensuring it is true for all stores where this promotion applies.',
            VALIDATION_ERROR: 'The promotional price was found to be greater than or equal to the regular price in {{val}} product-stores.',
            VALIDATION_SUCCESS: 'The promotional price is lower than the regular price in all product-stores for this promotion.',
            VALIDATION_INCOMPLETE:
              'It cannot be determined if the promotional price is correct because products or stores in their respective scopes were not selected.',
          },
          FixPriceExceptions: {
            VALIDATION_NAME: 'Price exception vs regular price',
            VALIDATION_DESCRIPTION:
              'Validates that the promotional price set in the price exceptions importer is lower than the regular price for each store in the store scope defined in the importer.',
            VALIDATION_ERROR:
              'The promotional price is greater than or equal to the regular price in {{val}} product-stores in the exceptions of this promotion.',
            VALIDATION_SUCCESS: 'The promotional price is lower than the regular price in all product-stores of this promotion.',
            VALIDATION_INCOMPLETE:
              'To validate this promotional action it is necessary to define product scope, store scope and import at least 1 price exception correctly.',
          },
          Coverage: {
            VALIDATION_NAME: 'Minimum Coverage',
            VALIDATION_DESCRIPTION: 'Validates that the minimum coverage is reached.',
            VALIDATION_ERROR: 'The defined minimum coverage of {{val}}% is not met.',
            VALIDATION_SUCCESS: 'The defined minimum coverage of {{val}}% is met.',
            VALIDATION_INCOMPLETE: 'Coverage was not calculated because products or stores in their respective scopes were not selected.',
          },
          ReferencePrice: {
            VALIDATION_NAME: 'Promotional Price vs Truck Price',
            VALIDATION_DESCRIPTION:
              'Validates that the promotional price complies with the defined price rule, ensuring it applies to all stores where this promotion is valid.',
            VALIDATION_ERROR:
              'The promotional price does not comply with the truck price rule for all product-store combinations in this promotion.',
            VALIDATION_SUCCESS:
              'The promotional price complies with the truck price rule for all product-store combinations in this promotion.',
            VALIDATION_INCOMPLETE:
              'It cannot be determined if the promotional price is correct because it needs to be loaded in the activation tab.',
          },
          PromotionalMessage: {
            VALIDATION_NAME: 'Promotional Message',
            VALIDATION_DESCRIPTION: 'Validates that the promotional message is correct.',
          },
          ADDITIONAL_GIFT_PRICE_TOOLTIP: 'Validates that the regular price of the gift product is greater than the extra value.',
          AdditionalGiftPrice: {
            VALIDATION_NAME: 'Regular Gift Product Price vs Extra Value',
            VALIDATION_DESCRIPTION: 'Validates that the regular price of the gift product is greater than the extra value.',
            VALIDATION_ERROR: 'The regular price of the gift product is less than the extra value in {{val}} product-stores.',
            VALIDATION_SUCCESS:
              'The regular price of the gift product is greater than the extra value in all product-stores of this promotion.',
            VALIDATION_INCOMPLETE:
              'The gift price cannot be determined because products or stores in their respective scopes were not selected.',
          },
        },
        DOWNLOAD_VALIDATION_REPORT: 'Download Validation Report',
        VALIDATION_NO_DATA: 'There is not enough data to validate',
        ACTIVATION: {
          ASSORTMENTMETHOD: 'Assortment Behavior',
          CHANNELCODES: 'Sales Channels',
          LOYALTYPROGRAMCODES: 'Loyalty Programs',
          LOYALTYPROGRAMCODES_GLOBAL: 'Restriction for Loyalty Programs',
          LOYALTYPROGRAMCODE: 'Loyalty Program',
          LOYALTY_PROGRAM_CODE_EXC: 'Exceptional Loyalty Program',
          LOYALTY_PROGRAM_MODAL_ADVICE_TITLE: 'Do you want to delete the loaded price exceptions?',
          LOYALTY_PROGRAM_MODAL_ADVICE_SUBTITLE:
            'The promotional action has price exceptions that will be deleted if loyalty program restrictions are applied.',
          BUY_A_QUANT: 'Take',
          BUY_B_QUANT: 'Pay',
          BUY_B_QUANT_DESC: 'Units to Discounted',
          MIN_QUANT: 'Quantity',
          MIN_QUANT_DISCOUNT: 'Units to buy',
          BUY_B_QUANT_DESC_DISCOUNT: 'Apply discount to',
          SAMEITEM: 'Same Product',
          UNTILSTOCKLAST: 'Until Stock Out',
          MIN_VALUE: 'Minimum Value $',
          MIN_VALUE_TICKET: 'Total Ticket $ Minimum Value',
          DISCOUNT: 'Discount',
          LOYALTY_DISCOUNT: 'Exceptional Loyalty Discount',
          LOYALTY_FIXED_PRICE: 'Exceptional Loyalty Fixed Price',
          SURCHARGE: 'Surcharge',
          DISCOUNTTYPE: 'Discount Type',
          SURCHARGETYPE: 'Type of Surcharge',
          FIXPRICE: 'Fixed Price $',
          FIXPRICE_TOOLTIP:
            "Indicates the promotional price for the total quantity of products loaded. Example: If the action is '3 x $40,' the Minimum Quantity of products is 3, and the fixed price to be applied is the final one, in this case, $40.",
          SHIPPINGDISCOUNT: 'Shipping Discount%',
          MAXIMUMDISCOUNTVALUE: 'Discount Cap $',
          COMMUNICATIONTYPE: 'Communication type',
          COMMUNICATIONDISPLAY: 'Communication Order',
          COMMUNICATIONDISPLAY_TOOLTIP:
            'Communication Order: Allows you to define the order in which the text is generated for the production list.',
          EXCEPTIONAL_FIXED_PRICE_TITLE: 'Exceptional Fixed Price Upload',
          EXCEPTIONAL_DISCOUNT_TITLE: 'Exceptional Discount Upload',
          EXCEPTIONAL_FIXED_PRICE_SBUTITLE: 'You can upload price exceptions via the importer',
          EXCEPTIONAL_FIXED_PRICE_SBUTITLE_NO_ID: 'You can upload price exceptions via the importer. You need to save the current changes.',
          EXCEPTIONAL_FIXED_PRICE_SBUTITLE_NO_ID_ALT:
            'You can upload price exceptions via the importer. Allowing you to upload exceptions at the store or tag level (only one of the two levels can be used for the entire importer). Each import replaces the previous import. You need to save the current changes.',
          EXCEPTIONAL_DISCOUNT_SBUTITLE: 'You can upload discount exceptions via the importer',
          EXCEPTIONAL_DISCOUNT_SBUTITLE_ALT:
            'You can upload discount exceptions via the importer. Allowing you to upload exceptions at the store or tag level (only one of the two levels can be used for the entire importer). Each import replaces the previous import.',
          EXCEPTIONAL_FIXED_PRICE_SBUTITLE_ALT:
            'You can upload price exceptions via the importer. Allowing you to upload exceptions at the store or tag level (only one of the two levels can be used for the entire importer). Each import replaces the previous import.',
          EXCEPTIONAL_DISCOUNT_SBUTITLE_NO_ID: 'You can upload discount exceptions via the importer. You need to save the current changes.',
          LOYALTYPROGRAMCODES_GLOBAL_TOOLTIP: 'Optionally restrict the execution of activation for the selected loyalty program(s).',
          COMMUNICATIONTYPE_TOOLTIP:
            'If you select <b>"Communicate Discount"</b> the percentage of discount that will be applied to the product for your purchase will be indicated.<br>If you select <b>"Communicate Price"</b> you will obtain the price end of the promotion in the promotions and printing reports.<br><br><b>Report example:</b><br><b>Promotion 1</b> Coca Cola 600ml with a 10% discount each.<br><b>Promotion 2</b> Coca Cola 600ml only $10 each in store A and Coca Cola 600ml only $9 each in store B, considering that regular prices may be different in each store.',
          LOYALTY_DISCOUNT_TOOLTIP: 'Optionally allows granting a different and exclusive discount value for the selected loyalty program.',
          LOYALTY_FIXED_PRICE_TOOLTIP:
            'Optionally allows granting a different and exclusive fixed price value for the selected loyalty program.',
          LOYALTY_FIXED_PRICE_TOOLTIP_ALT:
            'Indicates the promotional price for the selected loyalty program, respecting the total quantity of products loaded. Example: If the action is "3 x $30 for loyalty program," the Minimum Quantity of products is 3 and the exceptional fixed price by loyalty to be loaded is the final one, in this case, $30. This price applies to all stores without exception.',
          ActionsV2_communicationType: {
            CommunicateDiscount: 'Communicate Discount',
            CommunicatePrice: 'Communicate Price',
          },
          ActionsV2_communicationDisplay: {
            CommunicateFirstValue: 'Promotional Value + Product Name',
            CommunicateFirstName: 'Product Name + Promotional Value',
          },
          COMMUNICATION: {
            PROMOTIONAL_MESSAGE: 'Promotional message',
            PROMOTIONAL_MESSAGE_TOOLTIP:
              'This field allows you to quickly view an example of the promotional message obtained in productive reports',
            PROMOTIONAL_MESSAGE_WARNING:
              'The promotional action does not have enough data to generate the promotional message, please complete all required data',
            SUPPORT_TEXT: 'Support text',
            SUPPORT_TEXT_TOOLTIP: ' ',
            COMMUNICATION_COMBO_MODAL_TITLE: 'Select information for each block',
          },
          IMPORT_LIST: {
            valuePrice: 'Fixed Price $',
            valueDiscount: 'Discount',
            tagValueId: 'Tag {{val}}',
            storeId: 'Store',
            storeName: 'Store',
            storeScope: 'Scope of points of sale',
            regularPrice: 'Regular Price $',
            discount: 'Estimated Discount %',
            comboId: 'Combo ID',
          },
          COMBOS: {
            DELETE_BLOCK: 'Delete block',
            EDIT_ITEMS: 'Edit items',
            EDIT_NAME_STAGGERED: 'When editing the name of this combo, the change will be applied to all combos.',
            EDIT_NAME_MIXED: 'Edit name',
            EDIT_QUANTITY: 'Edit quantity',
            ADD_COMBO: 'Add combo',
            ADD_STAGGERED_COMBO: 'Add staggered combo',
            COMBO_ITEMS: 'Products{{val}}',
            COMBO_ITEMS_EDIT: 'Edit items',
            ADD_BLOCK: 'Add block',
            COPY_IDS: 'Copy IDS',
            COPY_ID: 'Copy ID',
            EDIT_STAGGERED_COMBO: 'Edit Staggered Combo',
            EDIT_COMBO: 'Edit Combo',
            DELETE_COMBO: 'Do you want to delete the combo?',
            CREATE_COMBO: 'Create Combo',
            CREATE_STAGGERED_COMBO: 'Create Staggered Combo',
            CLONE_COMBO: 'Clone Combo',
            DELETE_BLOCK_TITLE: 'Do you want to delete the block {{val}}?',
            NAME_INPUT_VALIDATION_MESSAGES: {
              DUPLICATE_NAMES: 'Blocks cannot have the same name.',
              PRICE: 'Prices are not allowed in the name.',
              SPECIALCHARACTERS: 'Special characters are not allowed in the name.',
              DOUBLESPACES: 'Double spaces are not allowed in the name.',
              MAXCHARACTER: 'The maximum allowed characters for the name has been reached.',
              DUPLICATE_ITEMS: 'Duplicate items are not allowed between blocks.',
            },
          },
          DISCOUNT_AND_REGULAR_PRICE: 'Regular price ${{val}}. Estimated discount {{val2}}%.',
          DISCOUNT_TOOLTIP_TITLE: 'Estimated discount on fixed price',
          DISCOUNT_TOOLTIP_DESCRIPTION:
            'An estimated discount is defined by comparing the regular price and the fixed price. The regular price is defined as the mode, the most frequently occurring price, within the store range for this promotion.<br><br> If the promotion includes more than one product or a combo has more than one product in each block, the lowest mode price among the participating products in the promotional action or block is used.',
          STORES_WITHOUT_REGULAR_PRICE: 'There is no regular price in the selected stores to calculate the discount.',
          DISCOUNT_WARNING_MESSAGE: 'To see the new applied discount, it is necessary to save.',
          WITHOUT_POP_MATERIAL_TOOLTIP_TITLE: 'Without promotional material',
          WITHOUT_POP_MATERIAL_TOOLTIP_DESCRIPTION:
            'Active: It does not require selecting a promotional material to publish the promotional action, and validations depending on this data will be automatically validated. The promotions report will not include advertising space, and this promotional action will not be part of the results of reports related to promotional material.<br><br> Not active: It requires selecting at least one promotional material. The promotional action will be included in the reports related to promotional material, and validations depending on this data must be verified.',
        },
        SCOPE_ITEM: {
          IMPORT: 'Import',
          RADIO_SIMPLE_PRODUCT: 'Simple or multiple products',
          RADIO_MULTIPLE_PRODUCT: 'Combos',
          RADIO_STAGGERED_PRODUCT: 'Staggered Promotions',
          DESCRIPTION_SIMPLE_PRODUCT:
            'Select the products that are part of the promotion. Choose either a single type or combine them as desired. All products will have the same promotional price.',
          DESCRIPTION_MULTIPLE_PRODUCT:
            'Create one or more sets of products participating in the promotion. Define the quantity and the products that are part of each component.',
          DESCRIPTION_STAGGERED_PRODUCT:
            'Create a set of products to define the base promotion and variants, differing only in the quantity of their components. Each set will have a different promotional price.',
          WARNING_MESSAGE:
            'By modifying the scope of products, the Promotional Material assigned to this promotional action will be removed. You will need to reassign them after saving the changes.',
          WARNING_IMPORTANT_MESSAGE: 'Important Notice:',
        },
        SCOPE_STORE: {
          IMPORT: 'Import',
          WARNING_MESSAGE:
            'When modifying the store scope, the promotional spaces assigned to this promotional action will be deleted. You will need to reassign them after saving the changes.',
          WARNING_IMPORTANT_MESSAGE: 'Important Notice:',
        },
        ActionsV2_FrequencyType: {
          EveryDay: 'Every day',
          CertainDaysOfTheWeek: 'Certain days of the week',
          CertainDaysOfTheMonth: 'Certain days of the month',
        },
        ActionsV2_AssortmentType: {
          ActivateOnlyDuringPromotion: 'Active only during promotion',
          ActivateIndefinitely: 'Active indefinitely',
          DoNotActivate: 'Do not activate products',
        },
        ActionsV2_DiscountType: {
          AbsoluteValue: '$',
          Percentage: '%',
        },
        PAYMENTS: {
          ADD_BLOCK: 'Add Payment Method',
          PAYMENT_BLOCK: 'Payment method',
          FINANCIAL_INSTITUTION: 'Financial Institution',
          CARD_TYPE: 'Card Type',
          PAYMENT_BLOCK_OPT: 'Private payment method (optional)',
          BANK: 'Bank',
          INSTALLMENTS: 'Quotas',
          LOYALTYPROGRAMPOINTS: 'Loyalty Points',
          LOYALTYPROGRAMPOINTSEQUIVALENCEINCASH: 'Loyalty Points Equivalence',
          SPONSORSHIP: 'Percentage of Sponsorship %',
          PAYMENT_BLOCK_COMBO: 'Combination of payment methods',
          VALUE: 'Value',
          ADDSUBCOMBINATION: 'Add type of Payment Method',
          REMOVECOMBINATION: 'Remove Combination',
          REMOVESUBCOMBINATION: 'Delete type of Payment Method',
          TYPE: 'Type of Payment Method',
          ALL: 'All',
          DEBIT: 'Debit',
          CREDIT: 'Credit',
          NONE: 'None',
          ADD_COMBINATION_BLOCK: 'Add Combination',
          HELP_PAYMENT1:
            'If no means of payment is selected, all means of payment will be applied. If means of payment are selected, these means of payment will be necessary requirements for the promotion to be activated',
          DUPLICATE_WARNING: 'Duplicate payment method',
          DUPLICATE_COMB_WARNING: 'Duplicate Payment Medium Combination',
          PAYMENT_ALL: 'All payment methods',
          PAYMENT_NO_COMB: 'Selection by Types of Payment Means',
          PAYMENT_COMB: 'Price of the Gift Product',
          PAYMENT_ALL_DESC: 'The promotional action will be active for any payment method.',
          PAYMENT_NO_COMB_DESC: 'If means of payment are selected, they will be necessary requirements for the promotion to be activated',
          PAYMENT_COMB_DESC:
            'Only applies if the Gift Product has an additional price (eg: "take a brownie for an additional $ 50 to your coffee"). It admits one or more combinations of one or more payment methods.',
          NO_ITEMS: 'You must select at least one option as a means of payment',
          NO_ITEMS_COMB: 'You must select at least one combination of payment methods',
          GIFT_ITEMS: {
            SIZE: 'Amount of products',
            Size_help: 'Amount of products that will be given.',
            GIF_SELECTION_NO_MANUAL_ITEMS_SELECTED: 'No items selected',
          },
        },
        GIFT_ITEMS: {
          SIZE: 'Quantity of products',
          SIZE_HELP: 'Amount of products that will be given away if the promotion is completed.',
          GIF_SELECTION_NO_MANUAL_ITEMS_SELECTED: 'There are no items selected',
        },
        PUBLISH_CONTENT: 'Do you want to publish the following selected {{val}} records?',
      },
      ACTIONS_STATUS: {
        NEW: 'New',
        ENDORSED: 'Endorsed',
        INFORMED: 'Informed',
        DELETED: 'Deleted',
        MODIFIED: 'Modified',
        CURRENT: 'Current',
        CANCELLED: 'Cancelled',
      },
      ACTIONS_VALIDATION_STATUS: {
        APPROVED: 'Approved',
        VALIDATING: 'Validating',
        ACTIONREQUIRED: 'Action Required',
        REJECTED: 'Rejected',
        PENDING: 'Pending',
      },
      HELP: {
        QUANTITY_BUY_INPUT: 'Indicate the units (A) that the customer will take. Example: If the action is "3 x 2" here we must enter "3".',
        QUANTITY_PAY_INPUT:
          'Indicates the units (B) that the customer will pay. It is a value less than "Quantity to Buy". Example: If the action is "3 x 2" here we must enter "2".',
        FRECUENCY_INPUT: 'Specify the repetition of action over time.',
        DAYS_INPUT: 'Days of the week in which the action will be effective.',
        DATE_FROM_INPUT: 'Effective start date of the action.',
        DATE_TO_INPUT: 'Action expiration date.',
        TIME_FROM_INPUT: 'Beginning of the daily time range of validity of the action.',
        TIME_TO_INPUT: 'Completion of the daily time range of the actions validity.',
        TICKET_MESSAGE_INPUT: 'Short description of the action that will be reflected in the invoice ticket.',
        OBSERVATION_INPUT: 'Allows you to enter some type of information or details of the action.',
        UNIT_DISCOUNT_INPUT:
          'Indicate the value of the discount to be applied to the total regular price of the promotion. Example: $5 discount when buying 2 products A, if each product has a regular price of $10. (2x$10) -$5 discount. Final promotional price $15.',
        DISCOUNT_RATE_INPUT: 'Indicates if the discount will be in percentage or in pesos.',
        SURCHARGE_RATE_INPUT: 'Choose whether the surcharge applies as a percentage (%) of price or as a fixed amount ($).',
        UNIT_SURCHARGE_INPUT: 'Value of the surcharge applied to each unit sold.',
        MAXIMUM_DISCOUNT_INPUT:
          'Maximum discount value per action. If the calculated discount (% × price) exceeds this cap, it is clipped. Example: 20% off a $500 item = $100, but with a $60 cap the effective discount is $60.',
        SHIPPING_DISCOUNT_INPUT: 'Percentage discount on shipping cost. Example: 100% → free shipping. 50% → half shipping.',
        UNTIL_STOCK_LAST_INPUT: 'If enabled, the action stops automatically when the stock of the item in the store reaches 0.',
        BUY_B_QUANT_DESC_INPUT_BUYAGETDISCOUNTINXUNIT:
          'Number of units within the minimum purchase that receive the discount. Example: "Buy 3, 30% off on 1" → enter 1.',
        BUY_B_QUANT_DESC_INPUT_DISCOUNT:
          'Optional. Empty = discount applies to ALL units purchased. With a number M = discount applies ONLY to those M units within the purchase quantity.',
        DISCOUNT_UNITS_HELPER_ALL: 'Buying {{val}} units, the discount applies to all of them.',
        DISCOUNT_UNITS_HELPER_PARTIAL: 'Buying {{val}} units, the discount applies only to {{val2}}.',
        SUMMARY_TITLE: 'Action summary',
        SUMMARY_EMPTY: 'Fill the fields above to see the summary.',
        SUMMARY_DISCOUNT_BASE: 'Buying <b>{{val}} units</b>',
        SUMMARY_FIXPRICE_BASE: 'Taking <b>{{val}} units</b> for <b>${{val2}} total</b> (not per unit)',
        SUMMARY_GIFT_BASE:
          'Buying <b>{{val}} units</b>, the customer gets the products configured in the <b>Scope of Gifts Products</b> tab',
        SUMMARY_BUYAPAYB_BASE: 'Taking <b>{{val}} units</b>, paying <b>{{val2}}</b> (<b>{{val3}}</b> free)',
        SUMMARY_SURCHARGE_PCT: 'Applies a <b>{{val}}%</b> surcharge on the price',
        SUMMARY_SURCHARGE_ABS: 'Applies a <b>${{val}}</b> surcharge on the price',
        SUMMARY_SURCHARGE_PAYMENT: 'The surcharge applies to the payment methods indicated in the <b>Payment Methods</b> tab',
        SUMMARY_SAME_ITEM: 'of the same item',
        SUMMARY_SCOPE_MIX: 'combining products in the scope',
        SUMMARY_DISCOUNT_APPLIES_PCT: 'applies <b>{{val}}% off</b>',
        SUMMARY_DISCOUNT_APPLIES_ABS: 'applies <b>${{val}} off</b>',
        SUMMARY_DISCOUNT_TO_ALL: 'to all units',
        SUMMARY_DISCOUNT_TO_N: 'to <b>{{val}}</b> unit(s)',
        SUMMARY_MIN_VALUE_SCOPE: 'only if <b>${{val}}</b> is spent on scoped products',
        SUMMARY_MIN_VALUE_TICKET: 'only if the ticket exceeds <b>${{val}}</b>',
        SUMMARY_MAX_DISCOUNT: 'with a discount cap of <b>${{val}}</b>',
        SUMMARY_SHIPPING: '<b>{{val}}% off</b> on shipping',
        SUMMARY_UNTIL_STOCK: 'until stock lasts',
        SUPPLIES_LAST_CHECK: 'Informative message for legal purposes for the point of sale.',
        UNITS_AVAILABLE_INPUT:
          'Indicates the total company product units available for action. Informative message for legal purposes for the point of sale.',
        DISCOUNT_VALUE_INPUT:
          'Total value of the discount corresponding to the promotion. Example: If the action is "2nd unit at 30% discount", here we must enter the number "30".',
        UNIT_DISCOUNT_PER_INPUT:
          'Indicates the value of the discount to be applied to each unit sold. Example: If the action is "2nd unit at 30% discount", here we must enter the number "15" which is the percentage that will be applied as a discount on each unit sold.',
        QUANTITY_UNITS_INPUT:
          'Indicates the mandatory units that the customer must buy for the discount to apply. Example: If the action is "2nd unit at 30% discount", here we must enter the number "2" which are the units necessary for the discount to apply.',
        QUANTITY_UNITS_INPUT_DISCOUNT:
          'Mandatory units the customer must buy for the discount to apply. Example: "2nd unit at 30% off" → enter 2.',
        QUANTITY_UNITS_INPUT_FIXPRICE:
          'Number of units included in the fixed price. Example: "2 units for $100" → enter 2. The total is $100 (not $100 per unit).',
        QUANTITY_UNITS_INPUT_GIFT:
          'Units the customer must buy to earn the gift. The gift quantity and products are configured in the "Scope of Gifts Products" tab.',
        QUANTITY_UNITS_INPUT_BUYAGETDISCOUNTINXUNIT:
          'Minimum number of units of the same product to buy so the discount applies to a subset of those units.',
        QUANTITY_UNITS_INPUT_IMAGECOMMUNICATION: 'Reference quantity displayed in the price highlight (e.g. show "price for 6 units").',
        MINIMUM_AMOUNT_INPUT:
          'Indicates the minimum units that the customer must buy for the discount to apply. Example: If the action is "15% discount carrying 3 units", here we must enter the number "3".',
        MAXIMUM_AMOUNT_INPUT:
          'Indicates the maximum units that the customer can buy with the discount. From this value, the units will not have the promotion. Example: If the action is "15% discount up to 6 units", here we must enter the number "6", in unit "7" or successive 15% does not apply.',
        MINIMUM2_AMOUNT_INPUT:
          'Indicates the minimum monetary value that the customer must buy (on the total ticket) for the promotion to apply. Example: If the action is "10% discount on purchases over $ 1,000", here we must enter the number "1,000". If that amount is not reached, the discount does not apply.',
        MAXIMUM2_AMOUNT_INPUT:
          'Indicates the maximum monetary value that the customer can buy to apply the promotion. From that amount, the surplus of the purchase will not have a discount. Example: If the action is "10% discount on purchases up to $ 1,000", here we must enter the number "1,000". If the purchase is for $ 1,500, the $ 500 does not have the 10% discount.',
        ASSORTMENTMETHOD: 'Indicates Assortment behavior',
        MINIMUM_AMOUNT_INPUT_GROUP:
          'Indicates the minimum monetary value that the customer must buy (on the products reached) for the promotion to apply. Example: If the action is "10% discount on soft drinks from $ 1,000", here we must enter the number "1,000". If that amount is not reached, the discount does not apply.',
        SAME_ITEM: 'The discount will be calculated by grouping the same products',
        COMPLETE_COVERAGE:
          "Activating full coverage changes the calculation, indicating that the store meets the coverage only if all the products within the scope of this promotion are active in the store's assortment. If it is deactivated, but at least one product is active in the store, the coverage will be met. <br><br> If the product is a combo type, whether active or not, at least one variant of each component of the combo must be active for the store to meet the coverage.",
        COVERAGE_BASED_COMMUNICATION:
          'Active: Promotional messages vary with each change in coverage of the promotional action across stores in the scope. <br><br> Inactive: Regardless of the coverage, all stores within the scope receive the same promotional message.',
        COMMUNICATE_REGULAR_PRICE:
          'If enabled, reports will calculate the regular price of the product for each store within the defined scope. <br> If disabled, the message to communicate will not include a price.',
        FREECUENCY_INPUT: 'Indicates the repetition of the action over time.',
      },
      PAY_METHODS: {
        PAY_METHOD_Money: 'Money',
        PAY_METHOD_LoyaltyPoints: 'Loyalty Program',
      },
      PRODUCT_LIST: {
        TITLE: 'Printing report',
        DOWNLOAD: 'Download Report',
        GENERATE: 'Generate Report',
        LAST: 'Last Generated Report',
        PERIODS: 'Periods',
        VENDORS: 'Printers',
        ERROR_REPORT: 'The report could not be generated correctly',
      },
      PROMOTION_OUTPUT: {
        TITLE: 'Data for POS',
        DOWNLOAD: 'Download Data',
        GENERATE: 'Generate Data',
        LAST: 'Last Generated Report',
        PERIODS: 'Periods',
        ERROR_REPORT: 'The report could not be generated correctly',
      },
      LOGISTIC_REPORT: {
        TITLE: 'Logistics Report',
        DOWNLOAD: 'Download Report',
        GENERATE: 'Generate Report',
        LAST: 'Last Generated Report',
        PERIODS: 'Periods',
        VENDORS: 'Vendors',
        ERROR_REPORT: 'The report could not be generated correctly',
      },
      PROMOTION_REPORT: {
        TITLE: 'Promotion Report',
        DOWNLOAD: 'Generate Report',
        LAST: 'Last Generated Report',
        PERIODS: 'Periods',
        VENDORS: 'Vendors',
        ERROR_REPORT: 'The report could not be generated correctly',
      },
      PROMOTION_PRODUCTION_LISTS: {
        TITLE: 'Promotion production lists',
        DOWNLOAD: 'Generate report',
        LAST: 'Last generated report',
        PERIODS: 'Periods',
        VENDORS: 'Vendors',
        ERROR_REPORT: 'The report could not be generated correctly',
      },
      PROMOTION_LOG: {
        TITLE: 'Promotions Log',
        DOWNLOAD: 'Generate report',
        LAST: 'Last generated report',
        ERROR_REPORT: 'The report could not be generated correctly',
      },
      MARKETPLACE_LIST: {
        EXPORT_TTIP: 'export',
        FILTER_TTIP: 'filter',
        DELETE_TTIP: 'delete',
        DELETE: 'delete',
        DELETE_ROW: 'Delete',
        EDIT_ROW: 'Edit',
        TITLE: 'Marketplace',
        PROMOTION_TYPE: 'Promotion Type',
        YEAR: 'Year',
        CLONE_ALL_PERIODS: 'Clone periods',
        CLONE_CONTENT: 'Clone all periods from the first Promotion Type field to the second for the indicated year',
        CLONE_TITLE: 'Clone periods by promotion type',
        PROMOTION_TYPE_FROM: 'Clone promotional process periods from',
        PROMOTION_TYPE_TO: 'Clone promotional process periods to',
        NEW_PERIOD: 'New',
        EDIT_ROW_DISABLED_TOOLTIP: 'Cannot edit a record in the publishing process',
        SEE_DELETED_FILTERS: 'See deleted',
        CREATION_ON: 'Creation date',
        CLONE: 'Clone Periods',
        COPY: 'Copy Periods',
        NAME: 'Name',
        ROUTE: 'Marketplace',
        FULLSCREEN_TTIP: 'Expand',
        EXITFULLSCREEN_TTIP: 'Reduce',
        STORENAME: 'Store Name',
        CODE: 'Code',
        STATUS: 'Status',
        VIEW_MATERIAL_POP: 'View promotional material',
        DISABLE_STATUS: 'Filter disabled for using filter `Contracts about to expire`',
        STATUS_AVAILABLE: 'Available',
        STATUS_RESERVED: 'Reserved',
        STATUS_RENTED: 'Rented',
        RESERV: 'Reserve',
        RENT: 'Rent',
        POPMATERIAL: 'Promotional Material',
        CADUCATE: 'Contracts about to expire',
        CADUCATE_1MONTH: 'Within 1 Month',
        CADUCATE_2MONTH: 'Within 2 Months',
        CADUCATE_3MONTH: 'Within 3 Months',
        ADVANCED_SEARCH: 'Advanced Filters',
        INTERNAL_USE: 'Internal Use',
        CONTRACT: 'Manage Contract',
        CONTRACT_CONTENT: 'Reserve or Rent {{val}}. Assigning dates and price for the selected vendor',
        VENDOR: 'Vendor',
        PRICE: 'Price',
        STORECOUNT: '# Stores',
        OCUPATION: 'Occupation',
        SPACE: 'Space',
        VALIDFROM: 'Start date',
        VALIDTO: 'End date',
      },
      PERIODS_LIST: {
        EXPORT_TTIP: 'export',
        FILTER_TTIP: 'filter',
        DELETE_TTIP: 'delete',
        CANT_DELETE_TTIP: 'The promotional period cannot be deleted because there are promotional actions that use it.',
        DELETE_MODAL_TITLE: 'Do you want to delete the promotional period{{val}}?',
        DELETE: 'delete',
        DELETE_ROW: 'Delete',
        IS_CANCELING: 'deleting',
        EDIT_ROW: 'Edit',
        TITLE: 'Promotional Periods',
        PROMOTION_TYPE: 'Promotion Type',
        PROMOTION_TYPE_PROCESS: 'Promotional process',
        FOLIO: 'Promotional Folio',
        YEAR: 'Year',
        YEAR_FROM: 'Year From',
        YEAR_TO: 'Year To',
        CLONE_ALL_PERIODS: 'Clone periods',
        CLONE_CONTENT: 'Clone all periods from the first Promotion Type field to the second for the indicated year',
        CLONE_TITLE: 'Clone periods by promotion type',
        PROMOTION_TYPE_FROM: 'Clone promotion type periods from',
        PROMOTION_TYPE_TO: 'Clone promotion type periods to',
        NEW_PERIOD: 'New promotional period',
        EDIT_ROW_DISABLED_TOOLTIP: 'Cannot edit a record in the publishing process',
        SEE_DELETED_FILTERS: 'See deleted',
        CREATION_ON: 'Creation date',
        CLONE: 'Clone Periods',
        COPY: 'Copy Periods',
        ROUTE: 'Promotional Periods',
        FULLSCREEN_TTIP: 'Expand',
        EXITFULLSCREEN_TTIP: 'Reduce',
        NAME: 'Name',
        CODE: 'Code',
        RESPONSIBLEROLEID: 'Responsible',
        OBSERVATIONS: 'Observations',
        CONSULTEDROLEID: 'Consultant',
        STARTINGDAYOFWEEK: 'Starting days',
        DURATIONINDAYS: 'Duration in days',
        ORDER: 'Order',
        VALIDFROM: 'Start date',
        VALIDTO: 'End date',
        EXTRAPLANNINGDAYS: 'Extra planning days',
        ISSPECIALEVENT: 'Special event',
        VALIDATION_CODE: 'The code {{val}} already exists',
        EDIT_ERROR: 'Error editing: {{val}}',
      },
      CALENDAR_LIST: {
        EXPORT_TTIP: 'export',
        FILTER_TTIP: 'filter',
        DELETE_TTIP: 'delete',
        DELETE: 'delete',
        TITLE: 'Calendar',
        MODIFY: 'Modify',
        CHANGE_DATE_TITLE: 'Modify Date',
        CHANGE_DATE_CONTENT: 'Modify the date of this activity',
        EDIT_ROW_DISABLED_TOOLTIP: 'Cannot edit a record in the publishing process',
        ONLY_CURRENT_PERIODS: 'Only active periods.',
        ACTIONS: {
          NAME: 'Description',
          RESPONSIBLEROLEID: 'Responsible',
          CONSULTEDROLEID: 'Consultant',
          OBSERVATIONS: 'Observations',
          STARTTASKXDAYSBEFORE: 'Starting day',
          DURATIONINDAYS: 'Duration in days',
        },
      },
      PERIODS_EDIT: {
        SAVE: 'Save',
        PUBLISH: 'Publish',
        WARNING_SAVE: 'Current changes need to be saved.',
        WARNING_PUBLISH: 'Republishing is necessary for the saved changes to take effect.',
        NOVALID_PUBLISH_ADVICE: 'The following tab is not valid:',
        BASIC_INFORMATION_TAB: 'Basic Information',
        ACTIVATION_TAB: 'Activation',
        LOADING: 'Loading...',
        NEW_ITEM_BTN: 'New Promotional Action',
        PUBLISH_CONFIRM:
          'The publishing process includes the creation of Assortment, Prices, Costs, and other records related to this action.<br><br><b>Are you sure you want to Publish?</b>',
        PUBLISH_CONFIRM_TITLE: 'Publish Confirmation',
        PUBLISHING_WARNING: 'Item in publishing process, please try again in a few minutes.',
        PUBLISH_LONG_TIME: 'Publishing this Product may take a few minutes, when finished you will be notified with a notification.',
        MAIN_DATA: {
          VALID_DATE: 'Validity date',
          ORDER_WARNING:
            'Choosing an order lower than the maximum will recalculate the dates of subsequent periods, excluding special events',
          VALIDFROMEXCEEED: 'Start date exceeds the current year',
          PERIOD_IN_USE: 'The period cannot be edited because it is in use.',
        },
      },
      COVERAGE: {
        WARNING_IS_NEW: 'You need to save changes to check coverage.',
        WARNING_STORE_AND_ITEM_SCOPE: 'When modifying both item and store scopes, you need to save changes to check coverage.',
        COVERAGE_BASED_COMMUNICATION_TITLE: 'Coverage-Based Communication',
        COMPLETE_COVERAGE_TITLE: 'Complete Coverage',
        COMMUNICATION_REGULAR_PRICE_TITLE: 'Communicate regular price',
      },
      REPORTS: {
        AVAILABLE_SPACES: {
          REGION: 'Region',
          AVAILABLE_SLOTS_PERCENTAGE: 'Total % available',
          AVAILABLE_SLOTS: 'Total available quantity',
          SLOTS: 'Slots',
          STORES: '# Stores',
          SLOTS_TOTAL: 'Total number of slots',
          SLOTS_TOTAL_IN_USE: 'Total number in use',
          SLOTS_PERCENTAGE_IN_USE: 'Total % in use',
          SLOTS_EXCEEDED: 'Slots exceeded',
        },
        TAG_VALUES: 'Download tag report',
      },
    },
    M_SHOPPER: {
      MISSIONS: {
        CHECK_RULE: {
          MODAL_TITLE: 'Do you want to change the selection?',
          MODAL_CONTENT_FIRST_STEP: 'If you confirm, the following steps will copy the competition rule settings',
          MODAL_CONTENT:
            'If confirmed, the affected missions will be replaced by the modifications made based on the first step competition rule.',
          MODAL_BTN_CLOSE: 'Cancel',
          MODAL_BTN_ACCEPT: 'Confirm',
          CHECK: "Don't ask again.",
        },
        TYPE_OPTION: {
          PriceSurvey: 'Price Survey',
          ExhibitionSurvey: 'Exhibition Survey',
        },
        FRECUENCY_OPTION: {
          OneTime: 'One Time',
          Daily: 'Daily',
          Weekly: 'Weekly',
          Biweekly: 'Biweekly',
          Monthly: 'Monthly',
          Biannual: 'Biannual',
          Annual: 'Annual',
        },
        AUDYT_OPTION: {
          Internal: 'Internal',
          External: 'External',
        },
        METHODS_OPTION: {
          Strip: 'Strip',
          Ticket: 'Ticket',
          Catalog: 'Catalog',
          Totem: 'Totem',
        },
        ACTION_OPTION: {
          PriceLabelScan: 'Price Label Scan',
          VoiceCommand: 'Voice Command',
          ManualEntry: 'ManualEntry',
          Indistinct: 'Indistinct',
        },
        CADUCATE: 'expired',
        TODAY: 'Today',
        DAYTOEXPIRE: 'Days to expire',
        ROUTE: 'Mystery Shopper',
        TITLE: 'Missions',
        SUBTITLE:
          'On this screen you will see all the missions created, with their progress percentage, their frequency and whether or not they have competition rules associated with them. These missions will be executed by the shopper through the Prisma Mystery Shopper app, if there are relationships between own stores or those of the competition with the shopper, the mission will be made available to that user, in order to ascertain their own prices or those of the competition.',
        NEW_MISSION_BTN: 'New Mission',
        DAILYREPORT: 'Daily Report',
        FILTER_TTIP: 'Filter',
        FULLSCREEN_TTIP: 'Expand',
        EXITFULLSCREEN_TTIP: 'Reduce',
        EXPORT_TTIP: 'Export',
        IMPORT_TTIP: 'Import',
        PRINT_TTIP: 'Print',
        DELETE_TTIP: 'Delete selected missions',
        DELETE: 'Delete',
        EDIT: 'Edit',
        NAME: 'Name',
        TYPE: 'Type',
        AUDIT_METHOD: 'Audit Method',
        AUDIT_METHOD_TTIP: 'Audit Method',
        START_DATE: 'Start Date',
        START_DATE_TTIP: 'Mission Start Date',
        FINISH_DATE: 'End Date',
        FINISH_DATE_TTIP: 'Mission End Date',
        FRECUENCY: 'Frequency',
        ADVANCED: 'Progress %',
        SURVEYED_STATUS: 'Survey status',
        SURVEYED_STATUS_NOTAVAIBLE_TOOLTIP:
          'The mission is not available to users because they are not assigned or do not have competitors',
        SURVEYED_STATUS_AVAIBLE_TOOLTIP: 'The mission is available to users',
        SURVEYED_STATUS_TAKENBYME_TOOLTIP: 'A user accepted the mission and will be in charge of relieving it',
        SURVEYED_STATUS_COMPLETED_TOOLTIP: 'The mission has already been surveyed, download the daily report to obtain the results',
        SURVEYED_STATUS_NOTSURVEY_TOOLTIP: 'The mission was not surveyed and the effective date has ended',
        SURVEYED_STATUS_NOTAVAIBLE: 'Not Available',
        SURVEYED_STATUS_AVAIBLE: 'Available',
        SURVEYED_TAKENBYME: 'In progress',
        SURVEYED_STATUS_COMPLETED: 'Completed',
        SURVEYED_STATUS_NOTSURVEY: 'Not surveyed',
        DAYS_TO_EXPIRE: 'Days to expire',
        SKUS: '# Products',
        SKUS_TTIP: 'Quantity of products',
        MATCHINGS: '# Matchings',
        MATCHINGS_TTIP: 'Quantity of matchings',
        SITES: '# Stores',
        SITES_TTIP: 'Quantity of stores',
        USERS_TTIP: 'Quantity of users',
        USERS: '# Users',
        RULE: 'Rule',
        RULE_TTIP: 'Mission associated with a competition rule',
        YES: 'Yes',
        NO: 'No',
        STATUS: 'Status',
        DATE: 'Date',
        STATUS_ACTIVE: 'Mision Active',
        STATUS_OVERDUE: 'Mision Overdue',
        STORES_FILTER: 'Points of sale',
        DEFINE_MISSION_STP1: 'Setup Mission',
        COMPETITORS_SCOPE_STP2: 'Competitors Scope',
        PRODUCT_SCOPE_STP3: 'Products Scope',
        STORE_SCOPE_STP4: 'Stores Scope',
        RESPONSIBLE_STP5: 'Auditor',
        NEW_TITLE_FORM: 'New Mission',
        EDIT_TITLE_FORM: 'Edit Mission',
        STP1: 'Step 1 - Setup Mission',
        STP1_SUBTITLE: 'In this step you will be able to define the main components of a Mission',
        NAME_INPUT: 'Name',
        TYPE_INPUT: 'Type',
        AUDIT_METHOD_INPUT: 'Audit Method',
        FRECUENCY_INPUT: 'Frequency',
        ACTION_TYPE_INPUT: 'Action Type',
        AUDIT_TYPE_INPUT: 'Audit Type',
        VALIDATE_LOCATION_TOOLTIP: 'The mission must within the allowed range of distance',
        REQUEST_EVIDENCE_TOOLTIP: 'It will be mandatory to load an image of evidence of the surveyed product',
        REQUEST_EVIDENCE: 'require photographic evidence',
        VALIDATE_LOCATION: 'Validate location',
        SHOW_LAST_PRICE: 'show last captured price to shopper',
        SHOW_LAST_PRICE_TOOLTIP:
          'If enabled, the shopper sees the last captured competitor price for each item. Turn it off for a blind capture without anchoring bias.',
        SURVEYSAMOUNT: '#Competitors',
        SURVEYSAMOUNT_TTIP: 'Competitors Amount',
        STARTS_INPUT: 'Starts on',
        FINISHED_INPUT: 'Ends on',
        VALIDATE_PROMOTION_CHECK: 'Validate Promotion',
        VALIDATE_DATE_START: 'The start date must be less than or equal to the end date',
        VALIDATE_DATE_END: 'The end date must be greater than or equal to the start date',
        VALIDATE_RANGE_TOO_SHORT_FOR_FREQUENCY: 'The date range does not cover a full cycle of the selected frequency',
        AUTOBUMP: {
          TOAST_TITLE: 'End date adjusted',
          TOAST_BODY: 'The "Ends on" date was adjusted to include a full cycle of the selected frequency.',
        },
        ERROR: {
          MISSION_SCOPE_ITEMS_EMPTY: 'Cannot save: add at least one item to the scope.',
          MISSION_SCOPE_COMPETITORS_EMPTY: 'Cannot save: configure at least one competitor in the scope.',
          MISSION_FREQUENCY_INVALID: 'Invalid frequency.',
          MISSION_RANGE_TOO_SHORT_FOR_FREQUENCY:
            'The date range does not cover a full cycle. Extend "Ends on" to at least the indicated date.',
        },
        EDIT_WARNING: {
          MODAL_TITLE: 'Changes do not affect ongoing surveys',
          MAIN_MESSAGE: 'Ongoing surveys (those scheduled for today or earlier) will not be modified.',
          NEXT_AFFECTED_WITH_DATE: 'Changes will apply starting from the survey of {{date}}.',
          NEXT_AFFECTED_OVERDUE:
            'There are no future surveys scheduled. Changes will apply when new surveys are generated (by extending the date range).',
          BTN_ACCEPT: 'Accept',
          BTN_CANCEL: 'Cancel',
        },
        PREVIEW: {
          STEP_TITLE: 'Summary',
          NO_COMPETITORS: 'No competitors were found for this selection. Please review the configuration.',
          BACK_TO_COMPETITORS: 'Back to Competitors step',
          COMPETITORS_COUNT: 'competitors in scope',
          COMPETITOR_COUNT_ONE: 'competitor in scope',
          ITEMS_COUNT: 'items in scope',
          ITEM_COUNT_ONE: 'item in scope',
          SUMMARY_INTERNAL: 'Internal mission — surveying owned stores',
          ESTIMATE_PREFIX: 'A total of',
          ESTIMATE_SUFFIX: 'surveys will be generated throughout the mission.',
          ESTIMATE_TOOLTIP:
            'A survey is one visit to a competitor (or own store) on a scheduled date, covering all of its items. Total = competitors × cycles in range.',
          LOADING_ERROR: 'Could not load competitors',
          RETRY: 'Retry',
          SEARCH_PLACEHOLDER: 'Search by name',
        },
        VALIDATE_STOCK_CHECK: 'Validate Stock',
        COMPETITIVE_RULE_INPUT: 'Rule',
        COMPETITIVE_RULE_INPUT_IN_USE: 'This rule is applied in a mission',
        NEXT_BTN: 'Next',
        STP2: 'Step 2 - Competitors Scope',
        LEGEND_SKIP_STEP: 'This Step is not necessary if the type of Audit is Internal',
        SKIP_BTN: 'Skip',
        PREVIUS_BTN: 'Previous',
        STP3: 'Step 3 - Products Scope',
        STP3_SUBTITLE:
          'In this step you will be able to define which products and which ones this Mission will not achieve. You can choose them by selection by attribute, or individual selection.',
        STP3_TOGGLE: 'Allow capturing product prices outside the mission',
        STP3_TOGGLE_TOOLTIP:
          'A batch of generic products will be available to identify products found that are not configured in the mission.',
        VIEW_PRODUCTS_BTN: 'View Products',
        REFRESH_PRODUCTS_BTN: 'Refresh Products',
        STP4: 'Step 4 - Stores Scope',
        STP4_SUBTITLE:
          'In this step you will be able to define which stores and which ones this Mission will not reach. You can choose them by selection by attribute, or individual selection.',
        AUTOMATIC_ASIGNATION_CHECK: 'Automatic allocation',
        ADD_RESPONSIBLE_BTN: 'Add Auditor',
        SAVE_BTN: 'Save',
        ADD_RESPONSIBLE_TITLE: 'Add Auditor',
        COMPETITOR_INPUT: 'Competitor',
        SHOPPER_INPUT: 'Shopper',
        ACCEPT_BTN: 'Accept',
        CANCEL_BTN: 'Cancel',
        ADD_BTN: 'Add',
        STRATEGY_ATTR_TITLE: 'Selection by attribute (Dinamic)',
        STRATEGY_ATTR_MSG:
          'Attributes are selected to define the scope of products, if the scope changes, the impact of this setting is done automatically and does not need to be changed',
        STRATEGY_PROD_TITLE: 'Selection by product',
        STRATEGY_PROD_MSG: 'Products should be selected one by one',
        STRATEGY_ATTR_TITLE_STORE: 'Selection by attribute (Dinamic)',
        STRATEGY_ATTR_MSG_STORE:
          'Attributes are selected to define the scope of stores, if the scope changes, the impact of this setting is done automatically and does not need to be changed',
        STRATEGY_STORE_TITLE_STORE: 'Selection by store',
        STRATEGY_STORE_MSG_STORE: 'Stores should be selected one by one',
        VIEW_STORES_BTN: 'View Stores',
        REFRESH_STORES_BTN: 'Refresh Stores',
        STP5: 'Step 5 - Responsible for the Mission',
        LEGEND_RESPONSIBLE_STEP:
          'The assignment of users to the mission will be done automatically based on the relationships loaded in the User Assignment screen. The mission will be available in MS App, to all users related to the points of sale and/or competitors reached, and the first user to take the mission will be the one assigned to it',
        PASTE: 'Paste',
        PASTE_TTIP: 'Add points of sale from a list copied to your clipboard.',
        SEARCH: 'Search',
        CODE_AND_DESCRIPTION_INPUT: 'Code / Description',
        CLIPBOARD_TITLE: 'Paste stores from clipboard',
        CLIPBOARD_STEP1: '1) Define what type of codes you are using',
        TYPE_CODE: 'Type Code',
        INTERNAL_CODE_INPUT: 'Internal Code',
        EXTERNAL_CODE_INPUT: 'External Code',
        NOT_FOUND_CODE_ITEM: 'This product code was not found in Item Master',
        NOT_FOUND_CODE_STORE: 'This point of sale code was not found in the Store Master',
        CLIPBOARD_STEP2:
          '2) Select and copy the codes from a spreadsheet or text. (Ctrl + C) as shown in the image below. They can also be loaded by delimiting each code with the following characters "," ";" "|" "/" "" (tab) (enter) (space) ',
        CLIPBOARD_STEP3: '3) Press here and paste the codes (Ctrl + V)',
        CLIPBOARD_MAX: 'Individual selection supports up to {{val}} products.',
        CLIPBOARD_COUNT: 'Codes have been loaded',
        CLIPBOARD_TITLE_DEFUALT: 'Press here and paste the codes (Ctrl + V)',
        CLIPBOARD_NONE: 'No code has been loaded',
        CLIPBOARD_ACTION: 'Paste',
        PASTE_PRODUCT_TTIP: 'Add products from a list copied to your clipboard.',
        CLIPBOARD_PRODUCT_TITLE: 'Paste products from clipboard',
        CLIPBOARD_STORE_TITLE: 'Paste stores from clipboard',
        FILTER_PROD: 'Filtered Products',
        SELECT_PROD: 'Selected Products',
        ADD_PROD: 'Add Products to the list',
        FILTER_STORE: 'Filtered Stores',
        SELECT_STORE: 'Selected Stores',
        ADD_STORE: 'Add Stores to the list',
        PROVINCE_CHIP: 'Province:',
        COUNTRY_CHIP: 'Country:',
        PRICE_CHIP: 'Price:',
        COST_CHIP: 'Cost:',
        LEGEND_SKIP_STEP4: 'This Step is not necessary since the Competitors Selection option was chosen in the Competitors Scope',
        STP2_COMP_BUTTON_TITLE: 'Select how you want to compare against your competitors.',
        MAINMARKET_TITLE: 'Markers',
        ONLY_MARKERS_TITLE: 'Only select Markers',
        MAINMARKET_MSG: 'It will search the price of the Markers of each Point of Sale.',
        USE_TRADE_AREA_TITLE: 'Trade Area',
        USE_TRADE_AREA_MSG: 'It will search the price of the Competitors associated with the Trade Area of ​​each Point of Sale.',
        SELECT_COMPETITORS_TITLE: 'Selection of Competitors',
        SELECT_COMPETITORS_MSG: 'It will search for competitors who meet the criteria to be defined below',
        HELP: {
          TYPE_INPUT:
            'Price Survey: You will send the shopper to audit the prices of the competition and within your points of sale, to inform you or ensure that your policies are met.',
          TYPE_INPUT2:
            'Exhibition Survey: You will send the shopper to audit how the products are displayed at your points of sale or at competitive points of sale.',
          AUDIT_METHOD_INPUT: 'Strapping: The price that appears in the gondola where the product is located must be audited. ',
          AUDIT_METHOD_INPUT2: 'Ticket: The price that appears on the ticket or invoice will be audited after purchasing the products.',
          AUDIT_METHOD_INPUT3:
            'Catalog: The prices that appear in a catalog, magazine, flyer or any printed product publication will be audited.',
          AUDIT_METHOD_INPUT4: 'Totem: Prices in totem and / or product billboard should be audited.',
          STARTS_INPUT: 'From this date the mission begins.',
          FINISHED_INPUT: 'From this date on, Mystery Shopper APP will not ask shoppers to take over the mission. It will be paused.',
          VALIDATE_PROMOTION_CHECK: 'The selected products must also be audited, whether they are in promotion or not.',
          VALIDATE_STOCK_CHECK: 'It must be confirmed whether or not there was stock of the product available at the time of auditing.',
          FRECUENCY_INPUT: 'Determine how often the audit will be repeated until the completion date.',
          ACTION_TYPE_INPUT:
            'Determine if you need to audit in any specific way, Prisma Mystery Shopper APP will allow the shopper to audit only by using the selected methodology.',
          AUDIT_TYPE_INPUT: 'Internal: It will be audited in your establishments.',
          AUDIT_TYPE_INPUT2: 'External: The establishment of the competition will be audited.',
          COMPETITIVE_RULE_INPUT:
            'When choosing a competition rule, the following steps will be completed by what has already been defined previously in the creation of the rule.',
        },
        CHANGES_REFLECTED_NEXT_SURVEY: 'The changes made will be reflected from the next survey.',
      },
      USER_ASSIGNMENT: {
        TITLE: 'User Assignment',
        STATUS: {
          ASSIGNED: 'Assigned',
          NOTASSIGNED: 'Unassigned',
        },
        CLONATION: {
          TITLE: 'Clone user settings',
          CONTENT: 'The configuration of {{val}} will be assigned to the selected users',
          CLIPBOARD: 'Import Users',
          USER_SELECTED: 'Selected Users',
          USER_FOUND: 'Users Filtered',
          ADD_USERS: 'Add Users',
          PASTE_USERS: 'Paste Users to clipboard',
          USER_NOTFOUND: 'User not found',
          HAS_ASSIGNED:
            "Currently assigned users were found, if you wish to continue they will be overwritten with the assignments of the user you wish to clone from. Otherwise cancel and remove the assigned users you Don't want to overwrite.",
          CLIPBOARD_SELECT_STEP:
            'Select and copy codes from a spreadsheet or text. (Ctrl + C) as shown in the image below. They can also be loaded by delimiting each code with the following characters "," ";" "|" "/" "" (tab) (enter) (space) ',
          CLIPBOARD_PASTE_STEP: 'Click here and paste the codes (Ctrl + V)',
          SUCCESSFULL: 'The cloning was completed successfully',
          FAILED: 'An error has occurred and cloning failed',
        },
        UNASSIGNED: {
          TITLE_ONE: 'Do you want to unassign {{val}}?',
          CONTENT: 'The action unassign the configuration of the own stores to which it belongs and the competitors that it has designated',
          TITLE_MULTIPLE: 'Do you want to unassign the selected users ({{val}})?',
        },
        LIST: {
          NAME: 'Name',
          EMAIL: 'Email',
          CODE: 'Code',
          STORES_COUNT: '# Own Stores',
          STORES: 'Own Stores',
          COMPETITORS_COUNT: '# Competitors',
          STATUS: 'Status',
          UNASSIGNED_ROW: 'Unassign',
          FILTER: 'Filter',
        },
        EDIT: {
          SAVE_WITH_CURRENT_COMPETITORS: 'Save with Current Scope Competitors',
          WARNING_SAVE:
            'Due to the change made in the Scope of Sales Points, there are new Competitors by Trade Area available, if you wish to use them you must go to the Scope of Competitors before saving. Otherwise the currently selected competitors will remain',
          WARNING_COMPETITORS: 'News Competitors by Trade Area',
          STRATEGY_ATTR_TITLE_STORE: 'Selection by attribute (Static)',
          STRATEGY_ATTR_MSG_STORE:
            'Attributes are selected to define the scope of points of sale, if the scope changes, they will not impact this configuration, if you want it to impact you must modify this scope and save it again',
          STRATEGY_STORE_TITLE_STORE: 'Selection by points of sale',
          STRATEGY_STORE_MSG_STORE: 'The points of sale must be explicitly chosen one by one',
          CLIPBOARD_COMPETITORS_TITLE: 'Paste competitors from clipboard',
          STORESCOPE: 'Scope of Sales Points',
          COMPETITORSSCOPE: 'Scope of competitors',
          CHANGE_STORE_SCOPE_TITLE: 'Are you sure you want to change the store scope?',
          CHANGE_STORE_SCOPE_DESCRIPTION:
            'If you cancel it will return to the previous configuration. If you confirm, you will modify the scope of points of sale, only the selected competitors marked as trade area will be overwritten',
          STORE_SCOPE: {
            SUBTITLE:
              'In this step you can define which own stores this user belongs to. You can choose them by attribute selection or individual selection / import them',
            VIEW_STORES_BTN: 'View outlets',
            CODE_AND_DESCRIPTION_INPUT: 'Search by name or code',
            PASTE: 'Import Points of sale',
          },
          COMPETITORS_SCOPE: {
            SUBTITLE:
              'In this step you can define which competitors the user will have available missions to relieve. Competitors will initially be assigned within the trade area of ​​their own stores, with the possibility of removing or adding new competitors',
            SEARCH_COMPETITORS: 'Search by name or code',
            PASTE: 'Import Competitors',
            NOTFOUND: 'Not found',
            SAVE_FIRST: 'You must save the changes to be able to configure the scope of competitors',
          },
        },
      },
    },
    COMP: {
      GENERIC_TABLE: {
        COMPETITORS: {
          COMPETITORS_FOUND: 'Competitors Filtered',
          COMPETITORS_SELECTED: 'Competitors selected',
          ADD_COMPETITORS: 'Add Competitors',
        },
      },
      PRISMA_TABLE: {
        CONFIG_COLUMNS: 'Config columns',
        DELETE_ACTION: {
          DELETE: 'Delete',
          DELETE_TTIP: 'Deactivate the registry',
          UNDELETE: 'Activate',
          UNDELETE_TTIP: 'Activate the registry',
          DELETE_ROW: 'Inactive Record',
          DELETE_ROWS: 'Inactive, Records',
          DELETE_ROW_CONTENT: 'Are you sure you want to inactive {{val}}?',
          DELETE_ROWS_CONTENT: 'Are you sure you want to inactive {{val}}',
          UNDELETE_ROW: 'Activate Record',
          UNDELETE_ROWS: 'Activate Records',
          UNDELETE_ROW_CONTENT: 'Are you sure you want to activate {{val}}? it will be activated with the state new',
          UNDELETE_ROWS_CONTENT: 'Are you sure you want to activate {{val}} Records? they will be activated with the state new',
          ACTION_ROW_CONTENT_SUCCESS: 'Action completed successfully',
          ACTION_ROW_CONTENT_FAILED: 'The action could not be carried out correctly',
        },
        ENTITIES: {
          REPORT: 'Full report here',
          APPLY: 'Due to being in use in the following entities:',
          ITEM_NOT_FOUND: 'Item/s not found',
          USEDINCOMBOS: 'Combos: {{val}}',
          USEDINMISSIONS: 'Missions: {{val}}',
          USEDINPARENTRULES: 'Pricing rules: {{val}}',
          USEDINPLANOGRAMS: 'Planograms: {{val}}',
          USEDINPROMOTIONS: 'Promotions: {{val}}',
          USEDINRECIPES: 'Recipes: {{val}}',
        },
        ACTION_FAIL: {
          DESCRIPTION_ERROR: 'The problem was caused by ',
          TYPE: 'Type: {{val}}',
          KEYWORD: 'Keyword: {{val}}',
          VALUES: 'Values: {{val}}',
          WARNING: 'Alert',
          ERROR: 'Error',
          ENTITYNOTFOUND: 'Entity not found',
        },
      },
      INSIGHT: {
        CONTEXT_MENU: {
          SUBSCRIBED: 'Subscribed',
          UNSUBSCRIBED: 'Unsuscribed',
          SUBSCRIBE: 'Subscribe to all insights',
          UNSUBSCRIBE: 'Subscribe to all insights',
          TYPE: 'of {{val}}',
          CATEGORY: 'of the Category {{val}}',
          STORE: 'of the Store {{val}}',
          STORETAG: 'of the Tag {{val}}',
          CONCATENATE_MESSAGE: '{{val}} {{val2}}',
        },
      },
      MODAL: {
        IMPORT_VENDORS: {
          TITLE: 'Solve supplier conflicts',
          CLOSE: 'Close',
        },
        ADD_MODAL_VERIFY: {
          SELECT_ALL: 'Select All',
          SELECT_OPTIONS_MSG: 'Select Options',
          CURRENT_SELECTION: 'Current Selection',
          VALIDATE_BTN: 'Validate',
          VALIDATION_TITLE: 'Validation',
          PLACEHOLDER: 'Search {{val}}',
          TITLE_EMPTY: 'There is no {{val}} to validate',
          VALIDATION_MESSAGE_OK: 'All vendors were configured correctly for the point of sale.',
          VALIDATION_MESSAGE_WARNING:
            'The selected {{val}} do not cover 100% of the active assortment. No suppliers were found for the following products',
          VALIDATION_MESSAGE_WARNING_FOOTER: 'Select {{val}} until the entire assortment is covered.',
          VALIDATION_TITLE_WARNING: 'Warning',
          CLOSE: 'Close',
          VALIDATION_MESSAGE_ERROR: 'More than one supplier has the same product',
          VALIDATION_TITLE_ERROR: 'Conflicts ',
          SOLVE: 'Solve',
          DOWNLOAD_XLSX: 'Download excel',
          XLSX: 'suppliers.xlsx',
          BTN_TOOLTIP_ERROR: 'Download excel, and fill in the IsPrimary column with the main provider with an X',
          INIT_VENDORS: 'Initialize vendors',
          SURE_TO_SAVE:
            'This process is unique and then it cannot be modified on this screen, make sure that the selected providers are the correct ones',
          CANCEL: 'Cancel',
          SAVE: 'Save',
        },
        COPY_VENDORS_BY_STORE: {
          INTRO: 'Vendors will be cloned according to the selected point of sale.',
          PLACEHOLDER: 'Stores',
          SAVE: 'Save',
          CLOSE: 'Close',
        },
      },
      PICK_COLOR: {
        SELECTION: 'Select',
        CANCEL: 'Cancel',
        CLEAR: 'Clear',
        SELECTION_TITLE: 'Select a color',
      },
      KPIS: {
        DOUBLE_KPI_SUGGESTION: 'SUGGESTIONS ACCEPTED',
      },
      MULTIPLE_GREEN_BUTTON: {
        MODAL_TITLE: 'Do you want to change the selection?',
        MODAL_CONTENT: 'If you confirm, the data related to the selection can be removed from the current load',
        MODAL_BTN_CLOSE: 'Cancel',
        MODAL_BTN_ACCEPT: 'Confirm',
        CHECK: 'Do not ask again.',
      },
      ALERT_AND_CAP: {
        ALERTACOMPETENCIA:
          'The suggested price of ${{val}} is ${{val2}} than the limit set for competitor {{val3}}. Your price should be between ${{val4}} and ${{val5}}',
        ALERTACOMPETENCIA_NO_MIN:
          'Your suggested price of ${\\{val\\}} is at risk by competitor {\\{val3\\}} with a limit of ${\\{val2\\}}. Your price should be no less than ${\\{val5\\}}.',
        ALERTACOMPETENCIA_NO_MAX:
          'Your suggested price of ${val} is at the upper limit by competitor {val3}. Your price should be no more than ${val4}',
        ALERTACOMPETENCIA_NO_RANGE: 'Suggested price of ${\\{val\\}} is at limit by competitor {\\{val3\\}} for \\${{\\val2}}.',
        ALERTACOMPETENCIAMISSING: "The competitor limit could not be checked because we didn't find valid market prices for {{val}}",
        ALERTAMARGEN: 'The suggested price of ${{val}} is {{val2}} than the {{val3}} {{val4}} according to the margin limit.',
        ALERTAMARGENMISSING: "The margin limit could not be checked because we didn't find costs for this product at this store.",
        ALERTAVARIACION: 'The suggested price of ${{val}} is {{val2}} than the {{val3}} {{val4}} according to the variation limit.',
        CAPCOMPETENCIA:
          'The suggested price of {{val}} has been changed to {{val2}} because it was {{val3}} than {{val4}} {{val7}} price. Your price should be between {{val5}} and {{val6}}',
        CAPCOMPETENCIAMISSING: "The competitor limit could not be checked because we didn't find valid market prices for {{val}}.",
        CAPMARGE:
          'The suggested price of ${{val}} has been changed to ${{val2}} because it was {{val3}} than the {{val4}} {{val7}} according to the margin limit. Your price should be between {{val5}} and {{val6}}',
        CAPMARGEMISSING: "The margin limit could not be checked because we didn't find costs for this product at this store.",
        CAPVARIACION:
          'The suggested price of ${{val}} has been changed to ${{val2}} because it was {{val3}} than the {{val4}} {{val7}} according to the variation limit. Your price should be between {{val5}} and {{val6}}',
        MINIMOMAXIMO: '{{val}} of ${{val2}}',
        MINIMUM: 'minimum',
        MAXIMUM: 'maximum',
        GREATER: 'greater',
        ABOVE: 'above',
        BELOW: 'below',
        ALERT_MARGEN_LIMIT: 'The suggested price is within {{val}} of the {{val2}} of the required margin limit.',
        ALERT_VARIATION_LIMIT: 'The suggested price is within {{val}} of the {{val2}} of the required variation limit.',
        OF: 'of',
        LOWER: 'lower',
        FOR: 'for {{val}}',
      },
      DEFAULT_TBAR: {
        SEARCH: 'Search...',
        SEARCH_ITEM: 'Search Item...',
        SEARCH_STORE: 'Search Point of Sale...',
      },
      ACTION_TBAR: {
        ACTIONS: 'Actions',
        SELECTED_SINGULAR: 'Selected',
        SELECTED_PLURAL: 'Selected',
      },
      ITEMS_NO_FOUND: {
        NO_RESULTS_FILTERS: 'No results found with the selected filters.',
        NO_RESULTS_FILTERS_MANDATORY: 'No results were found with the selected filters. Please complete the mandatory filters.',
        NO_RESULTS: 'No results found.',
        NO_RESULTS_REPORTS: 'No reports found.',
      },
      ERROR_MESSAGE: {
        TITLE: 'An error has occurred',
        SUBTITLE: 'Contact the support team.',
        ACCEPT_BTN: 'Accept',
        DOWNLOAD_LOG: 'Download error-log',
      },
      DINAMIC_TAGS: {
        ADD_ATTRIBUTE_BTN: '+',
        WITHOUT_SELECTION: 'Without Selection...',
        SEARCH: 'Search ',
        ELEMENTS_NOTFOUND: 'No tags found',
        NO_ELEMENTS_SELECTED: 'No tags were selected',
        SELECTION_ALL: 'Select all',
      },
      FILTER_CHARGE_COMBO: {
        OTHERS: ', Others',
        OTHER: ', Other',
        SELECTED: 'Selected',
        RESULT: 'Results found',
        TOOLTIP: 'Selected Options: ',
      },
      ADD_ATTRIBUTE: {
        TITLE_MODAL: 'New Attribute',
        SELECT_ATTRIBUTE: 'Select Attribute',
        SEARCH_ATTRIBUTE: 'Search Attribute',
        SELECT_ALL: 'Select all',
        CANCEL_BTN: 'Cancel',
        ADD_BTN: 'Add',
        EXCLUDED: 'Excluded',
      },
      ERASURE_CONFIRMATION: {
        TITLE: 'Delete',
        SUBTITLE: 'Do you want to continue with the removal?',
        CANCEL_BTN: 'Cancel',
        DELETE_BTN: 'Delete',
      },
      DRAG_DROP: {
        TITLE: 'Drag and drop the image here or click to search on your PC',
        SUBTITLE: 'Extension not allowed: ',
        SUBTITLE_TTIP: 'Allowed extensions: "jpeg", "jpg", "png", "ico"',
        SUBTITLE_TTIP_EXCEL: 'Allowed extensions: "xls", "xlsx"',
        SUBTITLE_TTIP_ONLY: 'Allowed extensions:',
      },
      OPERATION_SUCCESS: {
        TITLE: 'Successful operation',
        SUBTITLE: 'The operation was completed successfully',
        ACCEPT_BTN: 'Accept',
        TITLE_EMPTY: 'Operation Without Modifications',
        SUBTITLE_EMPTY: 'The operation completed successfully, no changes were found pending to report',
        SUBTITLE_WITHOUT_RESULT: 'Without results',
      },
      IAN_IMPORTER: {
        BTN_IMPORT_SWITCH: 'Finish',
        CLOSE: 'Close',
        UPLOAD_FILES_STP1: 'Upload files',
        VERIFY_FORMAT_STP2: 'Verify Format',
        VALIDATE_INFORMATION_STP3: 'Validate Information',
        UPDATE_TABLES_STP4: 'Update tables',
        UPDATE_TABLES_STP_END: 'Finalize',
        RESTART_TTIP: 'Restart importer to upload new files',
        STP1: 'Step 1 - Upload file',
        DRAG_FILE: 'Drag and drop the file here, or click to search on your PC',
        STP2: 'Step 2 - Verify format',
        CHECKING_FORMAT: 'Verifying the format and extension of the file to upload to the server',
        STP3: 'Step 3 - Validate information',
        VALIDATING_DATA: 'Validating file data for inconsistencies',
        STP4: 'Step 4 - Update tables',
        STP_END: 'Step 2 - Finalize',
        INCORPORATING_INFORMATION: 'Processed information is being added to Prisma',
        CORRECT_FILE: 'The file format and extension are correct',
        WITHOUT_ERRORS: 'The information has been added to Prisma successfully, but with',
        WARNINGS: 'warnings',
        ERRORS: 'The information has not been added to Prisma. The following errors and warnings were found',
        WITHOUT_ERRORS_WARNINGS: 'The information has been added to Prisma successfully, without errors or warnings',
        DOWNLOAD_TEMPLATE: 'Download Template',
        TOTAL_ROWS_REGISTRED: 'Total records loaded',
        TOTAL_ROWS_REGISTRED_WITH_WARNINGS: 'Total records with warnings not loaded',
      },
      GEN_CATEGORYS: {
        CATEGORIES_INPUT: 'Categories',
        CATEGORIES_INPUT_EXC: 'Categories Excluded',
        CATEGORIES_TTIP: 'You must select at least one category, to select the subcategories',
        SEARCH_CATEGORIES: 'Search Categories',
        SUBCATEGORIES_INPUT: 'Subcategories',
        SUBCATEGORIES_INPUT_EXC: 'Subcategories Excluded',
        DEPT_INPUT: 'Deparatament Excluded',
        DEPT_INPUT_EXC: 'Deparatament Excluded',
        SUBCATEGORIES_TTIP: 'You must select at least one subcategory per selected category',
        SEARCH_SUBCATEGORIES: 'Search Subcategories',
        SELECT_ALL: 'Select all',
        SELECT_ALL_SUBCATEGORY: 'Select all Subcategories',
        SEARCH_SUBCATEGORIES_FILTER: 'Search Subcategories',
        SELECT_ALL_CATEGORY: 'Select all Categories',
      },
      GEN_ITEM_LIST: {
        NAME: 'Name',
        CODE: 'Code',
        BRAND: 'Brand',
        MANUFACTURER: 'Manufacturer',
        PRICE: 'Price $',
        COST: 'Cost $',
      },
      GEN_ITEM_STORE: {
        NAME: 'Name',
        CODE: 'Code',
        BRAND: 'Brand',
      },
      GEN_TAGS: {
        FILTER_TAG_VALUES: 'Filter options that are related to the results of the list',
        ADD_ATRIBUTE_BTN: 'Add Attributes',
        NO_TAGS: 'No Attributes to add',
        NONE: 'None',
        ALL: 'All',
        EXCLUDED: 'excluded',
        SEARCH: 'Search',
        AUTO_VISIBLE_FALLBACK_HINT: 'No default tags: showing some. Use "+" to see the rest.',
      },
    },
    MAT_PAGINATOR: {
      QUANTITY: 'Number of products per page',
      NEXT: 'Next page',
      PREVIUS: 'Previous page',
      FIRST: 'First page',
      LAST: 'Last page',
    },
    SERVICES: {
      CAN_DEACTIVATE: {
        TITLE_MODAL: 'Changes without saving',
        SUBTITLE_MODAL: 'Do you want to exit anyway?',
        GO_OUT_BTN: 'Exit',
        FOLLOW_BTN: 'Continue on the form',
      },
    },
    SPACES: {
      COMMON: {
        SEE_MORE: 'See more',
        STORES_LIST_TITLE: 'Stores',
        STORES_TABLE_NAME: 'Name',
        STORES_TABLE_ACTION: 'Actions',
      },
      ITEM_FINANCIALS: {
        TITLE: 'Financial data (Range scope)',
        SUBTITLE: 'Per item, store and structure. Same period and consolidation as Range assortment detail.',
        COL_ITEM: 'Item',
        COL_STORE: 'Store',
        COL_STRUCTURE: 'Structure',
        COL_STORES: 'Stores #',
        COL_SALES: 'Sales $',
        COL_UNITS: 'Units',
        COL_MARGIN: 'Margin',
        COL_MARGIN_VENDOR: 'Margin w/ agreements',
        COL_STOCK: 'Stock $',
        COL_STOCK_UN: 'Stock units',
        COL_AVAIL: 'Availability',
        COL_DAYS_STOCK: 'Days in stock',
        COL_LINEAR: 'Linear space',
        COL_FACINGS: 'Facings',
        COL_MKT_SALES: 'Market sales $',
        COL_MKT_UN: 'Market units',
        COL_PRICE: 'Price',
        COL_GMROI: 'GMROI',
        PREV: 'Previous',
        NEXT: 'Next',
        EMPTY: 'There are no financial rows for this template in the current scope (item–store–structure).',
      },
      REPLACE: {
        LIST_TITLE: 'Latest replacements made',
        NEW_BTN: 'Replace',
        LIST: {
          DATE_INPUT: 'Date',
          HOUR_INPUT: 'Hour',
          USER_INPUT: 'User',
          FILE_INPUT: 'File',
        },
        EDIT: {
          TITLE: 'New Replacement',
          TITLE_FORM_EDIT: 'Edit Replacement',
          STP1: 'Replacements',
          STP1_SUBTITLE: 'Select the products and their corresponding replacements',
          STP2: 'Planograms',
          STP2_SUBTITLE: 'Select the planograms in which you want to make the replacement',
          STP3: 'Confirmation',
          STP3_SUBTITLE: 'The selected products will be replaced for all subsequent planograms. Verify the list before continuing.',
          NEXT_BTN: 'Next',
          PREVIOUS_BTN: 'Previous',
          REPLACE_BTN: 'Replace',
          NAME_INPUT: 'Name',
          SAVE_BTN: 'Save',
          CANCEL_BTN: 'Cancel',
          PRODUCT_INPUT: 'Product',
          PRODUCT_REQUIRED: 'The product is required',
          ACTION_INPUT: 'Action',
          ACTION_REPLACE_OPTION: 'Replace',
          ACTION_DELETE_OPTION: 'Delete',
          REPLACEMENT_INPUT: 'Replacement',
          REPLACEMENT_REQUIRED: 'The replacement is required',
          SEARCH_PLACEHOLDER: 'Search by code or name',
          SEARCH_CLEAR: 'Clear search',
          SEARCH_RESULTS: '{{val}} of {{val2}} planograms',
          SELECTED_COUNT: '{{val}} selected',
          SEARCH_NO_RESULTS: 'No planograms match your search',
        },
      },
      LIST: {
        ENTITIES: {
          REPORT: 'Full report here',
          APPLY: 'Due to being in use in the following entities:',
          CONTENT_DELETE_LAYOUT:
            'The action could not be carried out correctly, the planogram is associated with at least one layout, press continue to delete it and remove it from the corresponding layouts',
          ITEM_NOT_FOUND: 'Not enough permissions on all linked stores by requested planograms',
          USEDINLAYAOUTS: 'Used in Layouts: {{val}}',
          IMPEDIMENT: {
            USEDINLAYAOUTS: 'Used in Layouts: {{val}}',
          },
        },
        STATUS: {
          New: 'New',
          PendingEndorsement: 'Pending Approval',
          Current: 'Published',
          Endorsed: 'Approved',
          Deleting: 'Deleting',
          Draft: 'Preview',
          Implanted: 'Implanted',
        },
        TITLE_STRUCTURE: 'Structure',
        BTN_STRUCTURE: 'New Structure',
        TITLE_GENERIC_SPACE: 'Generic Spaces',
        BTN_GENERIC_SPACE: 'New Generic Space',
        TITLE: 'Planograms',
        POPOVER_TEXT:
          'Only planograms whose Points of Sale are available to the user are displayed. If one or more planograms are not displayed, please contact the system administrator, informing them of the missing planograms and requesting verification of the Points of Sale associated with the user.',
        ROUTE: 'Space Planning',
        BTN: 'New Planogram',
        ADMIN: 'Planograms Administration',
        EXPORT_TTIP: 'Export',
        FILTER_TTIP: 'Filter',
        FULLSCREEN_TTIP: 'Expand',
        EXITFULLSCREEN_TTIP: 'Reduce',
        PRINT_TTIP: 'Print',
        DELETE: 'Delete',
        DELETE_TTIP: 'Delete selected planograms',
        RECOVER: 'Recover',
        RECOVER_TTIP: 'Recover',
        CLONE_STRUCTURE: 'Clone structure only',
        CLONE_STRUCTURE_AND_PRODUCTS: 'Clone structure and products',
        SURE_CLONE:
          'Are you sure you want to clone this item? only the planogram structure will be cloned and not the configuration with all its products applied',
        SURE_CLONE_COMPLETE:
          'Are you sure you want to clone this item? the planogram structure and configuration will be cloned with all its products applied',
        EDIT: 'Edit',
        STATUS_NEW: 'New',
        STATUS_EDITED: 'Edited',
        STATUS_ACTUAL: 'Current',
        STATUS_APPROVED: 'Approved',
        STATUS_PENDING_APPROVAL: 'Pending approval',
        STATUS_PEVIEW: 'Preview',
        STATUS_INFORMED: 'Informed',
        STATUS_INFORM: 'Inform',
        STATUS_IMPLANTED: 'Implanted',
        STATUS_INFORM_EXECUTED_SHORT: 'Executed Inf.',
        REQUEST_APPROVAL: 'Request Approval',
        REQUEST_APPROVAL_SMALL: 'Request Approval',
        APPROVE: 'Approve',
        COLUMN: {
          NAME: 'Name',
          CODE: 'Code',
          TYPE: 'Type',
          LAST_MODIF: 'Last Modif.',
          STATUS: 'Status',
          CAT: '# Categories',
          SUBCAT: '# Subcategories',
          GENERATE: 'Generate',
          CHARGE: 'Capacity (UN)',
          FRONT: 'Length',
          LINEAL_SIZE: 'Linear space',
          LAYOUT: '# Layouts',
          STORES: '# Stores',
          SKU: '# Products',
          SALES: 'Sales month/ Linear space',
          VAR: 'Var. Last Month',
          SCORE: 'Score',
          SCORE_MIN: 'Min. Score',
          SCORE_MAX: 'Max. Score',
          SCORE_MIN_ERROR: 'Score must be between 0 and 100',
          SCORE_MAX_ERROR: 'Score must be between 0 and 100',
          SCORE_RANGE_ERROR: 'Min score cannot be greater than max score',
          PLANOGRAMTYPE: 'Type',
          STRUCTUREONLY: 'Structure',
          STRUCTUREONLY_Structure: 'Structure',
          STRUCTUREONLY_Planogram: 'Planogram',
          STRUCTUREONLY_Generic: 'Generic Space',
          FILTER_PREVIEW: 'View Previews',
          EXCLUDED_FROM_ANALYSIS: 'Excluded from analysis',
          EXCLUDED_YES: 'Excluded',
          EXCLUDED_NO: 'No',
          EXCLUDED_FILTER_ALL: 'All',
          EXCLUDED_FILTER_ONLY: 'Only excluded',
          EXCLUDED_FILTER_NONE: 'Only not excluded',
          FILTER_TEMPLATE_GENERATE: 'Generated by:',
          FILTER_TEMPLATE_GENERATE_FOR: 'Generate:',
          MASIVE_ACTIONS: 'Bulk Actions:',
          request_approval_msg: 'Are you sure you want to request approval for {{val}} records?',
          approve_msg: 'Are you sure you want to approve {{val}} records?',
          inform_msg: 'Are you sure you want to inform {{val}} records?',
          APPROVE_ALERT: 'Approval sent. You will receive a notification when the process is completed.',
          REQUEST_APPROVAL_ALERT: 'Approval request sent. You will receive a notification when the process is completed.',
          INFORM_ALERT: 'Informing planograms. You will receive a notification when the process is completed.',
          INACTIVATE_ALERT: 'Deleting planograms. You will receive a notification when the process is completed.',
          request_approval: 'Request Approval',
          approve: 'Approve',
          inform: 'Inform',
          delete: 'Deactivate',
          exclude_from_analysis: 'Exclude from analysis',
          include_from_analysis: 'Include in analysis',
          exclude_from_analysis_msg: 'Are you sure you want to exclude {{val}} selected planograms from analysis?',
          include_from_analysis_msg: 'Are you sure you want to include {{val}} selected planograms in analysis?',
          EXCLUDE_FROM_ANALYSIS_ALERT: 'Exclusion from analysis sent. You will receive a notification when the process is completed.',
          INCLUDE_FROM_ANALYSIS_ALERT: 'Inclusion in analysis sent. You will receive a notification when the process is completed.',
          VISITED: 'Visited',
          NO_PERMISSIONS: 'You do not have permissions.',
          AUTOMATIC: 'Automatic',
          MANUAL: 'Manual',
        },
        SNACKBAR_REPORT: 'The report is being generated',
        MULTIPLE_REPORT_BTN: 'Multiple report',
        MULTIPLE_REPORT_BTN_FLAT_OPTION: 'Planograms per sheet',
        MULTIPLE_REPORT_BTN_MULTISHEET_OPTION: 'Planograms by tabs',
        SNACKBAR_CLOSE: 'Cerrar',
        PLANOGRAM_TYPES: {
          All: 'All',
          Structure: 'Structures',
          Planogram: 'Planograms',
          GenericSpace: 'Generic Space',
          isGenericSpace: 'Generic Space',
        },
        PLANOGRAM_TYPE: {
          Structure: 'Structure',
          Planogram: 'Planogram',
          GenericSpace: 'Generic Space',
          isGenericSpace: 'Generic Space',
        },
      },
      TABS: {
        TAB1_ICON: 'settings',
        TAB1: 'General',
      },
      GENERAL: {
        TITLE_NEW: 'New Planogram',
        TITLE_NEW_TEMPLATE: 'New Structure',
        TITLE_NEW_GENERICSPACE: 'New Generic Space',
        TITLE_EDIT: 'Edit floorplan',
        TITLE_EDIT_TEMPLATE: 'Edit Structure',
        TITLE_EDIT_GENERICSPACE: 'Edit Generic Space',
        SUBTITLE: 'You are creating a new planogram, type a Name and select related stores and categories',
        SAVE_BTN: 'Save',
        NAME_INPUT: 'Name',
        OBSERVATIONS_INPUT: 'Observations',
        EXCLUDED_FROM_ANALYSIS: 'Exclude from space analysis',
        EXCLUDED_FROM_ANALYSIS_TOOLTIP:
          'Indicates that this planogram should be excluded from space analysis. This is informational and does not change its status.',
        ADVANCED_SEARCH: 'Advanced search',
        UPDATE: 'Refresh',
        UPDATE_STRUCTURES: 'You must update the list of structures to see the changes made.',
        CODE_SEARCH: 'Search by codes',
        VALIDATION_CODE: 'The code {{val}} already exists and is in a working or inactive planogram',
        STORES: 'Stores',
        CATEGORIES: 'Categories',
        DELETE_ALL: 'Delete all',
        CONFIRM_DELETE: 'Are you sure you want to delete the store?',
        CONFIRM_DELETE_ALL: 'Are you sure you want to delete all?',
        SUBTITLE_LAYOUT: 'You are creating a new layout, type a Name and select related stores',
      },
      STRUCTURE: {
        HIDE_PANEL: 'Hide Panel',
        OPEN_L_PANEL: 'Open left panel',
        OPEN_R_PANEL: 'Open right panel',
      },
      PRODUCTS: {
        TURN_OFF_INDICATOR: 'Turn off indicator',
        FILTER_TITLE: 'Filters',
      },
      CONFIRMATION: {
        TITLE: 'Attention!',
        SUBTITLE: 'Do you want to add it to the existing or replace it completely?',
        REPLACE_BTN: 'Replace',
        ADD_BTN: 'Add',
      },
      EXTRAS: {
        CATEGORY_TITLE: 'Subcategories',
        CATEGORY_DESC: 'Select the subcategories related to this planogram. You can modify them later on.',
        STORE_TITLE: 'Stores',
        STORE_DESC:
          'Select the stores individually or in bulk to which it will belong. You can modify them later. Use (Ctrl + P) to paste from Excel.',
      },
      MATERIAL_POP: {
        TITLE: 'POP Material',
        ROUTE: 'Space Planning',
        NEW_BTN: 'New Pop Material',
        FULLSCREEN_TTIP: 'Expand',
        EXITFULLSCREEN_TTIP: 'Reduce',
        NAME: 'Name',
        CODE: 'Código',
        TYPE: 'Type',
        LAST_MODIF: 'Last Modif.',
        OBSERVATION: 'Observation',
        CHARGE_UNITS: 'Capacity (UN)',
        LAYOUTS: '# Layouts',
        STP1_INITIAL_DATA: 'Initial Data',
        STP2_ASSEMBLY: 'Assembly',
        STP1: 'Step 1 - Initial Data',
        BTN_NEXT: 'Next',
        STP2: 'Step 2 - Assembly',
        DISTANCE: 'Distance between Products (cm.)',
        PREVIOUS_BTN: 'Previous',
        SAVE_BTN: 'Save',
        MOVE_UP: 'Move the product up',
        MOVE_DOWN: 'Move the product down',
        DELETE: 'Remove the product',
        SEARCH_PRODUCT: 'Search by product or code',
        TITLE_FORM: 'New Pop Material',
        POP_MATERIAL: 'POP Material / ',
        EMTY_MSG: 'Drag products here',
        VALIDATION_CODE: 'The code {{val}} already exists and is either active or inactive on an existing Product On Promotion (POP)',
        PARENT_MATERIAL: 'Parent POP Material',
        LIST: {
          DELETE_ROW: 'Inactive record',
          DELETE_ROWS: 'Inactive records',
          DELETE_ROW_IN_PROCESS: "Inactivation request in progress. We'll notify you once completed.Inactive record",
          CONTENT_DELETE_PLANOGRAM:
            'The action could not be carried out correctly, the Material POP is associated with at least one planogram.',
        },
      },
      PLANOGRAMS_EDITOR: {
        VARIANT_GROUP: {
          PRINCIPAL_LABEL: '(Principal Variant)',
          COLLISION_TOAST: 'This variant group is already placed in the planogram. It cannot be added more than once.',
          PRINCIPAL_DATA_TOAST: 'The main product data for this variant group could not be loaded.',
          GROUP_TERM: 'Equivalence group',
        },
      },
      EDITOR: {
        IS_PREVIEW: 'Is a Preview',
        PREVIEW: 'Preview',
        SAVE_FOR_PREVIEW: 'Changes must be saved to generate a preview.',
        DELETE: 'Remove preview',
        OPACITY: 'Opacity',
        NEW_STRUCTURE: 'New structure',
        NEW_GENERIC_SPACE: 'New generic space',
        DOWNLOAD_EXCEL: 'Download report',
        LOADING_POG: 'Loading planogram...',
        NEW_POG: 'New planogram',
        SAVE: 'Save',
        AUTOSAVE_STATUS_SYNCING: 'Syncing…',
        AUTOSAVE_STATUS_SAVED: 'Saved',
        AUTOSAVE_STATUS_ERROR: 'Could not save automatically',
        AUTOSAVE_STATUS_OFFLINE: 'No connection: retrying automatically',
        AUTOSAVE_STATUS_PREPARE_ERROR: 'Could not prepare the automatic save',
        AUTOSAVE_ERROR_MODAL_MSG:
          'The planogram could not be saved automatically: the server returned an error ({{val}}). Please try again in a few minutes; your changes are still on screen and autosave resumes once a manual save succeeds.',
        STALE_VERSION_MODAL_MSG:
          'This planogram was saved from another tab or by another user after you opened it (last save: {{val}}). The changes on this screen were not saved and autosave is paused. Reload the page to work on the latest version.',
        SAVING: 'Saving…',
        SAVING_IN_PROGRESS: 'The planogram is being saved…',
        VISUALIZATION: 'Display',
        NULL_SPACES: 'Empty space',
        NULL_SPACES_LEGEND: ' ',
        SEARCH_STRUCTURE: 'Search structure',
        STRUCTURE_SELECTED: 'Structure selected {{val}}',
        STRUCTURES_SELECTED: '{{val}} Structures selected',
        STRUCTURE_WITHOUT_MEASUREMENTS: 'This structure has no valid furniture measurements.',
        STRUCTURE_WITHOUT_MODULES: 'This structure has no available modules.',
        STRUCTURE_INVALID: 'The selected structure could not be validated.',
        STRUCTURE_LOAD_ERROR: 'We could not load the selected structure. Please try again.',
        STRUCTURE_NOT_FOUND: 'The selected structure is no longer available.',
        STRUCTURES_SELECTION_REFRESHED: 'We refreshed the selection because some structures were modified or removed.',
        ORDER: 'Order',
        ORDER_STRUCTURES: 'Order structures',
        ORDER_ITEMS: 'Order on planogram',
        ORDER_ITEMS_HINT: 'Drag items to set left-to-right order. Structures move all their modules as one block.',
        ORDER_MANUAL_MODULE: 'Manual fixture',
        BACK_TO_LIST: 'Back to list',
        CLEAN_NI: 'Clear empty spaces',
        CLEAN_POG: 'Clear planogram',
        NEW_BLOCK_SPACES: 'Add Area',
        EDIT_BLOCK_SPACES: 'Edit Area',
        DELETE_ALL_BLOCK_SPACES: 'Clear Areas',
        DELETE_ALL_WARNING: 'Delete all Areas',
        DELETE_ALL_MSG: 'This action cannot be undone. Do you wish to continue?',
        MIRROR_POG: 'Mirror planogram',
        JUSTIFY_FACINGS: 'Disperse',
        CLEAN_MOD: 'Clear module',
        MIRROR_MOD: 'Mirror module',
        CLEAN_SHELF: 'Clear shelf',
        MIRROR_SHELF: 'Mirror shelf',
        AUTOCOMPLETE_SHELF: 'Autocomplete shelf',
        SHELF_AVOID_CHECK_SPACE: 'Do Not Validate Sizes',
        AUTOCOMPLETE_MODULE: 'Autocomplete module',
        TITLE_POG: 'Planogram',
        TITLE_LAYERS: 'Layers',
        TITLE_HEATMAP: 'Heat Maps',
        TITLE_HEATMAP_SING: 'Heat Map',
        TITLE_VARIABLE: 'Variable',
        TITLE_TIMELINE: 'Timeline',
        TITLE_VARIATIONS: 'Variations',
        TITLE_VIS_ATTRS: 'Display attributes',
        TITLE_VIS_ATTRS_SING: 'Display attribute',
        TITLE_VIS_ATTRS_CAT: 'Ranking by Category',
        TITLE_VIS_ATTRS_DEP: 'Ranking by Department',
        TITLE_STORES: 'Stores',
        TITLE_FILTERS: 'Filters',
        TITLE_SEARCH_BTN: 'Add products to the Impulse Strip',
        TITLE_TYPE: 'Type',
        TITLE_SHELF: 'Shelf',
        TITLE_BLOCK_SPACE: 'Blocked Area',
        NAME_BLOCK_SPACE: 'Name',
        COUNT_SHELFS: 'Shelves selected:',
        WIDTH_BLOCK_SPACE: 'Width (cm):',
        DST_X_BLOCK_SPACE: 'Start distance from furniture (cm):',
        TITLE_OWN: 'Own',
        TITLE_CAPACITY: 'Capacity',
        TITLE_CAPACITY_LIN: 'Linear capacity',
        TITLE_CAPACITY_LIN_FREE: 'Free linear capacity',
        TITLE_ASSIGNED_TO: 'Assigned to',
        TITLE_PRODS: 'Products',
        TITLE_FACINGS: 'Facings',
        TITLE_LEVELS: 'Levels',
        TITLE_LOAD: 'Capacity',
        TITLE_STOCK_VALUE: 'Stock $',
        TITLE_PERFORMANCE: 'Performance',
        TITLE_ACTIVES: 'All Active',
        TITLE_NO_ACTIVES: 'Not active',
        TITLE_ACTIVE: 'Active',
        TITLE_NO_ACTIVE: 'Active in some Stores',
        TITLE_NO_ACTIVE_ALL_STORES: 'Inactive in all stores',
        TITLE_IS_BLOCKED: 'Available for Sales in some Stores',
        TITLE_NO_BLOCKED: 'Available for Sales',
        TITLE_BLOCKED_ALL_STORES: 'Blocked for Sales',
        TITLE_SEARCH: 'Search',
        TITLE_EXHIBITED: 'Exhibited',
        TITLE_EXHIBITED_SING: 'Exhibited',
        TITLE_NO_EXHIBITED: 'Not exhibited',
        TITLE_NEW_ONLY: 'Only New',
        TITLE_BLOCKEDFORSALES: 'Blocked for Sales',
        TITLE_BLOCKEDFORSALES_NO: 'Available for Sales',
        TITLE_ADVANCED_FILTERS: 'Advanced Filters',
        TITLE_CLEAN_FILTERS: 'Clear Filters',
        TITLE_SMALL_COD: 'Code',
        TITLE_SMALL_UNIT_MED: 'UOM',
        TITLE_EAN: 'EAN',
        TITLE_BRAND: 'Brand',
        TITLE_SUPLIER: 'Supplier',
        TITLE_CAN_STACK: 'Can Stack',
        TITLE_CAN_LAYDOWN: 'Can Tumb',
        TITLE_CAN_ROTATE: 'Can Rotate',
        TITLE_SALES_PART_PER: 'Sales Share',
        TITLE_SALES_PART_LIN_ESP: 'Space Share',
        TITLE_EXH_DAYS: 'Days in Display',
        TITLE_EXH_STOCK: 'Days in Stock',
        TITLE_STOCK: 'Stock $',
        TITLE_STOCK_UN: 'Stock UN',
        TITLE_DATE: 'Date',
        TITLE_USER: 'User',
        TITLE_ANALISYS_TYPE: 'Analysis Type',
        TITLE_LOAD_LIMIT: 'Load limit',
        TITLE_STACK_LIMIT: 'Stack limit',
        TITLE_LIMIT_PLACEHOLDER: 'lim.',
        TITLE_IS_PALLET: 'is Pallet',
        TITLE_IS_PALLET_PLACEHOLDER: 'is Pallet',
        FILTER_POPMATERIALESPECIAL: 'POP Material Special',
        FREE_AREA: 'Free Area',
        TOTAL_AREA: 'Total Area',
        TOTAL_PLANOGRAMS: 'Planograms',
        YES: 'Yes',
        NO: 'No',
        TTIP_UNDO: 'Undo last change [ctrl+z]',
        TTIP_REDO: 'Redo last change [ctrl+y]',
        TTIP_DRAG: 'Drag [spacebar+mouse]',
        TTIP_FIT: 'Fit content',
        TTIP_ZOOM_IN: 'Zoom in [+]',
        TTIP_ZOOM_OUT: 'Zoom out [-]',
        TTIP_FULL_SCREEN: 'Maximize screen',
        TTIP_FULL_PRINT: 'Print [ctrl+p]',
        TTIP_OPTIONS: 'Options',
        TTIP_DEL: 'Delete [del]',
        TTIP_CLONE: 'Clone Module',
        TTIP_CLONE_ALT: 'Clone',
        TTIP_COMMENTS: 'Comments',
        TTIP_STACK_WARING: 'This product is not stackable',
        PRINT_NAME: 'Name',
        PRINT_POSITION: 'Position',
        PRINT_NAME_CAT: 'Category Name',
        PRINT_NAME_SUBCAT: 'Subcategory Name',
        PRINT_UNIT_MESURE: 'Unit of Measure',
        PRINT_BRAND: 'Brand',
        PRINT_MANUFACTURE: 'Manufacturer',
        PRINT_WIDTH: 'Width',
        PRINT_HEIGHT: 'Height',
        PRINT_DEPTH: 'Depth',
        PRINT_FACES: 'Faces',
        PRINT_LOAD: 'Max Load.',
        PRINT_LINEAL_SPACE: 'Linear Space',
        PRINT_ROTATION: 'Rotation',
        PRINT_STACK: 'Stacks',
        PRINT_VARIANT: 'Variant',
        PRINT_CONSOLIDATED_EQUIVALENTS: 'Consolidated Equivalents',
        PRINT_MEMBER_CUFS: 'Member CUFs',
        PRINT_TOTAL_FACINGS: 'Total Facings',
        PRINT_TOTAL_LOAD: 'Total Load',
        PRINT_SALES: 'Sales',
        PRINT_UNITS: 'Units',
        PRINT_MARGIN: 'Margin',
        PRINT_VARIANT_LISTING: 'Variant Listing',
        PRINT_PRINCIPAL_PRODUCT_CODE: 'Principal Product Code',
        PRINT_PRINCIPAL_PRODUCT_NAME: 'Principal Product Name',
        PRINT_VARIANT_PRODUCT_CODE: 'Variant Product Code',
        PRINT_VARIANT_PRODUCT_NAME: 'Variant Product Name',
        MSG_SHELF_SHOULD_EMPTY: 'The shelf must be empty.',
        MSG_CONFIRM_SAVE: 'Are you sure you want to save the planogram?',
        MSG_CONFIRM_SAVE_TEMPLATE: 'Are you sure you want to save the structure?',
        MSG_CONFIRM_SAVE_SPACE: 'Are you sure you want to save the generic space?',
        MSG_WIDTH_NI: 'The width of the empty space must be assigned.',
        MSG_CONFIRM_DEL_PRODS: 'Do you want to proceed with removing all products from the planogram?',
        MSG_CONFIRM_DEL_NI_PRODS: 'Do you want to proceed with removing all empty spaces from the planogram?',
        MSG_CONFIRM_MIRROR_PRODS: 'Do you want to continue mirroring the planogram?',
        MSG_CONFIRM_DEL_SHELF_PRODS: 'Do you want to continue removing all products from the shelf?',
        MSG_CONFIRM_MIRROR_SHELF_PRODS: 'Do you want to continue mirroring all products in the shelf?',
        MSG_CONFIRM_DEL_PRODS_MOD: 'Do you want to continue removing all products from the module?',
        MSG_CONFIRM_MIRROR_PRODS_MOD: 'Do you want to continue mirroring all products from the module?',
        MSG_CONFIRM_DEL_PRODS_MOD_PRD:
          'Do you want to continue with the removal of the module? <br> <b> All products will be removed. </b>',
        MSG_CONFIRM_DEL_PRODS_SHELF_PRD: 'Do you want to continue removing the shelf? <br> <b> All products will be removed. </b>',
        MSG_CONFIRM_DEL: 'Delete confirmation.',
        MSG_CONFIRM_MIRROR: 'Mirror confirmation.',
        MSG_MODULE_WIDTH_ALERT: 'There are products in the shelf that do not fit into the new width.',
        MSG_MODULE_DEPTH_ALERT: 'There are products in the shelf that do not fit into the new depth.',
        MSG_PRD_NO_ENOUGH_SPACE: 'Not enough space.',
        MSG_PRD_NO_ENOUGH_SPACE_LIMIT: 'Max load.',
        MSG_COMPRESSION_APPLIED: 'Compression applied: {{val}}%',
        MSG_COMPRESSION_BLOCKED: 'Could not add facings: {{val}} exceeds its max compression or is not compressible.',
        MSG_COMPRESSION_ADD_FACING_REJECTED: 'Not enough space to add a facing, even after compressing shelf products.',
        MSG_COMPRESSION_ADD_PRODUCT_REJECTED: 'Not enough space to add the product, even after compressing shelf products.',
        MSG_COMPRESSION_ORIENTATION_REJECTED: 'Not enough space for this orientation, even after compressing shelf products.',
        MSG_PRD_CATN_ROTATE: 'The selected product cannot be rotated.',
        MSG_PRD_CATN_LAYDOWN: 'The selected product cannot be tumbed.',
        MSG_PRD_CATN_ROTATE_LAYDOWN: 'Tumbed products cannot be rotated.',
        MSG_PRD_CATN_ROTATE_ROTATEY: 'Tumbed products cannot be rotated.',
        MSG_PRD_CATN_PALLET: 'The selected product cannot be placed in display mode due to lack of space.',
        MSG_SHELF_SHOULD_EMPTY_TYPE: 'Empty the shelf before changing its type.',
        MSG_SHELF_PRD_HEIGTH_WARNING: 'There are products with a height higher than the shelf',
        MSG_SHELF_PRD_DEPTH_WARNING: 'There are products with a greater depth than the shelf.',
        EXHIBITION_FORMAT_TITLE: 'Which format do you want to use?',
        EXHIBITION_FORMAT_SUBTITLE: 'Choose the exhibition format to place the product on the shelf.',
        EXHIBITION_FORMAT_OPTION_INDIVIDUAL: 'Individual',
        EXHIBITION_FORMAT_OPTION_SRP: 'SRP',
        BTN_CANCEL: 'Cancel',
        BTN_DEL: 'Remove',
        BTN_ACEPT: 'Accept',
        BTN_PRINT: 'Print',
        BTN_CLEAN: 'Clear',
        BTN_APPLY: 'Apply',
        BTN_SAVE: 'Save',
        BTN_CLOSE: 'Close',
        ACTION_REORDER_LEFT: 'Reorder Left',
        ACTION_REORDER_RIGHT: 'Reorder Right',
        ACTION_ADD_SHELF: 'Add Shelf',
        ACTION_DEL_PRODS: 'Delete products',
        ACTION_PRD_ADD_FACING: 'Add Facing [ctrl+right]',
        ACTION_PRD_REMOVE_FACING: 'Remove Facing [ctrl+left]',
        ACTION_PRD_STACKSLYINGDOWN: 'Do not tumb',
        ACTION_PRD_NO_STACKSLYINGDOWN: 'Tumb facings',
        ACTION_PRD_ROTATE_CW_NORMAL: 'Rotate right [r]',
        ACTION_PRD_ROTATE_NOCW: 'Rotate left',
        ACTION_PRD_ROTATE_CW: 'Lay right [r]',
        ACTION_PRD_ROTATE_UP_CW: 'Lay up[r]',
        ACTION_PRD_ROTATE_REV: 'Lay left',
        ACTION_PRD_ROTATE_REV_Y: 'Side View',
        ACTION_PRD_ROTATE_REV_Y2: 'Front View',
        MASS_SELECTION_ACTIONS_TITLE: 'Bulk actions',
        MASS_SELECTION_PRODUCTS_SELECTED: 'Selected products ({{val}})',
        MASS_SELECTION_SHELFS_SELECTED: 'Selected shelves ({{val}})',
        MASS_SELECTION_COPY_PRODUCTS: 'Copy products [Ctrl + C]',
        MASS_SELECTION_COPY_SUCCESS: '{{val}} products copied.',
        MASS_SELECTION_ADD_FACING: 'Add facing',
        MASS_SELECTION_REMOVE_FACING: 'Remove facing',
        MASS_SELECTION_ROTATE_RIGHT: 'Rotate right',
        MASS_SELECTION_VIEW_FRONT: 'Front view',
        MASS_SELECTION_VIEW_SIDE: 'Side view',
        MASS_SELECTION_VIEW_TOP: 'Top view',
        MASS_SELECTION_LOAD_LIMIT: 'Load limit',
        MASS_SELECTION_STACK_LIMIT: 'Stack limit',
        MASS_SELECTION_DISABLE_LIMIT: 'Disable limit',
        MASS_SELECTION_LIMIT_INVALID: 'Enter a valid limit greater than 0.',
        MASS_SELECTION_DEPTH_INVALID: 'Enter a valid depth between 6 and 1000.',
        MASS_SELECTION_DEPTH_UPDATED: 'Depth was updated for {{val}} shelves.',
        MASS_SELECTION_NOT_APPLIED_TITLE: 'Partial bulk action',
        MASS_SELECTION_NOT_APPLIED_MESSAGE: '"{{val}}" was not applied to the following products because the option is not enabled:',
        MASS_SELECTION_NOT_APPLIED_MESSAGE_ADD_FACING:
          '"{{val}}" could not be applied to the following products due to insufficient available space:',
        MASS_SELECTION_NOT_APPLIED_MESSAGE_REMOVE_FACING:
          '"{{val}}" could not be applied to the following products because they already have only one facing:',
        ACTION_SHELF_MOVEUP: 'Move up',
        ACTION_SHELF_MOVEDOWN: 'Move down',
        ACTION_SHELF_ADD_UP: 'Add shelf above',
        ACTION_SHELF_ADD_DOWN: 'Add shelf below',
        ACTION_SHELF_DEL_PRODS: 'Delete products',
        SHELF_SPACE_REASSIGN_TITLE: 'Reassign vertical space',
        SHELF_SPACE_REASSIGN_HEIGHT_MESSAGE: 'When changing shelf height, choose how to reassign the space.',
        SHELF_SPACE_REASSIGN_ADD_MESSAGE: 'When adding a shelf, choose where the required space comes from.',
        SHELF_SPACE_REASSIGN_REMOVE_MESSAGE: 'When removing a shelf, choose where the freed space goes.',
        SHELF_SPACE_REASSIGN_UPPER: 'Affect upper shelf',
        SHELF_SPACE_REASSIGN_LOWER: 'Affect lower shelf',
        SHELF_SPACE_REASSIGN_MODULE: 'Update module height',
        SHELF_PASTE_PRODUCTS: 'Paste products [Ctrl + V]',
        SHELF_PASTE_SUCCESS: '{{val}} products pasted.',
        SHELF_PASTE_PARTIAL: '{{added}} of {{total}} products were pasted. There is not enough space in the shelf.',
        SHELF_PASTE_NO_SPACE: 'There is not enough space in the shelf to paste the copied products.',
        MASS_MOVE_SUCCESS: '{{val}} products were moved.',
        MASS_MOVE_PARTIAL: '{{added}} products were moved. {{failed}} did not fit.',
        MASS_MOVE_NO_SPACE: 'There is not enough space in the shelf to move the selected products.',
        ACTION_LAYER_TOGGLE_MODS: 'Hide / Turn on Modules',
        ACTION_LAYER_HIDE_MODS: 'Hide modules',
        ACTION_LAYER_SHOW_MODS: 'Show modules',
        ACTION_LAYER_HIDE_PRODS: 'Hide products',
        ACTION_LAYER_HIDE_IMG: 'Hide images',
        ACTION_LAYER_SHOW_IMG: 'Show images',
        ACTION_LAYER_HIDE_TEXT_ANNOTATIONS: 'Hide free texts',
        ACTION_LAYER_SHOW_TEXT_ANNOTATIONS: 'Show free texts',
        ACTION_LAYER_SHOW_PRODS: 'Show products',
        ACTION_LAYER_HIDE_POP: 'Hide POP material',
        ACTION_LAYER_SHOW_POP: 'Show POP material',
        ACTION_LAYER_HIDE_PITSHELF: 'Show Box Front',
        ACTION_LAYER_SHOW_PITSHELF: 'Show Box 3D',
        ACTION_ADD_CONSTRAINTS: 'Add Constraints',
        SHELF: 'Shelf',
        SHELF_FRONT_VIEW: 'Box Front View',
        SHELF_NORMAL_TYPE_SHELF: 'Shelves',
        SHELF_NORMAL_TYPE_REFRIGERATOR: 'Refrigerators',
        SHELF_NORMAL_TYPE_SIMPLEPEG: 'Peg Shelf',
        SHELF_NORMAL_TYPE_PITSHELF: 'Box / Fridge',
        SHELF_NORMAL_TYPE_PALLET: 'Pallet',
        SHELF_NORMAL_TYPE_SLATWALL: 'Hook Modules SlatWall',
        NEW_SLATWALL: 'New SlatWall',
        MAG_SLAT_SPACING: 'Slat spacing',
        MAG_HOOK_DISTANCE: 'Hook distance',
        MAG_HOOK_HEIGHT: 'Hook height',
        MAG_HOOK_LENGTH: 'Hook length',
        MAG_VERTICAL_MARGIN: 'Vertical margin',
        MAG_PRICE_TAG_HEIGHT: 'Price tag height',
        MAG_PRICE_TAG_WIDTH: 'Price tag width',
        SHOW_PRICE_TAG: 'Show price tag',
        PEGBOARD_LAYOUT: 'Pegboard layout',
        PEGBOARD_LAYOUT_MASONRY: 'Masonry',
        PEGBOARD_LAYOUT_ROWBASED: 'Row based',
        SHELF_CANT_LEVELS: '# of Levels',
        MOD_TITLE: 'Module',
        BARTAB_GENERAL: 'Main Data',
        BARTAB_MODULES: 'Structure',
        BARTAB_BLOCK_SPACES: 'Blockable Areas',
        BARTAB_PROMOTION_MATERIAL: 'Promotional Materials',
        BARTAB_SCOPES: 'Products Scope',
        BARTAB_MODULES_PL: 'Structures',
        BARTAB_PRODS: 'Products',
        BARTAB_MULTI_PLANOGRAMS: 'Multi-Planograms',
        BARTAB_OTHERS: 'Others',
        BARTAB_POPMAT: 'POP material',
        BARTAB_ACCESSORIES: 'Accessories',
        FREE_TEXT: 'Free Text',
        FREE_TEXT_PLACEHOLDER: 'Add free text here...',
        FREE_TEXT_ANNOTATION_PLACEHOLDER: 'Write an annotation...',
        DELETE_TEXT_ANNOTATION: 'Delete free text',
        TEXT_ANNOTATION_UNKNOWN_AUTHOR: 'User',
        TEXT_ANNOTATION_FORMAT: 'Text format',
        TEXT_ANNOTATION_MOVE: 'Move',
        TEXT_ANNOTATION_RESIZE_WIDTH: 'Resize width',
        TEXT_ANNOTATION_RESIZE_HEIGHT: 'Resize height',
        TEXT_ANNOTATION_RESIZE_CORNER: 'Resize width and height',
        TEXT_ANNOTATION_FONT_SIZE: 'Font size',
        TEXT_ANNOTATION_TEXT_COLOR: 'Color',
        TEXT_ANNOTATION_BACKGROUND_COLOR: 'Background',
        TEXT_ANNOTATION_NO_BACKGROUND: 'No background',
        BARTAB_ANALISYS: 'Analysis',
        BARTAB_CONSTRAINTS: 'Constraints',
        BARTAB_AUDIT: 'Audit',
        BADGE_GENERIC_SPACE: 'Generic',
        BADGE_SPECIFIC_SPACE_PREFIX: 'Specific —',
        BADGE_SPECIFIC_SPACE_SUFFIX: 'POS',
        TRANSITION_TO_SPECIFIC: 'POS assigned. Assortment, indicators and performance are now enabled.',
        TRANSITION_TO_GENERIC: 'POS removed. The planogram returns to generic mode. Placed products are preserved.',
        PLANOGRAM_WITHOUT_STORES: 'Planogram without associated Stores',
        BARTAB_MAX_QUANT: 'Maximum Quantity of Promotions',
        IND_SALES: 'Sales',
        IND_SALES_MAG: 'Sales $',
        IND_SALES_UINIT: 'Unit Sales',
        IND_SALES_UINIT_PER: 'Unit Sales %',
        IND_SALES_PER: '% Sales $',
        IND_MARGIN: 'Margin',
        IND_MARGIN_UNIT: 'Unit Margin',
        IND_MARGIN_MAG: 'Margin $',
        IND_MARGIN_PER: 'Margin %',
        IND_MARGIN_TOT: 'Total Margin',
        IND_ESP_MT_LIN: 'Space %',
        IND_ESP_MT2_LIN: 'Space m2',
        IND_SPACE_SUB: 'Underspaced',
        IND_SPACE_OK: 'Balanced',
        IND_SPACE_HI: 'Overspaced',
        SPACE_WARNING: 'Space Alert',
        IND_SPACE_SUB_SMALL: 'Under',
        IND_SPACE_OK_SMALL: 'Bal.',
        IND_SPACE_HI_SMALL: 'Over',
        IND_SPACE_GMROI: 'GMROI',
        IND_SPACE_GMROS: 'GMROS',
        IND_SPACE_PRICE: 'Price',
        IND_SPACE_NONE: 'None',
        IND_SPACE_DAYS_EXH: 'Days in Display',
        IND_SPACE_DAYS_EXH_FULL: 'Days in Display',
        IND_SALES_PER_PROD: 'Sales per prod.',
        IND_SALES_PER_FACING: 'Sales per facing',
        IND_SALES_MTS_LIN_RATIO: 'Sales $ / space',
        IND_SALES_MTS_LIN_RATIO_USED: 'Sales $ / used space',
        IND_SALES_PRICE_PROM: 'Avg Price $',
        IND_SALES_MARGIN_PROM: 'Avg Margin $',
        IND_SALES_MARGIN_PROM_PER: 'Avg Margin %',
        IND_SALES_MONTH_UNITS: 'Avg. Unit Sales',
        OPEN_IN_ITEM_MASTER: 'Open in Item Master',
        IND_SALES_MONTH: 'Avg. Sales $',
        IND_SALES_UNITS_FACINGS: 'Units / Facings',
        IND_MARGIN_MONTH: 'Avg. Margin',
        IND_SPACE_ASSIGN: 'Space Allocation',
        IND_SPACE_ASSIGN_FULL: 'Space Allocation',
        IND_LOAD: 'Capacity',
        IND_STOCK_DAYS: 'Days in stock',
        IND_STOCK_DAYS_FULL: 'Days in stock',
        IND_ATTRS: 'Attributes',
        IND_NONE: 'None',
        IND_DAYS: 'days',
        IND_MIN_SMALL: 'Min',
        IND_MAX_SMALL: 'Max',
        IND_NORMAL: 'Normal',
        IND_BIGGER_THAN_DAYS: 'Greater than {{val}} days',
        IND_SMALER_THAN_DAYS: 'Less than {{val}} days',
        MAG_DEFAULT: 'cm.',
        MAG_VOL_DEFAULT: 'm³',
        MAG_HEIGHT_WITH_MAG: 'Height (cm.)',
        MAG_HEIGHT_WITH_MAG_ALLMOD: 'Height (cm.)',
        MAG_WIDTH_WITH_MAG: 'Width (cm.)',
        MAG_DEPTH_WITH_MAG: 'Depth (cm.)',
        MARGIN_LEFT: 'Margin Left (cm.)',
        MARGIN_RIGHT: 'Margin Right (cm.)',
        MAG_GUIDES: 'Guides distance (cm.)',
        MAG_HEIGHT: 'Height',
        MAG_WIDTH: 'Width',
        MAG_DEPTH: 'Depth',
        MAG_VOL: 'Vol.',
        PRINT_TITLE_DIALOG: 'Print Planogram',
        PRINT_MODS_SELECTION:
          'Choose the module to be printed, if you leave the range empty, all modules will be printed. (It is possible to use ranges, ex: 2-4)',
        PRINT_MODS_TO_PRINT: 'Modules to print',
        PRINT_PRINT_TYPES: 'Printing types',
        PRINT_COMMENTS: 'Comments',
        PRINT_REVERSE_VIEW: 'Print reverse view',
        PRINT_BODIES_PER_PAGE: 'Bodies per page',
        PRINT_BODY_LABEL: 'Body {{val}}',
        PRINT_PRINT_TYPE_IMAGES: 'Images',
        PRINT_PRINT_TYPE_GROUP: 'Group Codes',
        PRINT_PRINT_TYPE_INDIV: 'Individual Codes',
        PRINT_PRINT_TYPE_ALL_PLANOGRAM_IMAGE: 'Full Planogram',
        PRINT_PRINT_TYPE_POP: 'POP material',
        PRINT_REPORT: 'Report',
        PRINT_WARN_NO_RANGE: 'There are no modules to print within the selected range.',
        AUDIT_STATUS: 'Status',
        AUDIT_LAST_PUBLISH: 'Last. Pub.',
        AUDIT_NO_IMAGE: 'No image',
        AUDIT_IMG_UPLOAD: 'Upload image',
        AUDIT_IMG_VIEW: 'View image',
        OPEN_PRISMA_VISION: 'Compliance',
        AUDIT_TITLE: 'Audit',
        AUDIT_WARNING_NO_SAVED: 'To change the status of the planogram there must be no unsaved changes.',
        AUDIT_AUDIT_IMG: 'Audit image',
        AUDIT_NEW_AUDIT_IMG: 'New audit image',
        AUDIT_NEW_AUDIT_IMG_OK: 'Image saved successfully',
        CONSTRAINTS_TITLE: 'Constraints',
        TLINE_TITLE: 'Timeline',
        TLINE_ACTUAL_TIME: 'Current (Today)',
        TLINE_TOTAL_MARG: 'Total margin',
        TLINE_SALES_UNITS: 'Unit Sales',
        TLINE_LAST_PUB: 'Previous [ctrl+left]',
        TLINE_NEXT_PUB: 'Next [ctrl+right]',
        TLINE_CLOSE_TL: 'Close timeline',
        TLINE_OPEN_TL: 'Open timeline',
        TYPES: {
          'normalShelf-module': 'Shelf',
          'simplePeg-module': 'Peg Shelf',
          'slatWall-module': 'Hook Modules SlatWall',
          'pitShelf-module': 'Pit Shelf',
          'refrigerator-module': 'Refrigerator',
          'normalShelf-level': 'Shelf',
          'simplePeg-level': 'Peg Shelf',
          'slatWall-level': 'Hook Modules SlatWall',
          'pitShelf-level': 'Pit Shelf',
          'float-pop-impulse-strip-simple': 'Impulse strip',
        },
        COMM_TITLE: 'Comments',
        COMM_DATE: 'Date',
        COMM_COMMENT: 'Comment',
        COMM_NEW_COMMENT: 'New comment',
        COMM_READ_MORE: '[Read more]',
        MENTION_NO_RESULTS: 'No matches',
        NEW_NORMALSHELF: 'New Shelf',
        NEW_REFRIGERATOR: 'New Refrigerator',
        NEW_SIMPLEPEG: 'New Peg Shelf',
        NEW_PITSHELF: 'New Box / Fridge',
        CONSTRAINS_TYPES: {
          MIN_FACINGS: 'Minimum fronts per product',
          MAX_FACINGS: 'Maximum fronts per product',
          MIN_LINE_SPACE: 'Linear space minimum',
          MAX_LINE_SPACE: 'Maximum linear space',
          MIN_SHARE_SPACE: 'Minimum space share',
          MAX_SHARE_SPACE: 'Maximum share of space',
        },
        CONSTRAINS_NAME_TITLE: 'Name',
        CONSTRAINS_APPLY_TO: 'Apply to:',
        CONSTRAINS_ALL_THE_PLANOGRAM: 'All the planogram',
        CONSTRAINS_ALL_THE_PLANOGRAM_TTIP: 'This rule will apply to the entire planogram',
        CONSTRAINS_ALL_SHELF_TTIP: 'This rule will apply to the entire shelf',
        CONSTRAINS_ALL_SHELF_MODULE_TTIP: 'This rule will apply to the entire module',
        CONSTRAINS_SHELF_SELECTED: 'Shelf',
        CONSTRAINS_SHELF_MODULE: 'Module',
        CONSTRAINS_CONDITION: 'Condition',
        CONSTRAINS_FRONTS_VALUE: 'Fronts',
        CONSTRAINS_LINE_SPACE_VALUE: 'linear space (cm.)',
        CONSTRAINS_SHARE_SPACE_VALUE: '% share of space',
        CONSTRAINS_GROUP_EAN: 'Grouped by ean',
        CONSTRAINS_ALL_ITEMS: 'All items',
        CONSTRAINS_WARNINGS: 'warnings',
        CONSTRAINS_ONLY_THIS: 'View warnings',
        CONSTRAINS_WARNINGS_SIZE: 'Warnings',
        DELETE_DELETE_ITEM: 'Remove item',
        DELETE_DELETE_ALL_EANS: 'Remove all items grouped by EAN',
        CLONE_STRUCTURE: 'Clone structure only',
        SELECTED_STRUCTURES: 'Selected structures',
      },
      SPACES_TEMPLATES: {
        GENERATION_PLANOGRAMS: 'Generation planograms...',
        GENERATION_PLANOGRAMS_ALT:
          'Solicitude for planogram generation has been saved and queued. You will receive a notification when it is complete.',
        TITLE: 'Templates',
        TITLE_NEW: 'New Template',
        TAB_GENERAL: 'General',
        TAB_BLOCKS: 'Blocks Config',
        TAB_BLOCKS_TT: 'Defines the sorting rules and commercial conditions for the generation of planograms.',
        TAB_PLANOGRAMS: 'Planograms',
        TAB_STRUCTURES: 'Structures',
        TAB_GENERATE: 'Generation',
        DEMO_TITLE_EDIT: 'Template para YOGHURT',
        DEMO_TITLE_CODE_EDIT: 'YOG1',
        PREVIEW: 'Preview',
        CLOSE_PREVIEW: 'Close Preview',
        NEW_DIVISION: 'New Division',
        DIVISION: 'Division',
        LEVELS: 'Levels',
        LEVEL_BLOCK: 'Block Level',
        TABLE: {
          NAME: 'Name',
          FRONT: 'Width',
          HEIGHT: 'Height',
          SHELVES: 'Shelves',
          STORES: 'Stores',
          BLOCK_AREAS: 'Assign Blocked Spaces',
          STORES_VIEW: 'View Stores',
          STRUCTURE_VIEW: 'View Structure',
          DELETE: 'Delete',
          SAVED_AREAS: 'Blocked Spaces',
        },
        LIST: {
          TITLE: 'Template list',
          PLANOGRAMS: 'Planograms',
          STRUCTURES: 'Structures',
          GenericSpace: 'General Space',
          DIVISIONS: 'Divisions',
          NO_DIVISIONS: 'Add divisions to start defining your blocks.',
          NO_BLOCKS: 'Currently, there are no products available for the selected configuration.',
          TAG_SCOPE: 'Tags Hit',
          CATEGORY_SCOPE: 'Categories Reached',
          EXCEED_TOLERANCE: 'Excess tolerated',
          MIN_LINEAR_SPACE: 'Minimum linear space',
          MAX_LINEAR_SPACE: 'Maximum linear space',
          LINEAR_SPACE_CALC_TYPE: 'Linear Calculation Type',
          LEVELS: 'Levels',
          CODE: 'Code',
          NAME: 'Name',
          EDIT_ROW: 'Edit',
          COPY_ROW: 'Clone',
          DELETE_ROW: 'Delete',
          ITEM_TAGS: 'Product Tags',
          NEW_ITEM: 'New Template',
          DELETE: 'Delete',
          DELETE_TTIP: 'Delete a template',
          FILTER: 'Advanced filter',
          FILTER_TTIP: 'Enable or disable Advanced Filter',
          EXPORT: 'Export',
          EXPORT_TTIP: 'Export a template',
          DELETE_ROW_IN_PROCESS: "Inactivation request in progress. We'll notify you once completed.Inactive record",
          DELETE_ROWS: 'Inactive records',
        },
        PLANOGRAMS: {
          TITLE: 'Associated Structures',
          INTRO: 'Assign the structures to link them with the template',
          PLANOGRAMS: 'Planograms',
          STRUCTURES: 'Structures',
        },
        LINEAR_SPACES: {
          SALES: 'Sales $',
          UNITS: 'Sales Units',
          MARGIN: 'Margin $',
          PROJECTEDSALES: 'Projected Sales',
          STOCK: 'Stock',
          PRICE: 'Price',
          RANKING: 'Ranking',
        },
        MAIN_TAB: {
          TITLE: 'General Data',
          CODE: 'Code',
          CODE_EXIST: 'Code already exist',
          NAME: 'Name',
          LEVELS: 'Levels',
          LINEAR_SPACE_CALC: 'Fronts calculation based on',
          MIN_LINEAR_SPACE: 'Minimum of linear space',
          MAX_LINEAR_SPACE: 'Maximum linear space',
          LEVELS_PER_PRODUCT: 'Levels by product',
          ORDER_TYPE: 'Order type',
          FILL_SPACES: 'Optimize space',
          FACINGS_LIMIT: 'Use item limits',
          FILL_SPACES_MSG:
            'By enabling this option, empty spaces in the planograms will be automatically filled, maximizing the use of available space and avoiding loss of business opportunities',
          FACINGS_LIMIT_MSG:
            'By enabling this option, the configured minimum and maximum limits for each SKU will be applied, ensuring visibility and preventing excess stock',
          EXCEED_BLOCK_TOLERANCE: 'Tolerance to Exceed the width of the block',
          SCOPE_ITEMS: 'Product Scope',
          SCOPE_ITEMS_COUNT: 'Selected products',
        },
        GENERATE: {
          TITLE: 'Planogram Generation',
          INTRO:
            'Select the criteria to efficiently generate your planograms. Optimize the presentation of your products at points of sale according to your specific needs.',
          BTN1_TITLE: 'Generation by Structure',
          BTN1_MSG: 'Develop a planogram for each structure, using the average data from all stores with that structure.',
          VERIFY_CONFIG: 'Verify Configuration',
          VERIFY_CONFIG_DESC: 'Verify the configuration of the template to ensure that it is correct and complete.',
          HAS_ALERTS: 'Has alerts',
          NO_ALERTS: 'No alerts',
          BTN2_TITLE: 'Generation by Point of Sale',
          BTN2_MSG: 'Create a specific planogram for each store, using detailed data from each point of sale.',
          BTN3_TITLE: 'Generation by Cluster',
          BTN3_MSG: 'Generate planograms for clusters of stores that share similar behaviors, averaging the data from each group.',
          TEXT1:
            'A planogram will be generated for each structure associated with the Template; the performance of each product will be the average of the points of sale associated with the structure.',
          TEXT2:
            "A planogram will be generated for each Point of Sale associated with the Template's Structures; the performance of each product will correspond to each Point of Sale. Important: If one or more Points of Sale are present in more than one structure, then a planogram will be generated for each Structure-Point of Sale pair.",
          TEXT3:
            'A planogram will be generated for each Cluster selected; the performance of each product will be the average within each Cluster. Important: If there are multiple structures, and these are associated with Points of Sale in the same Cluster, then planograms will be generated for each Cluster-Structure pair.',
          INTRO2: 'This process may take several minutes',
          PLANOGRAM: 'Generate Planogram',
          PREVIEW: 'Generate Preview',
          MODAL_TITLE_PREVIEW: 'Generate Preview',
          MODAL_INTRO_PREVIEW: 'Select the point of sale to generate the preview',
          MODAL_TITLE_GENERATE: 'Generate Planograms',
          MODAL_INTRO_GENERATE: 'Select the associated Stores to generate the related planograms',
          SELECT_PLANOGRAM: 'Planograms',
          SELECT_STORE: 'Stores',
          SELECT_AREA: 'Blocked Areas',
          SELECT_STRUCTURE: 'Structures',
          SELECT_CLUSTER: 'Cluster',
          ACCEPT: 'Accept',
          CANCEL: 'Cancel',
          ALERT: 'Save changes for generate planograms',
          WARNING: 'You must save the changes to generate planograms with the new modifications of the structures tab',
          WARNING_ALT: 'Some unsaved changes were detected. Unsaved changes will be saved automatically when generating planograms.',
          WARNING_ALT_PDV: 'You must save the changes to view the points of sale.',
          CREATEVERSIONFOR: 'Generate Planograms for:',
          PREVIEW_MODE: 'Generate Planograms as Draft (Preview)',
          ALERTS: {
            NO_EXHIBIT: 'There are non-exhibitable products, the Unit of Measure configuration in Item Master must be verified',
            STORE_NOT_AVAILABLE: 'There are {{quantity}} products not available for sale in the store: {{storeCode}}',
            STRUCTURE_OVERSPACE:
              'There are fixtures with low display index (their dimensions do not meet the configured minimum fronts), the dimensions of the structures must be verified',
            EXHIBIT: 'All products are exhibitable based on their Unit of Measure in Item Master',
            STORE_AVAILABLE: 'All products are available for sale in all stores',
            STRUCTURE_AVAILABLE: 'All fixtures have a high display index (their dimensions meet the configured minimum fronts)',
            BLOCKED_FOR_SALES: 'There are products blocked for sale, the Unit of Measure configuration in Item Master must be verified',
            NOT_BLOCKED_FOR_SALES: 'There are no products blocked for sale from their Unit of Measure in Item Master',
            NO_ALERTS: 'No alerts found',
            ERROR: 'Error verifying configuration',
            DISCARDED_COMBINATIONS:
              '{{count}} store tag value combinations will not generate a planogram: no store in the template has that combination of values assigned.',
          },
          SELECT_TAGS: 'Store tags',
          TAG_REQUIRED: 'You must select at least one store tag to generate in this mode.',
          TAG_MIN_ONE_VALUE: 'Select at least one value for this tag',
          CREATEVERSIONFOR_OPTIONS: {
            PerStructure: 'Template Associated Structures',
            PerStore: 'Manual Point-of-Sale Selection',
            PerClusterStructure: 'Manual Selection by Cluster',
            PerStoreTag: 'Generation by Store Tag',
          },
          NAME_COLUMN: 'Name',
          PLANOGRAM_EXIST_TITLE: 'Existing Planograms',
          PLANOGRAM_EXIST_SUBTITLE:
            'Are you sure you want to continue with the generation of planograms? This process will overwrite the items in the following list:',
          AI: {
            GENERATE_DIVISIONS: 'Generate Divisions with AI',
            GENERATE_DIVISIONS_TTIP: 'Generate Divisions with AI',
            GENERATOR_TITLE: 'AI Division Generator',
            MINIMIZE: 'Minimize',
            MINIMIZE_TTIP: 'Minimize',
            WRITE_PROMPT: 'Write your prompt...',
            GENERATE_DIVISIONS_BTN: 'Generate Divisions',
            PROCESSING: 'Processing...',
            AI_RESPONSE: 'AI Response:',
            COPY: 'Copy',
            CLEAR: 'Clear',
            RESPONSE_COPIED: 'AI response copied to clipboard',
            COPY_ERROR: 'Error copying to clipboard',
            IA_SERVICE_ERROR: 'The AI service is only available in development environment (port 4200)',
            AI_PROCESSING_ERROR: 'Error processing the AI response. Verify that the format is correct.',
            AI_COMMUNICATION_ERROR: 'Error communicating with the AI',
          },
          ENTER:
            'The current content of the planograms for the points of sale associated with this master will be replaced by the current generation.',
        },
        CUSTOM_PARAMETERS: 'Custom Parameters',
        CUSTOM_PARAMETERS_CONFIG: 'Custom Parameters Configuration',
        CUSTOM_PARAMETERS_INFO: 'This is a custom parameter that allows specific configurations',
        CUSTOM_PARAMETERS_ADVANCED: 'Advanced Configuration',
        BLOCKS: {
          SELECT_PARENT: 'Select Parent Block',
          CREATE_CUSTOM_PARAMETER: 'Create Custom Parameter',
          SELECT_VARIABLE: 'Select Variable',
          STOP_DIVISION_AT_BLOCK: 'Stop division',
          STOP_DIVISION_DESCRIPTION:
            'If enabled, the division will stop at this block and not continue with the division in the child blocks',
          STOP_DIVISION_TITLE: 'Division Configuration',
          CREATE_MASS_CUSTOM_PARAMETER: 'Create Mass Custom Parameter',
          UNION: {
            ENTER_MODE: 'Merge blocks',
            EXIT_MODE: 'Exit merge mode',
            MODE_ACTIVE: 'Merge mode active',
            MODE_HINT: 'Select 2 or more sibling blocks using the orange checkboxes on the canvas.',
            ADD_TO_SELECTION: 'Add to merge selection',
            REMOVE_FROM_SELECTION: 'Remove from merge selection',
            SELECTED_LABEL: 'blocks selected',
            DEFAULT_NAME: 'Default name',
            MERGE_BUTTON: 'Merge blocks',
            UNDO_BUTTON: 'Undo merge',
            UNDO_CONFIRM_TITLE: 'Undo block merge',
            UNDO_CONFIRM_MESSAGE: 'Blocks will be shown separately again and the compound name will be lost. Continue?',
            CHANGE_DIVISION_VARIABLE_TITLE: 'Change division criterion',
            CHANGE_DIVISION_VARIABLE_MESSAGE:
              'This level has active block merges. If you change the division criterion, those merges will be lost. Continue?',
            PREVIEW_BEFORE: 'Before',
            PREVIEW_AFTER: 'After',
            CONFIRM_TITLE: 'Confirm block merge',
            NAME_LABEL: 'Compound name',
            NAME_HINT: 'If left empty, block names will be concatenated.',
            COMPOSITE_LABEL: 'Compound',
            OTHER_LABEL: 'Other',
            VALIDATION: {
              MIN_BLOCKS: 'To merge blocks, select at least 2 blocks.',
              DIFFERENT_LEVEL: 'To merge blocks, all selected blocks must be at the same division level.',
              DIFFERENT_PARENT: 'To merge blocks, they must belong to the same parent block.',
              BLOCK_ALREADY_UNITED: 'One or more selected blocks already belong to another merge.',
              UNDO_BLOCKED_BY_CHILDREN: 'Cannot undo: the compound has child subdivisions created after the merge.',
            },
            ERRORS: {
              GENERIC: 'Could not save the merge. Please try again.',
              UNION_MIN_TWO_BLOCKS: 'A merge requires at least 2 blocks.',
              UNION_BLOCK_ALREADY_UNITED: 'One or more blocks already belong to another merge at this level.',
              UNION_DIFFERENT_PARENT: 'Blocks must belong to the same parent block.',
              UNION_UNDO_BLOCKED_BY_CHILDREN: 'Cannot undo: the compound has child subdivisions created after the merge.',
            },
          },
          SELECT_VARIABLE_OPTS: {
            Department: 'by Departament',
            Category: 'by Category',
            SubCategory: 'by Subcategory',
            Tag: 'by Label',
            Price: 'by Price',
            Size: 'by Size',
            category: 'Category',
            subcategory: 'Subcategory',
            tag: 'Label',
            price: 'Price',
            size: 'Size',
          },
          SELECT_ORIENTATION_OPTS_NEW: {
            Vertical: 'Vertical',
            Horizontal: 'Horizontal',
          },
          SELECT_CALCULATIONTYPE: {
            Sales: 'Sales',
            Units: 'Units',
            Margin: 'Margin',
            Price: 'Price',
            Size: 'Size',
            ProjectedSales: 'Projected Sales',
            Stock: 'Stock',
            Ranking: 'Ranking',
            Custom: 'Custom',
          },
          SELECT_ORDERTYPE: {
            Descending: 'Descending',
            Ascending: 'Ascending',
            Custom: 'Custom',
          },
          COLOR: 'Color',
          SELECT_DIVISIONTYPE_ROOT: 'Division type',
          SELECT_DIVISIONTYPE: 'Block Division Calculation',
          SELECT_DIVISIONTYPE_ITEM: 'Item Division Calculation',
          SELECT_ORDER_TYPE: 'Item Order',
          SELECT_ORDER_TYPE_ITEMS: 'Item Order',
          SELECT_ORDER_TYPE_BLOCKS: 'Block Order',
          SELECT_DIVISIONTYPE_OPTS: {
            Horizontal: 'Horizontal',
            Vertical: 'Vertical',
          },
          MAX_DIVISIONS: 'Maximum Divisions',
          MAX_DIVISIONS_ALT: 'Maximum',
          MIN_DIVISIONS_ALT: 'Minimum',
          DIVISION_INDEX: 'Division No.',
          DIVISION_WIDTH_ALT: 'Width (%)',
          ALLOCATION_CRITERIA: 'Criteria for Space Allocation',
          ALLOCATION_CRITERIA_OPTS: {
            '0': 'Prop. to sales $',
            '1': 'Sale Un.',
            '2': 'Margin $',
          },
          ORDER: 'Order',
          ORDER_OPTS: {
            '0': 'Ascending',
            '1': 'Descending',
            '2': 'Custom',
          },
          ADD_DIVITION: 'Add Division',
          PRODUCTS: 'Products',
          UNITS: 'Units',
          MARGIN: 'Margin',
          SALES: 'Sales',
          ADD_DIVITION_EXCEPTION: 'Add custom order',
          ADD_DIVITION_EXCEPTION_SIZE: 'Add custom size',
          DIVISION_WIDTH: 'Size (%)',
          DIVISION: 'Division',
          DIVISIONS: 'Divisions',
          DEMO_BRAND: 'Brand',
          DEMO_FLAVOR: 'Flavor',
          DEMO_SIZE: 'Size',
          DEMO_PRESENTATION: 'Presentation',
          SELECT_ORIENTATION: 'Orientation',
          SELECT_ORIENTATION_OPTS: {
            horizontal: 'Horizontal',
            vertical: 'Vertical',
          },
          SELECT_VARIABLE_CUSTOM: 'Select Variable (Custom Parameter)',
          SELECT_DIVISIONTYPE_CUSTOM: 'Division Type (Custom Parameter)',
          MAX_DIVISIONS_CUSTOM: 'Maximum divisions (Custom)',
          MAX_DIVISIONS_CUSTOM_HINT: 'Maximum number of divisions for this custom parameter',
          BLOCK_CUSTOM_ORDER_CUSTOM: 'Custom block order (Custom)',
          BLOCK_CUSTOM_SIZE_CUSTOM: 'Custom block size (Custom)',
          ADD_DIVISION_EXCEPTION_CUSTOM: 'Add Order Exception (Custom)',
          ADD_DIVISION_EXCEPTION_SIZE_CUSTOM: 'Add Size Exception (Custom)',
          VALIDATIONS: {
            blockCustomSize_invalidWidth: 'Invalid Block Size',
            blockCustomSize_invalidWidth_max: 'Invalid Block Size',
            blockCustomSize_invalidtagValueOrCategoryId: 'Category or Label Not Found',
            blockCustomOrder_invalidtagValueOrCategoryId: 'Category or Label Not Found',
            blockCustomOrder_invalidOrder: 'Invalid Order',
            blockCustomSize_invalidtagValueOrCategoryId_dup: 'Duplicated Category or Label',
            blockCustomOrder_invalidtagValueOrCategoryId_dup: 'Duplicated Category or Label',
            blockCustomDivisionType_invalidHorizontal: 'Invalid split type at top level',
            divisionVariable_duplicate: 'Duplicated variable',
            tagId_duplicate: 'Duplicated tag',
          },
        },
      },
      FLOOR_PLANS: {
        LIST: {
          NEW_ITEM: 'Create Layout',
          TITLE: 'List of Layouts',
          NAME: 'Name',
          CODE: 'Code',
          SIZE_PLANOGRAMS: 'Nr Planograms',
          SIZE_LEVELS: 'Levels',
          EDIT_ROW: 'Edit',
          COPY_ROW: 'Clone',
          DELETE_ROW: 'Delete',
          ITEM_TAGS: 'Product Tags',
          DELETE: 'Delete',
          DELETE_TTIP: 'Delete a template',
          FILTER: 'Advanced filter',
          FILTER_TTIP: 'Turn Advanced Filter On or Off',
          EXPORT: 'Export',
          EXPORT_TTIP: 'Export a template',
          DELETE_CONFIRM: 'Do you want to continue with the deletion of the Layout? ',
        },
        EDITOR: {
          TAB_GENERAL: 'General',
          TAB_LAYOUTS: 'Layouts',
          TAB_ANALISYS: 'Analysis',
          TITLE_EDIT: 'Layouts',
          TAB_LEVELS: 'Levels',
          LEVEL: 'Level',
          LEVEL_LABEL_NAME: 'Level',
          TITLE_NEW: 'New Layout',
          SUBTITLE: 'You are creating a new Layout, select the Name, the stores or categories',
          BACK_OPACITY: 'Background Opacity',
          ROTATION: 'Angle of Rotation',
          BACK_BW: 'Monochrome Image',
          DELETE_ALL_MODULES: 'Delete Modules',
          OPEN_PLANOGRAM: 'Open Planogram',
          OPEN_STRUCTURE: 'Open Structure',
          OPEN_STRUCTURE_UNAVAILABLE: 'No structure is associated with this planogram.',
          MSG_CONFIRM_DEL_MODULES: 'Do you want to continue deleting all planograms from the layouts',
          ADD_LEVEL: 'Add Level',
          EDIT_LEVEL: 'Edit Level',
          NEW_LEVEL: 'New Level',
          WIDTH: 'Width (m.)',
          DEPTH: 'Depth (m.)',
          TOTALSPACE: 'Total area (m².)',
          SELLINGAREASPACE: 'Sales area (m².)',
          BLUEPRINT_PHOTO: 'Plane Reference Image',
          DELETE_LEVEL: 'Delete Level',
          MOVELEVELTOP: 'Move up (reorder)',
          MOVELEVELBOTTOM: 'Move Bottom (Reorder)',
          MSG_CONFIRM_DEL_LEVEL: 'Do you want to continue deleting level {{val}}?',
          NAME: 'Name',
          CODE: 'Code',
          CATEGORY: 'Category',
          NO_LEVELS: 'No levels',
          PLANOGRAMS: 'Planograms',
        },
        VERSIONS: {
          DROPDOWN: {
            LABEL: 'Version',
            LOADING: 'Loading versions…',
            ERROR_TOOLTIP: 'Failed to load versions — reopen the editor to retry',
            NO_PREVIOUS_TOOLTIP: 'No previous versions',
            CURRENT_TAG: 'Current',
            SYSTEM_USER: 'System',
          },
          TRIGGER: {
            CREATE: 'Creation',
            STORES_CHANGE: 'Stores',
            LEVELS_CHANGE: 'Levels',
            PLANOGRAM_ASSIGNMENT: 'Plan. assigned',
            PLANOGRAM_MOVEMENT: 'Plan. moved',
            PLANOGRAM_PUBLICATION: 'Publication',
            BACKFILL: 'Migrated',
          },
          MODAL: {
            HEADER: 'Version V{{val}} · {{val2}} · {{val3}} · by {{val4}}',
            SECTION_WHAT_CHANGED: 'What changed',
            SECTION_SNAPSHOT: 'Layout snapshot',
            SECTION_METRICS: 'Published planograms performance',
            INHERITED_DISCLAIMER: 'Performance inherited from V{{val}} ({{val2}}). This version did not change published planograms.',
            METRIC_UNAVAILABLE: 'Metric unavailable',
            NO_PUBLISHED_PLANOGRAMS: 'No published planograms in this version',
            CLOSE: 'Close',
            TABLE: {
              PLANOGRAM: 'Planogram',
              SALES: 'Sales',
              MARGIN: 'Margin',
              UNITS: 'Units',
              PERIOD: 'Period',
            },
          },
          ERRORS: {
            LIST_LOAD_FAILED: 'Failed to load layout versions',
            DETAIL_LOAD_FAILED: 'Failed to load the selected version',
          },
        },
      },
      SUPER_PLANOGRAMAS: {
        LIST: {
          DELETE_CONFIRM: 'Do you want to continue with the deletion of the Multi-Planogramas',
          TITLE: 'Multi-Planograms',
          NAME: 'Name',
          CODE: 'Code',
          PLANOGRAMS: 'Planograms',
          NEW_SUPER_PLANOGRAMA_BTN: 'New Multi-Planogram',
          DELETE_ROW: 'Delete',
          DELETE: 'Delete',
        },
        EDIT: {
          TITLE: 'New Multi-Planograms',
          TAB1: 'Main Data',
          NAME: 'Name',
          CODE: 'Code',
          PLANOGRAMS: 'Planograms',
          NEW_PLANOGRAM_BTN: 'New Planogram',
          VALIDATION_CODE: 'The code already exists',
          LOADING: 'Loading...',
          PLANOGRAMAS_TAB: 'Planograms',
          PLANOGRAMAS_TAB_TITLE: 'Planograms',
          PLANOGRAMAS_TAB_ADD_PLANOGRAM: 'Add Planogram',
          PLANOGRAMAS_TAB_DELETE_PLANOGRAM: 'Delete Planogram',
          PLANOGRAMAS_TAB_DELETE_PLANOGRAM_CONFIRM: 'Do you want to continue with the deletion of the Planogram',
          PLANOGRAMAS_TAB_NAME: 'Name',
          PLANOGRAMAS_TAB_CODE: 'Code',
          PLANOGRAM_ADDED_SUCCESSFULLY: 'Planogram added successfully',
          PLANOGRAM_REMOVED_FROM_SELECTION: 'Planogram removed from selection',
          PLANOGRAMS_ADDED_SUCCESSFULLY: 'Planograms added successfully',
          PLANOGRAMAS_TAB_VIEW_PLANOGRAM: 'View Planogram',
        },
      },
    },
    TAGS_MODAL: {
      TITLE: 'Advanced Selection',
      DESC: 'Apply filters to your search in order to get the desired result. This option will deselect by filters.',
      FIRST_TABLE_BTN: 'Apply',
      FIRST_TABLE_HEADER: 'Filters',
      SECOND_TABLE_BTN: 'To Select',
      THIRD_TABLE_HEADER: 'Current Selection',
      THIRD_TABLE_EMPTY: 'Select Options',
      CANCEL: 'Cancel',
      APPLY: 'Apply',
    },
    AI_CHAT: {
      PAGE_TITLE: 'AI Chat',
      CHAT_TYPES: {
        DATABRICKS: 'Chat with Your Data',
        STREAMING: 'Insights Agent',
        DATABRICKS_DESC: 'Chat directly with your data using natural language',
        STREAMING_DESC: 'Advanced chat with real-time streaming',
      },
      HEADERS: {
        DATABRICKS_TITLE: 'Chat with your data',
        STREAMING_TITLE: 'Streaming Chat',
        DEFAULT_TITLE: 'AI Chat',
      },
      MESSAGES: {
        USER_DEFAULT: 'User',
        AI_NAME: 'Ask Prisma',
        AI_NAME_AGENT: 'Prisma Agent',
        INITIAL_MESSAGE: 'How can I help you today?',
        DATABRICKS_WELCOME:
          "Hello! I'm your data assistant. I can help you analyze information, generate queries, and answer questions about your data using natural language. How can I help you today?",
        STREAMING_WELCOME:
          "Hello, I'm your **Insight Agent** specialized in sales analysis. I'm here to help you extract actionable insights from business data.\n\nTell me what type of analysis you need or select one of the suggestions to get started.",
        LOADING: 'Thinking...',
        PROCESSING: 'Processing query...',
        HEALTH_CHECK: 'Checking API...',
        COPY_TOOLTIP: 'Copy content to clipboard',
        COPY_SUCCESS: 'Content copied to clipboard',
        COPY_SUCCESS_CONVERSATION: 'Conversation copied to clipboard',
        COPY_ERROR: 'Error copying content',
        COPY_THIS_MESSAGE: 'Copy this response',
        COPY_CONVERSATION: 'Copy full conversation',
        PDF_TOOLTIP: 'Download as PDF',
        PDF_THIS_MESSAGE: 'Download this response',
        PDF_CONVERSATION: 'Download full conversation',
        PDF_CONVERSATION_TITLE: 'Prisma Agent – Full conversation',
      },
      INPUT: {
        PLACEHOLDER: 'Write a message for the assistant...',
        PLACEHOLDER_SIMPLE: 'Write a message...',
        RESET_TOOLTIP: 'Reset conversation',
      },
      ERRORS: {
        SERVICE_UNAVAILABLE: 'Service unavailable',
        SERVICE_UNAVAILABLE_DESC: 'Could not connect to the AI service. Please check that the backend is working correctly.',
        PROCESSING_ERROR: 'An error occurred while processing your message',
        API_HEALTH_CHECK_FAILED: 'Unexpected error verifying API',
        CONNECTION_ERROR_TITLE: 'Connection Error',
        CONNECTION_ERROR_MESSAGE: 'Could not verify Data Agent API status. Check your internet connection and try again later.',
        NETWORK_ERROR_TITLE: 'Connection Error',
        TIMEOUT_ERROR_TITLE: 'Request Timeout',
        AUTH_ERROR_TITLE: 'Authentication Error',
        RATE_LIMIT_ERROR_TITLE: 'Query Limit Reached',
        UNKNOWN_ERROR_TITLE: 'Error Processing Query',
        NETWORK_ERROR_MESSAGE: 'Could not connect to the server. Check your internet connection or that the server is available.',
        TIMEOUT_ERROR_MESSAGE: 'The query took too long',
        AUTH_ERROR_MESSAGE: 'Authentication error',
        RATE_LIMIT_ERROR_MESSAGE: 'Query limit reached',
        UNKNOWN_ERROR_MESSAGE: 'An error occurred while processing your message.',
        STREAM_ERROR_MESSAGE: 'An error occurred in communication with the agent.',
        NETWORK_ERROR_SUGGESTION: 'If the problem persists, contact technical support.',
        TIMEOUT_ERROR_SUGGESTION: 'Try a simpler question or try again later.',
        AUTH_ERROR_SUGGESTION: 'Reload the page or contact technical support.',
        RATE_LIMIT_ERROR_SUGGESTION: 'Wait a few minutes before making another query.',
        UNKNOWN_ERROR_SUGGESTION: 'If the problem persists, contact technical support.',
        AUTH_EXPIRED_SUGGESTION: 'Your session may have expired. Try reloading the page.',
        INTERNAL_SERVER_SUGGESTION: 'We are working to fix it. Try again later.',
        CONTACT_SUPPORT: 'If the problem persists, contact technical support.',
        DATABRICKS_RESOURCE_NOT_FOUND: 'The configured Lakehouse space does not exist or is not available.',
        DATABRICKS_RESOURCE_GENERIC: 'The requested resource does not exist in the Lakehouse.',
        DATABRICKS_PERMISSION_DENIED: 'You do not have permission to access this resource in the Lakehouse.',
        DATABRICKS_INVALID_PARAMS: 'The parameters sent to the Lakehouse are invalid.',
        DATABRICKS_COMM_ERROR: 'Communication error with Lakehouse',
        SERVICE_DISABLED: 'AI chat service is disabled',
        AUTH_FAILED_GENERIC: 'Authentication failed',
        RATE_LIMIT_EXCEEDED: 'Query limit exceeded',
        INTERNAL_SERVER_ERROR: 'Internal server error',
        BAD_GATEWAY: 'Communication error with Proxy',
        SERVICE_UNAVAILABLE_TEMP: 'Service is temporarily unavailable',
        WAREHOUSE_WARMING_UP: 'The query engine is starting up. Please try again in a few seconds.',
        GATEWAY_TIMEOUT: 'Server took too long to respond',
        AGENT_NETWORK_ERROR: 'Could not connect to the server',
        AGENT_NETWORK_SUGGESTION: 'Check your internet connection and that the server is available.',
      },
      QUERY_RESULTS: {
        HEADER: 'Query result',
        NO_DATA: 'No data available.',
        VIEW_QUERY: 'View Query',
        COPY_QUERY: 'Copy Query to Clipboard',
      },
      REASONING: {
        VIEW_HISTORY: 'View reasoning history',
        VIEW_HISTORY_TOOLTIP: 'View the step-by-step reasoning process',
        PROCESSING_HISTORY: 'Processing history',
        CYCLE: 'Cycle',
        WORDS: 'words',
        STEP: 'Step',
        STEPS: 'steps',
        OF: 'of',
        NO_HISTORY: 'No reasoning history',
        NO_HISTORY_DESC: 'This query did not generate a detailed cycle history.',
        CYCLE_PROCESSING: 'processing cycle',
        CYCLES_PROCESSING: 'processing cycles',
      },
      CYCLES: {
        PROCESSING_STEP: 'Processing step',
        EXECUTING: 'Executing...',
        SUCCESS: 'Success',
        RUNNING: 'Running',
        UNKNOWN_TOOL: 'Unknown tool',
      },
      NOTIFICATIONS: {
        NEW_SUGGESTIONS_ONE: '{{count}} new suggestion has been generated.',
        NEW_SUGGESTIONS_MANY: '{{count}} new suggestions have been generated.',
        VIEW_ACTION: 'View',
      },
      ACTIONS: {
        RESET_CONVERSATION: 'Reset conversation',
        CLOSE_PANEL: 'Close panel',
        RETRY: 'Check again',
        EXPORT: 'Export',
      },
      INSIGHTS: {
        CONTAINER_TITLE: 'Action Suggestions',
        TITLE: 'Insights Agent',
        CONTAINER_DESC: 'Based on the previous analysis, these are the recommended actions:',
        LOADING: 'Loading suggestions...',
        ERROR: 'Error loading suggestions',
        RETRY: 'Retry',
        NO_SUGGESTIONS: 'No pending suggestions at this time',
        SUGGESTIONS_AVAILABLE: 'suggestion',
        SUGGESTIONS_AVAILABLE_PLURAL: 'suggestions',
        AVAILABLE: 'available',
        AVAILABLE_PLURAL: 'available',
        NO_PENDING: 'No pending suggestions',
        EXPAND_ARIA: 'Expand suggestions',
        COLLAPSE_ARIA: 'Collapse suggestions',
        PROCESSING: 'Processing...',
        APPROVE: 'Approve',
        REJECT: 'Reject',
        PROPOSED_CHANGES: 'Proposed changes:',
        ITEM_STORE: 'Item',
        STORE: 'Store',
        TYPES: {
          PRICE_CHANGE: 'Price Change',
          INVENTORY_ADJUSTMENT: 'Inventory Adjustment',
          PROMOTION_RECOMMENDATION: 'Promotion Recommendation',
          OTHER: 'Other Suggestion',
          DEFAULT: 'Suggestion',
        },
        STATUS: {
          PENDING: 'Pending',
          APPROVED: 'Approved',
          REJECTED: 'Rejected',
          IMPLEMENTED: 'Implemented',
          UNKNOWN: 'Unknown',
        },
      },
      HISTORY: {
        TITLE: 'Session History',
        TOOLTIP: 'View session history',
        REFRESH: 'Refresh history',
        LOADING: 'Loading history...',
        EMPTY: 'No saved sessions',
        NEW_SESSION: 'New session',
        VIEW_SUGGESTION: 'View Suggestion',
      },
      CHAT_INPUT: {
        SELECT_TYPE: 'Select chat type',
        TYPE_PREFIX: 'Type:',
        SEND_TOOLTIP: 'Send message',
        STOP_TOOLTIP: 'Stop processing',
      },
      PROMPT_EXAMPLES: {
        TOP_PRODUCTS: 'What are the top 10 best-selling products this month?',
        SALES_COMPARISON: 'Compare sales from this month with last month',
        INVENTORY_ALERT: 'Show sales by category for the last month',
        MONTHLY_TREND: 'Give me a monthly sales trend analysis for the last 6 months',
        INSIGHT_PRICE_OPTIMIZATION: 'Which products should adjust their price to maximize profitability?',
        INSIGHT_PERFORMANCE_ANOMALIES: 'Detect anomalies in sales performance over the last few weeks',
        INSIGHT_STOCK_RECOMMENDATIONS: 'Which items have low stock and high demand requiring urgent restocking?',
        INSIGHT_STRATEGIC_OPPORTUNITIES: 'Identify strategic opportunities based on market trends',
      },
    },
    INSIGHTS_SUGGESTIONS_PANEL: {
      TITLE: 'Insights Suggestions',
      PENDING_BADGE: 'pending',
      PENDING_BADGE_PLURAL: 'pending',
      ACCEPT_BUTTON: 'Accept',
      REJECT_BUTTON: 'Reject',
      STATUS_ACCEPTED: 'Accepted',
      STATUS_REJECTED: 'Rejected',
      EMPTY_MESSAGE: 'No suggestions available',
      VIEW_DETAILS: 'View details',
      DETAILED_REPORT_TITLE: 'Detailed Analysis',
      VIEW_CONVERSATION: 'View conversation',
      VIEW_CONVERSATION_TOOLTIP: 'View original conversation',
      CLOSE_BUTTON: 'Close',
      PRICE_RECOMMENDATIONS_TABLE: 'Price Recommendations',
      ESTIMATED_IMPACT: 'Estimated impact:',
      DEFAULT_TITLE_SUGGESTION: 'Untitled suggestion',
      SORT_BY: 'Sort by',
      SORT_IMPACT: 'Estimated impact',
      SORT_DATE: 'Date',
      SCHEMA: {
        ITEM: 'Item',
        STORE: 'Store',
        CURRENT_PRICE: 'Current Price',
        NEW_PRICE: 'New Price',
      },
      TYPE: {
        PRECIOS: 'Prices',
        SURTIDO: 'Assortment',
        PROMOS: 'Promos',
      },
      PRIORITY: {
        ALTA: 'High',
        MEDIA: 'Medium',
        BAJA: 'Low',
      },
      TIME_AGO: {
        MINUTES: '{{count}} minute ago',
        MINUTES_PLURAL: '{{count}} minutes ago',
        HOURS: '{{count}} hour ago',
        HOURS_PLURAL: '{{count}} hours ago',
        DAYS: '{{count}} day ago',
        DAYS_PLURAL: '{{count}} days ago',
      },
    },
    DATA_AGENT: {
      ERRORS: {
        API_UNAVAILABLE: 'Data Agent API is unavailable',
        API_TIMEOUT: 'API verification timeout (more than 15 seconds without response)',
        API_CONNECTION_ERROR: 'Could not connect to Data Agent API',
        API_ERROR_PREFIX: 'Error verifying API:',
        NETWORK_ERROR: 'Could not connect to the server. Check your internet connection or that the server is available.',
        API_STATUS_ERROR: 'API responded with status {{status}}: {{statusText}}',
        API_HEALTHY: 'Data Agent API is available and working correctly',
        BAD_GATEWAY: 'Bad Gateway - Data Agent Proxy communication error',
        SERVICE_UNAVAILABLE: 'Service Unavailable - The service is temporarily unavailable',
        GATEWAY_TIMEOUT: 'Gateway Timeout - The server took too long to respond',
      },
    },
    DATA_VISUALIZATION: {
      TABLE: {
        TITLE: 'Results Table',
        SEARCH_PLACEHOLDER: 'Search...',
        NO_DATA: 'No data available.',
        RECORDS: 'records',
        PIN_TOOLTIP: 'Pin to Dashboard',
        VIEW_QUERY_TOOLTIP: 'View Query',
        EXPORT_CSV_TOOLTIP: 'Export to CSV',
        DOWNLOAD_FULL_CSV_TOOLTIP: 'Download full CSV',
        EXPAND_TABLE_TOOLTIP: 'Expand table',
        COPY_QUERY_TOOLTIP: 'Copy Query to Clipboard',
        PREPARING_DOWNLOAD: 'Preparing download...',
        DOWNLOAD_READY: 'Download completed',
        DOWNLOAD_ERROR: 'Error downloading full CSV',
        DOWNLOADING_PART: 'Downloading part {current} of {total}...',
        RESULTS_LIMIT_WARNING: 'The table display is limited. To obtain the full dataset,',
        CLICK_HERE: 'you can download the complete CSV here.',
        PIN_LIMIT_TOOLTIP: 'Cannot pin: results exceed the limit of {limit} records.',
      },
      CHART: {
        NO_VISUALIZATION: 'With the currently available data, it is not possible to generate the chart',
        SELECT_COLUMNS: 'View Chart, select columns to visualize',
        VIEW_CHART: 'View chart',
        PIE_CHART: 'pie',
        TIME_LINE_CHART: 'time series',
        BAR_CHART: 'bar',
        SHOW_GROUPED_VALUES: 'Show grouped values',
        SHOW_GROUPED_VALUES_OTHERS: 'Show grouped values (Others)',
        TYPE: 'Type',
        TYPE_BAR: 'Bar',
        TYPE_HORIZONTALBAR: 'Horizontal bar',
        TYPE_TIME_LINE: 'Line',
        TYPE_PIE: 'Pie',
        LABEL_COLUMN: 'Label',
        SERIES: 'Series',
        AXIS_MODE: 'Axes',
        AXIS_AUTO: 'Auto',
        AXIS_SHARED: 'Shared axis',
        AXIS_DUAL: 'Dual axis',
      },
      COLUMN_SELECTOR: {
        TITLE: 'Select columns for chart',
        LABEL_COLUMN: 'Label column',
        NUMERIC_COLUMN: 'Numeric column (values)',
        MULTI_SERIES_HINT: 'You can select multiple columns to compare series',
        CANCEL: 'Cancel',
        VISUALIZE: 'Visualize',
      },
      PIN_DIALOG: {
        DESCRIPTION:
          'This query will be converted into an interactive card that will display results in table and chart format, updating periodically.',
        USER_QUERY: 'What would you like to query?',
        SQL_QUERY: 'SQL Query:',
        CANCEL: 'Cancel',
        CONFIRM: 'Confirm',
      },
      PIN: {
        SUCCESS: 'Card "{title}" successfully added to dashboard',
        ACTION_VIEW: 'View Dashboard',
      },
    },
    AI_DASHBOARD: {
      PAGE_TITLE: 'Smart Dashboard',
      ACTIONS: {
        ADD_CARD: 'Add Card',
        ADD_CARD_TOOLTIP: 'Add new card',
        REMOVE_CARD: 'Remove card',
        VIEW_JSON: 'View JSON',
        HIDE_JSON: 'Hide',
        VIEW_CONFIG_JSON: 'View JSON configuration',
        CLEAR_ALL: 'Clear All',
        CLEAR_ALL_TOOLTIP: 'Remove all cards',
        LAYOUT_JSON: 'Layout JSON',
        NEW_COMPONENT: 'New Component',
        EDIT_TITLE: 'Edit title',
        EDIT_TITLE_TOOLTIP: 'Change the title of this card',
        VIEW_QUERY: 'View SQL Query',
        VIEW_QUERY_TOOLTIP: 'View and edit the SQL query code',
        VIEW_PROMPT: 'View AI Prompt',
        VIEW_PROMPT_TOOLTIP: 'View and edit the original AI prompt (natural language)',
        REFRESH_DATA: 'Refresh data',
        REFRESH_DATA_TOOLTIP: 'Update data by re-running the query',
        REMOVE_CARD_SHORT: 'Remove card',
        REMOVE_CARD_TOOLTIP: 'Permanently remove this card from the dashboard',
        COPY: 'Copy',
        SAVE: 'Save',
        CANCEL: 'Cancel',
        CLOSE: 'Close',
        CONFIRM: 'CONFIRM',
        VIEW_TABLE: 'View as Table',
        VIEW_TABLE_TOOLTIP: 'Switch to results table view',
        VIEW_CHART: 'View Chart',
        VIEW_CHART_TOOLTIP: 'Switch to graphical visualization view',
        CHANGE_VISUALIZATION: 'Change Visualization',
        CHANGE_VISUALIZATION_TOOLTIP: 'Modify the chart or component type',
        EXPAND_CHART: 'Expand',
        EXPAND_CHART_TOOLTIP: 'Open the chart in a larger window',
        DOWNLOAD_PNG: 'Download PNG',
        DOWNLOAD_PNG_TOOLTIP: 'Download the current chart as a PNG image',
        CHANGE: 'Change',
        MORE_OPTIONS: 'More options',
        CONFIRM_DELETE_CARD_TITLE: 'Confirm deletion',
        CONFIRM_DELETE_CARD_MESSAGE: 'Are you sure you want to remove this card from the dashboard?',
        DELETE: 'Delete',
        DELETE_GALLERY: 'Delete Dashboard',
        EDIT_GALLERY: 'Edit Dashboard',
        CREATE_GALLERY: 'Create Dashboard',
        CREATE: 'Create',
        CREATE_GALLERY_TITLE: 'New Dashboard',
        CREATE_GALLERY_MESSAGE: 'Enter the name for the new Dashboard',
        EDIT_GALLERY_TITLE: 'Edit Dashboard',
        EDIT_GALLERY_MESSAGE: 'Modify the Dashboard name',
        CONFIRM_DELETE_GALLERY_TITLE: 'Confirm Dashboard deletion',
        CONFIRM_DELETE_GALLERY_MESSAGE: 'Are you sure you want to delete the Dashboard "{{galleryName}}"?',
        CONFIRM_DELETE_GALLERY_WITH_CARDS_MESSAGE:
          'Are you sure you want to delete the Dashboard "{{galleryName}}"? {{cardCount}} associated cards will be removed.',
        CHANGE_GALLERY: 'Change Dashboard',
        CHANGE_GALLERY_TOOLTIP: 'Move this card to another section or dashboard',
        CHANGE_GALLERY_TITLE: 'Change card Dashboard',
        CHANGE_GALLERY_MESSAGE: 'Select the new Dashboard for this card',
        REORDER_GALLERIES: 'Reorder Dashboards',
        REORDER_GALLERIES_TITLE: 'Reorder Dashboards',
        REORDER_GALLERIES_MESSAGE: 'Drag Dashboards to change their order',
        REORDER_GALLERIES_HINT: 'The first Dashboard (with ⭐) will be the default Dashboard',
        MANAGE_GALLERIES_TITLE: 'Manage Dashboards',
        MANAGE_GALLERIES_MESSAGE: 'Drag to reorder, edit names or delete dashboards',
        EDIT_NAME: 'Edit name',
        DELETE_GALLERY_TITLE: 'Delete Dashboard?',
        DELETE_GALLERY_MESSAGE: 'Are you sure you want to delete the dashboard "{{val}}"? All associated cards will also be deleted.',
        DELETE_GALLERY_ERROR_TITLE: 'Cannot delete',
        DELETE_GALLERY_ERROR_MESSAGE: 'You must keep at least one active Dashboard.',
        CANNOT_DELETE_LAST: 'Cannot delete the last Dashboard',
        OK: 'OK',
        ADD_FIRST_COMPONENT: 'Add Component',
      },
      LABELS: {
        POSITION: 'Position',
        SIZE: 'Size',
        TYPE: 'Type',
        QUERY_SQL: 'SQL Query',
        AI_PROMPT: 'AI Prompt',
        CARD_TITLE: 'Card Title',
        USER_QUERY: 'User Query:',
        GALLERY_NAME: 'Dashboard Name',
        GALLERY_NAME_PLACEHOLDER: 'E.g: Sales, Marketing, etc.',
        SELECT_GALLERY: 'Select Dashboard',
        DEFAULT_GALLERY: 'Default Dashboard',
      },
      CARD_TYPES: {
        CHART: 'Chart',
        KPI: 'KPI',
        LIST: 'List',
        STATUS: 'Status',
        TABLE: 'Table',
        DEFAULT: 'Card',
      },
      CHART_TYPES: {
        BAR: 'Bar Chart',
        LINE: 'Line Chart',
        PIE: 'Pie Chart',
        HORIZONTAL: 'Horizontal Bars',
      },
      MESSAGES: {
        NO_DATA: 'No data to display',
        ERROR_LOADING: 'Error loading data',
        CURRENT_TYPE: 'Current type',
        CURRENT_CHART_TYPE: 'Current chart type',
        SELECT_CARD_TYPE: 'Select card type',
        SELECT_CHART_TYPE: 'Select chart type',
        COLUMN_MAPPING: 'Chart columns',
        LABEL_COLUMN: 'Label (X axis)',
        SERIES_COLUMNS: 'Series (values)',
        SERIES_MULTI_HINT: 'You can select multiple columns to compare series',
        BOTH_FIELDS_REQUIRED: 'Both fields are required',
        GENERATING_COMPONENT: 'Generating component...',
        NEW_COMPONENT: 'New Component',
        REGENERATING_QUERY: 'Regenerating query from prompt...',
        QUERY_REGENERATED: 'Query regenerated successfully',
        NO_QUERY_GENERATED:
          'Could not generate the query. Try describing what information you want to see in a table with numbers or values, for example: "Show sales by month" or "Top 10 best-selling products".',
        NO_QUERY_AVAILABLE: 'No query available - the card will have no data',
        ERROR_REGENERATING_QUERY: 'Error regenerating query from prompt',
        MAX_CARDS_REACHED: 'Maximum limit of {{maxCards}} cards per Dashboard reached',
        GALLERY_FULL: 'Full',
        EMPTY_DASHBOARD_HINT: 'Start by adding components with your business data',
        LOADING_CARDS: 'Loading components...',
        LOADING_GALLERIES: 'Loading galleries...',
        CARD_MOVED_TO: 'Card moved to {{val}}',
        CONFIRM_MOVE_TITLE: 'Move Card',
        CONFIRM_MOVE_MESSAGE: 'Are you sure you want to move the card "{{val}}" to the dashboard "{{val2}}"?',
      },
      PLACEHOLDERS: {
        CARD_TITLE: 'Total accumulated sales for the last 5 months',
        AI_PROMPT: 'Total accumulated sales for the last 5 months',
      },
      CONFIRMATION: {
        CLEAR_ALL_CARDS: 'Are you sure you want to remove all cards?',
      },
      TROUBLESHOOTING: {
        REQUEST_SPECIFIC_DATA: 'Make sure to request specific data (numbers, sales, quantities, etc.)',
        MENTION_TABLE_INFO: 'Mention what information you want to see in the table',
        INCLUDE_TIME_PERIOD: 'Include the time period if relevant (last month, current year, etc.)',
        BE_MORE_SPECIFIC: 'Be more specific about the metrics you need',
      },
      NEW_CARD: {
        TITLE: 'New Card',
        DATA_LABEL_A: 'Data A',
        DATA_LABEL_B: 'Data B',
        DATA_LABEL_C: 'Data C',
      },
      ERRORS: {
        EXECUTING_QUERY: 'Error executing query',
        GENERATING_QUERY: 'Error generating query from prompt',
        UNKNOWN_ERROR: 'Unknown error',
        UNKNOWN_DATABRICKS_ERROR: 'Unknown error communicating with Databricks.',
        UNEXPECTED_STATEMENT_STATE: 'Statement in unexpected state',
        QUERY_GENERATION_FAILED:
          'Could not generate a valid query from the prompt. Try rephrasing the question or providing more context about the data you are looking for.',
        QUERY_GENERATION_FAILED_SHORT: 'Error: Could not generate query',
        LOAD_CARDS_FAILED: 'Error loading components. Please try again.',
        LOAD_GALLERIES_FAILED: 'Error loading galleries. Please try again.',
        SAVE_FAILED: 'Error saving changes. Please try again.',
      },
      BUTTON_LABELS: {
        DETAILS: 'Details',
        EDIT_PROMPT: 'Edit Query',
        RETRY: 'Retry',
      },
    },
    REPORTS: {
      MAX_SELECTED_WARNING: 'You cannot select more than {{val}} {{val2}} per report. Remove some to continue.',
      GENERAL_TITLE: 'Reports Hub',
      PREFIX_TITLE: 'Reports: ',
      TYPE_FILTERS: 'Report Type',
      DOWNLOAD: 'Generate and download Report',
      GENERATE: 'Generate Report',
      FORMAT: 'FORMATO',
      GENERATE_FORMAT: 'FORMATO',
      GO_TO_REPORT_LIST: 'Go to Reporting List',
      OPEN_REPORT_LIST: 'Open Reporting List',
      ASYNC_START_MSG: 'The request to generate the report has been queued. You will receive a notification when it is completed.',
      FILTERS_TITLE: 'Filter Selection',
      TABLE: {
        filename: 'File Name',
        lastModified: 'Last Modification',
        reportType: 'Report Type',
        username: 'Username',
        status: 'Status',
      },
      REPORT_TYPE_KEYS: {
        COMMENTARIO_DOCU: 'Used/Use: GENERIC_COMP.IMPORTERV2.TYPES',
      },
      LABEL_KEYS: {
        INCLUDEISDELETED: 'Include Deleted',
        SEARCH: 'Search',
        PRICE: 'Price',
        PERCENT: 'Percentage',
        DATE: 'Date',
        DATEFROM: 'Date From',
        DATETO: 'End Date',
        FROMTODATES: 'Dates (From/To)',
        ITEMTAGVALUES: 'Item Attributes',
        STORETAGVALUES: 'PDV Attributes',
        CATEGORYVALUES: 'Categories',
        PLANOGRAMAS: 'Planograms',
      },
      STATUS: {
        LABEL: 'Status',
        PENDING: 'Pending',
        SUCCESS: 'Success',
        FAILED: 'Failed',
        REPORTNOTGENERATED: 'Report not generated',
        NODATA: 'No data in range',
      },
      TOOLTIP: {
        REPORTNOTGENERATED: 'No results obtained with the filters used',
        NODATA: 'The query ran successfully but there is no data for the selected filters. Check the date range and generate it again.',
        FAILED: 'An error occurred while generating the report. Try again and if it persists, contact the support team',
        DOWNLOAD: 'Download {{val}}',
        PENDING: 'The report is being generated',
      },
      CANNOT_GENERATE_MANUALLY: 'This report cannot be generated manually',
    },
    SELLING: {
      PRICING: {
        TITLE: 'Pricing',
        SUBTITLE: 'Get the right price with AI.',
        SEE_MORE_BTN: 'See More',
        FEATURE1_TITLE: 'Achieve your desired competitive positioning',
        FEATURE1_SUBTITLE:
          'Location algorithms identify your competitors in each price zone and help you adjust your prices to reach your positioning.',
        FEATURE2_TITLE: 'Analyze the impact of your decisions',
        FEATURE2_SUBTITLE: 'Prisma estimates an impact in margin and price image that will help your decision-making process.',
        CTA_TITLE: 'Find out how we can help you!',
        CTA_BTN: 'Lets talk',
      },
      CTA_MODAL: {
        TITLE: 'Contact us for more information',
        NAME_INPUT: 'Name',
        COMPANY_INPUT: 'Company',
        PHONE_INPUT: 'Telephone',
        SEND_BTN: 'Send',
      },
      ASSORTMENT: {
        TITLE: 'Assortment Planning',
        SUBTITLE: 'Optimize your product mix and maximize your results.',
        SEE_MORE_BTN: 'See More',
        FEATURE1_TITLE: 'Cataloging',
        FEATURE1_SUBTITLE:
          'Assign products to your stores: *Segment your products. *Group your stores into clusters and relate your product segmentation in each cluster. ',
        FEATURE2_TITLE: 'Assortment Optimization',
        FEATURE2_SUBTITLE:
          'Pareto Rules with AI: Your business rules can work together with AI in order to exhibit in your stores the products that your customers want. Add products that perform better in the market or in other stores. Easily remove products that are not performing as expected.',
        CTA_TITLE: 'Find out how we can help you!',
        CTA_BTN: 'Lets talk',
      },
      PROMOTIONS: {
        TITLE: 'Promotions',
        SUBTITLE: 'Boost your promotional intelligence.',
        SEE_MORE_BTN: 'See More',
        FEATURE1_TITLE: 'Design amazing promotions',
        FEATURE1_SUBTITLE: 'Delight your customers by implementing different promotional mechanics.',
        FEATURE2_TITLE: 'Measure the results in detail',
        FEATURE2_SUBTITLE:
          'Take into account the cannibalization effect, the pre and post-promotional sales and the marketing investment to calculate the incremental profitability of each promotion.',
        CTA_TITLE: 'Find out how we can help you!',
        CTA_BTN: 'Lets talk',
      },
      ITEM_MASTER: {
        TITLE: 'Item Master',
        SUBTITLE: 'Simplify your product management process with Artificial Intelligence.',
        SEE_MORE_BTN: 'See More',
        FEATURE1_TITLE: 'Product Matching with AI',
        FEATURE1_SUBTITLE: 'Find matching products in order to compare prices and assortment and detect market trends.',
        FEATURE2_TITLE: 'Category Tree continuous improvement',
        FEATURE2_SUBTITLE: 'Increase precision and speed in the process of classifying products.',
        CTA_TITLE: 'Find out how we can help you!',
        CTA_BTN: 'Lets talk',
      },
      SPACES: {
        TITLE: 'Space Planning',
        SUBTITLE: 'Place your products in an efficient, optimized, and visually appealing way for customers.',
        SEE_MORE_BTN: 'See More',
        FEATURE1_TITLE: 'Smart Autocomplete',
        FEATURE1_SUBTITLE:
          'Use the autocomplete feature setting the exhibition days target and Prisma will suggest facings to minimize out of stocks.',
        FEATURE2_TITLE: 'Use mobile elements and different types of shelves',
        FEATURE2_SUBTITLE:
          'Add products such as hooks, drawers or hangers on planogram shelves. Freezers for frozen or dairy products, free baskets and tables, to be able to locate your promotions.',
        CTA_TITLE: 'Find out how we can help you!',
        CTA_BTN: 'Lets talk',
      },
      SUPPLY: {
        TITLE: 'Smart Supply',
        SUBTITLE: 'INTEGRATE YOUR DATA INTO THE SUPPLY CHAIN',
        SEE_MORE_BTN: 'See More',
        FEATURE1_TITLE: 'Reduce stock-outs and Inventory Days',
        FEATURE1_SUBTITLE:
          'Estimate the behavior of each SKU in each of the stores to calculate a suggested distribution. Using information from sales, prices and promotions to adjust the suggestion.',
        FEATURE2_TITLE: 'Design your Supply Chain',
        FEATURE2_SUBTITLE:
          'Define warehouses per store and design an omnichannel supply network where suppliers and warehouses are involved in each part of the Supply Chain.',
        CTA_TITLE: 'Find out how we can help you!',
        CTA_BTN: 'Lets talk',
      },
      PROMOTIONSV2: {
        TITLE: 'Promotions',
        SUBTITLE: 'Boost your promotional intelligence.',
        SEE_MORE_BTN: 'See More',
        FEATURE1_TITLE: 'Design amazing promotions',
        FEATURE1_SUBTITLE: 'Surprise your customers by implementing a variety of promotional dynamics.',
        FEATURE2_TITLE: 'Measure the results in details',
        FEATURE2_SUBTITLE:
          'It takes into account the cancellation effect, pre and post promotion sales and investment in marketing to measure the incremental profitability per promotion.',
        CTA_TITLE: 'Know how we can help you!',
        CTA_BTN: 'Lets talk',
        LIST: {
          EXPORT_TTIP: 'export',
          FILTER_TTIP: 'filter',
          DELETE_TTIP: 'delete',
          DELETE: 'delete',
          TITLE: 'List of actions',
          NEW_ACTION: 'new action',
        },
      },
    },
    GLOBAL_WARNINGS: {
      MODAL_WARNING_TITLE: 'Publish Warning - Confirmation',
      MODAL_WARNING_TITLE_ONLY_ALERT: 'Publish Warning',
      MODAL_FILE_REPORT_TITLE: 'Download Report',
      TEST: 'Inconsistent data was found in the publication process.\nWould you like to publish anyway?',
      ITEM_UNCOVERED_COST:
        'The item does not resolve the costs for all the points of sale selected by assortment.\nWould you like to publish anyway?',
      STORE_UNCOVERED_COST:
        'The point of sale does not resolve the costs for all the items selected by assortment.\nWould you like to publish anyway?',
      ASSORTMENT_UNCOVERED_COST:
        'Some points of sale and items do not cover the costs according to this assortment decision, you can download the report to see the detail.\nWould you like to publish anyway?',
      CLUSTER_UNCOVERED_COST_ONLYALERT:
        'Changes made to clustering affect cost coverage by provider. Please review the coverage report or reverse your last action.',
    },
    INTERFACE_LOG_MSG_KEYS: {
      UnitsLowerToZero: 'Units lower to zero',
      SalesLowerOrEqualToZero: 'Sales lower or equal to zero',
      SalesLowerToZero: 'Sales lower to zero',
      IsActiveMustNotBeNull: 'Is Active must not be null',
      ItemIsBloquedForSalesNullReplacement: 'Default Bloqued for Sales value',
      ItemIsBloquedForPurchaseNullReplacement: 'Default Bloqued for Purchase value',
      WrongBloquedForSaleForIngredientOrSupply: 'The Ingredients or Supplies cannot be enabled for direct sale.',
      WrongBloquedForPurchaseForComboOrRecipe: 'Combos or Recipes cannot be enabled for purchase',
      WrongBloquedOptionsForInactive: 'Inactive Items must be Blocked for Purchase or Sale',
      IsExceptionRedundant: 'The assortment exception is redundant',
      SameStoreAssortmentExist: 'The assorment by store already exists',
      PromotionNotFound: 'Promotion not found',
      ItemNotFound: 'Item not found',
      ItemDoesNotExists: 'Item does not exist',
      UomNotFound: 'Unit of Measure not found',
      NoDataProcessed: 'No data processed',
      HeaderIsInvalid: 'Invalid header',
      RecordsDiscardedByValidation: 'Rows discarded by validation and NOT processed',
      IsicRecalculationFailed: 'The deletion was saved but the current assortment recalculation failed. It will be fixed by the next scheduled process',
      ItemCodeMustNotBeNull: 'The Item Code cannot be "null"',
      UomCodeMustNotBeNull: 'The Unit of Measure Code cannot be empty',
      UomConversionMustBePositive: 'The Unit of Measure conversion factor must be greater than 0',
      ItemCostDoesNotBeNull: 'The Item Cost cannot be "null"',
      ItemCostGretherThanZero: 'Item Cost must be greater than 0',
      DiscountGretherThanZero: 'Item Discount must be greater than 0',
      Cost2GretherThanZero: 'Item Cost 2 must be greater than 0',
      Cost3GretherThanZero: 'Item Cost 3 must be greater than 0',
      TaxGretherThanZero: 'Item Tax must be greater than 0',
      Tax2GretherThanZero: 'Item Tax 2 must be greater than 0',
      Tax3GretherThanZero: 'Item Tax 3 must be greater than 0',
      StoreCodeMustNotBeNull: 'The Store Code cannot be null',
      StoreDoesNotExists: 'The Store does not exist',
      StoreBrandIdMustNotBeNull: 'The Store does not have an assigned brand',
      OpenedDateCannotBeEmpty: 'The Store does not have an opening date',
      StoreTypeInvalid: 'The Store has an invalid store type',
      StoreNameMustNotBeNull: 'The Store does not have an assigned name',
      OpenedDateCannotBeGreaterThanToday: 'The Store has an opening date greater than today',
      StoreMissingClusterizations: 'The Store does not have assigned clusterizations',
      PricesNotInitialized: 'Prices are not initialized for this Store',
      StoreLatitudeInvalid: 'The Store has an invalid latitude',
      StoreLongitudeInvalid: 'The Store has an invalid longitude',
      TagValueDoesNotExists: 'The tag value does not exist',
      TagValueDoesNotExistsForChildTag: 'The tag value does not exist and the tag depends on another tag: it cannot be created from an import',
      VendorDoesNotExists: 'The Vendor does not exist',
      ItemCannotBeSupply: 'Item cannot be of type Supply',
      ItemCannotBeIngredient: 'Item cannot be of type Ingredient',
      ItemCannotBeNew: 'Item cannot be in a new state',
      ItemBaseOnComponents: 'Cannot import combo prices with prices based on their components',
      ItemPriceGretherThanZero: 'Price must be greater than zero',
      ItemPriceStoreAndSegmentationSameTime: 'Point of sale and segmentation cannot be informed at the same time',
      ItemAndSegmentationSameTime: 'Item and segmentation cannot be informed at the same time',
      ValidFromGreaterThanTodayAndLessThen: 'The date must be greater than today and at most 30 days in the future',
      DiscountGretherThanOrEqualZero: 'Item Discount must be greater than or equal 0',
      DiscountLowerThanToItemCost: 'Item Discount must be lower than to item cost',
      keyword: 'Message',
      type: 'Type of message',
      values: 'Values',
      'GatewayTime-out': 'Gateway Time-Out',
      NULL: 'Unspecified error',
      ItemNameMustNotBeNull: 'Item Name must not be null',
      SalesTaxRateGreaterThanOrEqualToZero: 'Sales Tax Rate must be greater or equal to zero',
      CategoryCodeMustNotBeNull: 'Category Code must not be null',
      CategoryDoesNotExists: 'Category Code does not exists',
      CompetitorCodeMustNotBeNull: 'Competitor code must not be null',
      WrongAssortmentBehavior: 'Incorrect dispensing behavior',
      StoreAssortmentGeneratedByPromotion: 'Assortment per store generated by promotion',
      StoreAssortmentNotFound: 'The assortment by store was not found',
      ItemCodeTypeNotFound: 'ItemCodeType not found',
      DuplicateItemCode: 'Duplicate item code found',
      ItemCostGretherThanRegulated: 'The cost of an item exceeds the regulated cost',
      InvalidUnits: 'The units of measures are not correctly completed',
      InvalidDate: 'Invalid date',
      MonthlySaleAlreadyExist: 'The sales record already exists',
      SalesFutureAlreadyExist: 'The projected sales record already exists',
      RankingValueCannotBeEmptyNullOrLessThanOrEqualToZero: 'Ranking cannot be less than or equal to zero',
      DuplicatedStoreRanking: 'Duplicate Store-Ranking Code Combination',
      TagsRequiredNotCompleted: 'You must complete the required labels.',
      InvalidVendors: 'You must complete vendors.',
      VendorsWithoutDeliveryPlaces: 'Vendors without Delivery Places configured: {{val}}',
      WrongItemCode: 'You must complete mandatory codes.',
      InvalidCombo: 'Please check the components tab.',
      InvalidRecipe: 'Please check the ingredients tab.',
      ItemCannotPublish: 'The item cannot be published automatically.',
      ItemCostGreaterThanRegulated: 'The cost of an item exceeds the regulated cost.',
      DiscountGreaterThanOrEqualZero: 'Item Discount must be greater than or equal 0',
      ItemPriceGreaterThanZero: 'Price must be greater than zero',
      ItemCostGreaterThanZero: 'Item Cost must be greater than 0',
      DiscountGreaterThanZero: 'Item Discount must be greater than 0',
      Cost2GreaterThanZero: 'Item Cost 2 must be greater than 0',
      Cost3GreaterThanZero: 'Item Cost 3 must be greater than 0',
      TaxGreaterThanZero: 'The Item Tax must be greater than 0.',
      Tax2GreaterThanZero: 'Item Tax 2 must be greater than 0.',
      Tax3GreaterThanZero: 'Item Tax 3 must be greater than 0.',
      ValidFromGreaterThanToday: 'The date must be greater than today',
      DuplicateRecord: 'Duplicate record',
      ConflictingGuidelineForBrand: 'Conflicting guidelines for the same category and brand; rows discarded',
      BrandNotFoundOrNotOwn: 'Brand does not exist or is not an own brand',
      CostCodeDoesNotExists: 'Cost code does not exist',
      TaxCodeDoesNotExists: 'Tax code does not exist',
      VendorItemDoesNotExist: 'The relationship item and vendor does not exist',
      VendorCodeMustNotBeNull: 'The Vendor Code cannot be "null"',
      TaxGreaterThanOrEqualZero: 'Item Tax must be greater than or equal to 0',
      Tax2GreaterThanOrEqualZero: 'Item Tax 2 must be greater than or equal to 0',
      Tax3GreaterThanOrEqualZero: 'Item Tax 3 must be greater than or equal to 0',
      TaxRateNotAllowedInImport: 'The TAXRATE code is not allowed in the vendor cost importer',
      UomForNormaDoesNotExist: 'No unit of measure with packaging norm {0} exists for the item',
      TaxPercentValueOutOfRange: 'Percentage tax value must be between 0 and 100',
      ItemCostGreatherThanRegulated: 'The cost of an item exceeds the regulated cost',
      InvalidSalesUnits: 'Sales units of measures are not correctly populated',
      ItemHasNotSellingUnit: 'The item does not have a sales unit of measure',
      InvalidCompetitorPriceSource: 'Invalid competitor price source',
      CodeMustNotEmpty: 'Code must not be empty',
      NameMustNotEmpty: 'Name must not be empty',
      ItemIsDeleted: 'Item is deleted',
      StoreCostValueGreaterThanZero: 'StoreCost value must be greater than zero',
      WrongStoreCode: 'Wrong store code',
      InvalidSaleUnits: 'Invalid sale units',
      ValueShouldBeGreaterThanZero: 'Value should be greater than zero',
      MalFormedFieldTagValues: 'Malformed field in Tagvalues',
      TagNotFound: 'Tag not found',
      TaskFailedAfterRetries: 'Task failed after retries',
      UnitsLowerOrEqualToZero: 'Units lower or equal to zero',
      DateTimeGreaterThanTodayAndLessThen: 'Datetime greater than today',
      DailySaleAlreadyExist: 'DailySales already exists',
      InvalidVendorSegmentation: 'Invalid vendor segmentation',
      DocumentTypeDoesNotExists: 'Document type does not exist',
      DailyInventoryAlreadyExist: 'Daily inventory already exists',
      BrandNameCannotBeEmpty: 'The store brand cannot be empty',
      VendorCodeNotBeNull: 'The Vendor Code cannot be "null"',
      VendorNameNotBeNull: 'The Vendor Name cannot be "null"',
      LongCannotBeEmpty: 'Longitude (Long) cannot be empty',
      LongBadGeoData: 'Longitude (Long) must be between -180 and 180',
      LatCannotBeEmpty: 'Latitude (Lat) cannot be empty',
      LatBadGeoData: 'Latitude (Lat) must be between -90 and 90',
      CompetitorAddressCannotBeEmpty: 'Address or Long/Lat coordinates are required to locate the store',
      StoreIsDeleted: 'The store is marked as deleted and cannot be updated',
      ItemCodeTypeMustNotBeNull: 'The Item Code Type cannot be "null"',
      InvalidMonth: 'Invalid month',
      DuplicateTagValueForOneOrMoreStores: 'Duplicate tag value for one or more stores',
      SalesTotalCannotBeEmpty: 'Sales total cannot be empty',
      NetSalesCannotBeEmpty: 'Net sales cannot be empty',
      SalesTotalCannotBeEmptyOrEqualToZero: 'Sales total cannot be empty or equal to zero',
      NetSalesCannotBeEmptyOrEqualToZero: 'Net sales cannot be empty or equal to zero',
      ComboCodeDoesNotExists: 'Combo code does not exists',
      TagValueWrongType: 'Tag value has an incorrect data type',
      QuantityGreaterThanOrEqualOne: 'Quantity is greater or equal to one',
      QuantityMustBeGreaterThanOrEqualOne: 'Quantity must be greater or equal to one',
      TemplateCodeMustNotBeNullOrEmpty: 'The template code does not exist',
      InstanceContainsDuplicateKeyValues: 'The instance contains duplicate keys',
      TemplateDoesNotExist: 'The template does not exist',
      TemplateAttributeDoesNotExist: 'The specified attribute does not exist in the instance',
      TemplateAttributeIsNullOrEmptyButIsRequired: 'The template attribute is null and empty but is required',
      InstanceCodeMustNotBeNullOrEmpty: 'The instance code cannot be empty',
      InstanceNameMustNotBeNullOrEmpty: 'The instance name cannot be empty',
      ItemVariantCannotBeSelfPrincipal: 'A product cannot be its own principal product',
      ItemVariantPrincipalIsAlreadyAVariant:
        'The selected principal is already a variant of another product. Chained variants are not allowed',
      ItemVariantIsAlreadyAPrincipal: 'This product is already a principal for other variants and cannot be assigned as a variant',
      // PRICING-140: regional products (custom items)
      ItemCodeAlreadyExists: 'The code already exists in Prisma (deleted items count too)',
      CustomItemsAllowedExceeded: 'The store exceeded its regional products quota. Store and rejected codes',
      CustomItemsAllowedDetail: 'Store regional products quota (used/quota)',
      CustomItemCodeInvalidFormat: 'The code must have 9 digits and end with the store code',
      ItemCodeToReplaceNotCustomItemOfStore: 'Not replaced: the code to replace is not a regional product of the store (code, store)',
      CustomItemNotFoundForStore: 'The item is not a regional product of the store (code, store)',
      StoreCodeError: 'The store does not exist',
      ItemCodeNotFound: 'The item code does not exist',
      CategoryCodeIsNotValid: 'The category does not exist',
      EanCodeIsNotValid: 'The EAN code is not valid',
      NoCustomItemAdded: 'No regional product was created',
      ItemIsNewCannotUpdateCosts: 'The item is New: it cannot be updated until it is published',
      ItemNoHasVendorCannotUpdateCosts: 'The item has no vendor, so its cost cannot be updated',
      CannotUpdateAnyPrice: 'No price was updated',
      CannotUpdateAnyCosts: 'No cost was updated',
      NewValidFromCannotBeBeforeToday: 'The valid from date cannot be earlier than today',
      ItemNameTooLong: 'The name cannot exceed 25 characters',
      ItemShortNameMustNotBeNull: 'The short name is required',
      ItemShortNameTooLong: 'The short name cannot exceed 25 characters',
      ItemTaxGreaterThanZero: 'The item tax must be greater than 0',
      SalesTaxRateOutsideZeroToOneRange: 'The sales tax rate must be between 0 and 1 (e.g. 0.21)',
      SalesTaxRateMustNotBeNull: 'The sales tax rate is required (e.g. 0.21; 0 if exempt)',
    },
    CUSTOM_ERRORS: {
      '1': 'Test Custom Error Trad EN val: {{val}}',
      BrandHasAssociatedStores: 'The brand has associated stores. Migrate the stores before modifying it.',
      BaseUnitOfMeasureNotFound: 'No base unit of measure was found for this product. 1 will be used as the conversion.',
      UnitOfMeasureNotFound: 'Unit of measure not found',
      CalculationTypeCostNotFound: '{{val}} not found for Store {{val2}} to calculate the cost or tax of product {{val3}} ',
      MissingInitialPriceMethod:
        'A Pricing Initialization Method was not found. Make sure you have an initial price for each selling unit of measure and that you have selected one initialization method in the Prices Tab.',
      MissingSellingUnitOfMeasure: 'You must create at least one selling unit of measure for this type of product',
      OnlyOneSellingUnitOfMeasureAllowed: 'Only one selling unit of measure is allowed per item ({{val}}).',
      OneBaseUnitOfMeasureRequired: 'Exactly one base unit of measure is required ({{val}}).',
      DuplicateUnitsOfMeasure: 'Duplicate units of measure found: {{val}}.',
      CannotDeleteUnitOfMeasureNotFound: 'Unit of measure {{val}} was not found.',
      CannotDeleteUnitOfMeasureAlreadyDeleted: 'Unit of measure {{val}} was already deleted.',
      CannotDeleteUnitOfMeasureIsBase: 'Unit of measure {{val}} cannot be deleted because it is the base unit.',
      CannotDeleteUnitOfMeasureIsSellingUnit: 'Unit of measure {{val}} cannot be deleted because it is the selling unit.',
      CannotDeleteUnitOfMeasureUsedByVendors: 'Unit of measure {{val}} cannot be deleted because it is a vendor order unit.',
      CannotDeleteUnitOfMeasureUsedByVendorCosts: 'Unit of measure {{val}} cannot be deleted because it has vendor costs.',
      CannotDeleteUnitOfMeasureUsedByItemCodes: 'Unit of measure {{val}} cannot be deleted because it has item codes.',
      CannotDeleteUnitOfMeasureUsedByRecipes: 'Unit of measure {{val}} cannot be deleted because it is used in a recipe.',
      CannotDeleteUnitOfMeasureUsedByCombos: 'Unit of measure {{val}} cannot be deleted because it is used in a combo.',
      CannotDeleteUnitOfMeasureUsedByStorePrices: 'Unit of measure {{val}} has active prices. Republish the item before deleting it.',
      NotGeneratedPriceMissingSellingUom: 'Prices were not generated. Selling unit of measure missing',
      CannotDeleteRegistryInUse: 'The registry is already in use',
      NoCodeSpecified: 'Item not found',
      TemplateInstanceAssigned: 'Cannot delete this instance, it is currently in use',
      ItemNotFound: 'Item not found: {{val}}',
      ItemIsPublishingCannotUpdate: "Cannot update this item, It's publishing.",
      CodeAlreadyExists: 'The code already exists {{val}}.',
      AutoCodeGenerationFailed: 'Could not retrieve the item code from your ERP. Please retry.',
      CLONED_PROCESS_FAILURE_TITLE: 'The cloning process failed',
      CLONED_PROCESS_FAILURE_MSG: 'Cloning was not performed or was partially performed without assortment.',
      InvalidCodeTypes: "The code type doesn't exists {{val}}.",
      ParamCannotBeNull: "The param {{val}} can't be null.",
      ParentCannotBeUse:
        'The selected parent cannot be used for the rule because it was already used as a child in another relationship rule',
      AtLeastOneChildWasFound: 'At least one child product was found that was already used as a child in another rule.',
      NoNeedToRepublish: 'This item does not need to be republished.',
      ItemHasNotStoreAssortment:
        'The publication was not carried out. Assortment exception is active and not charged correctly, at least one product must be charged to the importer, it be active and not blocked for sale',
      StoreIsPublishingCannotUpdate: 'This point of sale cannot be edited because it is being published.',
      DistributionCenterNotFoundOrNotCedis: 'The assigned Distribution Center does not exist or is not a valid one. (Id: {{val}})',
      DistributionCenterRequiredForPublish: 'The tenant requires a Distribution Center to be assigned before publishing store {{val}}.',
      DistributionCenterCodeNotFoundOrNotCedis:
        'The Distribution Center code {{val}} was not found in the system or in the imported file, or it is not a valid Distribution Center. The assignment was ignored.',
      DistributionCenterCodeIgnoredForCedisStoreType:
        'The Distribution Center code {{val}} was ignored because the store type is already a Distribution Center.',
      DefaultDistributionCenterCodeApplied: 'The tenant default Distribution Center was applied to store {{val}}.',
      DistributionCenterHasAssignedStores:
        'The Distribution Center cannot be deleted because it is assigned to the following stores: {{val}}',
      UNAUTHORIZED_ACCESS: 'You do not have sufficient permissions to perform this action.',
      INVALID_STORE_SCOPE: 'No stores found for the selected product scope.',
      INVALID_MANUAL_STORE_SCOPES: 'The following selected stores are not valid for the chosen scope of products',
      NO_STORES_FOUND: 'No stores were found to perform this action.',
      AnyRoleInUse: 'It is not possible to delete Roles that are in use.',
      NoRecordSelected: 'There are no items selected to delete.',
      EntityCreated: 'Entity created successfully',
      EntityUpdated: 'Entity updated successfully',
      CodeCompetitorCannotBeNull: 'The competitor code cannot be empty.',
      CompetitorBadGeoData: 'The latitude or longitude data is incorrect.',
      BrandCompetitorCannotBeNull: 'The flag cannot be empty.',
      NameCompetitorCannotBeNull: "The competitor's name cannot be empty.",
      FileIsTooBig: 'The file size is too large.',
      ItemForecastDataIsNull: 'Item Forecast Data is Null',
      ReferencedItemIsAlreadyInUse: 'The referenced item is already in use.',
      ErrorOnAddingItemForecast: 'Error on adding item forecast',
      ErrorOnRemovingItemForecast: 'Error on removing item forecast',
      ReferencedNotFound: 'Referenced not found',
      ExpiredPromotion: 'The start date of the promotional action and promotional period is before the current date.',
      CategoriesWithoutPermission: 'You do not have permission to access the following categories: {{val}}',
      TemplateFound: 'An entity with the entered data already exists',
      TagNameFound: 'A tag with the entered code-name already exists',
      ExistsTemplateInstances: 'The entity has associated instances',
      TemplateAssigned: 'Actions cannot be performed. The related tag is associated.',
      DuplicateTemplateInstance: 'The file contains duplicate values: {{val}}',
      ColumnNotFound: 'The column {{val}} does not exist in the entity',
      InvalidValue: 'The file contains invalid values: {{val}}',
      PromotionAlreadyStarted: 'Promotional actions cannot be modified once their promotional period has started',
      RefreshDecisionSummaryInProgress: 'Refreshing in progress',
      RefreshDesicionSummaryCompleted: 'Refresh completed',
      RefreshDesicionSummaryFailed: 'Refresh failed',
      RejectSuccess: 'The new value has been successfully rejected',
      SUGGESTIONS_PRE_APPROVED: '{{val}} suggestion(s) pre-approved.',
      SUGGESTIONS_REJECTED: 'Suggestion rejected',
      ChargeDefinitionFound: 'There is already a cost/tax with the code {{val}}',
      ChargeDefinitionOverlap:
        'You have already configured a [cost/tax] ( [{{val}}] - [{{val2}}] ) for this combination of points of sale and items. To avoid conflicts, each configuration must have a unique scope.',
      PlanogramCodeFound: 'A planogram with that code already exists.',
      RANGE_SERVICE_UNAVAILABLE: 'The Range service is currently unavailable. Please try again in a few minutes.',
    },
  },
};
